export default {
  "100110": "Durum wheat",
  "100111": "Cereals; wheat and meslin, durum wheat, seed",
  "100119": "Durum wheat; excl. seed",
  "100190": "Wheat and meslin; excl. durum",
  "100191": "Cereals; wheat and meslin, other than durum wheat, seed",
  "100199": "Wheat and meslin; excl. durum and seed",
  "100200": "Cereals; rye",
  "100210": "Cereals; rye, seed",
  "100290": "Cereals; rye, other than seed",
  "100300": "Barley",
  "100310": "Cereals; barley, seed",
  "100390": "Barley; excl. seed",
  "100400": "Cereals; oats",
  "100410": "Cereals; oats, seeds",
  "100490": "Cereals; oats, other than seed",
  "100510": "Cereals; maize (corn), seed",
  "100590": "Maize; excl. seed corn",
  "100610": "Cereals; rice in the husk (paddy or rough)",
  "100620": "Cereals; husked (brown) rice",
  "100630": "Rice; semi-milled or wholly milled",
  "100640": "Cereals; rice, broken",
  "100700": "Cereals; grain sorghum",
  "100710": "Cereals; grain sorghum, seed",
  "100790": "Cereals; grain sorghum, other than seed",
  "100810": "Cereals; buckwheat",
  "100820": "Cereals; millet",
  "100821": "Cereals; millet, seed",
  "100829": "Cereals; millet, other than seed",
  "100830": "Cereals; canary seeds",
  "100840": "Cereals; fonio (Digitaria spp.)",
  "100850": "Cereals; quinoa (Chenopodium quinoa)",
  "100860": "Cereals; triticale",
  "100890": "Cereals; n.e.c. in chapter 10",
  "110100": "Wheat or meslin flour",
  "110210": "Cereal flour; of rye",
  "110220": "Cereal flour; of maize (corn)",
  "110230": "Cereal flour; of rice",
  "110290": "Cereal flours; other than wheat, meslin, and maize (corn)",
  "110311": "Cereal groats and meal; of wheat",
  "110312": "Cereal groats and meal; of oats",
  "110313": "Cereal groats and meal; of maize (corn)",
  "110314": "Cereal groats and meal; of rice",
  "110319": "Cereal groats and meal; n.e.c. in heading no. 1103",
  "110320": "Cereal pellets",
  "110321": "Cereal pellets; of wheat",
  "110329": "Cereal pellets; of cereals other than wheat",
  "110411": "Cereal grains; rolled or flaked, of barley",
  "110412": "Cereal grains; rolled or flaked, of oats",
  "110419": "Cereal grains; rolled or flaked, other than oats",
  "110421":
    "Cereal grains; worked (eg hulled, pearled, sliced or kibbled) of barley",
  "110422":
    "Cereal grains; worked (e.g. hulled, pearled, sliced or kibbled) of oats",
  "110423":
    "Cereal grains; worked (e.g. hulled, pearled, sliced or kibbled) of maize (corn)",
  "110429":
    "Cereal grains; worked, other than rolled or flaked (e.g. Hulled, pearled, sliced or kibbled) of cereals, excluding oats and maize, and rice of heading no.1006",
  "110430": "Cereal; germ of cereals, whole, rolled, flaked or ground",
  "110510": "Flour, meal and powder; of potatoes",
  "110520": "Flakes, granules and pellets; of potatoes",
  "110610":
    "Flour, meal and powder; of the dried leguminous vegetables of heading no. 0713",
  "110620":
    "Flour, meal and powder; of sago or of roots or tubers of heading no. 0714",
  "110630": "Flour, meal and powder; of the products of chapter 8",
  "110710": "Malt; not roasted",
  "110720": "Malt; roasted",
  "110811": "Starch; wheat",
  "110812": "Starch; maize (corn) starch",
  "110813": "Starch; potato",
  "110814": "Starch; manioc (cassava)",
  "110819": "Starch; n.e.c. in item no. 1108.11 to 1108.14",
  "110820": "Inulin",
  "110900": "Wheat gluten; whether or not dried",
  "120100": "Soybeans",
  "120110": "Soya beans; seed, whether or not broken",
  "120190": "Soybeans; excl. seed",
  "120210": "Ground-nuts; in shell, not roasted or otherwise cooked",
  "120220":
    "Ground-nuts; shelled, not roasted or otherwise cooked, whether or not broken",
  "120230":
    "Ground-nuts; seed, not roasted or otherwise cooked, whether or not shelled or broken",
  "120241":
    "Ground-nuts; other than seed, not roasted or otherwise cooked, in shell",
  "120242":
    "Ground-nuts; other than seed, not roasted or otherwise cooked, shelled, whether or not broken,",
  "120300": "Copra",
  "120400": "Oil seeds; linseed, whether or not broken",
  "120500": "Rape or colza seeds",
  "120510": "Low erucic acid rape or colza seeds",
  "120590":
    "Oil seeds; rape or colza seeds, other than low erucic, whether or not broken",
  "120600": "Oil seeds; sunflower seeds, whether or not broken",
  "120710": "Oil seeds; palm nuts and kernels, whether or not broken",
  "120720": "Oil seeds; cotton seeds, whether or not broken",
  "120721": "Oil seeds; cotton seeds, seed, whether or not broken",
  "120729": "Oil seeds; cotton seeds, other than seed, whether or not broken",
  "120730": "Oil seeds; castor oil seeds, whether or not broken",
  "120740": "Oil seeds; sesamum seeds, whether or not broken",
  "120750": "Oil seeds; mustard seeds, whether or not broken",
  "120760":
    "Oil seeds; safflower (Carthamus tinctorius) seeds, whether or not broken",
  "120770": "Oil seeds; melon seeds, whether or not broken",
  "120791": "Oil seeds; poppy seeds, whether or not broken",
  "120792": "Oleaginous fruits; shea nuts (karite nuts)",
  "120799":
    "Oil seeds and oleaginous fruits; n.e.c. in heading no. 1207, whether or not broken",
  "120810": "Flours and meals; of soya beans",
  "120890":
    "Flours and meals of oil seeds or oleaginous fruits; excluding soya beans and mustard seeds",
  "120910": "Seed; sugar beet seeds, of a kind used for sowing",
  "120911": "Seed; sugar beet seed, of a kind used for sowing",
  "120919":
    "Seed; beet seed, (excluding sugar beet), of a kind used for sowing",
  "120921":
    "Seeds of forage plants; lucerne (alfalfa) seeds, of a kind used for sowing",
  "120922":
    "Seeds of forage plants; clover (Trifolium spp.) seeds, of a kind used for sowing",
  "120923": "Seeds of forage plants; fescue seeds, of a kind used for sowing",
  "120924":
    "Seeds of forage plants; Kentucky blue grass (Poa pratensis L.) seeds, of a kind used for sowing",
  "120925":
    "Seeds of forage plants; rye grass (Lolium multiflorum Lam., Lolium perenne L.) seeds, of a kind used for sowing",
  "120926": "Seed; timothy grass seed, of a kind used for sowing",
  "120929":
    "Seeds of forage plants; other than lucerne, clover, fescue, Kentucky blue grass, and rye grass seeds, of a kind used for sowing",
  "120930":
    "Seeds of herbaceous plants; cultivated principally for their flowers, of a kind used for sowing",
  "120991": "Seeds; vegetable seeds, of a kind used for sowing",
  "120999": "Seeds; n.e.c. in heading 1209, of a kind used for sowing",
  "121010": "Hop cones; neither ground nor powdered nor in the form of pellets",
  "121020": "Hop cones; ground, powdered or in the form of pellets; lupulin",
  "121110":
    "Liquorice roots used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes; fresh or dried, whether or not cut, crushed or powdered",
  "121120":
    "Ginseng roots, of a kind used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes, fresh, chilled, frozen or dried, whether or not cut, crushed or powdered",
  "121130":
    "Coca leaf; of a kind used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes, fresh, chilled, frozen or dried, whether or not cut, crushed or powdered",
  "121140":
    "Poppy straw; of a kind used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes, fresh, chilled, frozen or dried, whether or not cut, crushed or powdered",
  "121150":
    "Ephedra, of a kind used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes, fresh, chilled, frozen or dried, whether or not cut, crushed or powdered",
  "121160":
    "Bark of African cherry (Prunus africana); of a kind used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes, fresh, chilled, frozen or dried, whether or not cut, crushed or powdered",
  "121190":
    "Plants and parts (including seeds and fruits) n.e.c. in heading no. 1211, of a kind used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes, fresh, chilled, frozen or dried, whether or not cut, crushed or powdered",
  "121210":
    "Locust beans, including locust bean seeds; of a kind used primarily for human consumption, fresh, chilled, frozen or dried, whether or not ground",
  "121220":
    "Seaweeds and other algae; of a kind used primarily for human consumption, fresh, chilled, frozen or dried, whether or not ground",
  "121221":
    "Seaweeds and other algae; fit for human consumption, fresh, chilled, frozen or dried, whether or not ground",
  "121229":
    "Seaweeds and other algae; not fit for human consumption, fresh, chilled, frozen or dried, whether or not ground",
  "121230":
    "Apricot, peach (including nectarine) or plum stones and kernels; of a kind used primarily for human consumption",
  "121291":
    "Sugar beet; fit for human consumption, fresh, chilled, frozen or dried, whether or not ground",
  "121292":
    "Locust beans (carob); fit for human consumption, fresh, chilled, frozen or dried, whether or not ground",
  "121293":
    "Sugar cane; fit for human consumption, fresh, chilled, frozen or dried, whether or not ground",
  "121294":
    "Chicory roots (Chicorium intybus sativum); fit for human consumption, fresh, chilled, frozen or dried, whether or not ground",
  "121299":
    "Vegetable products; fit for human consumption, n.e.c. in heading no. 1212, fresh, chilled, frozen or dried, whether or not ground",
  "121300":
    "Cereal straw and husks; unprepared, whether or not chopped, ground, pressed or in the form of pellets",
  "121410": "Lucerne (alfalfa) meal and pellets",
  "121490":
    "Forage products including swedes, mangolds, fodder roots, hay, sainfoin, clover, forage kale, lupines, vetches etc., pelletised or otherwise",
  "130110": "Lac",
  "130120": "Gum Arabic",
  "130190":
    "Natural gums, resins, gum-resins and oleoresins, n.e.c. in heading no. 1301",
  "130211": "Vegetable saps and extracts; opium",
  "130212": "Vegetable saps and extracts; of liquorice",
  "130213": "Vegetable saps and extracts; of hops",
  "130214": "Vegetable saps and extracts; of ephedra",
  "130219": "Vegetable saps and extracts; n.e.c. in item no. 1302.1",
  "130220": "Pectic substances; pectinates and pectates",
  "130231":
    "Mucilages and thickeners; agar-agar, whether or not modified, derived from vegetable products",
  "130232":
    "Mucilages and thickeners; whether or not modified, derived from locust beans, locust bean seeds or guar seeds",
  "130239":
    "Mucilages and thickeners; whether or not modified, derived from vegetable products, n.e.c. in item no. 1302.3",
  "140110": "Bamboo used primarily for plaiting",
  "140120": "Rattans used primarily for plaiting",
  "140190":
    "Vegetable materials of a kind used primarily for plaiting; n.e.c. in heading no. 1401",
  "140200":
    "Vegetable materials of a kind used primarily as stuffing or as padding; (eg kapok, vegetable hair and eel grass), whether or not put up as a layer with or without supporting material",
  "140210":
    "Kapok used primarily as stuffing or as padding; whether or not put up as a layer with or without supporting material",
  "140290":
    "Vegetable products; (excluding kapok), of a kind used primarily as stuffing or as padding, whether or not put up as a layer, with or without supporting material",
  "140291":
    "Vegetable hair of a kind used primarily as stuffing or as padding; whether or not put up as a layer with or without supporting material",
  "140299":
    "Vegetable materials (excluding kapok and vegetable hair) used primarily as stuffing or as padding; whether or not put up as a layer with or without supporting materials",
  "140300":
    "Vegetable materials of a kind used primarily in brooms or brushes; (eg broomcorn, piassava, couch-grass and istle), whether or not in hanks or bundles",
  "140310":
    "Broomcorn (sorghum vulgare var. technicum), of a kind used primarily in brooms or in brushes; whether or not in hanks or bundles",
  "140390":
    "Vegetable materials; (excluding broomcorn) of a kind used primarily in brooms or in brushes, whether or not in hanks or bundles",
  "140410":
    "Vegetable products; raw materials used primarily in dyeing or tanning",
  "140420": "Vegetable products; cotton linters",
  "140490": "Vegetable products; n.e.c. in chapter 14",
  "150100":
    "Animal fat; pig and poultry fat (including lard), other than that of heading no. 0209 or 1503",
  "150110": "Pig fat; lard, other than that of heading 0209 and 1503",
  "150120": "Pig fat; not lard, other than that of heading 0209 or 1503",
  "150190": "Poultry fat; other than that of heading 0209 or 1503",
  "150200":
    "Fats of bovine animals, sheep or goats; other than those of heading no. 1503",
  "150210": "Tallow; other than those of heading 1503",
  "150290":
    "Fats of bovine animals, sheep or goats; excluding tallow, and other than those of heading 1503",
  "150300":
    "Lard stearin, lard oil, oleostearin, oleo-oil and tallow oil; not emulsified or mixed or otherwise prepared",
  "150410":
    "Oils of fish; fish-liver oils and their fractions, whether or not refined, but not chemically modified",
  "150420":
    "Fats and oils and their fractions; of fish, (excluding liver-oils)",
  "150430": "Fats and oils and their fractions; of marine mammals",
  "150500":
    "Wool grease and fatty substances derived therefrom (including lanolin)",
  "150510": "Animal fats and oils; wool grease, crude",
  "150590":
    "Animal fats and oils; wool grease (other than crude) and fatty substances derived therefrom (including lanolin)",
  "150600":
    "Animal fats and oils and their fractions; whether or not refined, but not chemically modified, n.e.c. in chapter 15",
  "150710": "Soybean oil; crude",
  "150790":
    "Vegetable oils; soya-bean oil and its fractions, other than crude, whether or not refined, but not chemically modified",
  "150810":
    "Vegetable oils; ground-nut oil and its fractions, crude, not chemically modified",
  "150890":
    "Vegetable oils; ground-nut oil and its fractions, other than crude, whether or not refined, but not chemically modified",
  "150910":
    "Vegetable oils; olive oil and its fractions, virgin, whether or not refined, but not chemically modified",
  "150920":
    "Vegetable oils; olive oil and its fractions, extra virgin olive oil, whether or not refined, but not chemically modified",
  "150930":
    "Vegetable oils; olive oil and its fractions, virgin olive oil, whether or not refined, but not chemically modified",
  "150940":
    "Vegetable oils; olive oil and its fractions, virgin olive oils n.e.c. in heading 1509, whether or not refined, but not chemically modified",
  "150990":
    "Vegetable oils; olive oil and its fractions, other than virgin, whether or not refined, but not chemically modified",
  "151000":
    "Vegetable oils; oils and their fractions n.e.c. in chapter 15, obtained solely from olives, whether or not refined, but not chemically modified, including blends of these oils or fractions with oils or fractions of heading no. 1509",
  "151010":
    "Vegetable oils; crude olive pomace oil and their fractions, obtained solely from olives, whether or not refined, but not chemically modified",
  "151090":
    "Vegetable oils; oils and their fractions n.e.c. in heading 1510, obtained solely from olives, whether or not refined, but not chemically modified, including blends of these oils or fractions with oils or fractions of heading no. 1509",
  "151110": "Palm oil; crude",
  "151190": "Palm oil and its fractions; excl. crude",
  "151211":
    "Vegetable oils; sunflower seed or safflower oil and their fractions, crude, not chemically modified",
  "151219":
    "Vegetable oils; sunflower seed or safflower oil and their fractions, other than crude, whether or not refined, but not chemically modified",
  "151221":
    "Vegetable oils; cotton-seed oil and its fractions; crude, whether or not gossypol has been removed, not chemically modified",
  "151229":
    "Vegetable oils; cotton-seed oil and its fractions, other than crude, whether or not refined, but not chemically modified",
  "151311":
    "Vegetable oils; coconut (copra) oil and its fractions, crude, not chemically modified",
  "151319":
    "Vegetable oils; coconut (copra) oil and its fractions, other than crude, whether or not refined, but not chemically modified",
  "151321":
    "Vegetable oils; palm kernel or babassu oil and their fractions, crude, not chemically modified",
  "151329":
    "Vegetable oils; palm kernel or babassu oil and their fractions, other than crude, whether or not refined, but not chemically modified",
  "151410":
    "Vegetable oils; rape, colza or mustard oil and their fractions, crude, not chemically modified",
  "151411":
    "Vegetable oils; low erucic acid rape or colza oil and its fractions, crude",
  "151419":
    "Vegetable oils; low erucic acid rape or colza oil and its fractions, other than crude, but not chemically modified",
  "151490":
    "Vegetable oils; rape, colza or mustard oil and their fractions, other than crude, whether or not refined, but not chemically modified",
  "151491":
    "Vegetable oils; excluding low erucic acid rape or colza oil and its fractions, crude",
  "151499":
    "Vegetable oils; excluding low erucic acid rape or colza oil and its fractions, other than crude, but not chemically modified",
  "151511":
    "Vegetable oils; linseed oil and its fractions, crude, not chemically modified",
  "151519":
    "Vegetable oils; linseed oil and its fractions, other than crude, whether or not refined, but not chemically modified",
  "151521":
    "Vegetable oils; maize (corn) oil and its fractions, crude, not chemically modified",
  "151529":
    "Vegetable oils; maize (corn) oil and its fractions, other than crude, whether or not refined, but not chemically modified",
  "151530":
    "Vegetable oils; castor oil and its fractions, whether or not refined, but not chemically modified",
  "151540":
    "Vegetable oils; tung oil and its fractions, whether or not refined, but not chemically modified",
  "151550":
    "Vegetable oils; sesame oil and its fractions, whether or not refined, but not chemically modified",
  "151560":
    "Vegetable oils; jojoba oil and its fractions, whether or not refined, but not chemically modified",
  "151590":
    "Vegetable fats and oils and their fractions; fixed, n.e.c. in heading no. 1515, whether or not refined, but not chemically modified",
  "151610":
    "Animal fats and oils and their fractions; partly or wholly hydrogenated, inter-esterified, re-esterified or elaidinised, whether or not refined, but not further prepared",
  "151620":
    "Vegetable fats and oils and their fractions; partly or wholly hydrogenated, inter-esterified, re-esterified or elaidinised, whether or not refined, but not further prepared",
  "151630":
    "Microbial fats and oils and their fractions; partly or wholly hydrogenated, inter-esterified, re-esterified or elaidinised, whether or not refined, but not further prepared",
  "151710": "Margarine; excluding liquid margarine",
  "151790":
    "Edible mixtures or preparations of animal or vegetable fats or oils or of fractions of different fats or oils of this chapter, other than edible fats or oils of heading no. 1516",
  "151800":
    "Animal or vegetable fats and oils and their fractions; oxidised, boiled or otherwise chemically modified, (excluding those of heading no. 1516), inedible mixtures or preparations of fats or oils",
  "151911": "Stearic acid",
  "151912": "Oleic acid",
  "151913": "Tall oil fatty acids",
  "151919": "Industrial monocarboxylic fatty acids n.e.s. in heading no. 1519",
  "151920": "Acid oils from refining",
  "151930": "Industrial fatty alcohols",
  "152000": "Glycerol, crude; glycerol waters and glycerol lyes",
  "152010": "Glycerol (glycerine); crude; glycerol waters and glycerol lyes",
  "152090": "Glycerol; n.e.s. in heading no. 1520, including synthetic",
  "152110":
    "Vegetable waxes (other than triglycerides); whether or not refined or coloured",
  "152190":
    "Waxes, other than vegetable, n.e.c. in heading no. 1521; whether or not refined or coloured",
  "152200":
    "Degras; residues resulting from the treatment of fatty substances or animal or vegetable waxes",
  "160100":
    "Meat preparations; sausages and similar products, of meat, meat offal or blood, and food preparations based on these products",
  "160210":
    "Meat preparations; homogenised preparations of meat, meat offal or blood",
  "160220":
    "Meat preparations; of the prepared or preserved liver of any animal (excluding homogenised preparations)",
  "160231":
    "Meat preparations; of turkeys, prepared or preserved meat or meat offal (excluding livers and homogenised preparations)",
  "160232":
    "Meat preparations; of the poultry of heading no. 0105, (i.e. of fowls of the species Gallus domesticus)",
  "160239":
    "Meat preparations; of poultry (excluding turkeys), prepared or preserved meat or meat offal (excluding livers and homogenised preparations)",
  "160241":
    "Meat preparations; of swine, hams and cuts thereof, prepared or preserved (excluding homogenised preparations)",
  "160242":
    "Meat preparations; of swine, shoulders and cuts thereof, prepared or preserved (excluding homogenised preparations)",
  "160249":
    "Meat preparations; of swine, meat or meat offal (including mixtures), prepared or preserved, n.e.c. in heading no. 1602",
  "160250":
    "Meat preparations; of bovine animals, meat or meat offal, prepared or preserved (excluding livers and homogenised preparations)",
  "160290":
    "Meat preparations; of meat, meat offal or the blood of any animal, n.e.c. in heading no. 1602",
  "160300":
    "Extracts and juices; of meat, fish or crustaceans, molluscs or other aquatic invertebrates",
  "160411":
    "Fish preparations; salmon, prepared or preserved, whole or in pieces (but not minced)",
  "160412":
    "Fish preparations; herrings, prepared or preserved, whole or in pieces (but not minced)",
  "160413":
    "Fish preparations; sardines, sardinella and brisling or sprats, prepared or preserved, whole or in pieces (but not minced)",
  "160414":
    "Fish preparations; tunas, skipjack and Atlantic bonito (sarda spp.), prepared or preserved, whole or in pieces (but not minced)",
  "160415":
    "Fish preparations; mackerel, prepared or preserved, whole or in pieces (but not minced)",
  "160416":
    "Fish preparations; anchovies, prepared or preserved, whole or in pieces (but not minced)",
  "160417":
    "Fish preparations; eels, prepared or preserved, whole or in pieces (but not minced)",
  "160418":
    "Fish preparations; shark fins, prepared or preserved, whole or in pieces (but not minced)",
  "160419":
    "Fish preparations; fish prepared or preserved, whole or in pieces (but not minced), n.e.c. in heading no. 1604",
  "160420":
    "Fish preparations; fish minced or in forms n.e.c. in heading no. 1604, prepared or preserved",
  "160430": "Fish preparations; caviar and caviar substitutes",
  "160431": "Fish preparations; caviar",
  "160432": "Fish preparations; caviar substitutes, prepared from fish eggs",
  "160510": "Crustacean preparations; crab, prepared or preserved",
  "160520":
    "Crustacean preparations; shrimps and prawns, prepared or preserved",
  "160521":
    "Crustacean preparations; shrimps and prawns, prepared or preserved, not in airtight containers",
  "160529":
    "Crustacean preparations; shrimps and prawns, prepared or preserved, in airtight containers",
  "160530": "Crustacean preparations; lobster, prepared or preserved",
  "160540":
    "Crustacean preparations; other than crab, shrimps, prawns, and lobsters, prepared or preserved",
  "160551": "Mollusc preparations; oysters, prepared or preserved",
  "160552":
    "Mollusc preparations; scallops, including queen scallops, prepared or preserved",
  "160553": "Mollusc preparations; mussels, prepared or preserved",
  "160554":
    "Mollusc preparations; cuttle fish and squid, prepared or preserved",
  "160555": "Mollusc preparations; octopus, prepared or preserved",
  "160556":
    "Mollusc preparations; clams, cockles and arkshells, prepared or preserved",
  "160557": "Mollusc preparations; abalone, prepared or preserved",
  "160558":
    "Mollusc preparations; snails, other than sea snails, prepared or preserved",
  "160559":
    "Mollusc preparations; n.e.c. in item no. 1605.5, preparations such as pastes, sausages, prepared meals and the like",
  "160561": "Aquatic invertebrates; sea cucumbers, prepared or preserved",
  "160562": "Aquatic invertebrates; sea urchins, prepared or preserved",
  "160563": "Aquatic invertebrates; jellyfish, prepared or preserved",
  "160569":
    "Aquatic invertebrates; other than crustaceans, molluscs, sea cucumbers, sea urchins, and jellyfish, prepared or preserved",
  "160590":
    "Molluscs and other aquatic invertebrates; prepared or preserved (excluding crustaceans)",
  "170111":
    "Sugars; cane sugar, raw, in solid form, not containing added flavouring or colouring matter",
  "170112":
    "Sugars; beet sugar, raw, in solid form, not containing added flavouring or colouring matter",
  "170113":
    "Sugars; cane sugar, raw, in solid form, as specified in Subheading Note 2 to this chapter, not containing added flavouring or colouring matter",
  "170114": "Raw cane sugar; solid form",
  "170191":
    "Sugars; sucrose, chemically pure, in solid form, containing added flavouring or colouring matter",
  "170199": "Sucrose",
  "170210":
    "Sugars; lactose, chemically pure, in solid form; lactose syrup, not containing added flavouring or colouring matter",
  "170211":
    "Sugars; lactose and lactose syrup, containing by weight 99% or more lactose, expressed as anhydrous lactose, calculated on the dry matter",
  "170219":
    "Sugars; lactose and lactose syrup, containing by weight less than 99% lactose, expressed as anhydrous lactose, calculated on the dry matter",
  "170220":
    "Sugars; maple sugar, chemically pure, in solid form; maple syrup, not containing added flavouring or colouring matter",
  "170230":
    "Sugars; glucose and glucose syrup, not containing fructose or containing in the dry state less than 20% by weight of fructose, the syrup not containing added flavouring or colouring matter",
  "170240":
    "Sugars; glucose and glucose syrup, containing in the dry state at least 20% but less than 50% by weight of fructose, excluding invert sugar, the syrup not containing added flavouring or colouring matter",
  "170250": "Sugars; fructose, chemically pure, in solid form",
  "170260":
    "Sugars; fructose, other than chemically pure fructose, and fructose syrup (containing in the dry state more than 50% by weight of fructose), excluding invert sugar",
  "170290":
    "Sugars; n.e.c. in heading no. 1702, including invert sugar and other sugar and sugar syrup blends containing, in the dry state, 50% by weight of fructose",
  "170310":
    "Sugars; molasses, from sugar cane, resulting from the extraction or refining of sugar",
  "170390":
    "Sugars; molasses, from sugar beet, resulting from the extraction or refining of sugar",
  "170410":
    "Sugar confectionery; chewing gum, whether or not sugar-coated, not containing cocoa",
  "170490": "Sugar confectionery; no cocoa content, excl. chewing gum",
  "180100": "Cocoa beans",
  "180200": "Cocoa; shells, husks, skins and other cocoa waste",
  "180310": "Cocoa; paste, not defatted",
  "180320": "Cocoa; paste, wholly or partly defatted",
  "180400": "Cocoa; butter, fat and oil",
  "180500":
    "Cocoa; powder, not containing added sugar or other sweetening matter",
  "180610": "Cocoa; powder, containing added sugar or other sweetening matter",
  "180620":
    "Chocolate & other food preparations containing cocoa; in blocks, slabs or bars weighing more than 2kg or in liquid, paste, powder, granular or other bulk form in containers or immediate packings, content exceeding 2kg",
  "180631":
    "Chocolate and other food preparations containing cocoa; in blocks, slabs or bars, filled, weighing 2kg or less",
  "180632":
    "Chocolate and other food preparations containing cocoa; in blocks, slabs or bars, (not filled), weighing 2kg or less",
  "180690":
    "Other chocolate and cocoa food preparations (exclusionary category)",
  "190110": "Baby food",
  "190120":
    "Food preparations; mixes and doughs for the preparation of bread, pastry, cakes, biscuits and other bakers' wares",
  "190190":
    "Food preparations; of flour, meal, starch, malt extract or milk products, for uses n.e.c. in heading no. 1901",
  "190211":
    "Food preparations; pasta, containing eggs, uncooked, not stuffed or otherwise prepared",
  "190219":
    "Food preparations; pasta, uncooked (excluding that containing eggs), not stuffed or otherwise prepared",
  "190220":
    "Food preparations; pasta, stuffed (with meat or other substances), whether or not cooked or otherwise prepared",
  "190230":
    "Food preparations; pasta (excluding stuffed), cooked or otherwise prepared",
  "190240": "Food preparations; couscous",
  "190300":
    "Food preparations; tapioca and substitutes thereof, prepared from starch in the form of flakes, grains, pearls, siftings or similar",
  "190410":
    "Food preparations; obtained by the swelling or roasting of cereals or cereal products",
  "190420":
    "Food preparations; obtained from unroasted cereal flakes or from mixtures of unroasted cereal flakes and roasted cereal flakes or swelled cereals",
  "190430":
    "Prepared foods obtained by the swelling or roasting of cereals or cereal products (e.g. corn flakes); cereals, not maize (corn), in grain form or in the form of flakes or other worked grains, from bulgur wheat",
  "190490":
    "Food preparations; cereal or cereal products (excluding maize), in grain form, pre-cooked or otherwise prepared",
  "190510": "Food preparations; crispbread, whether or not containing cocoa",
  "190520":
    "Food preparations; gingerbread and the like, whether or not containing cocoa",
  "190530":
    "Food preparations; sweet biscuits, waffles and wafers, whether or not containing cocoa",
  "190531":
    "Food preparations; sweet biscuits, whether or not containing cocoa",
  "190532":
    "Food preparations; waffles and wafers, whether or not containing cocoa",
  "190540":
    "Food preparations; rusks, toasted bread and similar toasted products, whether or not containing cocoa",
  "190590":
    "Communion wafers, rice paper, sealing wafers, and similar products",
  "200110":
    "Vegetable preparations; cucumbers and gherkins, prepared or preserved by vinegar or acetic acid",
  "200120":
    "Vegetable preparations; onions, prepared or preserved by vinegar or acetic acid",
  "200190":
    "Vegetable preparations; vegetables, fruit, nuts and other edible parts of plants, prepared or preserved by vinegar or acetic acid (excluding cucumbers and gherkins)",
  "200210":
    "Vegetable preparations; tomatoes, whole or in pieces, prepared or preserved otherwise than by vinegar or acetic acid",
  "200290":
    "Vegetable preparations; tomatoes, (other than whole or in pieces), prepared or preserved otherwise than by vinegar or acetic acid",
  "200310":
    "Vegetable preparations; mushrooms of the genus Agaricus, prepared or preserved otherwise than by vinegar or acetic acid",
  "200320":
    "Vegetable preparations; truffles, prepared or preserved otherwise than by vinegar or acetic acid",
  "200390":
    "Vegetable preparations; mushrooms and truffles, other than mushrooms of the genus Agaricus, prepared or preserved otherwise than by vinegar or acetic acid",
  "200410":
    "Vegetable preparations; potatoes, prepared or preserved otherwise than by vinegar or acetic acid, frozen",
  "200490":
    "Vegetable preparations; vegetables and mixtures of vegetables (excluding potatoes), prepared or preserved otherwise than by vinegar or acetic acid, frozen",
  "200510":
    "Vegetable preparations; homogenised vegetables, prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
  "200520":
    "Vegetable preparations; potatoes, prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
  "200530": "Vegetable preparations; sauerkraut",
  "200540":
    "Vegetable preparations; peas (pisum sativum), prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
  "200551":
    "Vegetable preparations; beans, shelled, prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
  "200559":
    "Vegetable preparations; beans, (not shelled), prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
  "200560":
    "Vegetable preparations; asparagus, prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
  "200570":
    "Vegetable preparations; olives, prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
  "200580":
    "Vegetable preparations; sweetcorn (zea mays var. saccharata), prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
  "200590":
    "Vegetable preparations; vegetables and mixtures of vegetables n.e.s. in heading no. 2005, prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
  "200591":
    "Vegetable preparations; bamboo shoots, prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
  "200599":
    "Vegetable preparations; vegetables and mixtures of vegetables n.e.c. in heading no. 2005, prepared or preserved otherwise than by vinegar or acetic acid, not frozen",
  "200600":
    "Vegetables, fruit, nuts, fruit-peel and other parts of plants, preserved by sugar (drained, glace or crystallised)",
  "200710":
    "Jams, fruit jellies, marmalades, fruit or nut puree and fruit or nut pastes; homogenised, cooked preparations, whether or not containing added sugar or other sweetening matter",
  "200791":
    "Jams, jellies, marmalades, purees and pastes; of citrus fruit, being cooked preparations (excluding homogenised), whether or not containing added sugar or other sweetening matter",
  "200799":
    "Jams, fruit jellies, marmalades, purees and pastes; of fruit or nuts n.e.c. in heading no. 2007, cooked preparations (excluding homogenised), whether or not containing added sugar or other sweetening matter",
  "200811":
    "Nuts; ground-nuts, whether or not containing added sugar, other sweetening matter or spirit",
  "200819":
    "Nuts and other seeds; whether or not containing added sugar, other sweetening matter or spirit (excluding ground-nuts except in mixtures)",
  "200820":
    "Fruit; pineapples, prepared or preserved in ways n.e.c. in heading no. 2007, whether or not containing added sugar, other sweetening matter or spirit",
  "200830":
    "Fruit; citrus, prepared or preserved in ways n.e.c. in heading no. 2007, whether or not containing added sugar, other sweetening matter or spirit",
  "200840":
    "Fruit; pears, prepared or preserved in ways n.e.c. in heading no. 2007, whether or not containing added sugar, other sweetening matter or spirit",
  "200850":
    "Fruit; apricots, prepared or preserved in ways n.e.c. in heading no. 2007, whether or not containing added sugar, other sweetening matter or spirit",
  "200860":
    "Fruit; cherries, prepared or preserved in ways n.e.c. in heading no. 2007, whether or not containing added sugar, other sweetening matter or spirit",
  "200870":
    "Fruit; peaches, including nectarines, prepared or preserved in ways n.e.c. in heading no. 2007 and 2008, whether or not containing added sugar, other sweetening matter or spirit",
  "200880":
    "Fruit; strawberries, prepared or preserved in ways n.e.c. in heading no. 2007, whether or not containing added sugar, other sweetening matter or spirit",
  "200891":
    "Fruit, palm hearts; prepared or preserved, whether or not containing added sugar, other sweetening matter or spirit",
  "200892":
    "Fruit, nuts and other edible parts of plants; mixtures (other than those of subheading no 2008.19), prepared or preserved in ways n.e.c. in heading no. 2007 and 2008, whether or not containing added sugar, other sweetening matter or spirit, n.e.c.",
  "200893":
    "Fruit; cranberries (Vaccinium macrocarpon, Vaccinium oxycoccos, Vaccinium vitis-idaea), prepared or preserved, whether or not containing added sugar, other sweetening matter or spirit",
  "200897":
    "Fruit, nuts and other edible parts of plants; mixtures (other than those of subheading no 2008.19); prepared or preserved in ways n.e.c. in headings 2007 and 2008, whether or not containing added sugar, or other sweetening matter or spirit, n.e.c.",
  "200899":
    "Fruit, nuts and other edible parts of plants; prepared or preserved, whether or not containing added sugar, other sweetening matter or spirit, n.e.c. in heading no. 2008",
  "200911":
    "Juice; orange, frozen, unfermented, (not containing added spirit), whether or not containing added sugar or other sweetening matter",
  "200912":
    "Juice; orange, not frozen, of a Brix value not exceeding 20, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
  "200919":
    "Juice; orange, not frozen, of a Brix value exceeding 20, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
  "200920":
    "Juice; grapefruit, unfermented, (not containing added spirit), whether or not containing added sugar or other sweetening matter",
  "200921":
    "Juice; grapefruit (including pomelo), of a Brix value not exceeding 20, unfermented, (not containing added spirit), whether or not containing added sugar or other sweetening matter",
  "200929":
    "Juice; grapefruit (including pomelo), of a Brix value exceeding 20, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
  "200930":
    "Juice; of single citrus fruit (excluding orange or grapefruit), unfermented, (not containing added spirit), whether or not containing added sugar or other sweetening matter",
  "200931":
    "Juice; of single citrus fruit (excluding orange or grapefruit), of a Brix value not exceeding 20, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
  "200939":
    "Juice; of single citrus fruit (excluding orange or grapefruit), of a Brix value exceeding 20, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
  "200940":
    "Juice; pineapple, unfermented, (not containing added spirit), whether or not containing added sugar or other sweetening matter",
  "200941":
    "Juice; pineapple, of a Brix value not exceeding 20, unfermented, (not containing added spirit), whether or not containing added sugar or other sweetening matter",
  "200949":
    "Juice; pineapple, of a Brix value exceeding 20, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
  "200950":
    "Juice; tomato, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
  "200960":
    "Juice; grape (including grape must), unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
  "200961":
    "Juice; grape, of a Brix value not exceeding 30, unfermented, (not containing added spirit), whether or not containing added sugar or other sweetening matter",
  "200969":
    "Juice; grape, of a Brix value exceeding 30, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
  "200970":
    "Juice; apple, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
  "200971":
    "Juice; apple, of a Brix value not exceeding 20, unfermented, (not containing added spirit), whether or not containing added sugar or other sweetening matter",
  "200979":
    "Juice; apple, of a Brix value exceeding 20, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
  "200980":
    "Juice; of any single fruit or vegetable n.e.c. in heading no. 2009, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
  "200981":
    "Juice; Cranberry (Vaccinium macrocarpon, Vaccinium oxycoccos, Vaccinium vitis-idaea) juice, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
  "200989":
    "Juice; of any single fruit or vegetable n.e.c. in heading no. 2009, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
  "200990":
    "Juices; mixtures of fruits or vegetables, unfermented, not containing added spirit, whether or not containing added sugar or other sweetening matter",
  "210110":
    "Extracts, essences and concentrates; of coffee and preparations with a basis of these extracts, essences or concentrates or with a basis of coffee",
  "210111":
    "Extracts, essences and concentrates; of coffee, and preparations with a basis of these extracts, essences or concentrates or with a basis of coffee",
  "210112":
    "Preparations with a basis of extracts, essences or concentrates or with a basis of coffee",
  "210120":
    "Extracts, essences and concentrates; of tea or mate, and preparations with a basis of these extracts, essences or concentrates or with a basis of tea or mate",
  "210130":
    "Chicory, roasted and other roasted coffee substitutes; extracts, essences and concentrates thereof",
  "210210": "Yeasts; active",
  "210220": "Yeasts; inactive, other single-cell micro-organisms, dead",
  "210230": "Baking powders; prepared",
  "210310": "Sauces; soya",
  "210320": "Sauces; tomato ketchup and other tomato sauces",
  "210330": "Mustard flour and meal and prepared mustard",
  "210390": "Mixed condiments and seasonings",
  "210410": "Soups and broths and preparations therefor",
  "210420": "Homogenised composite food preparations",
  "210500": "Ice cream and other edible ice; whether or not containing cocoa",
  "210610": "Protein; concentrates and textured protein substances",
  "210690": "Other food preparations (exclusionary category)",
  "220110":
    "Waters; mineral and aerated, including natural or artificial, (not containing added sugar or other sweetening matter nor flavoured)",
  "220190":
    "Waters; other than mineral and aerated, (not containing added sugar or other sweetening matter nor flavoured), ice and snow",
  "220210": "Beverage waters; sweetened or flavoured",
  "220290":
    "Non-alcoholic beverages; n.e.c. in item no. 2202.10, not including fruit or vegetable juices of heading no. 2009",
  "220291": "Non-alcoholic beverages; non-alcoholic beer",
  "220299":
    "Non-alcoholic beverages; other than non-alcoholic beer, n.e.c. in item no. 2202.10, not including fruit or vegetable juices of heading no. 2009",
  "220300": "Beer made from malt",
  "220410": "Wine; sparkling",
  "220421": "Wine; containers <2l",
  "220422":
    "Wine; still, in containers holding more than 2 litres but not more than 10 litres",
  "220429": "Wine; still, in containers holding more than 10 litres",
  "220430": "Grape must; n.e.c. in heading no. 2009, n.e.c. in item no. 2204.2",
  "220510":
    "Vermouth and other wine of fresh grapes, flavoured with plants or aromatic substances, in containers holding 2 litres or less",
  "220590":
    "Vermouth and other wine of fresh grapes, flavoured with plants or aromatic substances, in containers holding more than 2 litres",
  "220600": "Beverages, fermented; (e.g. cider, perry, mead, sake)",
  "220710":
    "Undenatured ethyl alcohol; of an alcoholic strength by volume of 80% vol. or higher",
  "220720": "Ethyl alcohol and other spirits; denatured, of any strength",
  "220810":
    "Alcoholic preparations; compound, of a kind used for the manufacture of beverages",
  "220820": "Spirits obtained by distilling grape wine or grape marc",
  "220830": "Whiskies",
  "220840":
    "Rum and other spirits obtained by distilling fermented sugar-cane products",
  "220850": "Gin and geneva",
  "220860": "Vodka",
  "220870": "Liqueurs and cordials",
  "220890":
    "Spirits, liqueurs and other spirituous beverages; n.e.c. in heading no. 2208",
  "220900": "Vinegar and substitutes for vinegar; obtained from acetic acid",
  "230110": "Flours, meals and pellets; of meat or meat offal, greaves",
  "230120":
    "Flours, meals and pellets; of fish or of crustaceans, molluscs or other aquatic invertebrates",
  "230210":
    "Bran, sharps and other residues; of maize (corn), whether or not in the form of pellets, derived from the sifting, milling or other workings thereof",
  "230220":
    "Bran, sharps and other residues; of rice, whether or not in the form of pellets, derived from the sifting, milling or other workings thereof",
  "230230":
    "Bran, sharps and other residues; of wheat, whether or not in the form of pellets, derived from the sifting, milling or other workings thereof",
  "230240":
    "Bran, sharps and other residues; of other cereals, whether or not in the form of pellets, derived from the sifting, milling or other workings thereof",
  "230250":
    "Bran, sharps and other residues; of leguminous plants, whether or not in the form of pellets, derived from the sifting, milling or other workings thereof",
  "230310":
    "Residues of starch manufacture and similar residues; whether or not in the form of pellets",
  "230320":
    "Beet-pulp, bagasse and other waste of sugar manufacture; whether or not in the form of pellets",
  "230330":
    "Brewing or distilling dregs and waste; whether or not in the form of pellets",
  "230400": "Soya-bean oil-cake and other solid residues",
  "230500":
    "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of ground-nut oil",
  "230610":
    "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of cotton seed oils",
  "230620":
    "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of linseed oils",
  "230630":
    "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of sunflower seed oils",
  "230640":
    "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of rape or colza seed oils",
  "230641":
    "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of low erucic acid rape or colza seed oils",
  "230649":
    "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of rape seed oils (other than low erucic acid rape or colza)",
  "230650":
    "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of coconut or copra seed oils",
  "230660":
    "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of palm nuts or kernels oils",
  "230670":
    "Oil cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of maize (corn) germ oils",
  "230690":
    "Oil-cake and other solid residues; whether or not ground or in the form of pellets, resulting from the extraction of oils, n.e.c. in heading no. 2306",
  "230700": "Wine lees; argol",
  "230800":
    "Vegetable materials and vegetable waste, vegetable residues and by-products; whether or not in the form of pellets, of a kind used in animal feeding, not elsewhere specified or included",
  "230810":
    "Vegetable materials and vegetable waste, vegetable residues and bi-products; whether or not in the form of pellets, of a kind used in animal feeding, acorns and horse-chestnuts",
  "230890":
    "Vegetable materials and vegetable waste, vegetable residues and bi-products; whether or not in the form of pellets, of a kind used in animal feeding, other than acorns or horse-chestnuts",
  "230910": "Dog or cat food; retail",
  "230990": "Dog or cat food; excl. retail",
  "240110": "Tobacco, (not stemmed or stripped)",
  "240120": "Tobacco; partly of wholly stemmed or stripped",
  "240130": "Tobacco refuse",
  "240210":
    "Cigars, cheroots and cigarillos; containing tobacco including the weight of every band, wrapper or attachment thereto",
  "240220": "Cigarettes containing tobacco",
  "240290":
    "Cigars, cigarillos and cheroots; containing tobacco substitutes including the weight of every band, wrapper or attachment thereto",
  "240310":
    "Tobacco, smoking; whether or not containing tobacco substitutes in any proportion",
  "240311":
    "Tobacco; smoking, water pipe tobacco as specified in Subheading Note 1 to this Chapter, whether or not containing tobacco substitutes in any proportion",
  "240319":
    "Tobacco; smoking, other than water pipe tobacco, whether or not containing tobacco substitutes in any proportion",
  "240391": "Tobacco; homogenised or reconstituted",
  "240399": "Tobacco; other than homogenised or reconstituted or smoking",
  "240411":
    "Products containing tobacco or reconstituted tobacco, intended for inhalation without combustion",
  "240412":
    "Products containing nicotine, other than tobacco or reconstituted tobacco, intended for inhalation without combustion",
  "240419":
    "Products containing tobacco or nicotine substitutes, intended for inhalation without combustion",
  "240491":
    "Products n.e.c. in heading 2404, intended for the intake of nicotine into the human body, for oral application",
  "240492":
    "Products n.e.c. in heading 2404, intended for the intake of nicotine into the human body, for transdermal application",
  "240499":
    "Products n.e.c. in heading 2404, intended for the intake of nicotine into the human body, by ways other than inhalation, and other than oral or transdermal application",
  "250100": "Sodium chloride",
  "250200": "Iron pyrites; unroasted",
  "250300": "Sulphur; excl. sublimed, precipitated, and colloidal",
  "250310": "Sulphur; crude or unrefined",
  "250390":
    "Sulphur; other kinds excluding crude, unrefined, sublimed, precipitated and colloidal",
  "250410": "Graphite; natural, in powder or in flakes",
  "250490": "Graphite; natural, in other forms, excluding powder or flakes",
  "250510": "Sands; natural, silica and quartz sands, whether or not coloured",
  "250590":
    "Sands; natural, (other than silica and quartz sands), whether or not coloured, (other than metal-bearing sands of chapter 26)",
  "250610": "Quartz; other than natural sands",
  "250620":
    "Quartzite; whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
  "250621": "Quartzite; crude or roughly trimmed",
  "250629":
    "Quartzite; cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape, (excluding crude or roughly trimmed)",
  "250700": "Kaolin and other kaolinic clays; whether or not calcined",
  "250810":
    "Clays (excluding expanded clays of heading no. 6806); bentonite, whether or not calcined",
  "250820":
    "Clays (excluding expanded clays of heading no. 6806); decolourising",
  "250830":
    "Clays (excluding expanded clays of heading no. 6806); fireclay, whether or not calcined",
  "250840":
    "Clays (excluding expanded clays of heading no. 6806); n.e.c. in heading no. 2508, whether or not calcined",
  "250850":
    "Clays (excluding expanded clays of heading no. 6806); andalusite, kyanite and sillimanite, whether or not calcined",
  "250860": "Clays (excluding expanded clays of heading no. 6806); mullite",
  "250870":
    "Clays (excluding expanded clays of heading no. 6806); chamotte or dinas earths",
  "250900": "Chalk",
  "251010":
    "Natural calcium phosphates, natural aluminium calcium phosphates and phosphatic chalk; unground",
  "251020":
    "Natural calcium phosphates, natural aluminium calcium phosphates and phosphatic chalk; ground",
  "251110": "Barium sulphate (barytes); natural",
  "251120":
    "Barium carbonate (witherite); natural, whether or not calcined, other than barium oxide of heading no. 2816",
  "251200":
    "Siliceous fossil meals (e.g. kieselguhr, tripolite and diatomite) and similar siliceous earths; whether or not calcined, of an apparent specific gravity of 1 or less",
  "251310": "Pumice stone, whether or not heat treated",
  "251311":
    "Pumice stone; crude or in irregular pieces, including crushed pumice (bimskies), whether or not heat-treated",
  "251319":
    "Pumice stone; in forms other than specified in item no. 2513.11, whether or not heat-treated",
  "251320":
    "Emery, natural corundum, natural garnet and other natural abrasives, whether or not heat-treated",
  "251321":
    "Emery, corundum, garnet and other abrasives; natural, crude or in irregular pieces, whether or not heat-treated",
  "251329":
    "Emery, corundum, garnet and other abrasives; natural, in other forms excluding crude or in irregular pieces, whether or not heat-treated",
  "251400":
    "Slate; whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
  "251511":
    "Marble and travertine; having a specific gravity of 2.5 or more, crude or roughly trimmed by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
  "251512": "Marble and travertine blocks; specific gravity >2.5",
  "251520":
    "Ecaussine and other calcareous monumental or building stone; alabaster, having a specific gravity of 2.5 or more",
  "251611": "Granite; crude or roughly trimmed",
  "251612":
    "Granite; merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
  "251620":
    "Sandstone;. whether or not roughly trimmed, cut, by sawing etc, into blocks or slabs of a rectangular (including square) shape",
  "251621": "Sandstone; crude or roughly trimmed",
  "251622":
    "Sandstone; merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
  "251690":
    "Monumental or building stone; n.e.c. in heading no. 2516, whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape",
  "251710": "Pebbles, gravel, broken or crushed stone",
  "251720":
    "Macadam of slag, dross or similar industrial waste; whether or not incorporating the materials in item no. 2517.10",
  "251730": "Tarred macadam",
  "251741":
    "Stones; of marble, in granules, chippings and powder, whether or not heat-treated",
  "251749":
    "Stones; of heading no. 2515 or 2516 (excluding marble), in granules, chippings and powder, whether or not heat-treated",
  "251810":
    "Dolomite, not calcined or sintered; including dolomite roughly trimmed, or merely cut by sawing or otherwise into blocks or slabs of rectangular (including square) shape",
  "251820":
    "Dolomite, calcined or sintered; including dolomite roughly trimmed, or merely cut by sawing or otherwise into blocks or slabs of rectangular (including square) shape",
  "251830": "Dolomite ramming mix",
  "251910": "Magnesium carbonate (magnesite); natural",
  "251990": "Magnesia; fused or sintered",
  "252010": "Gypsum; anhydrite",
  "252020":
    "Plasters; (consisting of calcined gypsum or calcium sulphate), whether or not coloured, with or without small quantities of accelerators or retarders",
  "252100":
    "Limestone flux; limestone and other calcareous stone, of a kind used for the manufacture of lime or cement",
  "252210":
    "Quicklime; excluding calcium oxide and hydroxide of heading no. 2825",
  "252220":
    "Slaked lime; excluding calcium oxide and hydroxide of heading no. 2825",
  "252230":
    "Hydraulic lime; excluding calcium oxide and hydroxide of heading no. 2825",
  "252310": "Cement clinkers",
  "252321": "Cement; portland, white, whether or not artificially coloured",
  "252329": "Portland cement; excl. white",
  "252330":
    "Cement; aluminous (ciment fondu), whether or not coloured or in the form of clinkers",
  "252390": "Cement; hydraulic kinds n.e.c. in heading no. 2523",
  "252400": "Asbestos",
  "252410": "Asbestos; crocidolite (blue asbestos)",
  "252490": "Asbestos; other than crocidolite (blue asbestos)",
  "252510": "Mica; crude and rifted into sheets or splittings",
  "252520": "Mica; powder",
  "252530": "Mica; waste",
  "252610":
    "Steatite; natural, (not crushed or powdered), whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape; talc",
  "252620":
    "Steatite; natural, crushed, powdered, whether or not roughly trimmed or merely cut, by sawing or otherwise, into blocks or slabs of a rectangular (including square) shape; talc",
  "252700": "Cryolite and chiolite; natural",
  "252800":
    "Natural borates and concentrates thereof (whether or not calcined), but not including borates separated from natural brine; natural boric acid containing not more than 85 % of H3BO3 calculated on the dry weight",
  "252810": "Sodium borates; natural, whether or not calcined",
  "252890":
    "Borates; natural, and concentrates thereof, n.e.c. in heading no. 2528, excluding borates separated from natural brine; natural boric acid containing not more than 85% of H3Bo3 calculated on the dry weight",
  "252910": "Feldspar",
  "252921": "Fluorspar; containing by weight 97% or less of calcium fluoride",
  "252922": "Fluorspar; containing by weight more than 97% of calcium fluoride",
  "252930": "Leucite; nepheline and nepheline syenite",
  "253010": "Vermiculite, perlite and chlorites; unexpanded",
  "253020": "Kieserite, epsomite (natural magnesium sulphates)",
  "253030": "Earth colours",
  "253040": "Natural micaceous iron oxides",
  "253090": "Other salts (exclusionary category)",
  "260111": "Iron ores and concentrates; non-agglomerated",
  "260112": "Iron ores and concentrates; agglomerated",
  "260120": "Iron pyrites; roasted",
  "260200": "Manganese ores and concentrates",
  "260300": "Copper ores and concentrates",
  "260400": "Nickel ores and concentrates",
  "260500": "Cobalt ores and concentrates",
  "260600": "Aluminium ores and concentrates",
  "260700": "Lead ores and concentrates",
  "260800": "Zinc ores and concentrates",
  "260900": "Tin ores and concentrates",
  "261000": "Chromium ores and concentrates",
  "261100": "Tungsten ores and concentrates",
  "261210": "Uranium ores and concentrates",
  "261220": "Thorium ores and concentrates",
  "261310": "Molybdenum ores and concentrates; roasted",
  "261390": "Molybdenum ores and concentrates; not roasted",
  "261400": "Titanium ores and concentrates",
  "261510": "Zirconium ores and concentrates",
  "261590": "Niobium, tantalum, vanadium ores and concentrates",
  "261610": "Silver ores and concentrates",
  "261690": "Precious metal ores and concentrates; excl. silver",
  "261710": "Antimony ores and concentrates",
  "261790": "Ores and concentrates n.e.c. in chapter 26; other than antimony",
  "261800":
    "Slag, granulated (slag sand); from the manufacture or iron or steel",
  "261900":
    "Slag, dross; (other than granulated slag), scalings and other waste from the manufacture of iron or steel",
  "262011":
    "Slag, ash and residues; (not from the manufacture of iron or steel), containing mainly zinc, hard zinc spelter",
  "262019":
    "Slag, ash and residues; (not from the manufacture of iron or steel), containing mainly zinc, other than hard zinc spelter",
  "262020":
    "Ash and residues; (not from the manufacture of iron or steel), containing mainly lead",
  "262021":
    "Slag, ash and residues; (not from the manufacture of iron or steel), containing mainly lead; leaded gasoline sludges and leaded anti-knock compound sludges",
  "262029":
    "Slag, ash and residues; (not from the manufacture of iron or steel), containing mainly lead; excluding leaded gasoline sludges and leaded anti-knock compound sludges",
  "262030":
    "Slag, ash and residues; (not from the manufacture of iron or steel), containing mainly copper",
  "262040":
    "Slag, ash and residues; (not from the manufacture of iron or steel), containing mainly aluminium",
  "262050":
    "Ash and residues; (not from the manufacture of iron or steel), containing mainly vanadium",
  "262060":
    "Slag, ash and residues; (not from the manufacture of iron or steel), containing arsenic, mercury, thallium or their mixtures, of a kind used for the extraction of arsenic or those metals or for the manufacture of their chemical compounds",
  "262090":
    "Ash and residues; (not from the manufacture or iron or steel), containing mainly metals or metal compounds n.e.s. in heading no. 2620",
  "262091":
    "Slag, ash and residues; (not from the manufacture of iron or steel), containing antimony, beryllium, cadmium, chromium or their mixtures",
  "262099":
    "Slag, ash and residues; (not from the manufacture of iron or steel), containing mainly metals or their compounds, n.e.c. in heading no. 2620",
  "262100": "Slag and ash; including seaweed ash (kelp), n.e.s. in chapter 26",
  "262110":
    "Slag and ash; ash and residues from the incineration of municipal waste",
  "262190":
    "Slag and ash n.e.c. in chapter 26; including seaweed ash (kelp) but excluding ash and residues from the incineration of municipal waste",
  "270111": "Coal; anthracite",
  "270112": "Coal; bituminous",
  "270119": "Coal; lower-rank; excl. lignite",
  "270120":
    "Briquettes, ovoids and similar solid fuels; manufactured from coal",
  "270210": "Lignite; not agglomerated",
  "270220": "Lignite; agglomerated, excluding jet",
  "270300": "Peat",
  "270400": "Coke; fuel",
  "270500":
    "Gases; coal, water, producer and similar gases (excluding petroleum and other gaseous hydrocarbons)",
  "270600": "Tar from coal, lignite, peat, or other minerals",
  "270710":
    "Oils and products of the distillation of high temperature coal tar; benzol (benzene)",
  "270720":
    "Oils and products of the distillation of high temperature coal tar; toluol (toluene)",
  "270730":
    "Oils and products of the distillation of high temperature coal tar; xylol (xylenes)",
  "270740":
    "Oils and products of the distillation of high temperature coal tar; naphthalene",
  "270750":
    "Aromatic hydrocarbon mixtures; n.e.c. in heading no. 2707, of which 65% or more by volume (including losses) distils at 250 degrees Celsius by the ISO 3405 method (equivalent to the ASTM D 86 method)",
  "270760":
    "Oils and other products of the distillation of high temperature coal tar; phenols",
  "270791":
    "Oils and other products of the distillation of high temperature coal tar; creosote oils",
  "270799": "Coal tar distillation products (exclusionary category)",
  "270810": "Pitch; obtained from coal tar or from other mineral tars",
  "270820": "Pitch coke; obtained from coal tar or from other mineral tars",
  "270900": "Crude oil",
  "271000": "Refined petroleum products",
  "271011":
    "Petroleum oils and oils from bituminous minerals, not crude or waste oils; preparations n.e.c. with 70% or more (weight), of petroleum oils or oils from bituminous minerals; being the basic constituents of the preparations: light oils and preparations",
  "271012":
    "Refined petroleum; light products, incl. gasoline, naphtha, solvents; not containing biodiesel",
  "271013": "Light petroleum products; excl. aviation or motor fuel",
  "271014": "Motor gasoline",
  "271015": "White spirit **LEGACY NON-WCO CODE**",
  "271016": "Naphtha",
  "271019":
    "Refined petroleum; heavy products, incl. diesel, kerosene; not containing biodiesel",
  "271020": "Refined petroleum; heavy products, containing biodiesel",
  "271021": "Jet fuel",
  "271022": "Kerosene, for furnaces **LEGACY NON-WCO CODE**",
  "271025":
    "Kerosene lamp oil, motor kerosene, light diesel, etc **LEGACY NON-WCO CODE**",
  "271026": "Diesel, light (no. 1 spec)",
  "271027": "Diesel (no.2 spec)",
  "271029": "Fuel oil",
  "271091":
    "Waste Oils; of petroleum or obtained from bituminous minerals, not crude; and preparations n.e.c., weight 70% or preparations of the same, containing polychlorinated biphenyls (PCBs), polychorinated terphenyls (PCTs) or polybrominated biphenyls (PBBs)",
  "271093": "Heavy furnace oil",
  "271094": "Petroleum oil used in road building **LEGACY NON-WCO CODE**",
  "271095": "Lubricants",
  "271096": "Petroleum lubricating greases **LEGACY NON-WCO CODE**",
  "271099":
    "Waste Oils; of petroleum or obtained from bituminous minerals, not crude and preparations n.e.c., weight 70% or preparations of the same, not containing polychlorinated biphenyls (PCBs), polychorinated terphenyls (PCTs) or polybrominated biphenyls (PBBs)",
  "271111": "Natural gas; liquefied",
  "271112": "Propane; liquefied",
  "271113": "Butanes; liquefied",
  "271114": "Ethylene, propylene, butylene, and butadiene; liquefied",
  "271119": "Other liquified gas products",
  "271121": "Natural gas; gaseous state",
  "271129": "Petroleum gases and gaseous hydrocarbons; excl. natural gas",
  "271210": "Petroleum jelly",
  "271220": "Paraffin wax; containing <0.75% oil",
  "271290": "Paraffin wax; containing >0.75% oil",
  "271311": "Petroleum coke; not calcined",
  "271312": "Petroleum coke; calcined",
  "271320": "Petroleum bitumen",
  "271390": "Residues from petroleum and bitumen refinement",
  "271410": "Bituminous or oil shale and tar sands",
  "271490": "Bitumen and asphalt, natural; asphaltites and asphaltic rock",
  "271500":
    "Bituminous mixtures based on natural asphalt, on natural bitumen, on petroleum bitumen, on mineral tar or on mineral tar pitch (e.g. bituminous mastics, cut-backs)",
  "271600": "Electrical energy",
  "280110": "Chlorine",
  "280120": "Iodine",
  "280130": "Fluorine; bromine",
  "280200": "Sulphur; sublimed or precipitated, colloidal sulphur",
  "280300": "Carbon; carbon blacks and other forms of carbon n.e.c.",
  "280410": "Hydrogen",
  "280421": "Gases, rare; argon",
  "280429": "Gases, rare; other than argon",
  "280430": "Nitrogen",
  "280440": "Oxygen",
  "280450": "Boron; tellurium",
  "280461": "Silicon; containing by weight not less than 99.99% of silicon",
  "280469": "Silicon; containing by weight less than 99.99% of silicon",
  "280470": "Phosphorus",
  "280480": "Arsenic",
  "280490": "Selenium",
  "280511": "Alkali or alkali-earth metals; sodium",
  "280512": "Alkali or alkali-earth metals; calcium",
  "280519": "Alkali or alkali-earth metals; other than sodium and calcium",
  "280521": "Alkaline-earth metals; calcium",
  "280522": "Alkaline-earth metals; strontium and barium",
  "280530":
    "Earth-metals, rare; scandium and yttrium, whether or not intermixed or interalloyed",
  "280540": "Mercury",
  "280610": "Hydrogen chloride (hydrochloric acid)",
  "280620": "Chlorosulphuric acid",
  "280700": "Sulphuric acid; oleum",
  "280800": "Nitric acid; sulphonitric acids",
  "280910": "Diphosphorus pentoxide",
  "280920": "Phosphoric acid and polyphosphoric acids",
  "281000": "Oxides of boron; boric acids",
  "281111": "Hydrogen fluoride (hydrofluoric acid)",
  "281112": "Hydrogen cyanide (hydrocyanic acid)",
  "281119": "Inorganic acids; other than hydrogen fluoride",
  "281121": "Carbon dioxide",
  "281122": "Silicon dioxide",
  "281123": "Sulphur dioxide",
  "281129":
    "Inorganic oxygen compounds; of non-metals, n.e.c. in item no. 2811.2",
  "281210": "Chlorides and chloride oxides",
  "281211": "Carbonyl dichloride (phosgene)",
  "281212": "Phosphorus oxychloride",
  "281213": "Phosphorus trichloride",
  "281214": "Phosphorus pentachloride",
  "281215": "Sulphur monochloride",
  "281216": "Sulphur dichloride",
  "281217": "Thionyl chloride",
  "281219":
    "Arsenic trichloride and other chlorides and chloride oxides, n.e.c. in item no. 2812",
  "281290": "Halides and halide oxides of non-metals; excluding chloride",
  "281310": "Carbon disulphide",
  "281390":
    "Sulphides of non-metals, (excluding carbon); commercial phosphorus trisulphide",
  "281410": "Ammonia; anhydrous",
  "281420": "Ammonia; in aqueous solution",
  "281511": "Sodium hydroxide (caustic soda); solid",
  "281512":
    "Sodium hydroxide (caustic soda); in aqueous solution (soda lye or liquid soda)",
  "281520": "Potassium hydroxide (caustic potash)",
  "281530": "Peroxides of sodium or potassium",
  "281610": "Hydroxide and peroxide of magnesium",
  "281620": "Oxide, hydroxide and peroxide of strontium",
  "281630": "Oxide, hydroxide and peroxide of barium",
  "281640": "Oxides, hydroxides and peroxides, of strontium or barium",
  "281700": "Zinc; oxide and peroxide",
  "281810": "Aluminium oxide; artificial corundum",
  "281820": "Aluminium oxide; other than artificial corundum",
  "281830": "Aluminium hydroxide",
  "281910": "Chromium trioxide",
  "281990": "Chromium oxides and hydroxides; excluding chromium trioxide",
  "282010": "Manganese dioxide",
  "282090": "Manganese oxides; excluding manganese dioxide",
  "282110": "Iron oxides and hydroxides",
  "282120":
    "Earth colours; containing 70% or more by weight of combined iron evaluated as Fe2o3",
  "282200": "Cobalt oxides and hydroxides; commercial cobalt oxides",
  "282300": "Titanium oxides",
  "282410": "Lead; lead monoxide (litharge, massicot)",
  "282420": "Lead; red and orange",
  "282490": "Lead oxides; n.e.c. in heading no. 2824",
  "282510": "Hydrazine and hydroxylamine and their inorganic salts",
  "282520": "Lithium oxide and hydroxide",
  "282530": "Vanadium oxides and hydroxides",
  "282540": "Nickel oxides and hydroxides",
  "282550": "Copper oxides and hydroxides",
  "282560": "Germanium oxides and zirconium dioxide",
  "282570": "Molybdenum oxides and hydroxides",
  "282580": "Antimony oxides",
  "282590":
    "Inorganic bases, metal oxides, hydroxides and peroxides; n.e.c. in heading no. 2825",
  "282611": "Fluorides; of ammonium or of sodium",
  "282612": "Fluorides; of aluminium",
  "282619": "Fluorides; other than of aluminium",
  "282620": "Fluorosilicates of sodium or of potassium",
  "282630": "Sodium hexafluoroaluminate (synthetic cryolite)",
  "282690":
    "Fluorides; fluorosilicates, fluoroaluminates and other complex fluorine salts, n.e.c. in heading no. 2826",
  "282710": "Chlorides; of ammonium",
  "282720": "Chlorides; of calcium",
  "282731": "Chlorides; of magnesium",
  "282732": "Chlorides; of aluminium",
  "282733": "Chlorides; of iron",
  "282734": "Chlorides; of cobalt",
  "282735": "Chlorides; of nickel",
  "282736": "Chlorides; of zinc",
  "282737": "Chlorides; of tin",
  "282738": "Chlorides; of barium",
  "282739":
    "Chlorides; other than of ammonium, calcium, magnesium, aluminium and nickel",
  "282741": "Chloride oxides and chloride hydroxides; of copper",
  "282749": "Chloride oxides and chloride hydroxides; other than of copper",
  "282751": "Bromides; of sodium or of potassium",
  "282759": "Bromides and bromide oxides; other than item no. 2827.51",
  "282760": "Iodides and iodide oxides",
  "282810":
    "Hypochlorites; commercial calcium hypochlorite and other calcium hypochlorites",
  "282890": "Hypochlorites; n.e.c. in heading no. 2828",
  "282911": "Chlorates; of sodium",
  "282919": "Chlorates; other than sodium",
  "282990": "Perchlorates; bromates and perbromates; iodates and periodates",
  "283010": "Sulphides; of sodium, whether or not chemically defined",
  "283020": "Sulphides; of zinc",
  "283030": "Sulphides; of cadmium",
  "283090":
    "Sulphides and polysulphides; whether or not chemically defined, other than sulphides of sodium",
  "283110": "Dithionites and sulphoxylates; of sodium",
  "283190": "Dithionites and sulphoxylates; other than sodium",
  "283210": "Sulphites; of sodium",
  "283220": "Sulphites; other than of sodium",
  "283230": "Thiosulphates",
  "283311": "Sodium sulphates; disodium sulphate",
  "283319": "Sodium sulphates; other than disodium sulphate",
  "283321": "Sulphates; of magnesium",
  "283322": "Sulphates; of aluminium",
  "283323": "Sulphates; of chromium",
  "283324": "Sulphates; of nickel",
  "283325": "Sulphates; of copper",
  "283326": "Sulphates; of zinc",
  "283327": "Sulphates; of barium",
  "283329": "Sulphates; n.e.c. in item no. 2833.2",
  "283330": "Alums",
  "283340": "Peroxosulphates (persulphates)",
  "283410": "Nitrites",
  "283421": "Nitrates; of potassium",
  "283422": "Nitrates; of bismuth",
  "283429": "Nitrates; of other than potassium",
  "283510":
    "Phosphinates (hypophosphites) and phosphonates (phosphites), whether or not chemically defined",
  "283521": "Phosphates; of triammonium",
  "283522":
    "Phosphates; of mono- or disodium, whether or not chemically defined",
  "283523": "Phosphates; of trisodium",
  "283524": "Phosphates; of potassium, whether or not chemically defined",
  "283525":
    "Phosphates; calcium hydrogenorthophosphate (dicalcium phosphate), whether or not chemically defined",
  "283526":
    "Phosphates; of calcium n.e.c. in item no. 2835.25, whether or not chemically defined",
  "283529":
    "Phosphates; (other than of mono- or disodium, other than of potassium or of calcium hydrogenorthophosphate (dicalcium phosphate) and excluding other phosphates of calcium), whether or not chemically defined",
  "283531":
    "Polyphosphates; sodium triphosphate (sodium tripolyphosphate), whether or not chemically defined",
  "283539":
    "Polyphosphates; other than sodium triphosphate (sodium tripolyphosphate), whether or not chemically defined",
  "283610":
    "Carbonates; commercial ammonium carbonate and other ammonium carbonates",
  "283620": "Carbonates; disodium carbonate",
  "283630": "Carbonates; sodium hydrogen carbonate (sodium bicarbonate)",
  "283640": "Carbonates; potassium carbonate",
  "283650": "Carbonates; calcium carbonate",
  "283660": "Carbonates; barium carbonate",
  "283670": "Carbonates; lead carbonate",
  "283691": "Carbonates; lithium carbonate",
  "283692": "Carbonates; strontium carbonate",
  "283693": "Carbonates; bismuth carbonate",
  "283699":
    "Carbonates; n.e.c. in heading no. 2836 and other than lithium or strontium",
  "283711": "Cyanides and cyanide oxides; of sodium",
  "283719": "Cyanides and cyanide oxides; other than of sodium",
  "283720": "Complex cyanides",
  "283800": "Fulminates, cyanates and thiocyanates",
  "283911": "Silicates; sodium metasilicates",
  "283919": "Silicates; of sodium (excluding sodium metasilicates)",
  "283920": "Silicates; of potassium",
  "283990":
    "Silicates; commercial alkali metal silicates, other than of sodium",
  "284011": "Borates; disodium tetraborate (refined borax), anhydrous",
  "284019":
    "Borates; disodium tetraborate (refined borax), other than anhydrous",
  "284020": "Borates; n.e.c. in heading no. 2840",
  "284030": "Peroxoborates (perborates)",
  "284110": "Salts; aluminates",
  "284120": "Salts; chromates of zinc or of lead",
  "284130": "Salts; sodium dichromate",
  "284140": "Salts; potassium dichromate",
  "284150":
    "Salts; chromates, dichromates, peroxochromates; n.e.c. in heading no. 2841",
  "284160": "Salts; manganites, manganates and permanganates",
  "284161":
    "Salts; of oxometallic or peroxometallic acids, manganites, manganates and permanganates, potassium permanganate",
  "284169":
    "Salts; of oxometallic or peroxometallic acids, manganites, manganates and permanganates, other than potassium permanganate",
  "284170": "Salts; molybdates",
  "284180": "Salts; tungstates (wolframates)",
  "284190":
    "Salts of oxometallic or peroxometallic acids; n.e.c. in heading no. 2841",
  "284210":
    "Salts of inorganic acids or peroxoacids, double or complex silicates, including aluminosilicates, whether or not chemically defined, excluding azides",
  "284290":
    "Salts; of inorganic acids or peroxoacids, other than double or complex silicates, including aluminosilicates, whether or not chemically, excluding azides",
  "284310": "Colloidal precious metals; whether or not chemically defined",
  "284321": "Silver compounds; silver nitrates",
  "284329": "Silver compounds; excluding silver nitrates",
  "284330": "Gold compounds",
  "284390":
    "Inorganic or organic compounds of precious metals, n.e.c.; amalgams",
  "284410":
    "Uranium; natural uranium and its compounds, alloys, dispersions (including cermets), ceramic products and mixtures containing natural uranium or natural uranium compounds",
  "284420":
    "Uranium; enriched in U235, plutonium, their compounds, alloys dispersions (including cermets), ceramic products and mixtures containing uranium enriched in U235, plutonium or compounds of these products",
  "284430":
    "Uranium; depleted in U235, thorium, their compounds, alloys, dispersions (including cermets), ceramic products and mixtures containing uranium depleted in U235, thorium; compounds of these products",
  "284440":
    "Radioactive elements, isotopes, compounds, n.e.c. in heading no. 2844 alloys, dispersions (including cermets), ceramic products and mixtures containing these elements, isotopes or compounds; radioactive residues",
  "284441":
    "Radioactive elements; tritium and its compounds; alloys, dispersions (including cermets), ceramic products and mixtures containing tritium or its compounds",
  "284442":
    "Radioactive elements; actinium-225, 227, californium-253, curium-240, 241, 242, 243, 244, einsteinium-253, 254, gadolinium-148, polonium-208, 209, 210, radium-223, uranium-230 or 232, compounds; alloys, dispersions, ceramic products and mixtures",
  "284443":
    "Radioactive elements, isotopes and compounds; other alloys, dispersions (including cermets), ceramic products and mixtures containing these elements, isotopes or compounds",
  "284444":
    "Radioactive elements, isotopes, compounds n.e.c. in heading no. 2844, alloys, dispersions (including cermets), ceramic products, mixtures containing the elements, isotopes, compounds; radioactive residues",
  "284450": "Spent (irradiated) fuel elements (cartridges) of nuclear reactors",
  "284510": "Heavy water (deuterium oxide)",
  "284520": "Boron enriched in boron-10 and its compounds",
  "284530": "Lithium enriched in lithium-6 and its compounds",
  "284540": "Helium-3",
  "284590":
    "Isotopes (excluding those of heading no. 2844); compounds, inorganic or organic, of such isotopes, whether or not chemically defined",
  "284610": "Cerium compounds",
  "284690":
    "Compounds, inorganic or organic (excluding cerium), of rare-earth metals, of yttrium, scandium or of mixtures of these metals",
  "284700": "Hydrogen peroxide; whether or not solidified with urea",
  "284800":
    "Phosphides; whether or not chemically defined, excluding ferrophosphorus",
  "284810":
    "Phosphides; of copper (phosphor copper), containing more than 15% by weight of phosphorus, whether or not chemically defined, excluding ferrophosphorus",
  "284890":
    "Phosphides; of metals or non-metals (excluding copper), whether or not chemically defined (excluding ferrophosphorus)",
  "284910": "Carbides; of calcium, whether or not chemically defined",
  "284920": "Carbides; of silicon, whether or not chemically defined",
  "284990":
    "Carbides; whether or not chemically defined, other than of calcium or silicon",
  "285000":
    "Hydrides, nitrides, azides, silicides and borides, whether or not chemically defined, other than compounds which are also carbides of heading no. 2849",
  "285100":
    "Inorganic compounds n.e.s. (including distilled or conductivity water and water of similar purity); liquid air (rare gases removed or not); compressed air; amalgams, other than precious metal amalgams",
  "285200": "Compounds, inorganic or organic, of mercury, excluding amalgams",
  "285210":
    "Inorganic or organic compounds of mercury, excluding amalgams, chemically defined",
  "285290":
    "Inorganic or organic compounds of mercury; excluding amalgams, not chemically defined,",
  "285300":
    "Inorganic compounds n.e.c. (including distilled or conductivity water and water of similar purity); liquid air (rare gases removed or not); compressed air; amalgams, other than precious metal amalgams",
  "285310": "Inorganic compounds; cyanogen chloride (chlorcyan)",
  "285390":
    "Phosphides, chemically defined or not, not ferrophosphorus; other inorganic compounds n.e.c. (including distilled, conductivity water and water of like purity); liquid air, rare gases removed or not; compressed air; amalgams, not precious metal amalgams",
  "290110": "Acyclic hydrocarbons; saturated",
  "290121": "Acyclic hydrocarbons; unsaturated, ethylene",
  "290122": "Acyclic hydrocarbons; unsaturated, propene (propylene)",
  "290123":
    "Acyclic hydrocarbons; unsaturated, butene (butylene) and isomers thereof",
  "290124": "Acyclic hydrocarbons; unsaturated, buta-1,3-diene and isoprene",
  "290129": "Acyclic hydrocarbons; unsaturated, n.e.c. in heading no. 2901",
  "290211": "Cyclic hydrocarbons; cyclohexane",
  "290219":
    "Cyclic hydrocarbons; cyclanes, cyclenes and cycloterpenes, excluding cyclohexane",
  "290220": "Cyclic hydrocarbons; benzene",
  "290230": "Cyclic hydrocarbons; toluene",
  "290241": "Cyclic hydrocarbons; o-xylene",
  "290242": "Cyclic hydrocarbons; m-xylene",
  "290243": "P-xylene",
  "290244": "Cyclic hydrocarbons; mixed xylene isomers",
  "290250": "Cyclic hydrocarbons; styrene",
  "290260": "Cyclic hydrocarbons; ethylbenzene",
  "290270": "Cyclic hydrocarbons; cumene",
  "290290": "Cyclic hydrocarbons; n.e.c. in heading no. 2902",
  "290311":
    "Saturated chlorinated derivatives of acyclic hydrocarbons; chloromethane (methyl chloride) and chloroethane (ethyl chloride)",
  "290312":
    "Saturated chlorinated derivatives of acyclic hydrocarbons; dichloromethane (methylene chloride)",
  "290313":
    "Saturated chlorinated derivatives of acyclic hydrocarbons; chloroform (trichloromethane)",
  "290314":
    "Saturated chlorinated derivatives of acyclic hydrocarbons; carbon tetrachloride",
  "290315":
    "Saturated chlorinated derivatives of acyclic hydrocarbons; ethylene dichloride (ISO) (1,2-dichloroethane)",
  "290316":
    "Saturated chlorinated derivatives of acyclic hydrocarbons; 1,2-dichloropropane (propylene dichloride) and dichlorobutanes",
  "290319":
    "Saturated chlorinated derivatives of acyclic hydrocarbons; n.e.c. in item no. 2903.1",
  "290321":
    "Unsaturated chlorinated derivatives of acyclic hydrocarbons; vinyl chloride (chloroethylene)",
  "290322":
    "Unsaturated chlorinated derivatives of acyclic hydrocarbons; trichloroethylene",
  "290323":
    "Unsaturated chlorinated derivatives of acyclic hydrocarbons; tetrachloroethylene (perchloroethylene)",
  "290329":
    "Unsaturated chlorinated derivatives of acyclic hydrocarbons; n.e.c. in item no. 2903.2",
  "290330":
    "Fluorinated, brominated or iodinated derivatives of acyclic hydrocarbons",
  "290331":
    "Fluorinated, brominated or iodinated derivatives of acyclic hydrocarbons; ethylene dibromide (ISO) (1,2-dibromoethane)",
  "290339":
    "Fluorinated, brominated or iodinated derivatives of acyclic hydrocarbons; other than ethylene dibromide (ISO) (1,2-dibromoethane)",
  "290340":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens",
  "290341":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; trichlorofluoromethane (CFC-11)",
  "290342":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; dichlorodifluoromethane (CFC-12)",
  "290343":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; trichlorotrifluoroethanes (CFC-113)",
  "290344":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; dichlorotetrafluoroethanes and chloropentafluoroethane",
  "290345":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; perhalogenated only with fluorine and chlorine, n.e.c. in item no. 2903.4",
  "290346":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; bromochlorodifluoromethane, bromotrifluoromethane and dibromotetrafluoroethanes",
  "290347":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; perhalogenated derivatives n.e.c. in item no. 2903.41 to 2903.46",
  "290348":
    "Saturated fluorinated derivatives of acyclic hydrocarbons; 1,1,1,3,3-pentafluorobutane (HFC-365mfc) and 1,1,1,2,2,3,4,5,5,5-decafluoropentane (HFC-43-10mee)",
  "290349":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; n.e.c. in item no. 2903.4",
  "290351":
    "Halogenated derivatives of cyclanic, cyclenic or cycloterpenic hydrocarbons; 1,2,3,4,5,6-hexachlorocyclohexane (HCH (ISO)), including lindane (ISO, INN)",
  "290352":
    "Halogenated derivatives of cyclanic, cyclenic or cycloterpenic hydrocarbons; aldrin (ISO), chlordane (ISO) and heptachlor (ISO)",
  "290359":
    "Halogenated derivatives of cyclanic, cyclenic, or cycloterpenic hydrocarbons; n.e.c. in item no. 2903.5",
  "290361":
    "Halogenated derivatives of aromatic hydrocarbons; chlorobenzene, o-dichlorobenzene and p-dichlorobenzene",
  "290362":
    "Halogenated derivatives of aromatic hydrocarbons; hexachlorobenzene (ISO) and DDT (ISO) (clofenotane (INN), 1,1,1-trichloro-2,2-bis(p-chlorophenyl)ethane)",
  "290369":
    "Halogenated derivatives of aromatic hydrocarbons; n.e.c. in item no. 2903.6",
  "290371":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; chlorodifluoromethane",
  "290372":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; dichlorotrifluoroethane",
  "290373":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; dichlorofluoroethanes",
  "290374":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; chlorodifluoroethanes",
  "290375":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; dichloropentafluoropropanes",
  "290376":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; bromochlorodifluoromethane, bromotrifluoromethane, and dibromotetrafluoroethanes",
  "290377":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; n.e.c. in headings 290371 to 290376, perhalogenated only with fluorine and chlorine",
  "290378":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; perhalogenated derivatives, other than those only with fluorine and chlorine, n.e.c. in item no. 2903.71 to 2903.76",
  "290379":
    "Halogenated derivatives of acyclic hydrocarbons containing two or more different halogens; n.e.c. in item no. 2903.7",
  "290381":
    "Halogenated derivatives of cyclanic, cyclenic or cycloterpenic hydrocarbons; 1,2,3,4,5,6-Hexachlorocyclohexane (HCH (ISO)), including lindane (ISO, INN)",
  "290382":
    "Halogenated derivatives of cyclanic, cyclenic or cycloterpenic hydrocarbons; aldrin (ISO), chlordane (ISO), and heptachlor (ISO)",
  "290383":
    "Halogenated derivatives of cyclanic, cyclenic or cycloterpenic hydrocarbons; mirex (ISO)",
  "290389":
    "Halogenated derivatives of cyclanic, cyclenic or cycloterpenic hydrocarbons; n.e.c. in item no. 2903.8",
  "290391":
    "Halogenated derivatives of aromatic hydrocarbons; chlorobenzene, o-dichlorobenzene, and p-dichlorobenzene",
  "290392":
    "Halogenated derivatives of aromatic hydrocarbons; hexachlorobenzene (ISO) and DDT (ISO) (clofenotane (INN), and 1,1,1-trichloro-2,2-bis(p-chlorophenyl)ethane)",
  "290393":
    "Halogenated derivatives of aromatic hydrocarbons; pentachlorobenzene (ISO)",
  "290394":
    "Halogenated derivatives of aromatic hydrocarbons; hexabromobiphenyls",
  "290399":
    "Halogenated derivatives of aromatic hydrocarbons; n.e.c. in item no. 2903.91, 2903.92, 2903.93 and 2903.94",
  "290410":
    "Derivatives of hydrocarbons; containing only sulpho groups, their salts and ethyl esters, whether or not halogenated",
  "290420":
    "Derivatives of hydrocarbons; containing only nitro or only nitroso groups, whether or not halogenated",
  "290431":
    "Derivatives of hydrocarbons; perfluorooctane sulphonic acid, whether or not halogenated",
  "290432":
    "Derivatives of hydrocarbons; ammonium perfluorooctane sulphonate, whether or not halogenated",
  "290433":
    "Derivatives of hydrocarbons; lithium perfluorooctane sulphonate, whether or not halogenated",
  "290434":
    "Derivatives of hydrocarbons; potassium perfluorooctane sulphonate, whether or not halogenated",
  "290435":
    "Derivatives of hydrocarbons; salts of perfluorooctane sulphonic acid n.e.c in heading no. 2904, whether or not halogenated",
  "290436":
    "Derivatives of hydrocarbons; perfluorooctane sulphonyl fluoride, whether or not halogenated",
  "290490":
    "Derivatives of hydrocarbons; n.e.c. in heading no. 2904, whether or not halogenated",
  "290491":
    "Derivatives of hydrocarbons; trichloronitromethane (chloropicrin), whether or not halogenated",
  "290499":
    "Derivatives of hydrocarbons n.e.c. in heading no. 2904, whether or not halogenated",
  "290511": "Methyl alcohol",
  "290512":
    "Alcohols; saturated monohydric, propan-1-ol (propyl alcohol) and propan-2-ol (isopropyl alcohol)",
  "290513": "Alcohols; saturated monohydric, butan-1-ol (n-butyl alcohol)",
  "290514":
    "Alcohols; saturated monohydric, butanols excluding item no. 2905.13",
  "290515":
    "Alcohols; saturated monohydric, pentanol (amyl alcohol) and isomers thereof",
  "290516":
    "Alcohols; saturated monohydric, octanol (octyl alcohol) and isomers thereof",
  "290517":
    "Alcohols; saturated monohydric, dodecan-1-ol (lauryl alcohol), hexadecan-1-ol (cetyl alcohol) and octadecan-1-ol (stearyl alcohol)",
  "290519": "Alcohols; saturated monohydric, n.e.c. in item no. 2905.1",
  "290521": "Alcohols; unsaturated monohydric, allyl alcohol",
  "290522": "Alcohols; unsaturated monohydric, acyclic terpene alcohols",
  "290529":
    "Alcohols; acyclic, unsaturated monohydric, (other than acyclic terpene alcohols)",
  "290531": "Alcohols; acyclic, diols; ethylene glycol (ethanediol)",
  "290532": "Alcohols; acyclic, diols; propylene glycol (propane-1, 2-diol)",
  "290539":
    "Alcohols; acyclic, diols, other than ethylene glycol (ethandiol) or propylene glycol (propane-1,2-diol)",
  "290541":
    "Alcohols; polyhydric, 2-ethyl-2- (hydroxymethyl) propane-1,3-diol (trimethylolpropane)",
  "290542": "Alcohols; polyhydric, pentaerythritol",
  "290543": "Alcohols; polyhydric, mannitol",
  "290544": "Alcohols; polyhydric, d-glucitol (sorbitol)",
  "290545": "Alcohols; polyhydric, glycerol",
  "290549": "Alcohols; polyhydric, n.e.c. in item no. 2905.4",
  "290550":
    "Alcohols; acyclic; halogenated, sulphonated, nitrated or nitrosated derivatives thereof",
  "290551":
    "Alcohols; acyclic; halogenated, sulphonated, nitrated or nitrosated derivatives thereof, ethchlorvynol (INN)",
  "290559":
    "Alcohols; acyclic; halogenated, sulphonated, nitrated or nitrosated derivatives thereof, other than ethchlorvynol (INN)",
  "290611":
    "Alcohols; cyclanic, cyclenic or cycloterpenic and derivatives, menthol",
  "290612":
    "Alcohols; cyclanic, cyclenic or cycloterpenic and derivatives, cyclohexanol, methylcyclohexanols and dimethylcyclohexanols",
  "290613":
    "Alcohols; cyclanic, cyclenic or cycloterpenic and derivatives, sterols and inositols",
  "290614":
    "Alcohols; cyclanic, cyclenic or cycloterpenic and derivatives, terpineols",
  "290619":
    "Alcohols; cyclanic, cyclenic or cycloterpenic and derivatives, n.e.c. in item no. 2906.1",
  "290621": "Alcohols; aromatic alcohols and derivatives, benzyl alcohol",
  "290629": "Alcohols; aromatic and derivatives, other than benzyl alcohol",
  "290711": "Monophenols; phenol (hydroxybenzene) and its salts",
  "290712": "Monophenols; cresols and their salts",
  "290713":
    "Monophenols; octylphenol, nonylphenol and their isomers, salts thereof",
  "290714": "Monophenols; xylenols and their salts",
  "290715": "Monophenols; naphthols and their salts",
  "290719": "Monophenols; n.e.c. in item no. 2907.1",
  "290721": "Polyphenols; resorcinol and its salts",
  "290722": "Polyphenols; hydroquinone (quinol) and its salts",
  "290723":
    "Polyphenols; 4,4'-isopropylidenediphenol (bisphenol A, diphenylolpropane) and its salts",
  "290729": "Phenol-alcohols and polyphenols n.e.c. in item number 2907.2",
  "290730": "Phenol-alcohols",
  "290810":
    "Phenol or phenol-alcohol derivatives; containing only halogen substituents and their salts",
  "290811":
    "Phenol or phenol-alcohol derivatives containing only halogen substituents and their salts; pentachlorophenol (ISO)",
  "290819":
    "Phenol or phenol-alcohol derivatives containing only halogen substituents and their salts; other than pentachlorophenol (ISO)",
  "290820":
    "Phenol or phenol-alcohol derivatives; containing only sulpho groups, their salts and esters",
  "290890":
    "Phenol or phenol-alcohol derivatives; containing only nitrated or nitrosated groups, their salts and esters",
  "290891":
    "Phenol or phenol-alcohol derivatives, sulphonated, nitrated or nitrosated derivatives thereof; dinoseb (ISO) and its salts",
  "290892":
    "Phenol or phenol-alcohol derivatives, sulphonated, nitrated or nitrosated derivatives thereof; 4,6-dinitro-o-cresol (DNOC (ISO)) and its salts",
  "290899":
    "Phenol or phenol-alcohol derivatives, sulphonated, nitrated or nitrosated derivatives thereof; other than dinoseb (ISO), and 4,6-dinitro-o-cresol (DNOC (ISO)), and their salts",
  "290911":
    "Ethers; acyclic, and their halogenated, sulphonated, nitrated or nitrosated derivatives, diethyl ether",
  "290919":
    "Ethers; acyclic, and their halogenated, sulphonated, nitrated or nitrosated derivatives, other than diethyl ether",
  "290920":
    "Ethers; cyclanic, cyclenic or cycloterpenic and their halogenated, sulphonated, nitrated or nitrosated derivatives",
  "290930":
    "Ethers; aromatic, and their halogenated, sulphonated, nitrated or nitrosated derivatives",
  "290941":
    "Ether-alcohols and their halogenated, sulphonated, nitrated or nitrosated derivatives; 2,2-oxydiethanol (diethylene glycol, digol)",
  "290942":
    "Ether-alcohols and their halogenated, sulphonated, nitrated or nitrosated derivatives; monomethyl ethers of ethylene glycol or of diethylene glycol",
  "290943":
    "Ether-alcohols and their halogenated, sulphonated, nitrated or nitrosated derivatives; monobutyl ethers of ethylene glycol or of diethylene glycol",
  "290944":
    "Ether-alcohols and their halogenated, sulphonated, nitrated or nitrosated derivatives; monoalkylethers of ethylene glycol or of diethylene glycol n.e.c. in heading no. 2909",
  "290949":
    "Ether-alcohols and their halogenated, sulphonated, nitrated or nitrosated derivatives; n.e.c. in item no. 2909.4",
  "290950":
    "Ether-phenols, ether-alcohol-phenols and their halogenated, sulphonated, nitrated or nitrosated derivatives",
  "290960":
    "Alcohol peroxides, ether peroxides, ketone peroxides and their halogenated, sulphonated, nitrated or nitrosated derivatives",
  "291010":
    "Epoxides, epoxyalcohols, epoxyphenols and epoxyethers; with a three-membered ring and their halogenated, sulphonated, nitrated or nitrosated derivatives; oxirane (ethylene oxide)",
  "291020":
    "Epoxides, epoxyalcohols, epoxyphenols and epoxyethers; with a three-membered ring and their halogenated, sulphonated, nitrated or nitrosated derivatives, methyloxirane (propylene oxide)",
  "291030":
    "Epoxides, epoxyalcohols, epoxyphenols and epoxyethers; with a three-membered ring and their halogenated, sulphonated, nitrated or nitrosated derivatives, 1-chloro-2,3-epoxypropane (epichlorohydrin)",
  "291040":
    "Epoxides, epoxyalcohols, epoxyphenols and epoxyethers; with a three-membered ring and their halogenated, sulphonated, nitrated or nitrosated derivatives, dieldrin (ISO, INN)",
  "291050":
    "Epoxides, epoxyalcohols, epoxyphenols and epoxyethers; with a three-membered ring and their halogenated, sulphonated, nitrated or nitrosated derivatives, endrin (ISO)",
  "291090":
    "Epoxides, epoxyalcohols, epoxyphenols and epoxyethers; with a three-membered ring and their halogenated, sulphonated, nitrated or nitrosated derivatives, n.e.c. in heading no. 2910",
  "291100":
    "Acetals and hemiacetals; whether or not with other oxygen function, and their halogenated, sulphonated, nitrated or nitrosated derivatives",
  "291211":
    "Aldehydes; acyclic, without other oxygen function, methanal (formaldehyde)",
  "291212":
    "Aldehydes; acyclic, without other oxygen function, ethanal (acetaldehyde)",
  "291213":
    "Aldehydes; acyclic, without other oxygen function, butanal (butyraldehyde, normal isomer)",
  "291219":
    "Aldehydes; acyclic, without other oxygen function, n.e.c. in item no. 2912.1",
  "291221": "Aldehydes; cyclic, without other oxygen function, benzaldehyde",
  "291229":
    "Aldehydes; cyclic, without other oxygen function, other than benzaldehyde",
  "291230": "Aldehyde-alcohols",
  "291241":
    "Aldehydes; aldehyde-ethers, aldehyde-phenols and aldehydes with other oxygen function, vanillin (4-hydroxy-3-methoxybenzaldehyde)",
  "291242":
    "Aldehydes; aldehyde-ethers, aldehyde-phenols and aldehydes with other oxygen function, ethylvanillin (3-ethoxy-4-hydroxybenzaldehyde)",
  "291249":
    "Aldehyde-alcohols, aldehyde-ethers, aldehyde-phenols and aldehydes with other oxygen function; other than vanillin (4-hydroxy-3-methoxybenzaldehyde) and ethylvanillin (3-ethoxy-4-hydroxybenzaldehyde)",
  "291250": "Aldehydes; cyclic polymers of aldehydes",
  "291260": "Paraformaldehyde",
  "291300":
    "Aldehydes; halogenated, sulphonated, nitrated or nitrosated derivatives of products of heading no. 2912",
  "291411": "Ketones; acyclic, without other oxygen function, acetone",
  "291412":
    "Ketones; acyclic, without other oxygen function, butanone (methyl ethyl ketone)",
  "291413":
    "Ketones; acyclic, without other oxygen function, 4-methylpentan-2-one (methyl isobutyl ketone)",
  "291419":
    "Ketones; acyclic, without other oxygen function, n.e.c. in item no. 2914.1",
  "291421":
    "Ketones; cyclanic, cyclenic or cycloterpenic, without other oxygen function, camphor",
  "291422":
    "Ketones; cyclanic, cyclenic or cycloterpenic, without other oxygen function, cyclohexanone and methylcyclohexanones",
  "291423":
    "Ketones; cyclanic, cyclenic or cycloterpenic, without other oxygen function, ionones and methylionones",
  "291429":
    "Ketones; cyclanic, cyclenic or cycloterpenic, without other oxygen function, other than cyclohexanone, methylcyclohexanones, ionones, and methylionones",
  "291430": "Ketones; aromatic, without other oxygen function",
  "291431":
    "Ketones; aromatic, (without other oxygen function), phenylacetone (phenylpropan-2-one)",
  "291439":
    "Ketones; aromatic, (without other oxygen function), excluding phenylacetone (phenylpropan-2-one)",
  "291440": "Ketone-alcohols and ketone-aldehydes",
  "291441":
    "Ketone-alcohols and ketone-aldehydes; 4- hydroxy-4-methylpentan-2-one (diacetone alcohol)",
  "291449": "Ketone-alcohols and ketone-aldehydes; n.e.s. in item no. 2914.41",
  "291450": "Ketone-phenols and ketones with other oxygen function",
  "291461": "Quinones; anthraquinone",
  "291462": "Quinones; coenzyme Q10 (ubidecarenone (INN))",
  "291469":
    "Quinones; other than anthraquinone and coenzyme Q10 (ubidecarenone (INN))",
  "291470":
    "Ketones and quinones; halogenated, sulphonated, nitrated or nitrosated derivatives",
  "291471":
    "Ketones and quinones; halogenated, sulphonated, nitrated or nitrosated derivatives; chlordecone (ISO)",
  "291479":
    "Ketones and quinones; halogenated, sulphonated, nitrated or nitrosated derivatives, other than chlordecone (ISO)",
  "291511": "Acids; saturated acyclic monocarboxylic acids; formic acid",
  "291512":
    "Acids; saturated acyclic monocarboxylic acids; salts of formic acids",
  "291513":
    "Acids; saturated acyclic monocarboxylic acids; esters of formic acid",
  "291521": "Acids; saturated acyclic monocarboxylic acids; acetic acid",
  "291522": "Acids; saturated acyclic monocarboxylic acids; sodium acetate",
  "291523": "Acids; saturated acyclic monocarboxylic acids; cobalt acetates",
  "291524": "Acids; saturated acyclic monocarboxylic acids; acetic anhydride",
  "291529":
    "Acids; saturated acyclic monocarboxylic acids; acetic acid and its salts n.e.c. in item no. 2915.2",
  "291531": "Acids; saturated acyclic monocarboxylic acids; ethyl acetate",
  "291532": "Acids; saturated acyclic monocarboxylic acids; vinyl acetate",
  "291533": "Acids; saturated acyclic monocarboxylic acids; n-butyl acetate",
  "291534": "Acids; saturated acyclic monocarboxylic acids; isobutyl acetate",
  "291535":
    "Acids; saturated acyclic monocarboxylic acids; 2-ethoxyethyl acetate",
  "291536":
    "Acids; saturated acyclic monocarboxylic acids; dinoseb (ISO) acetate",
  "291539":
    "Acids; saturated acyclic monocarboxylic acids; esters of acetic acid n.e.c. in item no. 2915.3",
  "291540":
    "Acids; saturated acyclic monocarboxylic acids; mono-, di- or trichloroacetic acids, their salts and esters",
  "291550":
    "Acids; saturated acyclic monocarboxylic acids; propionic acid, its salts and esters",
  "291560":
    "Acids; saturated acyclic monocarboxylic acids; butanoic acids, pentanoic acids, their salts and esters",
  "291570":
    "Acids; saturated acyclic monocarboxylic acids; palmitic acid, stearic acid, their salts and esters",
  "291590":
    "Acids; saturated acyclic monocarboxylic acids; anhydrides, halides, peroxides, peroxyacids and halogenated, sulphonated, nitrated or nitrosated derivatives, n.e.c. in heading no. 2915",
  "291611":
    "Acids; unsaturated acyclic monocarboxylic acids; acrylic acid and its salts",
  "291612":
    "Acids; unsaturated acyclic monocarboxylic acids; esters of acrylic acid",
  "291613":
    "Acids; unsaturated acyclic monocarboxylic acids; methacrylic acid and its salts",
  "291614":
    "Acids; unsaturated acyclic monocarboxylic acids; esters of methacrylic acid",
  "291615":
    "Acids; unsaturated acyclic monocarboxylic acids; oleic, linoleic or linolenic acids, their salts and esters",
  "291616":
    "Acids; unsaturated acyclic monocarboxylic, cyclic monocarboxylic, their anhydrides, halides, peroxides and peroxyacids; their halogenated, sulphonated, nitrated or nitrosated derivatives, binapacryl (ISO)",
  "291619":
    "Acids; unsaturated acyclic monocarboxylic, cyclic monocarboxylic, their anhydrides, halides, peroxides and peroxyacids; their halogenated, sulphonated, nitrated or nitrosated derivatives, n.e.c. in item no. 2916.1",
  "291620":
    "Acids; cyclanic, cyclenic or cycloterpenic monocarboxylic acids, their anhydrides, halides, peroxides, peroxyacids and their derivatives",
  "291631":
    "Acids; aromatic monocarboxylic acids, benzoic acid, its salts and esters",
  "291632":
    "Acids; aromatic monocarboxylic acids, benzoyl peroxide and benzoyl chloride",
  "291633":
    "Acids; aromatic monocarboxylic acids; phenylacetic acid, its salts and esters",
  "291634":
    "Acids; aromatic monocarboxylic acids, phenylacetic acid and its salts",
  "291635": "Acids; aromatic monocarboxylic acids, esters of phenylacetic acid",
  "291636": "Acids; aromatic monocarboxylic acids, binapacryl (ISO)",
  "291639":
    "Acids; aromatic monocarboxylic acids, and their anhydrides, halides, peroxides, peroxyacids and their derivatives, other than benzoic acid, its salts and esters, benzoyl peroxide and benzoyl chloride, phenylacetic acid and its salts",
  "291711":
    "Acids; acyclic polycarboxylic acids; oxalic acid, its salts and esters",
  "291712":
    "Acids; acyclic polycarboxylic acids; adipic acid, its salts and esters",
  "291713":
    "Acids; acyclic polycarboxylic acids; azelaic acid, sebacic acid, their salts and esters",
  "291714": "Acids; acyclic polycarboxylic acids; maleic anhydride",
  "291719": "Acids; acyclic polycarboxylic acids; n.e.c. in item no. 2917.1",
  "291720":
    "Acids; cyclanic, cyclenic or cycloterpenic polycarboxylic acids, their anhydrides, halides, peroxides, peroxyacids and derivatives",
  "291731": "Acids; aromatic polycarboxylic acids; dibutyl orthophthalates",
  "291732": "Acids; aromatic polycarboxylic acids; dioctyl orthophthalates",
  "291733":
    "Acids; aromatic polycarboxylic acids; dinonyl or didecyl orthophthalates",
  "291734":
    "Acids; aromatic polycarboxylic acids; other esters of orthophthalic acids",
  "291735": "Acids; aromatic polycarboxylic acids; phthalic anhydride",
  "291736":
    "Acids; aromatic polycarboxylic acids; terephthalic acid and its salts",
  "291737": "Acids; aromatic polycarboxylic acids; dimethyl terephthalate",
  "291739": "Acids; aromatic polycarboxylic acids; n.e.c. in item no. 2917.3",
  "291811":
    "Acids; carboxylic acids, (with alcohol function but without other oxygen function), lactic acid, its salts and esters",
  "291812":
    "Acids; carboxylic acids, (with alcohol function but without other oxygen function), tartaric acid",
  "291813":
    "Acids; carboxylic acids, (with alcohol function but without other oxygen function); salts and esters of tartaric acid",
  "291814":
    "Acids; carboxylic acids, (with alcohol function but without other oxygen function), citric acid",
  "291815":
    "Acids; carboxylic acids, (with alcohol function but without other oxygen function), salts and esters of citric acid",
  "291816":
    "Acids; carboxylic acids, (with alcohol function but without other oxygen function), gluconic acid, its salts and esters",
  "291817":
    "Acids; carboxylic acids, (with alcohol function but without other oxygen function), 2,2-Diphenyl-2-hydroxyacetic acid (benzilic acid)",
  "291818":
    "Acids; carboxylic acids, (with alcohol function but without other oxygen function), chlorobenzilate (ISO)",
  "291819":
    "Acids; carboxylic acids, (with alcohol function but without other oxygen function), other than lactic, tartaric, citric, and gluconic acids and their salts and esters",
  "291821":
    "Acids; carboxylic acids, (with phenol function but without other oxygen function), salicylic acid and its salts",
  "291822":
    "Acids; carboxylic acids, (with phenol function but without other oxygen function), o-acetylsalicylic acid, its salts and esters",
  "291823":
    "Acids; carboxylic acids, (with phenol function but without other oxygen function), other esters of salicylic acid and its salts n.e.c. in item no. 2918.2",
  "291829":
    "Acids; carboxylic acids, (with phenol function but without other oxygen function), their anhydrides, halides, peroxides, peroxyacids and their derivatives, n.e.c. in item no. 2918.2",
  "291830":
    "Acids; carboxylic acids, (with aldehyde or ketone function but without other oxygen function), their anhydrides, halides, peroxides, peroxyacids and their derivatives",
  "291890":
    "Acids; carboxylic acids, with additional oxygen function and their anhydrides, halides, peroxides and peroxyacids, n.e.s. in heading no. 2918",
  "291891":
    "Acids; carboxylic acids, with additional oxygen function (not alcohol, phenol, aldehyde or ketone) and their anhydrides, halides, peroxides and peroxyacids; 2,4,5-T (ISO) (2,4,5-trichlorophenoxyacetic acid), its salts and esters",
  "291899":
    "Acids; carboxylic acids, with additional oxygen function (not alcohol, phenol, aldehyde or ketone) and their anhydrides, halides, peroxides and peroxyacids; their halogenated, sulphonated, nitrated or nitrosated derivatives; other than 2,4,5-T (ISO)",
  "291900":
    "Esters; phosphoric, and their salts, including lactophosphates, their halogenated, sulphonated, nitrated or nitrosated derivatives",
  "291910":
    "Esters; phosphoric, and their salts, including lactophosphates, their halogenated, sulphonated, nitrated or nitrosated derivatives; tris(2,3-dibromopropyl) phosphate",
  "291990":
    "Esters; phosphoric, and their salts, including lactophosphates, their halogenated, sulphonated, nitrated or nitrosated derivatives; other than tris(2,3-dibromopropyl) phosphate",
  "292010":
    "Esters; thiophosphoric (phosphorothioates) and their salts; their halogenated, sulphonated, nitrated or nitrosated derivatives",
  "292011":
    "Esters; thiophosphoric esters (phosphorothioates) and their salts, their halogenated, sulphonated, nitrated or nitrosated derivatives, parathion (ISO) and parathion-methyl (ISO) (methyl-parathion)",
  "292019":
    "Esters; thiophosphoric esters (phosphorothioates) and their salts; other than parathion (ISO) and parathion-methyl (ISO) (methyl-parathion)",
  "292021":
    "Esters; phosphite esters and their salts; their halogenated, sulphonated, nitrated or nitrosated derivatives, dimethyl phosphite",
  "292022":
    "Esters; phosphite esters and their salts; their halogenated, sulphonated, nitrated or nitrosated derivatives, diethyl phosphite",
  "292023":
    "Esters; phosphite esters and their salts; their halogenated, sulphonated, nitrated or nitrosated derivatives, trimethyl phosphite",
  "292024":
    "Esters; phosphite esters and their salts; their halogenated, sulphonated, nitrated or nitrosated derivatives, triethyl phosphite",
  "292029":
    "Esters; phosphite esters and their salts; their halogenated, sulphonated, nitrated or nitrosated derivatives, n.e.c. in heading no. 2920",
  "292030":
    "Esters; of other inorganic acids of non-metals (excluding esters of hydrogen halides) and their salts; their halogenated, sulphonated, nitrated or nitrosated derivatives, endosulfan (ISO)",
  "292090":
    "Esters; other than thiophosphoric esters (phosphorothioates) and phosphite esters and their salts, their halogenated, sulphonated, nitrated or nitrosated derivatives, n.e.c. in heading no. 2920",
  "292111":
    "Amine-function compounds; acyclic monoamines and their derivatives, methylamine, di- or trimethylamine and their salts",
  "292112":
    "Amine-function compounds; acyclic monoamines and their derivatives, and salts thereof, 2-(N,N-Dimethylamino)ethylchloride hydrochloride",
  "292113":
    "Amine-function compounds; acyclic monoamines and their derivatives, and salts thereof, 2-(N,N-Diethylamino)ethylchloride hydrochloride",
  "292114":
    "Amine-function compounds; acyclic monoamines and their derivatives, and salts thereof, 2-(N,N-Diisopropylamino)ethylchloride hydrochloride",
  "292119":
    "Amine-function compounds; acyclic monoamines and their derivatives, and salts thereof, n.e.c. in item no. 2921.1",
  "292121":
    "Amine-function compounds; acyclic polyamines and their derivatives, ethylenediamine and its salts",
  "292122":
    "Amine-function compounds; acyclic polyamines and their derivatives, hexamethylenediamine and its salts",
  "292129":
    "Amine-function compounds; acyclic polyamines and their derivatives, and salts thereof, n.e.c. in item no. 2921.2",
  "292130":
    "Amine-function compounds; cyclanic, cyclenic or cycloterpenic mono- or polyamines and their derivatives; salts thereof",
  "292141":
    "Amine-function compounds; aromatic monoamines and their derivatives, aniline and its salts",
  "292142":
    "Amine-function-compounds; aromatic monoamines and their derivatives, aniline derivatives and their salts",
  "292143":
    "Amine-function compounds; aromatic monoamines and their derivatives, toluidines and their derivatives; salts thereof",
  "292144":
    "Amine-function compounds; aromatic monoamines and their derivatives, diphenylamine and its derivatives; salts thereof",
  "292145":
    "Amine-function compounds; aromatic monoamines and their derivatives; 1-naphthylamine (alpha-naphthylamine), 2-naphthylamine (beta-naphthaylamine) and their derivatives; salts thereof",
  "292146":
    "Amine-function compounds; aromatic monoamines and derivatives; amphetamine (INN), benzphetamine (INN), dexamphetamine (INN), etilamphetamine (INN), fencamfamin (INN), lefetamine (INN), levamphetamine (INN), mefenorex (INN), phentermine (INN); salts of",
  "292149":
    "Amine-function compounds; aromatic monoamines and their derivatives; salts thereof; n.e.c. in item no. 2921.4",
  "292151":
    "Amine-function compounds; aromatic amines and their derivatives; o-, m-, p-phenylenediamine, diaminotoluenes and their derivatives; salts thereof",
  "292159":
    "Amine-function compounds; aromatic polyamines and their derivatives, other than item no. 2921.51",
  "292211":
    "Amino-alcohols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof, monoethanolamine and its salts",
  "292212":
    "Amino-alcohols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof, diethanolamine and its salts",
  "292213":
    "Amino-alcohols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof, triethanolamine and its salts",
  "292214":
    "Amino-alcohols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof; dextropropoxyphene (INN) and its salts",
  "292215":
    "Amino-alcohols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof, triethanolamine",
  "292216":
    "Amino-alcohols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof, Diethanolammonium perfluorooctane sulphonate",
  "292217":
    "Amino-alcohols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof, Methyldiethanolamine and ethyldiethanolamine",
  "292218":
    "Amino-alcohols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof, 2-(N,N- Diisopropylamino)ethanol",
  "292219":
    "Amino-alcohols, other than those containing more than one kind of oxygen function, their ethers and esters; salts thereof, n.e.c. in item no. 2922.1",
  "292221":
    "Amino-naphthols and other amino-phenols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof, aminohydroxynaphthalenesulphonic acids and their salts",
  "292222":
    "Amino-naphthols and other amino-phenols, other than those containing more than one kind of oxygen function; their ethers and esters; salts thereof, anisidines, dianisidines, phenetidines and their salts",
  "292229":
    "Amino-naphthols and other amino-phenols, other than those containing more than one kind of oxygen function, their ethers and esters; salts thereof n.e.c. in item no. 2922.2",
  "292230":
    "Amino-aldehydes, amino-ketones and amino-quinones; other than those containing more than one kind of oxygen function; salts thereof",
  "292231":
    "Amino-aldehydes, amino-ketones and amino-quinones; other than those containing more than one kind of oxygen function; salts thereof",
  "292239":
    "Amino-aldehydes, amino-ketones and amino-quinones; other than those containing more than one kind of oxygen function; salts thereof, excluding amfepramone (INN), methadone (INN), and normethadone (INN) and salts thereof",
  "292241":
    "Amino-acids, other than those containing more than one kind of oxygen function, and their esters; lysine and its esters; salts thereof",
  "292242":
    "Amino-acids, other than those containing more than one kind of oxygen function, and their esters; glutamic acid and its esters; salts thereof",
  "292243":
    "Amino-acids, other than those containing more than one kind of oxygen function, and their esters; anthranilic acid and its esters; salts thereof",
  "292244":
    "Amino-acids, other than those containing more than one kind of oxygen function, and their esters; tilidine (INN) and its esters; salts thereof",
  "292249":
    "Amino-acids, other than those containing more than one kind of oxygen function, their esters; salts thereof, excluding lysine, glutamic acid, anthranalic acid and tilidine, their esters and salts thereof",
  "292250":
    "Amino-alcohol-phenols, amino-acid-phenols and other amino-compounds with oxygen function",
  "292310":
    "Quaternary ammonium salts and hydroxides; choline and its salts, whether or not chemically defined",
  "292320":
    "Lecithins and other phosphoaminolipids, whether or not chemically defined",
  "292330":
    "Quaternary ammonium salts and hydroxides; tetraethylammonium perfluorooctane sulphonate, whether or not chemically defined",
  "292340":
    "Quaternary ammonium salts and hydroxides; didecyldimethylammonium perfluorooctane sulphonate, whether or not chemically defined",
  "292390":
    "Quaternary ammonium salts and hydroxides; whether or not chemically defined n.e.c. in heading no. 2923",
  "292410":
    "Acyclic amides (including acyclic carbamates) and their derivatives; salts thereof",
  "292411":
    "Acyclic amides (including acyclic carbamates) and their derivatives; salts thereof; meprobamate (INN)",
  "292412":
    "Acyclic amides (including acyclic carbamates) and their derivatives; salts thereof; fluoroacetamide (ISO), monocrotophos (ISO) and phosphamidon (ISO)",
  "292419":
    "Acyclic amides (including acyclic carbamates) and their derivatives; salts thereof, other than meprobamate (INN), fluoroacetamide (ISO), monocrotophos (ISO) or phosphamidon (ISO)",
  "292421":
    "Cyclic amides (including cyclic carbamates) and their derivatives, ureines and their derivatives; salts thereof",
  "292422":
    "Cyclic amides (including cyclic carbamates) and their derivatives; 2-acetamidobenzoic acid",
  "292423":
    "Cyclic amides (including cyclic carbamates) and their derivatives; 2-acetamidobenzoic acid (N-acetylanthranillic acid) and its salts",
  "292424":
    "Cyclic amides (including cyclic carbamates) and their derivatives; ethinamate and its salts",
  "292425":
    "Cyclic amides (including cyclic carbamates) and their derivatives; alachlor (ISO) and its salts",
  "292429":
    "Cyclic amides (including cyclic carbamates) and their derivatives; other than the derivatives and salts of ureines, 2-acetamidobenzoic acid (N-acetylanthancillic acid),ethinamate S, and alachlor (ISO) and their derivatives and salts",
  "292511": "Imides and their derivatives; saccharin and its salts",
  "292512": "Imides and their derivatives; glutethimide (INN)",
  "292519":
    "Imides and their derivatives; other than saccharin and glutethimide (INN)",
  "292520": "Imines and their derivatives; salts thereof",
  "292521": "Imines and their derivatives; salts thereof; chlordimeform (ISO)",
  "292529":
    "Imines and their derivatives; salts thereof; other than chlordimeform (ISO)",
  "292610": "Nitrile-function compounds; acrylonitrile",
  "292620": "Nitrile-function compounds; 1-cyanoguanidine (dicyandiamide)",
  "292630":
    "Nitrile-function compounds; fenproporex (INN) and its salts; methadone (INN) intermediate (4-cyano-2-dimethylamino-4,4-diphenylbutane)",
  "292640": "Nitrile-function compounds; alpha-phenylacetoacetonitrile",
  "292690": "Nitrile-function compounds; n.e.c. heading no. 2926",
  "292700": "Diazo-, azo- or azoxy compounds",
  "292800": "Organic derivatives of hydrazine or of hydroxylamine",
  "292910": "Nitrogen-function compounds; n.e.c. in chapter 29, isocyanates",
  "292990":
    "Nitrogen-function compounds; n.e.c. in chapter 29, excluding isocyanates",
  "293010": "Organo-sulphur compounds; dithiocarbonates (xanthates)",
  "293020": "Organo-sulphur compounds; thiocarbamates and dithiocarbamates",
  "293030": "Organo-sulphur compounds; thiuram mono-, di- or tetrasulphides",
  "293040": "Organo-sulphur compounds; methionine",
  "293050": "Organo-sulphur compounds; captafol (ISO) and methamidophos (ISO)",
  "293060": "Organo-sulphur compounds; 2-(N,N-Diethylamino)ethanethiol",
  "293070":
    "Organo-sulphur compounds; bis(2-hydroxyethyl)sulfide (thiodiglycol (INN))",
  "293080":
    "Organo-sulphur compounds; aldicarb (ISO), captafol (ISO) and methamidophos (ISO)",
  "293090": "Organo-sulphur compounds; n.e.c. in heading no. 2930",
  "293100": "Organo-inorganic compounds; n.e.c. in heading no. 2930",
  "293110": "Organo-inorganic compounds; tetramethyl lead and tetraethyl lead",
  "293120": "Organo-inorganic compounds; tributyltin compounds",
  "293131":
    "Organo-inorganic compounds; organo-phosphorus derivatives, dimethyl methylphosphonate",
  "293132":
    "Organo-inorganic compounds; organo-phosphorus derivatives, dimethyl propylphosphonate",
  "293133":
    "Organo-inorganic compounds; organo-phosphorus derivatives, diethyl ethylphosphonate",
  "293134":
    "Organo-inorganic compounds; organo-phosphorus derivatives, sodium-3-(hydroxysilyl)propyl methylphosphonate",
  "293135":
    "Organo-inorganic compounds; organo-phosphorus derivatives, 2,4,6-tripropyl-1,3,5,2,4,6-trioxatriphosphinane 2,4,6-trioxide",
  "293136":
    "Organo-inorganic compounds; organo-phosphorus derivatives, (5-ethyl-2-methyl-2-oxido-1,3,2-dioxaphosphinan-5-yl)methyl methyl methylphosphonate",
  "293137":
    "Organo-inorganic compounds; organo-phosphorus derivatives, bis[(5-Ethyl-2-methyl-2-oxido-1,3,2-dioxaphosphinan-5-yl)methyl methyl methylphosphonate]",
  "293138":
    "Organo-inorganic compounds; organo-phosphorus derivatives, salt of methylphosphonic acid and (aminoiminomethyl)urea (1 : 1)",
  "293139":
    "Organo-inorganic compounds; other organo-phosphorus derivatives, n.e.c. in heading no. 2931",
  "293141":
    "Non-halogenated organo-phosphorous derivatives; dimethyl methylphosphonate",
  "293142":
    "Non-halogenated organo-phosphorous derivatives; dimethyl propylphosphonate",
  "293143":
    "Non-halogenated organo-phosphorous derivatives; diethyl ethylphosphonate",
  "293144":
    "Non-halogenated organo-phosphorous derivatives; methylphosphonic acid",
  "293145":
    "Non-halogenated organo-phosphorous derivatives; salt of methylphosphonic acid and (aminominomethyl) urea (1:1)",
  "293146":
    "Non-halogenated organo-phosphorous derivatives; 2,4,6-tripropyl-1,3,5,2,4,6-trioxatriphosphinane 2,4,6-trioxide",
  "293147": "Halogenated organo",
  "293148":
    "Non-halogenated organo-phosphorous derivatives; 3,9-dimethyl-2,4,8,10-tetraoxa-3,9-diphosphaspiro[5.5] undecane 3,9-dioxide",
  "293149":
    "Non-halogenated organo-phosphorous derivatives; other non-halogenated organo-phosphorous derivatives, n.e.c. in item no. 2931.4",
  "293151":
    "Halogenated organo-phosphorous derivatives; methylphosphonic dichloride",
  "293152":
    "Halogenated organo-phosphorous derivatives; propylphosphonic dichloride",
  "293153":
    "Halogenated organo-phosphorous derivatives; O-(3-chloropropyl) O-[4-nitro-3-(trifluoromethyl)phenyl] methylphosphonothionate",
  "293154": "Halogenated organo-phosphorous derivatives; trichlorfon (ISO)",
  "293159":
    "Halogenated organo-phosphorous derivatives; other halogenated organo-phosphorous derivatives, n.e.c. in item no. 2931.5",
  "293190":
    "Organo-inorganic compounds; other than tetramethyl lead, tetraethyl lead, tributyltin compounds, and other organo-phosphorus derivatives",
  "293211":
    "Heterocyclic compounds; with oxygen hetero-atom(s) only, containing an unfused furan ring (whether or not hydrogenated) in the structure, tetrahydrofuran",
  "293212":
    "Heterocyclic compounds; with oxygen hetero-atom(s) only, containing an unfused furan ring (whether or not hydrogenated) in the structure, 2-furaldehyde (furfuraldehyde)",
  "293213":
    "Heterocyclic compounds; with oxygen hetero-atom(s) only, containing an unfused furan ring (whether or not hydrogenated) in the structure, furfuryl alcohol and tetrahydrofurfuryl alcohol",
  "293214":
    "Heterocyclic compounds; with oxygen hetero-atom(s) only, containing an unfused furan ring (whether or not hydrogenated) in the structure, sucralose",
  "293219":
    "Heterocyclic compounds; with oxygen hetero-atom(s) only, containing an unfused furan ring (whether or not hydrogenated) in the structure, n.e.c. in item no. 2932.1",
  "293220":
    "Heterocyclic compounds; with oxygen hetero-atom(s) only, containing an unfused furan ring (whether or not hydrogenated) in the structure, lactones",
  "293221":
    "Heterocyclic compounds; lactones, coumarin, methylcoumarins and ethylcoumarins",
  "293229":
    "Heterocyclic compounds with oxygen hetero-atom(s) only; lactones, other than coumarin, methylcoumarins and ethylcoumarins",
  "293290": "Heterocyclic compounds; n.e.s. in heading no. 2932",
  "293291":
    "Heterocyclic compounds; with oxygen hetero-atom(s) only, (other than lactones or compounds containing an unfused furan ring (whether or not hydrogenated) in the structure), isosafrole",
  "293292":
    "Heterocyclic compounds; with oxygen hetero-atom(s) only, (other than lactones or compounds containing an unfused furan ring (whether or not hydrogenated) in the structure), 1-(1,3-benzodiaxol-5-yl) propan-2-one",
  "293293":
    "Heterocyclic compounds; with oxygen hetero-atom(s) only, (other than lactones or compounds containing an unfused furan ring (whether or not hydrogenated) in the structure), piperonal",
  "293294":
    "Heterocyclic compounds; with oxygen hetero-atom(s) only, (other than lactones or compounds containing an unfused furan ring (whether or not hydrogenated) in the structure), safrole",
  "293295":
    "Heterocyclic compounds; with oxygen hetero-atom(s) only, (other than lactones or compounds containing an unfused furan ring (whether or not hydrogenated) in the structure), tetrahydrocannabinols (all isomers)",
  "293296":
    "Heterocyclic compounds; with oxygen hetero-atom(s) only, (other than lactones or compounds containing an unfused furan ring (whether or not hydrogenated) in the structure), carbofuran (ISO)",
  "293299":
    "Heterocyclic compounds; with oxygen hetero-atom(s) only, no lactones or unfused furan rings (hydrogenated or not) in the structure, other than isosafrole, 1-(1,3-benzodiaxol-5-yl) propan-2-one, piperonal, safrole, tetrahydrocannabinols (all isomers)",
  "293311":
    "Heterocyclic compounds; with nitrogen hetero-atom(s) only, containing an unfused pyrazole ring (whether or not hydrogenated) in the structure, phenazone (antipyrin) and its derivatives",
  "293319":
    "Heterocyclic compounds; with nitrogen hetero-atom(s) only, containing an unfused pyrazole ring (whether or not hydrogenated) in the structure, other than henazone (antipyrin) and its derivatives",
  "293321":
    "Heterocyclic compounds; with nitrogen hetero-atom(s) only, containing an unfused imidazole ring (whether or not hydrogenated) in the structure, hydantoin and its derivatives",
  "293329":
    "Heterocyclic compounds; with nitrogen hetero-atom(s) only, containing an unfused imidazole ring (whether or not hydrogenated) in the structure, other than hydantoin and its derivatives",
  "293331":
    "Heterocyclic compounds; containing an unfused pyridine ring (whether or not hydrogenated) in the structure, pyridine and its salts",
  "293332":
    "Heterocyclic compounds; containing an unfused pyridine ring (whether or not hydrogenated) in the structure, piperidine and its salts",
  "293333":
    "Heterocyclic compounds; containing an unfused pyridine ring (whether or not hydrogenated) in the structure, other than pyridine and its salts, other than piperidine and its salts",
  "293334":
    "Heterocyclic compounds; containing an unfused pyridine ring (whether or not hydrogenated) in the structure, other fentanyls and their derivatives",
  "293335":
    "Heterocyclic compounds; containing an unfused pyridine ring (whether or not hydrogenated) in the structure, 3-quinuclidinol",
  "293336":
    "Heterocyclic compounds; containing an unfused pyridine ring (whether or not hydrogenated) in the structure, 4-anilino-N-phenethylpiperidine (ANPP)",
  "293337":
    "Heterocyclic compounds; containing an unfused pyridine ring (whether or not hydrogenated) in the structure, N-phenethyl-4-piperdone (NPP)",
  "293339":
    "Heterocyclic compounds; containing an unfused pyridine ring (whether or not hydrogenated) in the structure, n.e.c. in 2933.3",
  "293340":
    "Heterocyclic compounds; containing a quinoline or isoquinoline ring-system (whether or not hydrogenated) in the structure, not further fused",
  "293341":
    "Heterocyclic compounds; containing a quinoline or isoquinoline ring-system (whether or not hydrogenated) in the structure, not further fused, levorphanol (INN) and its salts",
  "293349":
    "Heterocyclic compounds; containing a quinoline or isoquinoline ring-system (whether or not hydrogenated) in the structure, not further fused, other than levorphanol (INN) and its salts",
  "293351":
    "Heterocyclic compounds; containing a pyrimidine ring (whether or not hydrogenated) or piperazine ring in the structure, malonylurea (barbituric acid) and its derivatives; salts thereof",
  "293352":
    "Heterocyclic compounds; containing a pyrimidine ring (whether or not hydrogenated) or piperazine ring in the structure, malonylurea (barbituric acid) and its salts",
  "293353":
    "Allobarbital (INN), amobarbital (INN), barbital (INN), butalbital (INN), butobarbital, cyclobarbital (INN), methylphenobarbital (INN), pentobarbital (INN), phenobarbital (INN), secbutabarbital (INN), secobarbital (INN) and vinylbital (INN); salts thereof",
  "293354":
    "Heterocyclic compounds; containing a pyrimidine ring (whether or not hydrogenated) or piperazine ring in the structure, other derivatives of malonylurea (barbituric acid) and salts thereof, n.e.c. in 2933.53",
  "293355":
    "Heterocyclic compounds; containing a pyrimidine ring (whether or not hydrogenated) or piperazine ring in the structure; loprazolam (INN), mecloqualone (INN), methaqualone (INN), and zipeprol (INN); salts thereof",
  "293359":
    "Heterocyclic compounds; containing a pyrimidine ring (whether or not hydrogenated) or piperazine ring in the structure, (other than malonylurea and its derivatives, loprazolam, mecloqualone, methaqualone, zipeprol, and salts thereof) n.e.c. in 2933.5",
  "293361":
    "Heterocyclic compounds; containing an unfused triazine ring (whether or not hydrogenated) in the structure, melamine",
  "293369":
    "Heterocyclic compounds; containing an unfused triazine ring (whether or not hydrogenated) in the structure, others excluding melamine",
  "293371":
    "Heterocyclic compounds; lactams; 6-hexanelactam (epsilon-caprolactam)",
  "293372":
    "Heterocyclic compounds; lactams; clobazam (INN) and methyprylon (INN)",
  "293379": "Lactams; excl. 6-hexanelactam, clobazam, and methyprylon",
  "293390": "Heterocyclic compounds; n.e.s. in heading no. 2933",
  "293391":
    "Heterocyclic compounds; alprazolam (INN), camazepam (INN), chlordiazepoxide (INN), clonazepam (INN), clorazepate, delorazepam (INN), diazepam (INN), estazolam (INN), ethyl loflazepate (INN), fludiazepam (INN), flunitrazepam (INN), (cont)",
  "293392": "Heterocyclic compounds; azinphos-methyl (ISO)",
  "293399": "Other hetercyclic compounds (exclusionary category)",
  "293410":
    "Heterocyclic compounds; containing an unfused thiazole ring (whether or not hydrogenated) in the structure",
  "293420":
    "Heterocyclic compounds; containing in the structure, a benzothiazole ring-system (whether or not hydrogenated), not further fused",
  "293430":
    "Heterocyclic compounds; containing in the structure, a phenothiazine ring-system (whether or not hydrogenated), not further fused",
  "293490":
    "Nucleic acids and their salts, other heterocyclic compounds, n.e.s. in heading no. 2934",
  "293491": "Other heterocyclic compounds, n.e.c. in 2934.1, 2934.2 and 2934.3",
  "293492":
    "Heterocyclic compounds; other fentanyls n.e.c. in 2934, and their derivatives",
  "293499":
    "Other nucleic acids and their salts; other heterocyclic compounds (exclusionary category)",
  "293500": "Sulphonamides",
  "293510": "Sulphonamides; N-methylperfluorooctane sulphonamide",
  "293520": "Sulphonamides; N-ethylperfluorooctane sulphonamide",
  "293530":
    "Sulphonamides; N-ethyl-N-(2-hydroxyethyl) perfluorooctane sulphonamide",
  "293540":
    "Sulphonamides; N-(2-hydroxyethyl)-N-methylperfluorooctane sulphonamide",
  "293550": "Sulphonamides; other perfluorooctane sulphonamides",
  "293590": "Sulphonamides; n.e.c. in heading no. 2935",
  "293610": "Provitamins; unmixed",
  "293621": "Vitamins; vitamins A and their derivatives, unmixed",
  "293622": "Vitamins; vitamin B1 and its derivatives, unmixed",
  "293623": "Vitamins; vitamin B2 and its derivatives, unmixed",
  "293624":
    "Vitamins; D- or DL-pantothenic acid (vitamin B3 or vitamin B5) and its derivatives, unmixed",
  "293625": "Vitamins; vitamin B6 and its derivatives, unmixed",
  "293626": "Vitamins; vitamin B12 and its derivatives, unmixed",
  "293627": "Vitamins; vitamin C and its derivatives, unmixed",
  "293628": "Vitamins; vitamin E and its derivatives, unmixed",
  "293629":
    "Vitamins; n.e.c. in item no. 2936.2, and their derivatives, unmixed",
  "293690":
    "Vitamins; n.e.c. in heading no. 2936, including natural concentrates",
  "293710":
    "Hormones; pituitary (anterior) or similar hormones and their derivatives",
  "293711":
    "Polypeptide hormones, protein hormones and glycoprotein hormones, their derivatives and structural analogues; somatotropin, its derivatives and structural analogues",
  "293712":
    "Polypeptide hormones, protein hormones and glycoprotein hormones, their derivatives and structural analogues; insulin and its salts",
  "293719":
    "Polypeptide hormones; protein hormones and glycoprotein hormones; excl. insulin",
  "293721":
    "Steroidal hormones, their derivatives and structural analogues; cortisone, hydrocortisone, prednisone (dehydrocortisone) and prednisolone (dehydrohydrocortisone)",
  "293722":
    "Steroidal hormones, their derivatives and structural analogues; halogenated derivatives of corticosteroidal hormones",
  "293723":
    "Steroidal hormones, their derivatives and structural analogues; oestrogens and progestogens",
  "293729":
    "Steroidal hormones, their derivatives and structural analogues; other than cortisone, hydrocortisone, prednisone (dehydrocortisone), prednisolone (dehydrohydrocortisone), halogenated derivatives of corticosteroidal hormones, oestrogen and progestogens",
  "293731":
    "Hormones; catecholamine hormones, their derivatives and structural analogues, epinephrine",
  "293739":
    "Hormones; catecholamine hormones, their derivatives and structural analogues, other than epinephrine",
  "293740": "Hormones; amino-acid derivatives",
  "293750":
    "Prostaglandins, thromboxanes and leukotrienes, their derivatives and structural analogues",
  "293790":
    "Hormones, prostaglandins, thromboxanes and leukotrienes, natural or reproduced by synthesis; derivatives and structural analogues thereof, including chain modified polypeptides, used primarily as hormones, n.e.c. in heading 2937",
  "293791":
    "Hormones and steroids used primarily as hormones; insulin and its salts",
  "293792":
    "Hormones and steroids used primarily as hormones; oestrogens and progestogens",
  "293799":
    "Hormones and steroids used primarily as hormones; (other than insulin and its salts, oestrogens and progestogens)",
  "293810": "Glycosides; rutoside (rutin) and its derivatives",
  "293890":
    "Glycosides; natural or reproduced by synthesis, other than rutoside (rutin) and its derivatives",
  "293910":
    "Alkaloids, vegetable; of opium and their derivatives; salts thereof",
  "293911": "Alkaloids; of opium and their derivatives; salts thereof",
  "293919":
    "Alkaloids; of opium and their derivatives; other than in 2939.11, salts thereof",
  "293920": "Alkaloids; of cinchona and their derivatives; salts thereof",
  "293921":
    "Alkaloids, vegetable; of cinchona and their derivatives, quinine and its salts",
  "293929":
    "Alkaloids, vegetable; of cinchona and their derivatives; salts thereof, other than quinine and its salts",
  "293930": "Alkaloids; caffeine and its salts",
  "293940": "Alkaloids, vegetable; ephedrines and their salts",
  "293941": "Alkaloids; ephedrine and its salts",
  "293942": "Alkaloids; pseudoephedrine (INN) and its salts",
  "293943": "Alkaloids; cathine (INN) and its salts",
  "293944": "Alkaloids; norephedrine and its salts",
  "293945":
    "Alkaloids; of ephedrine and their derivatives; levometamfetamine, metamfetamine (INN), metamefetamine racemate and their salts",
  "293949":
    "Alkaloids; other than ephedrine, pseudoephedrine (INN), norephedrine, and cathine (INN) and their salts",
  "293950":
    "Alkaloids, vegetable; theophylline and aminophylline (theophyllineethylenediamine) and their derivatives; salts thereof",
  "293951":
    "Alkaloids; theophylline and aminophylline (theophylline-ethylenediamine) and their derivatives; salts thereof, fenetylline (INN) and its salts",
  "293959":
    "Alkaloids; theophylline and aminophylline (theophylline-ethylenediamine) and their derivatives; salts thereof, other than fenetylline",
  "293960":
    "Alkaloids, vegetable; of rye ergot and their derivatives; salts thereof",
  "293961":
    "Alkaloids; of rye ergot and their derivatives, ergometrine (INN) and its salts",
  "293962":
    "Alkaloids; of rye ergot and their derivatives, ergotamine (INN) and its salts",
  "293963":
    "Alkaloids; of rye ergot and their derivatives, lysergic acid and its salts",
  "293969":
    "Alkaloids; of rye ergot and their derivatives, salts thereof, n.e.c. in item no. 2939.6",
  "293970": "Alkaloids, vegetable; nicotine and its salts",
  "293971":
    "Alkaloids; of vegetal origin, cocaine, ecgonine, levometamfetamine, metamfetamine (INN), metamfetamine racemate; salts, esters and other derivatives thereof",
  "293972":
    "Alkaloids; of vegetal origin, cocaine, ecgonine; salts, esters and other derivatives thereof",
  "293979":
    "Alkaloids; of vegetal origin, other than cocaine, ecgonine, levometamfetamine, metamfetamine (INN), metamfetamine racemate; salts, esters and other derivatives; n.e.c. in heading no. 2939",
  "293980":
    "Alkaloids; natural or reproduced by synthesis, and their salts, esters and other derivatives n.e.c. in heading no. 2939",
  "293990":
    "Alkaloids, vegetable; natural or reproduced by synthesis, and their salts, esters and other derivatives n.e.s. in heading no. 2939",
  "293991":
    "Alkaloids, vegetable; natural or reproduced by synthesis, and their salts, esters and other derivatives n.e.c. in heading no. 2939.1, 2939.2, 2939.3, 2939.4, 2939.5, 2939.6, 2939.7",
  "293999":
    "Alkaloids, vegetable; natural or reproduced by synthesis, and their salts, esters and other derivatives n.e.c. in heading no. 2939",
  "294000":
    "Sugars, chemically pure, other than sucrose, lactose, maltose, glucose and fructose; sugar ethers, sugar acetals and sugar esters, and their salts, other than the products of heading 29.37, 29.38, or 29.39",
  "294110":
    "Antibiotics; penicillins and their derivatives with a penicillanic acid structure; salts thereof",
  "294120": "Antibiotics; streptomycins and their derivatives; salts thereof",
  "294130": "Antibiotics; tetracyclines and their derivatives; salts thereof",
  "294140": "Antibiotics; chloramphenicol and its derivatives; salts thereof",
  "294150": "Antibiotics; erythromycin and its derivatives; salts thereof",
  "294190": "Antibiotics; n.e.c. in heading no. 2941",
  "294200": "Organic compounds; n.e.c. in chapter 29",
  "300110": "Glands and other organs; dried, whether or not powdered",
  "300120":
    "Glands and other organs; extracts of glands or other organs or of their secretions, for organo-therapeutic uses",
  "300190": "Heparin and its salts; for therapeutic or prophylactic uses",
  "300210":
    "Blood, human or animal, antisera, other blood fractions and immunological products; whether or not modified or obtained by means of biotechnological processes",
  "300211":
    "Blood, human or animal, antisera, other blood fractions and immunological products; malaria diagnostic test kits",
  "300212": "Antisera and other blood fractions",
  "300213": "Immunological products; not retail, not mixed",
  "300214": "Immunological products; retail, mixed",
  "300215": "Immunological products; retail, not mixed",
  "300219":
    "Blood, human or animal, antisera, other blood fractions and immunological products; n.e.c. in heading 3002.1",
  "300220": "Vaccines for human use",
  "300230": "Vaccines for veterinary use",
  "300231": "Vaccines; for veterinary medicine, against foot and mouth disease",
  "300239":
    "Vaccines; for veterinary medicine, for other uses than against foot and mouth disease",
  "300241":
    "Vaccines, toxins, cultures of micro-organisms (excluding yeasts) and similar products; for human medicine",
  "300242":
    "Vaccines, toxins, cultures of micro-organisms (excluding yeasts) and similar products; for veterinary medicine",
  "300249":
    "Toxins, cultures of micro-organisms (excluding yeasts) and similar products; n.e.c. in item 3002.3",
  "300251": "Cell cultures, whether or not modified; cell therapy products",
  "300259":
    "Cell cultures, whether or not modified; other cell cultures not including cell therapy products",
  "300290": "Toxins and cultures of micro-organisms; excl. yeasts",
  "300310":
    "Medicaments; containing penicillins, streptomycins or their derivatives, for therapeutic or prophylactic uses, (not in measured doses, not packaged for retail sale)",
  "300320":
    "Medicaments; containing antibiotics other than penicillins, streptomycins and their derivatives, for therapeutic or prophylactic uses, (not in measured doses, not packaged for retail sale)",
  "300331":
    "Medicaments; containing insulin, for therapeutic or prophylactic uses, not packaged for retail sale",
  "300339":
    "Medicaments; containing hormones (excluding insulin), (but not containing antibiotics), for therapeutic or prophylactic uses, not packaged for retail sale",
  "300340":
    "Medicaments; containing alkaloids or their derivatives, (but not containing hormones or antibiotics), for therapeutic or prophylactic uses, (not packaged for retail sale)",
  "300341":
    "Medicaments; containing alkaloids or their derivatives, containing ephedrine or its salts, for therapeutic or prophylactic uses, (not packaged for retail sale)",
  "300342":
    "Medicaments; containing alkaloids or their derivatives, containing pseudoephedrine (INN) or its salts, for therapeutic or prophylactic uses, (not packaged for retail sale)",
  "300343":
    "Medicaments; containing alkaloids or their derivatives, containing norephedrine or its salts, for therapeutic or prophylactic uses, (not packaged for retail sale)",
  "300349":
    "Medicaments; containing alkaloids or their derivatives; other than ephedrine, pseudoephedrine (INN) or norephedrine or their salts; for therapeutic or prophylactic uses, (not packaged for retail sale)",
  "300360":
    "Medicaments; containing antimalarial active principles described in subheading note 2 to this chapter, for therapeutic or prophylactic uses, (not packaged for retail sale)",
  "300390": "Medicaments; not containing antibiotics, hormones, or alkoids",
  "300410": "Medicaments containing penicillins and streptomycins",
  "300420":
    "Medicaments; containing antibiotics; excl. penicillins and streptomycins",
  "300431": "Medicaments containing insulin",
  "300432": "Medicaments containing corticosteroid hormones",
  "300439":
    "Medicaments; containing hormones, adrenal cortex hormones, and antibiotics; excl. insulin",
  "300440":
    "Medicaments; containing alkaloids or their derivatives (but not hormones or antibiotics), for therapeutic or prophylactic uses, packaged for retail sale",
  "300441":
    "Medicaments; containing alkaloids or their derivatives, containing ephedrine or its salts, for therapeutic or prophylactic uses, packaged for retail sale",
  "300442":
    "Medicaments; containing alkaloids or their derivatives, containing pseudoephedrine (INN) or its salts, for therapeutic or prophylactic uses, packaged for retail sale",
  "300443":
    "Medicaments; containing alkaloids or their derivatives, containing norephedrine or its salts, for therapeutic or prophylactic uses, packaged for retail sale",
  "300449":
    "Medicaments; containing alkaloids or their derivatives; excl. ephedrine, pseudoephedrine, and norephedrine",
  "300450": "Medicaments containing vitamins",
  "300460":
    "Medicaments; containing antimalarial active principles described in Subheading Note 2 to this Chapter, for therapeutic or prophylactic uses, packaged for retail sale",
  "300490": "Other medicaments (exclusionary category)",
  "300510": "Medical dressings with adhesive layer",
  "300590": "Medical dressings; excl. adhesive",
  "300610": "Suture materials, sterile surgical and dental goods",
  "300620": "Pharmaceutical goods; blood-grouping reagents",
  "300630": "Opacifying preparations for x-ray examinations",
  "300640":
    "Pharmaceutical goods; dental cements and other dental fillings, bone reconstruction cements",
  "300650": "Pharmaceutical goods; first aid boxes and kits",
  "300660": "Contraceptives based on hormones or spermicides",
  "300670":
    "Pharmaceutical goods; Gel preparations designed to be used in human or veterinary medicine as a lubricant for parts of the body for surgical operations or physical examinations or as a coupling agent between the body and medical instruments",
  "300680": "Pharmaceutical goods; waste pharmaceuticals",
  "300691": "Pharmaceutical goods; appliances identifiable for ostomy use",
  "300692": "Pharmaceutical goods; waste pharmaceuticals",
  "300693":
    "Pharmaceutical goods; placebos and blinded (or double-blinded) clinical trial kits for a recognised clinical trial, put up in measured doses",
  "310100":
    "Fertilizers, animal or vegetable; whether or not mixed together or chemically treated; fertilizers, produced by the mixing or chemical treatment of animal or vegetable products",
  "310210": "Urea fertilizer",
  "310221": "Fertilizers, mineral or chemical; nitrogenous, ammonium sulphate",
  "310229":
    "Fertilizers, mineral or chemical; nitrogenous, other than ammonium sulphate",
  "310230":
    "Fertilizers, mineral or chemical; nitrogenous, ammonium nitrate, whether or not in aqueous solution",
  "310240":
    "Fertilizers, mineral or chemical; ammonium nitrate with calcium carbonate or other inorganic non-fertilizing substances, mixtures thereof",
  "310250": "Fertilizers, mineral or chemical; nitrogenous, sodium nitrate",
  "310260":
    "Fertilizers, mineral or chemical; nitrogenous, double salts and mixtures of calcium nitrate and ammonium nitrate",
  "310270": "Fertilizers, mineral or chemical; nitrogenous, calcium cyanamide",
  "310280":
    "Fertilizers, mineral or chemical; nitrogenous, mixtures of urea and ammonium nitrate in aqueous or ammoniacal solution",
  "310290":
    "Fertilizers, mineral or chemical; nitrogenous, other kinds including mixtures not specified in the foregoing subheadings",
  "310310": "Fertilizers, mineral or chemical; phosphatic, superphosphates",
  "310311":
    "Fertilizers, mineral or chemical; phosphatic, superphosphates, containing by weight 35% or more of diphosphorus pentaoxide (P2O5)",
  "310319":
    "Fertilizers, mineral or chemical; phosphatic, superphosphates, other than containing by weight 35% or more of diphosphorus pentaoxide (P2O5)",
  "310320": "Fertilizers, mineral or chemical; phosphatic, basic slag",
  "310390":
    "Fertilizers, mineral or chemical; phosphatic, n.e.c. in heading no. 3103",
  "310410":
    "Fertilizers, mineral or chemical; potassic, carnallite, sylvite and other crude natural potassium salts",
  "310420": "Potassium chloride fertilizer",
  "310430": "Fertilizers, mineral or chemical; potassic, potassium sulphate",
  "310490":
    "Fertilizers, mineral or chemical; potassic, n.e.c. in heading no. 3104",
  "310510":
    "Fertilizers, mineral or chemical; in tablets or similar forms or in packages of a gross weight not exceeding 10kg",
  "310520":
    "Fertilizers, mineral or chemical; containing the three fertilizing elements nitrogen, phosphorus and potassium",
  "310530":
    "Fertilizers, mineral or chemical; diammonium hydrogenorthophosphate (diammonium phosphate)",
  "310540":
    "Fertilizers, mineral or chemical; ammonium dihydrogenorthophosphate (monoammonium phosphate) and mixtures thereof with diammonium hydrogenorthophosphate (diammonium phosphate)",
  "310551":
    "Fertilizers, mineral or chemical; containing nitrates and phosphates",
  "310559":
    "Fertilizers, mineral or chemical; containing the two fertilizing elements nitrogen and phosphorus, other than nitrates and phosphates",
  "310560":
    "Fertilizers, mineral or chemical; containing the two fertilizing elements phosphorus and potassium",
  "310590": "Fertilizers, mineral or chemical; n.e.c. in heading no. 3105",
  "320110": "Tanning extracts of vegetable origin; quebracho extract",
  "320120": "Tanning extracts of vegetable origin; wattle extract",
  "320130": "Tanning extracts of vegetable origin; oak or chestnut extract",
  "320190":
    "Tanning extracts of vegetable origin; tannins and their salts, ethers, esters and other derivatives, (excluding quebracho or wattle extract)",
  "320210": "Tanning substances; synthetic organic tanning substances",
  "320290":
    "Tanning substances; inorganic tanning substances; tanning preparations, whether or not containing natural tanning substances; enzymatic preparations for pre- tanning",
  "320300":
    "Colouring matter of vegetable or animal origin, including dyeing extracts not animal black, whether or not chemically defined; preparations based on colouring matter of vegetable or animal origin",
  "320411": "Dyes; disperse dyes and preparations based thereon",
  "320412":
    "Dyes; acid, whether or not premetallised and preparations based thereon, mordant dyes and preparations based thereon",
  "320413": "Dyes; basic dyes and preparations based thereon",
  "320414": "Dyes; direct dyes and preparations based thereon",
  "320415":
    "Dyes; vat dyes (including those usable in that state as pigments) and preparations based thereon",
  "320416": "Dyes; reactive dyes and preparations based thereon",
  "320417": "Dyes; pigments and preparations based thereon",
  "320418": "Dyes; carotenoid colouring matters and preparations based thereon",
  "320419":
    "Dyes; n.e.c., including mixtures of colouring matter of two or more of those from item no. 3204.11 to 3204.19",
  "320420":
    "Dyes; synthetic organic products of a kind used as fluorescent brightening agents",
  "320490":
    "Dyes; synthetic organic products n.e.c. in heading no. 3204 (e.g. of a kind used as luminophores), whether or not chemically defined",
  "320500":
    "Colour lakes; preparations based on colour lakes as specified in note 3 to this chapter",
  "320610":
    "Colouring matter; pigments and preparations based on titanium dioxide",
  "320611":
    "Colouring matter; pigments and preparations based on titanium dioxide, containing 80% or more by weight of titanium dioxide calculated on the dry matter",
  "320619":
    "Colouring matter; pigments and preparations based on titanium dioxide, containing less than 80% by weight of titanium dioxide calculated on the dry weight",
  "320620":
    "Colouring matter; pigments and preparations based on chromium compounds",
  "320630":
    "Colouring matter; pigments and preparations based on cadmium compounds",
  "320641": "Colouring matter; ultramarine and preparations based thereon",
  "320642":
    "Colouring matter; lithopone and other pigments and preparations based on zinc sulphide",
  "320643":
    "Colouring matter; pigments and preparations based on hexacyanoferrates (ferrocyanides and ferricyanides)",
  "320649": "Colouring matter; other preparations n.e.c. in item no. 3206.4",
  "320650":
    "Colouring matter; inorganic products of a kind used as luminophores",
  "320710":
    "Pigments; prepared pigments, opacifiers, colours and similar preparations",
  "320720":
    "Enamels and glazes; vitrifiable enamels and glazes, engobes (slips) and similar preparations",
  "320730": "Lustres; liquid lustres and similar preparations",
  "320740":
    "Glass; glass frit and other glass, in the form of powder, granules or flakes",
  "320810":
    "Paints and varnishes; based on polyesters, dispersed or dissolved in a non-aqueous medium",
  "320820":
    "Paints and varnishes; based on acrylic or vinyl polymers, dispersed or dissolved in a non-aqueous medium",
  "320890":
    "Paints and varnishes; based on polymers n.e.c. in heading no. 3208, dispersed or dissolved in a non-aqueous medium",
  "320910":
    "Paints and varnishes; based on acrylic or vinyl polymers, dispersed or dissolved in an aqueous medium",
  "320990":
    "Paints and varnishes; (based on polymers other than acrylic or vinyl), dispersed or dissolved in an aqueous medium",
  "321000":
    "Paints and varnishes; (including enamels, lacquers and distempers), prepared water pigments of a kind used for finishing leather",
  "321100": "Driers; prepared",
  "321210":
    "Pigments; of a kind used in the manufacture of paints, stamping foils",
  "321290":
    "Pigments; of a kind used in the manufacture of paints, other than stamping foils",
  "321310":
    "Colours; in sets, of a kind used by artists, students or signboard painters",
  "321390":
    "Colours; (other than in sets), of a kind used by artists, students or signboard painters",
  "321410": "Mastics; painters' fillings",
  "321490": "Mastics; n.e.c. in heading no. 3214",
  "321511": "Ink; for printing, black, whether or not concentrated or solid",
  "321519":
    "Ink; for printing, other than black, whether or not concentrated or solid",
  "321590":
    "Ink; writing, drawing and other inks, n.e.c. in heading no. 3215, whether or not concentrated or solid",
  "330111":
    "Oils, essential; of bergamot (terpeneless or not), including concretes and absolutes",
  "330112":
    "Oils, essential; of orange (terpeneless or not), including concretes and absolutes",
  "330113":
    "Oils, essential; of lemon (terpeneless or not), including concretes and absolutes",
  "330114":
    "Oils, essential; of lime (terpeneless or not), including concretes and absolutes",
  "330119":
    "Oils, essential; of citrus fruits n.e.c. in heading no. 3301 (terpeneless or not), including concretes and absolutes",
  "330121":
    "Oils, essential; of geranium (terpeneless or not), including concretes and absolutes",
  "330122":
    "Oils, essential; of jasmin (terpeneless or not), including concretes and absolutes",
  "330123":
    "Oils, essential; of lavender or of lavandin (terpeneless or not), including concretes and absolutes",
  "330124":
    "Oils, essential; of peppermint (Mentha piperita), terpeneless or not, including concretes and absolutes",
  "330125":
    "Oils, essential; of mints (excluding peppermint), terpeneless or not, including concretes and absolutes",
  "330126":
    "Oils, essential; of vetiver (terpeneless or not), including concretes and absolutes",
  "330129":
    "Oils, essential; n.e.c. in heading no. 3301 (terpeneless or not), including concretes and absolutes",
  "330130": "Resinoids",
  "330190":
    "Oils, essential; concentrates in fats, fixed oils, waxes and the like, terpenic by-products, aqueous distillates and solutions, extracted oleoresins, n.e.c. in heading no. 3301",
  "330210": "Odoriferous substances and mixtures; for food or drink industries",
  "330290":
    "Odoriferous substances and mixtures; used as raw materials in industries other than the food or drink industries",
  "330300": "Perfumes and toilet waters",
  "330410": "Cosmetic and toilet preparations; lip make-up",
  "330420": "Cosmetic and toilet preparations; eye make-up",
  "330430":
    "Cosmetic and toilet preparations; manicure or pedicure preparations",
  "330491":
    "Cosmetic and toilet preparations; powders, whether or not compressed (excluding lip, eye, manicure or pedicure preparations)",
  "330499":
    "Cosmetic and toilet preparations; n.e.c. in heading no. 3304, for the care of the skin (excluding medicaments, including sunscreen or sun tan preparations)",
  "330510": "Hair preparations; shampoos",
  "330520": "Hair preparations; for permanent waving or straightening",
  "330530": "Hair preparations; lacquers",
  "330590": "Hair preparations; n.e.c. in heading no. 3305",
  "330610": "Oral or dental hygiene preparations; dentifrices",
  "330620":
    "Oral or dental hygiene preparations; yarn used to clean between the teeth (dental floss)",
  "330690": "Oral or dental hygiene preparations; other than dentifrices",
  "330710":
    "Perfumery, cosmetic or toilet preparations; pre-shave, shaving or after-shave preparations",
  "330720":
    "Perfumery, cosmetic or toilet preparations; personal deodorants and antiperspirants",
  "330730":
    "Perfumery, cosmetic or toilet preparations; perfumed bath salts and other bath preparations",
  "330741":
    "Perfumes and deodorizers; perfuming or deodorizing preparations for rooms, agarbatti and other odoriferous preparations which operate by burning (including those used during religious rites)",
  "330749":
    "Perfumes and deodorizers; perfuming or deodorizing preparations for rooms, (excluding those which operate by burning)",
  "330790":
    "Perfumes and deodorizers; perfuming or deodorizing preparations n.e.c. in heading no. 3307",
  "340111":
    "Soap and organic surface-active products; in the form of bars, cakes, moulded shapes, and paper, wadding, felt and nonwovens, impregnated, coated or covered with soap or detergent, for toilet use (including medicated products)",
  "340119":
    "Soap and organic surface-active products; in the form of bars, cakes, moulded shapes, and paper, wadding, felt and nonwovens, impregnated, coated or covered with soap or detergent, not for toilet use",
  "340120": "Soap; in forms n.e.c. in item no. 3401.11",
  "340130":
    "Organic surface-active products and preparations for washing the skin, in the form of liquid or cream and put up for retail sale, whether or not containing soap",
  "340211":
    "Organic surface-active agents; anionic (other than soap), whether or not put up for retail sale",
  "340212":
    "Organic surface-active agents; cationic (other than soap), whether or not put up for retail sale",
  "340213":
    "Organic surface-active agents; non-ionic (other than soap), whether or not put up for retail sale",
  "340219":
    "Organic surface-active agents; whether or not put up for retail sale, n.e.c. in heading no. 3402",
  "340220": "Washing and cleaning preparations; retail",
  "340231":
    "Anionic organic surface-active agents (other than soap); linear alkylbenzene sulphonic acids and their salts, whether or not put up for retail sale",
  "340239":
    "Anionic organic surface-active agents (other than soap); other than linear alkylbenzene sulphonic acids and their salts, whether or not put up for retail sale",
  "340241":
    "Organic surface-active agents; cationic (other than soap), whether or not put up for retail sale",
  "340242":
    "Organic surface-active agents; non-ionic (other than soap), whether or not put up for retail sale",
  "340249":
    "Organic surface-active agents; whether or not put up for retail sale, n.e.c. in item no. 3402",
  "340250":
    "Washing and cleaning preparations; powders, flakes and granules, surface-active, whether or not containing soap (excluding those of heading no. 3401), put up for retail sale",
  "340290":
    "Washing and cleaning preparations; surface-active, whether or not containing soap (excluding those of heading no. 3401), including auxiliary washing preparations, not for retail sale",
  "340311":
    "Lubricating preparations; for the treatment of textile and similar materials (leather, furskins etc), containing less than 70% (by weight) of petroleum oils or oils obtained from bituminous minerals",
  "340319":
    "Lubricating preparations; (other than for the treatment of textile and similar materials), containing less than 70% (by weight) of petroleum oils or oils obtained from bituminous minerals",
  "340391":
    "Lubricating preparations; for the treatment of textile and similar materials (leather, furskins etc), (not containing petroleum oils or oils obtained from bituminous minerals)",
  "340399":
    "Lubricating preparations; other than for the treatment of textile and similar materials, not containing petroleum oils or oils obtained from bituminous minerals",
  "340410": "Waxes; artificial and prepared, of chemically modified lignite",
  "340420":
    "Waxes; artificial and prepared, of poly(oxyethylene) (polyethylene glycol)",
  "340490": "Waxes; artificial and prepared, other than of polyethylene glycol",
  "340510":
    "Polishes, creams and similar preparations; for footwear or leather, excluding waxes of heading no. 3404",
  "340520":
    "Polishes, creams and similar preparations; for the maintenance of wooden furniture, floors or other woodwork, excluding waxes of heading no. 3404",
  "340530":
    "Polishes, creams and similar preparations; for coachwork, other than metal polishes, excluding waxes of heading no. 3404",
  "340540":
    "Scouring pastes and powders and other scouring preparations; (whether or not in the form of paper, wadding, felt, nonwovens, cellular plastics, cellular rubber, impregnated, coated or covered)",
  "340590":
    "Polishes, creams and similar preparations; n.e.c. in heading no. 3405, excluding waxes of heading no. 3404",
  "340600": "Candles, tapers and the like",
  "340700":
    "Modelling pastes; preparations known as dental wax, put up in sets, in packings for retail sale or in plates, horseshoe shapes, sticks or similar forms, other preparations for use in dentistry",
  "350110": "Casein",
  "350190": "Caseinates and other casein derivatives; casein glues",
  "350210": "Albumins; egg albumin",
  "350211": "Albumins; egg albumin, dried",
  "350219": "Albumins; egg albumin, not dried",
  "350220":
    "Albumins; milk albumin, including concentrates of two or more whey proteins",
  "350290":
    "Albumins, albuminates and other albumin derivatives; other than egg or milk albumin, including concentrates of two or more whey proteins",
  "350300":
    "Gelatin (including gelatin in rectangular sheets, whether or not surface-worked or coloured) and gelatin derivatives; isinglass; other glues of animal origin, excluding casein glues of heading no. 3501",
  "350400":
    "Peptones and their derivatives; other protein substances and their derivatives n.e.c. or included, hide powder, whether or not chromed",
  "350510": "Dextrins and other modified starches",
  "350520":
    "Glues; based on starches, or on dextrins or other modified starches",
  "350610":
    "Glues or adhesives; prepared, products suitable for use as glues or adhesives, put up for retail sale as glues or adhesives, not exceeding a net weight of 1kg",
  "350691":
    "Adhesives; prepared, based on polymers of heading 3901 to 3913 or on rubber",
  "350699":
    "Glues and other adhesives; prepared, n.e.c. in heading no. 3506, not exceeding a net weight of 1kg",
  "350710": "Enzymes; rennet and concentrates thereof",
  "350790":
    "Enzymes and prepared enzymes; other than rennet and concentrates thereof",
  "360100": "Explosives; propellent powders",
  "360200": "Explosives, prepared; other than propellent powders",
  "360300":
    "Fuses and detonators; safety or detonating fuses, percussion or detonating caps, igniters, electric detonators",
  "360310": "Safety fuses",
  "360320": "Detonating cords",
  "360330": "Percussion caps",
  "360340": "Detonating caps",
  "360350": "Igniters",
  "360360": "Electric detonators",
  "360410": "Pyrotechnic products; fireworks",
  "360490":
    "Pyrotechnic products; signalling flares, rain rockets, fog signals and other pyrotechnic articles (excluding fireworks)",
  "360500": "Matches; other than pyrotechnic articles of heading no. 3604",
  "360610":
    "Fuels; liquid or liquefied-gas, in containers, of a kind used for filling or refilling cigarette or similar lighters, (of a capacity not exceeding 300cm3)",
  "360690":
    "Ferro-cerium and other pyrophoric alloys in all forms; articles of combustible materials n.e.c. in chapter 36",
  "370110":
    "Photographic plates and film; for x-ray, in the flat, sensitised, unexposed, of any material other than paper, paperboard or textiles",
  "370120":
    "Photographic plates and film; instant print film, in the flat, sensitised, unexposed, whether or not in packs",
  "370130":
    "Photographic plates and film; in the flat, sensitised, unexposed, with any side exceeding 225mm, of any materials other than paper, paperboard or textiles",
  "370191":
    "Photographic plates and film; for colour photography (polychrome), in the flat, sensitised, unexposed, with no side exceeding 255mm, of any material other than paper, paperboard or textiles",
  "370199":
    "Photographic plates and film; (for other than colour photography), in the flat, sensitised, unexposed, with no side exceeding 255mm, of any material other than paper, paperboard or textiles",
  "370210":
    "Photographic film; for x-rays, in rolls, sensitised and unexposed (other than of paper, paperboard or textiles)",
  "370220":
    "Photographic film; instant print film, in rolls, sensitised and unexposed",
  "370231":
    "Photographic film; for colour photography (polychrome), in rolls, sensitised, unexposed, without sprocket holes, of a width not exceeding 105mm (other than of paper, paperboard or textiles)",
  "370232":
    "Photographic film; in rolls, with silver halide emulsion, sensitised, unexposed, without sprocket holes, of a width not exceeding 105mm (other than of paper, paperboard or textiles)",
  "370239":
    "Photographic film; in rolls, (other than with silver halide emulsion and for colour photography), sensitised, unexposed, without sprocket holes, of a width not exceeding 105mm (other than of paper, paperboard or textiles)",
  "370241":
    "Photographic film; for colour photography (polychrome), in rolls, sensitised, unexposed, without sprocket holes, of a width exceeding 610mm and of a length exceeding 200m (other than of paper, paperboard or textiles)",
  "370242":
    "Photographic film; in rolls, (other than for colour photography), sensitised, unexposed, without sprocket holes, of a width exceeding 610mm and of a length exceeding 200m (other than of paper, paperboard or textiles)",
  "370243":
    "Photographic film; in rolls, sensitised, unexposed, without sprocket holes, of a width exceeding 610mm and of a length not exceeding 200m (other than of paper, paperboard or textiles)",
  "370244":
    "Photographic film; in rolls, sensitised, unexposed, without sprocket holes, of a width exceeding 105mm but not exceeding 610mm (other than of paper, paperboard or textiles)",
  "370251":
    "Photographic film; for colour photography (polychrome), in rolls, sensitised, unexposed, of a width not exceeding 16mm and of a length not exceeding 14m (other than of paper, paperboard or textiles)",
  "370252":
    "Photographic film; for colour photography (polychrome), in rolls, sensitised, unexposed, of a width not exceeding 16mm (other than of paper, paperboard or textiles)",
  "370253":
    "Photographic film; for colour photography (polychrome) slides, in rolls, sensitised, unexposed, of a width exceeding 16mm but not exceeding 35mm and of a length not exceeding 30m (other than of paper, paperboard or textiles)",
  "370254":
    "Photographic film; for colour photography (polychrome), in rolls, sensitised, unexposed, of a width exceeding 16mm but not 35mm and of a length not exceeding 30m, excluding film for slides (other than of paper, paperboard or textiles)",
  "370255":
    "Photographic film; for colour photography (polychrome), in rolls, sensitised, unexposed, of a width exceeding 16mm but not 35mm and of a length exceeding 30m (other than of paper, paperboard or textiles)",
  "370256":
    "Photographic film; for colour photography (polychrome), in rolls, sensitised, unexposed, of a width exceeding 35mm (other than of paper, paperboard or textiles)",
  "370291":
    "Photographic film; in rolls, (for other than colour photography), of a width not exceeding 16mm (other than of paper, paperboard or textiles)",
  "370292":
    "Photographic film; in rolls, (for other than colour photography), sensitised, unexposed, of a width not exceeding 16mm and length exceeding 14m",
  "370293":
    "Photographic film; in rolls, (for other than colour film), sensitised, unexposed, of a width exceeding 16mm but not 35mm and of a length not exceeding 30m (other than of paper, paperboard or textiles)",
  "370294":
    "Photographic film; in rolls, (for other than colour photography), sensitised, unexposed, of a width exceeding 16mm but not 35mm and of a length exceeding 30m (other than of paper, paperboard or textiles)",
  "370295":
    "Photographic film; in rolls, (for other than colour photography), sensitised, unexposed, of a width exceeding 35mm (other than of paper, paperboard or textiles)",
  "370296":
    "Photographic film; other than for colour photography, in rolls, sensitised, unexposed, of a width not exceeding 35mm and of a length not exceeding 30m (other than of paper, paperboard or textiles)",
  "370297":
    "Photographic film; other than for colour photography, in rolls, sensitised, unexposed, of a width not exceeding 35mm and of a length exceeding 30m (other than paper, paperboard or textiles)",
  "370298":
    "Photographic film; other than for colour photography, in rolls, sensitised, unexposed, of a width exceeding 35mm (other than of paper, paperboard or textiles)",
  "370310":
    "Photographic paper, paperboard and textiles; in rolls, sensitised, unexposed, of a width exceeding 610mm",
  "370320":
    "Photographic paper, paperboard and textiles; for colour photography (polychrome), (other than in rolls of a width exceeding 610mm), sensitised, unexposed",
  "370390":
    "Photographic paper, paperboard and textiles; (for other than colour photography, other than in rolls of a width exceeding 610mm), sensitised, unexposed",
  "370400":
    "Photographic plates, film, paper, paperboard and textiles; exposed but not developed",
  "370500":
    "Photographic plates and film; exposed and developed, other than cinematographic film",
  "370510":
    "Photographic plates and film; for offset reproduction, exposed and developed",
  "370520": "Photographic plates and film; microfilms, exposed and developed",
  "370590":
    "Photographic plates and film; exposed and developed, (other than cinematographic film or for offset reproduction)",
  "370610":
    "Cinematographic film; exposed and developed, whether or not incorporating sound track or consisting only of sound track, of a width of 35cm or more",
  "370690":
    "Cinematographic film; exposed and developed, whether or not incorporating a sound track or consisting only of sound track, of a width less than 35mm",
  "370710":
    "Photographic goods; sensitised emulsions, put up in measured portions or put up for retail sale in a form ready for use",
  "370790":
    "Photographic goods; chemical preparations other than sensitised emulsions, put up in measured portions or put up for retail sale in a form ready for use",
  "380110": "Graphite; artificial",
  "380120": "Graphite; colloidal or semi-colloidal",
  "380130":
    "Carbonaceous pastes; for electrodes and similar pastes for furnace linings",
  "380190":
    "Graphite or other carbon based preparations; in the form of pastes, blocks, plates or other semi-manufactures",
  "380210": "Carbon; activated",
  "380290":
    "Chemical products; activated natural mineral products, animal black, including spent animal black",
  "380300": "Chemical products; tall oil, whether or not refined",
  "380400":
    "Lyes, residual; from the manufacture of wood pulp, whether or not concentrated, desugared or chemically treated, including lignin sulphonates but excluding tall oil of heading no. 3803",
  "380510": "Terpenic oils; gum, wood or sulphate turpentine oils",
  "380520":
    "Terpenic oils; pine oil, containing alpha-terpineol as the main constituent",
  "380590":
    "Terpenic oils; produced by the treatment of coniferous woods, crude dipentene, sulphite turpentine and other crude para-cymene, n.e.c. in heading no. 3805",
  "380610": "Rosin and resin acids",
  "380620":
    "Rosin and resin; salts of rosin, of resin acids or of derivatives of rosin or resin acids, other than salts of rosin adducts",
  "380630": "Ester gums",
  "380690": "Rosin; spirit and oils, n.e.c. in heading no. 3806",
  "380700":
    "Wood tar; wood tar oils; wood creosote; wood naphtha; vegetable pitch; brewers' pitch and similar preparations based on rosin, resin acids or on vegetable pitch",
  "380810":
    "Insecticides; put up in forms or packings for retail sale or as preparations or articles",
  "380820":
    "Fungicides; put up in forms or packings for retail sale or as preparations or articles",
  "380830":
    "Herbicides, anti-sprouting products and plant-growth regulators; put up in forms or packings for retail sale or as preparations or articles",
  "380840":
    "Disinfectants and similar products; in forms, packings or articles for retail sale",
  "380850":
    "Insecticides, rodenticides, fungicides, disinfectants, herbicides and the like; containing goods specified in Subheading Note 1 to this Chapter; put up in forms or packings for retail sale or as preparations or articles",
  "380852":
    "Insecticides and the like; containing goods specified in Subheading Note 1 to this Chapter; for retail sale or as preparations or articles; DDT (ISO) (clofenotane (INN)), in packings of 300g or less",
  "380859":
    "Insecticides, rodenticides, fungicides, disinfectants, herbicides and the like; containing goods specified in Subheading Note 1 to this Chapter; not DDT (ISO) (clofenotane (INN)), put up in forms or packings for retail sale or as preparations or articles",
  "380861":
    "Insecticides and the like; containing goods specified in Subheading Note 2 to this Chapter; in packings of a net weight content not exceeding 300g; for retail sale or as preparations or articles",
  "380862":
    "Insecticides; containing goods specified in Subheading Note 2 to this Chapter; put up in forms or packings for retail sale or as preparations or articles, in packings of a net weight content exceeding 300g but not exceeding 7.5kg",
  "380869":
    "Insecticides; containing goods named in Subheading Note 2 to this Chapter, put up in forms or packings for retail sale or as preparations or articles, in packings of a net weight content exceeding 7.5kg",
  "380890":
    "Rodenticides and similar products; n.e.s. in heading no. 3808, in forms, packings or articles for retail sale",
  "380891":
    "Insecticides; other than containing goods specified in Subheading Notes 1 & 2 to this Chapter; put up in forms or packings for retail sale or as preparations or articles",
  "380892":
    "Fungicides; other than containing goods specified in Subheading Note 1 to this Chapter; put up in forms or packings for retail sale or as preparations or articles",
  "380893":
    "Herbicides, anti-sprouting products and plant-growth regulators; other than containing goods of Subheading Note 1 to this Chapter; put up in forms or packings for retail sale or as preparations or articles",
  "380894":
    "Disinfectants; other than containing goods specified in Subheading Note 1 in this Chapter; put up in forms or packings for retail sale or as preparations or articles",
  "380899":
    "Rodenticides and other similar products n.e.c. in heading no. 3808.9; other than containing goods specified in Subheading Note 1 in this Chapter, put up in forms or packings for retail sale or as preparations or articles",
  "380910":
    "Finishing agents and dye carriers; to accelerate dyeing or fixing of dye-stuffs, other products and preparations, used in textile, paper, leather etc industries, with basis of amylaceous substances, n.e.c.",
  "380991":
    "Finishing agents and dye carriers; to accelerate dyeing or fixing of dye-stuffs, other products and preparations, used in the textile industry (excluding those with a basis of amylaceous substances)",
  "380992":
    "Finishing agents and dye carriers; to accelerate dyeing or fixing of dye-stuffs, other products and preparations, used in the paper industry (excluding those with a basis of amylaceous substances)",
  "380993":
    "Finishing agents and dye carriers; to accelerate dyeing or fixing of dye-stuffs, other products and preparations, used in the leather or like (excluding paper and textile) industries, (excluding those with a basis of amylaceous substances)",
  "380999":
    "Finishing agents and dye carriers; to accelerate dyeing or fixing of dye-stuffs and other products and preparations, used in the leather or like (excluding textile or paper) industries, n.e.s. in item 3809.9",
  "381010":
    "Pickling preparations for metal surfaces; soldering, brazing or welding powders and pastes consisting of metal and other materials",
  "381090":
    "Fluxes and other auxiliary preparations; for soldering, brazing or welding, or preparations used as cores or coatings for welding electrodes or rods",
  "381111": "Anti-knock preparations; based on lead compounds",
  "381119": "Anti-knock preparations; other than those based on lead compounds",
  "381121":
    "Lubricating oil additives; containing petroleum oils or oils obtained from bituminous minerals",
  "381129":
    "Lubricating oil additives; not containing petroleum oils or oils obtained from bituminous minerals",
  "381190":
    "Oxidation and gum inhibitors, viscosity improvers, anti-corrosive preparations, other prepared additives for mineral oils or liquids used as mineral oils (including gasoline), n.e.c. in heading no. 3811",
  "381210": "Rubber accelerators; prepared",
  "381220": "Plasticisers, compound; for rubber or plastics",
  "381230":
    "Anti-oxidising preparations and other compound stabilisers; for rubber or plastics, n.e.c. or included",
  "381231":
    "Anti-oxidising preparations and other compound stabilisers; for rubber or plastics, mixtures of oligomers of 2,2,4-trimethyl-1,2-dihydroquinoline (TMQ)",
  "381239":
    "Anti-oxidising preparations and other compound stabilisers; for rubber or plastics, other than mixtures of oligomers of 2,2,4-trimethyl-1,2-dihydroquinoline (TMQ)",
  "381300":
    "Fire-extinguishers; preparations and charges and charged fire-extinguishing grenades",
  "381400":
    "Solvents and thinners; organic composite solvents and thinners, n.e.c. or included, prepared paint or varnish removers",
  "381511":
    "Catalysts, supported; reaction initiators, reaction accelerators and catalytic preparations, with nickel or nickel compounds as the active substance, n.e.c. or included",
  "381512":
    "Catalysts, supported; reaction initiators, reaction accelerators and catalytic preparations, with precious metal or precious metal compounds as the active substance, n.e.c. or included",
  "381519":
    "Catalysts, supported; reaction initiators, reaction accelerators and catalytic preparations, with an active substance other than nickel or precious metals or their compounds, n.e.c. or included",
  "381590":
    "Reaction initiators, reaction accelerators and catalytic preparations, unsupported, n.e.c. or included",
  "381600":
    "Refractory cements, mortars, concretes and similar compositions; other than products of heading no. 3801",
  "381700":
    "Mixed alkylbenzenes and mixed alkylnaphthalenes, other than those of heading no. 2707 or 2902",
  "381710":
    "Alkylbenzenes; mixed, other than those of heading no. 2707 or 2902",
  "381720":
    "Alkylnaphthalenes; mixed, other than those of heading no. 2707 or 2902",
  "381800": "Chemical compounds doped for use in electronics",
  "381900":
    "Hydraulic fluids; for brakes and other prepared liquids for hydraulic transmission, not containing or containing less than 70% by weight of petroleum oils or oils obtained from bituminous minerals",
  "382000": "Anti-freezing preparations and prepared de-icing fluids",
  "382100":
    "Prepared culture media for the development or maintenance of micro-organisms (including viruses and the like) or of plant, human or animal cells",
  "382200":
    "Other composite diagnostic or laboratory reagents (exclusionary category)",
  "382211":
    "Reagents; diagnostic or laboratory reagents on a backing, prepared diagnostic or laboratory reagents whether or not on a backing, whether or not put up in the form of kits; for malaria",
  "382212":
    "Reagents; diagnostic or laboratory reagents on a backing, prepared diagnostic or laboratory reagents whether or not on a backing, whether or not put up in the form of kits; for zika and other diseases transmitted by mosquitoes of the genus Aedes",
  "382213":
    "Reagents; diagnostic or laboratory reagents on a backing, prepared diagnostic or laboratory reagents whether or not on a backing, whether or not put up in the form of kits; for blood grouping",
  "382219":
    "Reagents; diagnostic or laboratory reagents on a backing, prepared diagnostic or laboratory reagents whether or not on a backing, whether or not put up in the form of kits; n.e.c.in item 3822.1",
  "382290":
    "Reagents; diagnostic or laboratory reagents on a backing, prepared diagnostic or laboratory reagents whether or not on a backing, or put up in the form of kits, other than those of heading 30.06; certified reference materials, n.e.c. in heading 3822",
  "382310": "Binders, prepared; for foundry moulds or cores",
  "382311":
    "Industrial monocarboxylic fatty acids, acid oils from refining; stearic acid",
  "382312":
    "Industrial monocarboxylic fatty acids, acid oils from refining; oleic acid",
  "382313":
    "Industrial monocarboxylic fatty acids, acid oils from refining; tall oil fatty acids",
  "382319":
    "Industrial monocarboxylic fatty acids; acid oils from refining; (other than stearic acid, oleic acid or tall oil fatty acids)",
  "382320":
    "Acids; naphthenic acids, their water-insoluble salts and their esters",
  "382330":
    "Metal carbides; non-agglomerated, mixed together or with metallic binders",
  "382340": "Cements, mortars or concretes; their prepared additives",
  "382350": "Mortars and concretes; non-refractory",
  "382360": "Sorbitol; other than that of item no. 2905.44",
  "382370": "Industrial fatty alcohols",
  "382390":
    "Chemical products, preparations and residual products of chemical or allied industries n.e.s. or included in heading no. 3823",
  "382410": "Binders, prepared; for foundry moulds or cores",
  "382420":
    "Acids; naphthenic acids, their water-insoluble salts and their esters",
  "382430":
    "Metal carbides, non-agglomerated; mixed together or with metallic binders",
  "382440": "Cements, mortars or concretes; their prepared additives",
  "382450": "Mortars and concretes; non-refractory",
  "382460": "Sorbitol; other than that of subheading no. 2905.44",
  "382471":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing chlorofluorocarbons (CFCs), whether or not containing hydrochlorofluorocarbons (HCFCs), perfluorocarbons (PFCs) or hydrofluorocarbons (HFCs)",
  "382472":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing bromochlorodifluoromethane, bromotrifluoromethane or dibromotetrafluoroethanes",
  "382473":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing hydrobromofluorocarbons (HBFCs)",
  "382474":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing hydrochlorofluorocarbons (HCFCs), whether or not containing perfluorocarbons (PFCs) or hydrofluorocarbons (HFCs), but not containing chlorofluorocarbons (CFCs)",
  "382475":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing carbon tetrachloride",
  "382476":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing 1,1,1-trichloroethane (methyl chloroform)",
  "382477":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing bromomethane (methyl bromide) or bromochloromethane",
  "382478":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing perfluorocarbons (PFCs) or hydrofluorocarbons (HFCs), but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs)",
  "382479":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; n.e.c. in item no. 3827.7",
  "382481":
    "Chemical products, mixtures and preparations; containing goods specified in Subheading Note 3 to this Chapter; containing oxirane (ethylene oxide)",
  "382482":
    "Chemical products, mixtures and preparations; containing goods specified in Subheading Note 3 to this Chapter; containing polychlorinated biphenyls (PCBs), polychlorinated terphenyls (PCTs) or polybrominated biphenyls (PBBs)",
  "382483":
    "Chemical products, mixtures and preparations; containing goods specified in Subheading Note 3 to this Chapter; containing tris(2,3-dibromopropyl) phosphate",
  "382484":
    "Chemical products, mixtures and preparations; containing aldrin, camphechlor (toxaphene), chlordane, chlordecone, DDT (chlorfenotane, 1,1,1-trichloro-2,2-bis(p-chlorophenyl)ethane), dieldrin, endosulfan, endrin, heptachlor or mirex",
  "382485":
    "Chemical products, mixtures and preparations; containing goods specified in Subheading Note 3 to this Chapter; containing 1,2,3,4,5,6-hexachlorocyclohexane (HCH (ISO)), including lindane (ISO, INN)",
  "382486":
    "Chemical products, mixtures and preparations; containing goods specified in Subheading Note 3 to this Chapter; containing pentachlorobenzene (ISO), or hexachlorobenzene (ISO)",
  "382487":
    "Chemical products, mixtures and preparations; containing goods specified in Subheading Note 3 to this Chapter; containing perfluorooctane sulphonic acid, its salts, perfluorooctane sulphonamides, or perfluorooctane sulphonyl fluoride",
  "382488":
    "Chemical products, mixtures and preparations; containing goods specified in Subheading Note 3 to this Chapter; containing tetra-, penta-, hexa-, hepta- or octabromodiphenyl ethers",
  "382489":
    "Chemical products, mixtures and preparations; containing goods specified in Subheading Note 3 to this Chapter; containing short-chain chlorinated paraffins",
  "382490":
    "Chemical products, preparations and residual products of the chemical or allied industries, n.e.c. or included in heading no. 3824",
  "382491":
    "Chemical products, mixtures and preparations; consisting mainly of (5-ethyl-2-methyl-2-oxido-1,3,2-dioxaphosphinan-5-yl)methyl methylphosphonate and bis[(5-ethyl-2-methyl-2-oxido-1,3,2-dioxaphosphinan-5-yl)methyl] methylphosphonate",
  "382492":
    "Chemical products, mixtures and preparations; polyglycol esters of methylphosphonic acid",
  "382499":
    "Other chemical products, mixtures and preparations (exclusionary category)",
  "382510":
    "Residual products of the chemical or allied industries, not elsewhere specified or included; municipal waste",
  "382520":
    "Residual products of the chemical or allied industries, not elsewhere specified or included; sewage sludge",
  "382530":
    "Residual products of the chemical or allied industries, not elsewhere specified or included; clinical waste",
  "382541":
    "Residual products of the chemical or allied industries, not elsewhere specified or included; halogenated waste organic solvents",
  "382549":
    "Residual products of the chemical or allied industries, not elsewhere specified or included; waste organic solvents, other than halogenated",
  "382550":
    "Residual products of chemical or allied industries, not elsewhere specified or included; wastes of metal pickling liquors, hydraulic fluids, brake fluids and anti-freeze fluids",
  "382561":
    "Residual products of the chemical or allied industries, not elsewhere specified or included; (other than sewage sludge, municipal waste or waste covered in 27.10); other wastes n.e.c. in 3825; those mainly containing organic constituents",
  "382569":
    "Residual products of the chemical or allied industries, not elsewhere specified or included; (other than sewage sludge, municipal waste or waste covered by 27.10); other wastes n.e.c. in 3825; except those mainly containing organic constituents",
  "382590":
    "Residual products of the chemical or allied industries, not elsewhere specified or included; n.e.c. in 3825 or 27.10",
  "382600": "Biodiesel; incl. Mixtures",
  "382711":
    "Mixtures containing halogenated derivatives of methane, ethane or propane, not elsewhere specified or included; containing chlorofluorocarbons (CFCs), whether or not containing hydrochlorofluorocarbons (HCFCs), perfluorocarbons (PFCs) or hydrofluorocarbon",
  "382712":
    "Mixtures containing halogenated derivatives of methane, ethane or propane, not elsewhere specified or included; containing hydrobromofluorocarbons (HBFCs)",
  "382713":
    "Mixtures containing halogenated derivatives of methane, ethane or propane, not elsewhere specified or included; containing carbon tetrachloride",
  "382714":
    "Mixtures containing halogenated derivatives of methane, ethane or propane, not elsewhere specified or included; containing 1,1,1-trichloroethane (methyl chloroform)",
  "382720":
    "Mixtures containing halogenated derivatives of methane, ethane or propane, not elsewhere specified or included; containing bromochlorodifluoromethane (Halon-1211), bromotrifluoromethane (Halon-1301) or dibromotetrafluoroethanes (Halon-2402)",
  "382731":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing hydrochlorofluorocarbons (HCFCs), perfluorocarbons (PFCs) or hydrofluorocarbons (HFCs) or not, but not containing chlorofluorocarbons (CFCs); containing substances of su",
  "382732":
    "Mixtures containing halogenated methane, ethane, propane; containing hydrochlorofluorocarbons (HCFCs), perfluorocarbons (PFCs) or hydrofluorocarbons (HFCs) or not, not chlorofluorocarbons (CFCs); containing substances of subheadings 2903.71 to 2903.75",
  "382739":
    "Mixtures containing halogenated methane, ethane, or propane; containing hydrochlorofluorocarbons (HCFCs), perfluorocarbons (PFCs) or hydrofluorocarbons (HFCs) or not, but not chlorofluorocarbons (CFCs); n.e.c. in subheading 3827.3",
  "382740":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing hydrochlorofluorocarbons (HCFCs), perfluorocarbons (PFCs) or hydrofluorocarbons (HFCs) or not, but not containing chlorofluorocarbons (CFCs); containing bromomethane",
  "382751":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing trifluoromethan (HFC-23) or perfluorocarbons (PFCs) but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); containing trifluoromethane (HFC-2",
  "382759":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing trifluoromethan (HFC-23) or perfluorocarbons (PFCs) not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); other mixtures n.e.c. in subheading 38",
  "382761":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing other hydrofluorocarbons (HFCs) but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); containing 15% or more by mass of 1,1,1-trifluoroethan",
  "382762":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing other hydrofluorocarbons (HFCs) but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); other mixtures, not included in the subheading above,",
  "382763":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing other hydrofluorocarbons (HFCs) but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); other mixtures not included in the subheadings above,",
  "382764":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing other hydrofluorocarbons (HFCs) but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); other mixtures, not included in the subheadings above,",
  "382765":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing other hydrofluorocarbons (HFCs) but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); other mixtures, not included in the subheadings above,",
  "382768":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing other hydrofluorocarbons (HFCs) but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); other mixtures, not included in the subheadings above,",
  "382769":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; containing other hydrofluorocarbons (HFCs) but not containing chlorofluorocarbons (CFCs) or hydrochlorofluorocarbons (HCFCs); n.e.c. in items no. 3827.5 and 3827.6, not containing",
  "382790":
    "Mixtures containing halogenated derivatives of methane, ethane or propane; n.e.c. in subheading no 3827",
  "390110": "Polyethylene; specific gravity < 0.94",
  "390120": "Polyethylene; specific gravity > 0.94",
  "390130":
    "Ethylene polymers; in primary forms, ethylene-vinyl acetate copolymers",
  "390140": "Ethylene-alpha-olefin copolymers; specific gravity <0.94",
  "390190": "Ethylene polymers; in primary forms, n.e.c. in heading no. 3901",
  "390210": "Polypropylene",
  "390220":
    "Propylene, other olefin polymers; polyisobutylene in primary forms",
  "390230": "Propylene copolymers",
  "390290":
    "Propylene, other olefin polymers; n.e.c. in heading no. 3902, in primary forms",
  "390311": "Styrene polymers; expansible polystyrene, in primary forms",
  "390319":
    "Styrene polymers; (other than expansible polystyrene), in primary forms",
  "390320":
    "Styrene polymers; styrene-acrylonitrile (SAN) copolymers, in primary forms",
  "390330":
    "Styrene polymers; acrylonitrile-butadiene-styrene (ABS) copolymers, in primary forms",
  "390390": "Styrene polymers; in primary forms, n.e.c. in heading no. 3903",
  "390410": "PVC (Polyvinyl chloride)",
  "390421":
    "Vinyl chloride, other halogenated olefin polymers; non-plasticised poly(vinyl chloride), in primary forms, mixed with other substances",
  "390422":
    "Vinyl chloride, other halogenated olefin polymers; plasticised poly(vinyl chloride), in primary forms, mixed with other substances",
  "390430":
    "Vinyl chloride, other halogenated olefin polymers; vinyl chloride-vinyl acetate copolymers, in primary forms",
  "390440":
    "Vinyl chloride, other halogenated olefin polymers; vinyl chloride copolymers, in primary forms n.e.c. in heading no. 3904",
  "390450":
    "Vinyl chloride, other halogenated olefin polymers; vinylidene chloride polymers, in primary forms",
  "390461":
    "Halogenated olefin polymers; fluoro-polymers, polytetrafluoroethylene, in primary forms",
  "390469":
    "Halogenated olefin polymers; fluoro-polymers (other than polytetrafluoroethylene), in primary forms",
  "390490":
    "Vinyl chloride, other halogenated olefin polymers; n.e.c. in heading no. 3904",
  "390511": "Vinyl acetate polymers; in aqueous dispersion, in primary forms",
  "390512": "Poly(vinyl acetate); in aqueous dispersion, in primary forms",
  "390519":
    "Poly(vinyl acetate); (other than in aqueous dispersion), in primary forms",
  "390520":
    "Polyvinyl alcohol; whether or not containing unhydrolysed acetate groups",
  "390521": "Vinyl acetate copolymers; in aqueous dispersion, in primary forms",
  "390529":
    "Vinyl acetate copolymers; (other than in aqueous dispersion), in primary forms",
  "390530":
    "Poly(vinyl alcohol); whether or not containing unhydrolysed acetate groups",
  "390590":
    "Vinyl acetate, vinyl ester polymers, vinyl polymers; n.e.s. in heading no. 3905, in primary forms",
  "390591":
    "Vinyl acetate, vinyl ester polymers, vinyl polymers; n.e.c. in heading no. 3905, in primary forms, copolymers",
  "390599":
    "Vinyl acetate, vinyl ester polymers, vinyl polymers; n.e.c. in heading no. 3905, in primary forms, other than copolymers",
  "390610": "Acrylic polymers; poly(methyl methacrylate), in primary forms",
  "390690": "Acrylic polymers; excl. polymethyl methacrylate",
  "390710": "Polyacetals; in primary forms",
  "390720": "Polyethers",
  "390721":
    "Polyethers other than polyacetals; in primary forms, bis(polyoxyethylene) methylphosphonate",
  "390729":
    "Polyethers other than polyacetals, and bis(polyoxyethylene) methylphosphonate; in primary forms",
  "390730": "Epoxide resins; in primary forms",
  "390740": "Polycarbonates",
  "390750": "Alkyd resins; in primary forms",
  "390760": "Poly(ethylene terephthalate); in primary forms",
  "390761":
    "Poly(ethylene terephthalate); in primary forms, having a viscosity of 78ml/g or higher",
  "390769":
    "Poly(ethylene terephthalate); in primary forms, having a viscosity of less than 78ml/g",
  "390770": "Poly(lactic acid); in primary forms",
  "390791":
    "Polyesters; n.e.c. in heading no. 3907, unsaturated, in primary forms",
  "390799":
    "Polyesters; n.e.c. in heading no. 3907, saturated, in primary forms",
  "390810":
    "Polyamides; polyamide-6, -11, -12, -6,6, -6,9, -6,10 or -6,12, in primary forms",
  "390890": "Polyamides; n.e.c. in heading no. 3908, in primary forms",
  "390910": "Amino-resins; urea and thiourea resins, in primary forms",
  "390920": "Amino-resins; melamine resins, in primary forms",
  "390930": "Amino-resins; n.e.c. in heading no. 3909, in primary forms",
  "390931":
    "Amino-resins; n.e.c. in heading no. 3909, in primary forms, poly(methylene phenyl isocyanate) (Crude MDI, polymeric MDI)",
  "390939":
    "Amino-resins; n.e.c. in heading no. 3909, in primary forms, other than poly(methylene phenyl isocyanate) (Crude MDI, polymeric MDI)",
  "390940": "Phenolic resins; in primary forms",
  "390950": "Polyurethanes; in primary forms",
  "391000": "Silicones; in primary forms",
  "391110":
    "Petroleum resins, coumarone, indene or coumarone-indene resins and polyterpenes; in primary forms",
  "391120":
    "Petroleum resins, poly(1,3-phenylene methylphosphonate), in primary forms",
  "391190":
    "Polysulphides, polysulphones and similar products of chemical synthesis n.e.c. in chapter 39; in primary forms",
  "391211": "Cellulose acetates; non-plasticised, in primary forms",
  "391212": "Cellulose acetates; plasticised, in primary forms",
  "391220": "Cellulose nitrates (including collodions); in primary forms",
  "391231":
    "Cellulose ethers; carboxymethylcellulose and its salts, in primary forms",
  "391239":
    "Cellulose ethers; (other than carboxymethylcellulose and its salts), in primary forms",
  "391290":
    "Cellulose and its chemical derivatives; n.e.c. in item no. 3912, in primary forms",
  "391310":
    "Polymers, natural; alginic acid, its salts and esters, in primary forms",
  "391390":
    "Polymers, natural and modified natural; in primary forms (excluding alginic acid, its salts and esters)",
  "391400":
    "Ion-exchangers; based on polymers of heading no. 3901 to 3913, in primary forms",
  "391510": "Ethylene polymers; waste, parings and scrap",
  "391520": "Styrene polymers; waste, parings and scrap",
  "391530": "Vinyl chloride polymers; waste, parings and scrap",
  "391590": "Plastics n.e.c. in heading no. 3915; waste, parings and scrap",
  "391610":
    "Ethylene polymers; monofilament, of which any cross-sectional dimension exceeds 1mm, rods, sticks and profile shapes, whether or not surface-worked but not otherwise worked",
  "391620":
    "Vinyl chloride polymers; monofilament, of which any cross-sectional dimension exceeds 1mm, rods, sticks and profile shapes, whether or not surface-worked but not otherwise worked",
  "391690":
    "Plastics; monofilament, of plastics n.e.c. in heading no. 3916, cross-sectional dimension exceeds 1mm, rods, sticks and profile shapes, whether or not surface-worked but not otherwise worked",
  "391710":
    "Plastics; artificial guts (sausage casings) of hardened protein or of cellulosic materials",
  "391721":
    "Plastics; tubes, pipes and hoses thereof, rigid, of polymers of ethylene",
  "391722":
    "Plastics; tubes, pipes and hoses thereof, rigid, of polymers of propylene",
  "391723":
    "Plastics; tubes, pipes and hoses thereof, rigid, of polymers of vinyl chloride",
  "391729":
    "Plastics; tubes, pipes and hoses thereof, rigid, of plastics n.e.c. in heading no. 3917",
  "391731":
    "Plastics; tubes, pipes and hoses thereof, flexible, having a minimum burst pressure of 27.6MPa",
  "391732":
    "Plastics; tubes, pipes and hoses thereof, other than those of item no. 3917.31, not reinforced or otherwise combined with other materials, without fittings",
  "391733":
    "Plastics; tubes, pipes and hoses thereof, other than those of item no. 3917.31, not reinforced or otherwise combined with other materials, with fittings",
  "391739":
    "Plastics; tubes, pipes and hoses thereof, n.e.c. in item no. 3917.30",
  "391740":
    "Plastics; tube, pipe and hose fittings (e.g. joints, elbows, flanges)",
  "391810":
    "Floor, wall or ceiling coverings; of polymers of vinyl chloride, whether or not self-adhesive, in rolls or in the form of tiles",
  "391890":
    "Floor, wall or ceiling coverings; of plastics (excluding polymers of vinyl chloride), whether or not self-adhesive, in rolls or in the form of tiles",
  "391910":
    "Plastics; plates, sheets, film, foil, tape, strip, other flat shapes thereof, self-adhesive, in rolls of a width not exceeding 20cm",
  "391990":
    "Plastics; plates, sheets, film, foil, tape, strip, other flat shapes thereof, self-adhesive, other than in rolls of a width not exceeding 20cm",
  "392010":
    "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of polymers of ethylene, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392020":
    "Plastics; of polymers of propylene, plates, sheets, film, foil and strip (not self-adhesive), non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392030":
    "Plastics; of polymers of styrene, plates, sheets, film, foil and strip (not self-adhesive), non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392041":
    "Plastics; rigid, of polymers of vinyl chloride, plates, sheets, film, foil and strip, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392042":
    "Plastics; flexible, of polymers of vinyl chloride, plates, sheets, film, foil and strip, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392043":
    "Plastics; polymers of vinyl chloride, containing by weight not less than 6% of plasticisers; plates, sheets, film, foil and strip (not self-adhesive), non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392049":
    "Plastics; polymers of vinyl chloride, containing by weight, less than 6% of plasticisers; plates, sheets, film, foil and strip (not self-adhesive), non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392051":
    "Plastics; of acrylic polymers, polymethyl methacrylate, plates, sheets, film, foil and strip (not self-adhesive), non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392059":
    "Plastics; of acrylic polymers (excluding polymethyl methacrylate), plates, sheets, film, foil and strip (not self-adhesive), non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392061":
    "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of polycarbonates, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392062":
    "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of poly(ethylene terephthalate), non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392063":
    "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of unsaturated polyesters, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392069":
    "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of polyesters n.e.c. in heading no. 3920, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392071":
    "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of regenerated cellulose; non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392072":
    "Plastics; plates, sheets, film, foil and strip, of vulcanised fibre, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392073":
    "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of cellulose acetate, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392079":
    "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of cellulose derivatives n.e.c. in heading no. 3920, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392091":
    "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of poly(vinyl butyral), non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392092":
    "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of polyamides, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392093":
    "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of amino-resins, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392094":
    "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of phenolic resins, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392099":
    "Plastics; plates, sheets, film, foil and strip (not self-adhesive), of plastics n.e.c. in heading no. 3920, non-cellular and not reinforced, laminated, supported or similarly combined with other materials",
  "392111":
    "Plastics; plates, sheets, film, foil and strip, of polymers of styrene, cellular",
  "392112":
    "Plastics; plates, sheets, film, foil and strip, of polymers of vinyl chloride, cellular",
  "392113":
    "Plastics; plates, sheets, film, foil and strip, of polyurethanes, cellular",
  "392114":
    "Plastics; plates, sheets, film, foil and strip, of regenerated cellulose, cellular",
  "392119":
    "Plastics; plates, sheets, film, foil and strip, of plastics n.e.c. in heading no. 3921, cellular",
  "392190": "Plastic plates, sheets, film, foil, and strip; non-cellular",
  "392210": "Plastics; baths, shower-baths, sinks and wash-basins",
  "392220": "Plastics; lavatory seats and covers",
  "392290":
    "Plastics; bidets, lavatory pans, flushing cisterns and similar sanitary ware n.e.c. in heading no. 3922",
  "392310": "Plastic boxes, cases, and crates",
  "392321": "Plastic sacks, bags, and cones; of ethylene polymers",
  "392329":
    "Plastics; sacks and bags (including cones), for the conveyance or packing of goods, of plastics other than ethylene polymers",
  "392330": "Plastic bottles and flasks",
  "392340":
    "Plastics; spools, cops, bobbins and similar supports, for the conveyance or packing of goods",
  "392350": "Plastic stoppers, lids, caps, and other closures",
  "392390":
    "Plastics; articles for the conveyance or packing of goods n.e.c. in heading no. 3923",
  "392410": "Plastic tableware and kitchenware",
  "392490": "Plastic household and hygienic articles ",
  "392510":
    "Plastics; builders' ware, reservoirs, tanks, vats and similar containers of a capacity exceeding 300 litres",
  "392520":
    "Plastics; builders' ware, doors, windows and their frames and thresholds for doors",
  "392530":
    "Plastics; builders' ware, shutters, blinds (including venetian blinds) and similar articles and parts thereof",
  "392590": "Plastics; builders' ware, n.e.c. or included in heading no. 3925",
  "392610": "Plastics; office or school supplies",
  "392620": "Plastic apparel and clothing accessories",
  "392630": "Plastics; fittings for furniture, coachwork or the like",
  "392640": "Plastics; statuettes and other ornamental articles",
  "392690": "Other plastic articles (exclusionary category)",
  "400110":
    "Rubber; natural rubber latex, whether or not pre-vulcanised, in primary forms or in plates, sheets or strip",
  "400121": "Natural rubber; in smoked sheets",
  "400122": "Technically specified natural rubber (TSNR)",
  "400129":
    "Rubber; natural (excluding latex, technically specified natural rubber and smoked sheets), in primary forms or in plates, sheets or strip",
  "400130":
    "Balata, gutta-percha, guayule, chicle and similar natural gums; in primary forms or in plates, sheets or strip",
  "400211":
    "Rubber; synthetic, styrene-butadiene rubber (SBR) and carboxylated styrene-butadiene rubber (XSBR) latex, in primary forms or in plates, sheets or strip",
  "400219":
    "Rubber; synthetic, styrene-butadiene rubber (SBR) and carboxylated styrene-butadiene rubber (XSBR), (other than latex), in primary forms or in plates, sheets or strip",
  "400220":
    "Rubber; synthetic, butadiene rubber (BR), in primary forms or in plates, sheets or strip",
  "400231":
    "Rubber; synthetic, isobutene-isoprene (butyl) rubber (IIR), in primary forms or in plates, sheets or strip",
  "400239":
    "Rubber; synthetic, halo-isobutene-isoprene rubber (CIIR or BIIR), in primary forms or in plates, sheets or strip",
  "400241":
    "Rubber; synthetic, chloroprene (chlorobutadiene) rubber (CR), latex, in primary forms or in plates, sheets or strip",
  "400249":
    "Rubber; synthetic, chloroprene (chlorobutadiene) rubber (CR), (other than latex), in primary forms or in plates, sheets or strip",
  "400251":
    "Rubber; synthetic, acrylonitrile-butadiene rubber (NBR), latex, in primary forms or in plates, sheets or strip",
  "400259":
    "Rubber; synthetic, acrylonitrile-butadiene rubber (NBR), (other than latex), in primary forms or in plates, sheets or strip",
  "400260":
    "Rubber; synthetic, isoprene rubber (IR), in primary forms or in plates, sheets or strip",
  "400270":
    "Rubber; synthetic, ethylene-propylene-non-conjugated diene rubber (EPDM), in primary forms or in plates, sheets or strip",
  "400280":
    "Rubber; mixtures of natural and synthetic rubbers of heading no. 4001 and 4002, in primary forms or in plates, sheets or strip",
  "400291":
    "Rubber; synthetic, n.e.c. in heading 4002, latex, in primary forms or in plates, sheets or strip",
  "400299":
    "Rubber; synthetic, n.e.c. in heading 4002, (other than latex), in primary forms or in plates, sheets or strip",
  "400300":
    "Rubber; reclaimed rubber, in primary forms or in plates, sheets or strip",
  "400400":
    "Rubber; waste, parings and scrap of rubber (other than hard rubber) and powders and granules obtained therefrom",
  "400510":
    "Rubber; unvulcanised, compounded with carbon black or silica, in primary forms or in plates, sheets or strip",
  "400520":
    "Rubber; unvulcanised, compounded, solutions and dispersions other than those of item no. 4005.10",
  "400591":
    "Rubber; unvulcanised, (compounded other than with carbon black or silica), in plates, sheets and strip",
  "400599":
    "Rubber; unvulcanised, (compounded other than with carbon black or silica), in primary forms, (other than plates, sheets, strip, solutions or dispersions)",
  "400610":
    "Rubber; unvulcanised, camel-back strips for retreading rubber tyres",
  "400690":
    "Rubber; unvulcanised, other than camel back strips for retreading rubber tyres",
  "400700": "Rubber; vulcanised, thread and cord",
  "400811":
    "Rubber; vulcanised (other than hard rubber), in plates, sheets and strip of cellular rubber",
  "400819":
    "Rubber; vulcanised (other than hard rubber), cellular rubber, (other than in plates, sheets or strip)",
  "400821":
    "Rubber; vulcanised (other than hard rubber), in plates, sheets and strip, of non-cellular rubber",
  "400829":
    "Rubber; vulcanised (other than hard rubber), non-cellular rubber, in forms other than plates, sheets or strip",
  "400910":
    "Rubber; vulcanised (other than hard rubber), tubes, pipes and hoses, not reinforced or otherwise combined with other materials, without fittings",
  "400911":
    "Rubber; vulcanised (other than hard rubber), tubing, piping and hoses, not reinforced or otherwise combined with other materials, without fittings",
  "400912":
    "Rubber; vulcanised (other than hard rubber), tubing, piping and hoses, not reinforced or otherwise combined with other materials, with fittings",
  "400920":
    "Rubber; vulcanised (other than hard rubber), tubes, pipes and hoses, reinforced or otherwise combined only with metal, without fittings",
  "400921":
    "Rubber; vulcanised (other than hard rubber), tubing, piping and hoses, reinforced or otherwise combined only with metal, without fittings",
  "400922":
    "Rubber; vulcanised (other than hard rubber), tubing, piping and hoses, reinforced or otherwise combined only with metal, with fittings",
  "400930":
    "Rubber; vulcanised (other than hard rubber), tubes, pipes and hoses, reinforced or otherwise combined only with textile materials, without fittings",
  "400931":
    "Rubber; vulcanised (other than hard rubber), tubing, piping and hoses, reinforced or otherwise combined only with textile materials, without fittings",
  "400932":
    "Rubber; vulcanised (other than hard rubber), tubing, piping and hoses, reinforced or otherwise combined only with textile materials, with fittings",
  "400940":
    "Rubber; vulcanised (other than hard rubber), tubes, pipes and hoses, reinforced or otherwise combined with materials other than metal or textile materials, without fittings",
  "400941":
    "Rubber; vulcanised (other than hard rubber), tubing, piping and hoses, reinforced or otherwise combined with materials other than metal or textiles, without fittings",
  "400942":
    "Rubber; vulcanised (other than hard rubber), tubing, piping and hoses, reinforced or otherwise combined with materials other than metal or textiles, with fittings",
  "400950":
    "Rubber; vulcanised (other than hard rubber), tubes, pipes and hoses, with fittings",
  "401010":
    "Rubber; vulcanised, conveyor or transmission belts or belting of trapezoidal cross-section (v-belts and v-belting)",
  "401011":
    "Rubber; vulcanised, conveyor belts or belting, reinforced only with metal",
  "401012":
    "Rubber; vulcanised, conveyor belts or belting, reinforced only with textile materials",
  "401013":
    "Rubber; vulcanised, conveyor belts or belting, reinforced only with plastics",
  "401019":
    "Rubber; vulcanised, conveyor belts or belting, (reinforced with other than metal only or textile materials only)",
  "401021":
    "Rubber; vulcanised, transmission belts or belting, endless, of trapezoidal cross-section (v-belts), whether or not grooved, of a circumference exceeding 60cm but not exceeding 180cm",
  "401022":
    "Rubber; vulcanised, transmission belts or belting, endless, of trapezoidal cross-section (v-belts), whether or not grooved, of a circumference exceeding 180cm but not exceeding 240cm",
  "401023":
    "Rubber; vulcanised, transmission belts or belting, endless synchronous belts (of a circumference exceeding 60cm but not exceeding 150cm)",
  "401024":
    "Rubber; vulcanised, transmission belts or belting, endless synchronous belts (of a circumference exceeding 150cm but not exceeding 198cm)",
  "401029":
    "Rubber; vulcanised, transmission belts or belting, n.e.s. in heading no. 4010",
  "401031":
    "Rubber; vulcanised, endless transmission belts of trapezoidal cross-section (V-belts), V-ribbed, of an outside circumference exceeding 60cm but not exceeding 180 cm",
  "401032":
    "Rubber; vulcanised, endless transmission belts of trapezoidal cross-section (V-belts), other than V-ribbed, of an outside circumference exceeding 60cm but not exceeding 180 cm",
  "401033":
    "Rubber; vulcanised, endless transmission belts of trapezoidal cross-section (V-belts), V-ribbed, of an outside circumference exceeding 180cm but not exceeding 240 cm",
  "401034":
    "Rubber; vulcanised, endless transmission belts of trapezoidal cross-section (V-belts), other than V-ribbed, of an outside circumference exceeding 180cm but not exceeding 240 cm",
  "401035":
    "Rubber; vulcanised, endless synchronous belts, of an outside circumference exceeding 60 cm but not exceeding 150 cm",
  "401036":
    "Rubber; vulcanised, endless synchronous belts, of an outside circumference exceeding 150 cm but not exceeding 198 cm",
  "401039":
    "Rubber; vulcanised, conveyor or transmission belts or belting, n.e.c. in heading no. 4010",
  "401091":
    "Rubber; vulcanised, conveyor or transmission belts or belting, of a width exceeding 20cm",
  "401099":
    "Rubber; vulcanised, conveyor or transmission belts or belting, of a width 20cm or less",
  "401110": "New pneumatic rubber tyres for motor cars",
  "401120": "New pneumatic rubber tyres for buses or lorries",
  "401130": "Rubber; new pneumatic tyres, of a kind used on aircraft",
  "401140": "Rubber; new pneumatic tyres, of a kind used on motorcycles",
  "401150": "Rubber; new pneumatic tyres, of a kind used on bicycles",
  "401161":
    "Rubber; new pneumatic tyres having a herring-bone or similar tread, of a kind used on agricultural or forestry vehicles and machines",
  "401162":
    "Rubber; new pneumatic tyres having a herring-bone or similar tread, of a kind used on construction or industrial handling vehicles and machines and having a rim size not exceeding 61cm",
  "401163":
    "Rubber; new pneumatic tyres having a herring-bone or similar tread, of a kind used on construction or industrial handling vehicles and machines and having a rim size exceeding 61cm",
  "401169":
    "Rubber; new pneumatic tyres having a herring-bone or similar tread, of a kind used on light industrial vehicles",
  "401170":
    "Rubber; new pneumatic tyres, of a kind used on agricultural or forestry vehicles and machines",
  "401180":
    "Rubber; new pneumatic tyres, of a kind used on construction, mining or industrial handling vehicles and machines",
  "401190":
    "Rubber; new pneumatic tyres, of a kind used on light commercial vehicles",
  "401191":
    'Rubber; new pneumatic tyres, having a "herring bone" or similar tread',
  "401192":
    "Rubber; new pneumatic tyres having other than a herring-bone or similar tread, of a kind used on agricultural or forestry vehicles and machines",
  "401193":
    "Rubber; new pneumatic tyres having other than a herring-bone or similar tread, of a kind used on construction or industrial handling vehicles and machines and having a rim size not exceeding 61cm",
  "401194":
    "Rubber; new pneumatic tyres having other than a herring-bone or similar tread, of a kind used on construction or industrial handling vehicles and machines and having a rim size exceeding 61cm",
  "401199":
    "Rubber; new pneumatic tyres having other than a herring-bone or similar tread, of a kind used on light industrial vehicles",
  "401210": "Rubber; retreaded tyres",
  "401211":
    "Retreaded tyres ; of a kind used on motor cars (including station wagons and racing cars)",
  "401212": "Retreaded tyres; of a kind used on motor buses or lorries",
  "401213": "Retreaded tyres; of a kind used on aircraft",
  "401219":
    "Retreaded tyres; other than of a kind used on motor cars (including station wagons and racing cars), buses and lorries and aircraft",
  "401220": "Rubber; used pneumatic tyres",
  "401290": "Rubber; tyres n.e.c. in heading no. 4012",
  "401310":
    "Rubber; inner tubes, of a kind used on motorcars (including station wagons and racing cars), buses and lorries",
  "401320": "Rubber; inner tubes, of a kind used on bicycles",
  "401390": "Rubber; inner tubes, n.e.c. in heading no. 4013",
  "401410":
    "Rubber; vulcanised (other than hard rubber), sheath contraceptives",
  "401490":
    "Rubber; vulcanised (other than hard rubber), hygienic or pharmaceutical articles (excluding sheath contraceptives), with or without fittings of hard rubber",
  "401511": "Rubber; vulcanised (other than hard rubber), surgical gloves",
  "401512":
    "Rubber; vulcanised (other than hard rubber), gloves, of a kind used for medical, surgical, dental or veterinary purposes",
  "401519": "Rubber gloves; excl. surgical gloves",
  "401590":
    "Rubber; vulcanised (other than hard rubber), articles of apparel and clothing accessories (other than gloves, mittens and mitts)",
  "401610":
    "Rubber; vulcanised (other than hard rubber), moulded rubber mats and mats of non-rectangular shape made by cutting from the piece, of cellular rubber",
  "401691":
    "Rubber; vulcanised (other than hard rubber), floor coverings and mats, of non-cellular rubber",
  "401692":
    "Rubber; vulcanised (other than hard rubber), erasers, of non-cellular rubber",
  "401693": "Rubber gaskets, washers, and other seals; non-cellular",
  "401694":
    "Rubber; vulcanised (other than hard rubber), boat or dock fenders, whether or not inflatable, of non-cellular rubber",
  "401695":
    "Rubber; vulcanised (other than hard rubber), inflatable articles (other than boat or dock fenders), of non-cellular rubber",
  "401699":
    "Other vulcanised rubber articles; excl. hard rubber, non-cellular (exclusionary category)",
  "401700":
    "Rubber; ebonite and other hard rubbers in all forms, including waste and scrap, and articles of hard rubber",
  "410110":
    "Hides and skins; raw, whole, of bovine animals, weight per skin not exceeding 8kg when simply dried, 10kg when dry-salted or 14kg when fresh, wet-salted or otherwise preserved",
  "410120":
    "Raw hides and skins; whole, unsplit, of bovine or equine animals, of a weight per skin not exceeding 8kg when simply dried, 10kg when dry-salted or 16kg when fresh, wet-salted or otherwise preserved",
  "410121": "Hides and skins; raw, whole, of bovine animals, >14kg",
  "410122":
    "Hides and skins; raw, of bovine animals, fresh or wet-salted, butts and bends",
  "410129":
    "Hides and skins; raw, of bovine animals, fresh or wet-salted, other than whole, but not butts or bends",
  "410130":
    "Hides and skins; raw, of bovine animals, preserved in ways n.e.s. in heading no. 4101",
  "410140":
    "Hides and skins; raw, of equine animals, fresh or salted, dried, limed, pickled or otherwise preserved (excluding tanned, parchment-dressed or further prepared), whether or not dehaired or split",
  "410150":
    "Hides and skins; raw, whole, of bovine or equine animals, of a weight per skin exceeding 16 kg",
  "410190":
    "Hides and skins; other than whole, but including butts, bends and bellies, of bovine (including. buffalo) and equine animals, fresh, salted or preserved, but not tanned, parchment dressed or further prepared, whether or not dehaired or split",
  "410210":
    "Skins; raw, of sheep or lambs, fresh, or salted, dried, limed, pickled or otherwise preserved, (but not tanned, parchment-dressed or further prepared), with wool on",
  "410221":
    "Skins; raw, of sheep or lambs, pickled (but not tanned, parchment-dressed or further preserved), without wool on",
  "410229":
    "Hides and skins; raw, of animals n.e.c. in this chapter, fresh, salted, dried, limed, pickled or otherwise preserved, (but not tanned, parchment-dressed or further prepared), whether or not dehaired or split",
  "410310":
    "Hides and skins; raw, of goats or kids (fresh or salted, dried, limed, pickled or otherwise preserved, but not tanned, parchment-dressed or further prepared), whether or not dehaired or split",
  "410320":
    "Hides and skins; raw, of reptiles (fresh or salted, dried, limed, pickled or otherwise preserved, but not tanned, parchment-dressed or further prepared), whether or not dehaired or split",
  "410330":
    "Hides and skins; raw, of swine, (fresh or salted, dried, limed, pickled or otherwise preserved, but not tanned, parchment-dressed or further prepared), whether or not dehaired or split",
  "410390":
    "Hides and skins; raw, of animals n.e.c. in this chapter, fresh, salted, dried, limed, pickled or otherwise preserved, (but not tanned, parchment-dressed or further prepared), whether or not dehaired or split",
  "410410":
    "Leather; whole bovine skin, without hair on, of a unit surface area not exceeding 28 square feet (2.6m2), excluding leather of heading no. 4108 and 4109",
  "410411":
    "Tanned or crust hides and skins; without hair on, bovine or equine, in the wet state (including wet blue), full grains, unsplit; grain splits",
  "410419":
    "Tanned or crust hides and skins; bovine or equine, without hair on, in the wet state (including wet blue), excluding full grains, unsplit; grain splits",
  "410421":
    "Leather; bovine, without hair on, vegetable pre-tanned, (but not further prepared), whether or not split, excluding leather of heading no. 4108 and 4109",
  "410422":
    "Leather; bovine, without hair on, pre-tanned, (not vegetable pre-tanned), but not further prepared, whether or not split, excluding leather of heading no. 4108 and 4109",
  "410429":
    "Leather; bovine and equine n.e.s. in heading no. 4104, without hair on, tanned or retanned but not further prepared, whether or not split, excluding leather of heading no. 4108 and 4109",
  "410431":
    "Leather; bovine and equine, without hair on, parchment-dressed or prepared after tanning, full grains and grain splits, excluding leather of heading no. 4108 and 4109",
  "410439":
    "Leather; bovine and equine, without hair on,( excluding full grains and grain splits), parchment-dressed or prepared after tanning excluding leather of heading no. 4108 and 4109",
  "410441":
    "Tanned or crust hides and skins; bovine or equine, without hair on, in the dry state (crust), full grains, unsplit; grain splits",
  "410449":
    "Tanned or crust hides and skins; bovine or equine, without hair on, in the dry state (crust), (other than full grains, unsplit; grain splits)",
  "410510":
    "Tanned or crust skins of sheep or lambs, without wool on, whether or not split, but not further prepared, in the wet state (including wet-blue)",
  "410511":
    "Leather; of sheep or lamb, without wool on, tanned or retanned (but not further prepared), vegetable pre-tanned, whether or not split, excluding leather of heading no. 4108 and 4109",
  "410512":
    "Leather; of sheep or lamb, without wool on, tanned or retanned (but not further prepared), pre-tanned (not vegetable pre-tanned), whether or not split, excluding leather of heading no. 4108 and 4109",
  "410519":
    "Leather; of sheep or lamb, without wool on, tanned or retanned (but not further prepared), whether or not split, n.e.s. in heading no. 4105 (not pre-tanned), excluding leather of heading no. 4108 and 4109",
  "410520":
    "Leather; of sheep or lamb, without wool on, parchment-dressed or prepared after tanning, excluding leather of heading no. 4108 and 4109",
  "410530":
    "Tanned or crust skins; of sheep or lambs, without wool on, whether or not split, but not further prepared, in the dry state (crust)",
  "410611":
    "Leather; goat or kid skin, without hair on, vegetable pre-tanned but not further prepared, whether or not split, excluding leather of heading no. 4108 and 4109",
  "410612":
    "Leather; goat or kid skin, without hair on, pre-tanned (not vegetable pre-tanned) not further prepared, whether or not split, excluding leather of heading no. 4108 and 4109",
  "410619":
    "Leather; goat or kid skin, without hair on, tanned or retanned but not further prepared, whether or not split, n.e.s. in heading no. 4106 (not pre-tanned), excluding leather of heading no. 4108 and 4109",
  "410620":
    "Leather; goat or kid skin, without hair on, parchment-dressed or prepared after tanning excluding leather of heading no. 4108 and 4109",
  "410621":
    "Tanned or crust hides and skins; of goats or kids, without wool or hair on, whether or not split, but not further prepared, in the wet state (including wet blue)",
  "410622":
    "Tanned or crust hides and skins; of goats or kids, without hair on, whether or not split, but not further prepared, in the dry state (crust)",
  "410631":
    "Tanned or crust hides and skins; of swine, without hair on, whether or not split, but not further prepared, in the wet state (including wet blue)",
  "410632":
    "Tanned or crust hides and skins; of swine, without hair on, whether or not split, but not further prepared, in the dry state (crust)",
  "410640":
    "Tanned or crust hides and skins; of reptiles, whether or not split, but not further prepared",
  "410691":
    "Tanned or crust hides and skins; of animals other than equine, ovine, bovine, goats or kids, swine and reptiles, without wool or hair on, whether or not split, but not further prepared, in the wet state (including wet blue)",
  "410692":
    "Tanned or crust hides and skins; of animals other than equine, ovine, bovine, goats or kids, swine and reptiles, without wool or hair on, whether or not split, but not further prepared, in the dry state (crust)",
  "410710":
    "Leather; of swine, without hair on, excluding leather of heading no. 4108 or 4109",
  "410711":
    "Leather; further prepared after tanning or crusting, including parchment-dressed leather, of bovine (including buffalo) or equine animals, without hair on, other than leather of heading 41.14, whole hides and skins, full grain, unsplit",
  "410712":
    "Leather; further prepared after tanning or crusting, including parchment-dressed leather, of bovine (including buffalo) or equine animals, without hair on, other than leather of heading 41.14, whole hides and skins, grain splits",
  "410719":
    "Leather; further prepared after tanning or crusting, including parchment-dressed, of bovine (including buffalo) or equine animals, without hair on, split or not, other than leather of heading 41.14, (other than grain splits and full grains, unsplit)",
  "410721":
    "Leather; of reptiles, without hair on, vegetable pre-tanned, excluding leather of heading no. 4108 or 4109",
  "410729":
    "Leather; of reptiles, without hair on, other than vegetable pre-tanned, excluding leather of heading no. 4108 or 4109",
  "410790":
    "Leather; of animals n.e.s. in chapter 41, without hair on, excluding leather of heading no. 4108 or 4109",
  "410791":
    "Leather; further prepared after tanning or crusting, including parchment-dressed, of bovine (including buffalo) or equine animals, without hair on, other than leather of heading 41.14, not whole hides and skins, but including sides, full grain, unsplit",
  "410792":
    "Leather; further prepared after tanning or crusting, including parchment-dressed, of bovine (including buffalo) or equine animals, without hair on, other than leather of heading 41.14, not whole hides and skins, but including sides, grain splits",
  "410799":
    "Leather; further prepared after tanning or crusting, incl. parchment-dressed, of bovine (including buffalo) or equine animals, no hair, excluding leather of heading 41.14, and whole hides and skins, and sides, (full grains, unsplit and grain splits)",
  "410800": "Leather; chamois (including combination chamois) leather",
  "410900": "Leather; patent and patent laminated leather, metallised leather",
  "411000":
    "Leather or composition leather; parings and other waste (not suitable for the manufacture of leather articles), leather dust, powder and flour",
  "411100":
    "Leather; composition leather, with a basis of leather or leather fibres, in slabs, sheets or strip, whether or not in rolls",
  "411200":
    "Leather; further prepared after tanning or crusting, including parchment dressed leather, of sheep or lamb, without wool on, whether or not split, other than leather of heading 41.14",
  "411310":
    "Leather; further prepared after tanning or crusting, including parchment-dressed leather, without hair on, whether or not split, other than leather of heading 41.14, of goats and kids",
  "411320":
    "Leather; further prepared after tanning or crusting, including parchment-dressed leather, without hair on, whether or not split, other than leather of heading 41.14, of swine",
  "411330":
    "Leather; further prepared after tanning or crusting, including parchment-dressed leather, of reptiles, whether or not split, other than leather of heading 41.14",
  "411390":
    "Leather; further prepared after tanning or crusting, including parchment-dressed leather, of animals (other than sheep and lambs, goats and kids, swine and reptiles), without wool or hair on, whether or not split, other than leather of heading 41.14",
  "411410": "Leather; chamois (including combination chamois)",
  "411420":
    "Leather; patent leather and laminated patent leather; metallised leather",
  "411510":
    "Leather; composition leather with a basis of leather or leather fibre, in slabs, sheets or strip, whether or not in rolls",
  "411520":
    "Leather; parings and other waste, of leather or composition leather; not suitable for the manufacture of leather articles; leather dust, powder and flour",
  "420100":
    "Saddlery and harness; for any animal (including traces, leads, knee pads, muzzles, saddle cloths, saddle bags, dog coats and the like), of any materials",
  "420211":
    "Cases and containers; trunks, suit-cases, vanity-cases, executive-cases, brief-cases, school satchels and similar containers, with outer surface of leather or of composition leather",
  "420212":
    "Cases and containers; trunks, suit-cases, vanity-cases, executive-cases, brief-cases, school satchels and similar containers, with outer surface of plastics or of textile materials",
  "420219":
    "Cases and containers; trunks, suit-cases, vanity-cases, executive-cases, brief-cases, school satchels and similar containers, of vulcanised fibre or of paperboard, or wholly or mainly covered with such materials or with paper",
  "420221": "Handbags of leather",
  "420222": "Handbags of plastics or textile",
  "420229":
    "Cases and containers; handbags (whether or not with shoulder strap and including those without handle), of vulcanised fibre or of paperboard, or wholly or mainly covered with such materials or with paper",
  "420231":
    "Cases and containers; of a kind normally carried in the pocket or in the handbag, with outer surface of leather or of composition leather",
  "420232":
    "Cases and containers; of a kind normally carried in the pocket or in the handbag, with outer surface of sheeting of plastics or of textile materials",
  "420239":
    "Cases and containers; of a kind normally carried in the pocket or in the handbag, of vulcanised fibre or of paperboard, or wholly or mainly covered with such materials or with paper",
  "420291":
    "Cases and containers; n.e.c. in heading 4202, with outer surface of leather or of composition leather",
  "420292":
    "Other cases and containers of plastics or textiles (exclusionary category)",
  "420299":
    "Cases and containers; n.e.c. in heading 4202, of vulcanised fibre or of paperboard, or wholly or mainly covered with such materials or with paper",
  "420310":
    "Apparel; articles of apparel, of leather or of composition leather",
  "420321":
    "Clothing accessories; gloves, mittens and mitts, specially designed for use in sports, of leather or composition leather, padded",
  "420329":
    "Clothing accessories; gloves, mittens and mitts, n.e.c. in heading no. 4203, of leather or composition leather, not specially designed for use in sports",
  "420330":
    "Clothing accessories; belts and bandoliers, of leather or of composition leather",
  "420340":
    "Clothing accessories; of leather or of composition leather, n.e.c. in heading no. 4203",
  "420400":
    "Leather articles; of a kind used in machinery, mechanical appliances or for other technical uses, of leather or composition leather",
  "420500":
    "Leather articles; n.e.c. in chapter 42, of leather or composition leather",
  "420600":
    "Articles of gut (other than silk-worm gut), of goldbeater's skin, of bladders or of tendons",
  "420610": "Gut articles; catgut",
  "420690":
    "Gut articles; (other than silk-worm or catgut), of goldbeater's skin, bladders or tendons",
  "430110": "Furskins; raw, of mink, whole, with or without head, tail or paws",
  "430120":
    "Furskins; raw, of rabbit or hare, whole, with or without head, tail or paws",
  "430130":
    "Furskins; raw, of Astrakhan, Broadtail, Caracul, Persian and similar lamb, Indian, Chinese, Mongolian or Tibetan lamb, whole, with or without head, tail or paws",
  "430140":
    "Furskins; raw, of beaver, whole, with or without head, tail or paws",
  "430150":
    "Furskins; raw, of musk-rat, whole, with or without head, tail or paws",
  "430160": "Furskins; raw, of fox, whole, with or without head, tail or paws",
  "430170": "Furskins; raw, of seal, whole, with or without head, tail or paws",
  "430180":
    "Furskins; raw, of animals n.e.c. in heading no. 4301, whole, with or without head, tail or paws (excluding goods of heading no. 4101, 4102 and 4103)",
  "430190":
    "Furskins; raw, heads, tails, paws and other pieces or cuttings, suitable for furrier's use, excluding goods of heading no. 4101, 4102 and 4103",
  "430211":
    "Furskins; tanned or dressed, of mink, whole, with or without head, tail or paws, not assembled",
  "430212":
    "Furskins; tanned or dressed, of rabbit or hare, whole, with or without head, tail or paws, not assembled",
  "430213":
    "Furskins; tanned or dressed, Astrakhan, Broadtail, Caracul, Persian and similar lamb, Indian, Chinese, Mongolian or Tibetan lamb, whole, with or without head, tail or paws, not assembled",
  "430219":
    "Furskins; tanned or dressed, whole, with or without head, tail or paws, not assembled, n.e.c. in heading no. 4302, excluding goods or heading no. 4303",
  "430220":
    "Furskins; tanned or dressed, heads, tails, paws and other pieces or cuttings, not assembled, excluding goods of heading no. 4303",
  "430230":
    "Furskins; tanned or dressed, whole skins and pieces or cuttings thereof, assembled, excluding goods of heading no. 4303",
  "430310": "Furskin articles; apparel and clothing accessories",
  "430390": "Furskin articles; other than apparel and clothing accessories",
  "430400": "Fur, artificial; articles thereof",
  "440110":
    "Wood; for fuel, in logs, billets, twigs, faggots or similar forms, whether or not agglomerated",
  "440111":
    "Wood; for fuel, in logs, in billets, in twigs, in faggots or similar forms, whether or not agglomerated, coniferous",
  "440112":
    "Wood; for fuel, in logs, in billets, in twigs, in faggots or similar forms, whether or not agglomerated, non-coniferous",
  "440121":
    "Wood; for fuel, in chips or particles, coniferous, whether or not agglomerated",
  "440122":
    "Wood; for fuel, in chips or particles, non-coniferous, whether or not agglomerated",
  "440130":
    "Wood; sawdust, waste and scrap, whether or not agglomerated in logs, briquettes, pellets or similar forms",
  "440131":
    "Wood; for fuel, sawdust and wood waste and scrap, agglomerated in logs, briquettes, pellets or similar forms; wood pellets",
  "440132":
    "Wood; for fuel, sawdust and wood waste and scrap, agglomerated in wood briquettes",
  "440139":
    "Wood; for fuel, sawdust and wood waste and scrap, agglomerated in logs, briquettes, pellets or similar forms; other than wood pellets",
  "440140":
    "Wood; for fuel, sawdust and wood waste and scrap, not agglomerated",
  "440141":
    "Wood; for fuel, sawdust and wood waste and scrap, not agglomerated; sawdust",
  "440149":
    "Wood; for fuel, sawdust and wood waste and scrap, not agglomerated and not including sawdust",
  "440200":
    "Wood; charcoal (including shell or nut charcoal), whether or not agglomerated",
  "440210":
    "Wood; charcoal of bamboo (including shell or nut charcoal), whether or not agglomerated",
  "440220": "Wood; charcoal of nut or shell, whether or not agglomerated",
  "440290":
    "Wood; charcoal of wood other than bamboo (including shell or nut charcoal), whether or not agglomerated",
  "440310":
    "Wood; in the rough, whether or not stripped of bark or sapwood, or roughly squared; treated with paint, stains, creosote or other preservatives",
  "440311":
    "Wood; coniferous species, in the rough, whether or not stripped of bark or sapwood, or roughly squared; treated with paint, stains, creosote or other preservatives",
  "440312":
    "Wood; non-coniferous species, in the rough, whether or not stripped of bark or sapwood, or roughly squared; treated with paint, stains, creosote or other preservatives",
  "440320": "Wood; coniferous, untreated",
  "440321":
    "Wood; coniferous species, of pine (Pinus spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which any cross-sectional dimension is 15 cm or more",
  "440322":
    "Wood; coniferous species, of pine (Pinus spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which any cross-sectional dimension is less than 15 cm",
  "440323":
    "Wood; coniferous species, of fir (Abies spp.) and spruce (Picea spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which any cross-sectional dimension is 15 cm or more",
  "440324":
    "Wood; coniferous species, of fir (Abies spp.) and spruce (Picea spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which any cross-sectional dimension is less than 15 cm",
  "440325":
    "Wood; coniferous species n.e.c in headings 4403.21 or 4403.23, in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which any cross-sectional dimension is 15 cm or more",
  "440326":
    "Wood; coniferous species n.e.c in headings 4403.22 or 4403.24, in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which any cross-sectional dimension is less than 15 cm",
  "440331":
    "Wood; dark red meranti, light red meranti, meranti bakau; in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
  "440332":
    "Wood; white lauan, white meranti, white seraya, yellow meranti, alan; in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
  "440333":
    "Wood; keruing, ramin, kapur, teak, jongkong, merbau, jelutong, and kempas; in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
  "440334":
    "Wood; okoume, obeche, sapelli, sipo, acajou d'afrique, makore, iroko; in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
  "440335":
    "Wood; tiama, mansonia, ilomba, dibetou, limba, azobe; in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
  "440341":
    "Wood, tropical; as specified in Subheading Note 2 to this Chapter, dark red meranti, light red meranti and meranti bakau, in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
  "440342":
    "Wood, tropical; teak, in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
  "440349":
    "Wood, tropical; other than dark red meranti, light red meranti and meranti bakau, in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
  "440391":
    "Wood; oak, in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
  "440392":
    "Wood; beech, in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
  "440393":
    "Wood; of beech (Fagus spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which any cross-sectional dimension is 15 cm or more",
  "440394":
    "Wood; of beech (Fagus spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which any cross-sectional dimension is less than 15 cm",
  "440395":
    "Wood; of birch (Betula spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which any cross-sectional dimension is 15 cm or more",
  "440396":
    "Wood; of birch (Betula spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated, of which any cross-sectional dimension is less than 15 cm",
  "440397":
    "Wood; of poplar and aspen (Populus spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
  "440398":
    "Wood; of eucalyptus (Eucalyptus spp.), in the rough, whether or not stripped of bark or sapwood, or roughly squared, untreated",
  "440399": "Wood; non-coniferous, untreated",
  "440410":
    "Wood; coniferous, split poles, piles, pickets, stakes, pointed but not sawn lengthwise; sticks for umbrellas, tool handles etc, roughly trimmed but not turned or bent; chipwood etc, hoopwood",
  "440420":
    "Wood; non-coniferous, split poles, piles, pickets, stakes, pointed but not sawn lengthwise; sticks for umbrellas, tool handles etc, roughly trimmed but not turned or bent; chipwood etc, hoopwood",
  "440500": "Wood; wood wool and wood flour",
  "440610": "Wood; railway or tramway sleepers (cross-ties), not impregnated",
  "440611":
    "Wood; railway or tramway sleepers (cross-ties), not impregnated, coniferous",
  "440612":
    "Wood; railway or tramway sleepers (cross-ties), not impregnated, non-coniferous",
  "440690": "Wood; railway or tramway sleepers (cross-ties), impregnated",
  "440691":
    "Wood; railway or tramway sleepers (cross-ties), impregnated, coniferous",
  "440692":
    "Wood; railway or tramway sleepers (cross-ties), impregnated, non-coniferous",
  "440710":
    "Wood, coniferous; sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, of a thickness exceeding 6mm",
  "440711":
    "Wood; coniferous species, of pine (Pinus spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, of a thickness exceeding 6mm",
  "440712":
    "Wood; coniferous species, of fir (Abies spp.) and spruce (Picea spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, of a thickness exceeding 6mm",
  "440713":
    "Wood; coniferous species, of S-P-F (spruce (Picea spp.), pine (Pinus spp.) and fir (Abies spp.)), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, of a thickness exceeding 6mm",
  "440714":
    "Wood; coniferous species, of Hem-fir (western hemlock (Tsuga heterophylla) and fir (Abies spp.))",
  "440719":
    "Wood; coniferous species, other than of pine (Pinus spp.) or fir (Abies spp.) or spruce (Picea spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger-jointed, of a thickness exceeding 6mm",
  "440721":
    "Wood, tropical; as specified in Subheading Note 2 to this Chapter, mahogany (Swietenia spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, thicker than 6mm",
  "440722":
    "Wood, tropical; virola, imbuia and balsa, sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, thicker than 6mm",
  "440723":
    "Wood; baboen, mahogany (swietenia spp.), imbuia and balsa; sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or finger jointed, thicker than 6mm",
  "440724":
    "Wood, tropical; virola, mahogany (swietenia spp.), imbuia and balsa, sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, thicker than 6mm",
  "440725":
    "Wood, tropical; dark red meranti, light red meranti and meranti bakau, sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, thicker than 6mm",
  "440726":
    "Wood, tropical; white lauan, white meranti, white seraya, yellow meranti and alan, sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, thicker than 6mm",
  "440727":
    "Wood, tropical; sapelli, sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, thicker than 6mm",
  "440728":
    "Wood, tropical; iroko, sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, thicker than 6mm",
  "440729":
    "Wood, tropical, n.e.c. in item no. 4407.2, sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, of a thickness exceeding 6mm",
  "440791":
    "Wood; oak (Quercus spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, thicker than 6mm",
  "440792":
    "Wood; beech (Fagus spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, thicker than 6mm",
  "440793":
    "Wood; maple (Acer spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, thicker than 6mm",
  "440794":
    "Wood; cherry (Prunus spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, thicker than 6mm",
  "440795":
    "Wood; ash (Fraxinus spp.), sawn or chipped lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, thicker than 6mm",
  "440796":
    "Wood; of birch (Betula spp.), sawn or chipped lengthwise, sliced or peeled, of a thickness exceeding 6mm, whether or not planed, sanded or finger-jointed",
  "440797":
    "Wood; of poplar and aspen (Populus spp.), sawn or chipped lengthwise, sliced or peeled, of a thickness exceeding 6mm, whether or not planed, sanded or finger-jointed",
  "440799":
    "Wood; sawn or chipped lengthwise, sliced or peeled, of a thickness exceeding 6mm, whether or not planed, sanded or finger-jointed, n.e.c. in heading no. 4407",
  "440810":
    "Wood; coniferous, sheets for veneering (including those obtained by slicing laminated wood), for plywood or similar laminated wood and other wood, sawn lengthwise, sliced or peeled, planed or not, sanded, spliced or end-jointed, not over 6 mm thick",
  "440820":
    "Wood; meranti, lauan, limba, okoume, obeche, acajou d'afrique, sipo, sapelli, baboen, mahogany, palissandre du bresil, bois de rose; veneer, plywood sheets, other wood, not thicker than 6mm",
  "440831":
    "Wood, tropical; as specified in Subheading Note 2 to this Chapter, dark red meranti, light red meranti, meranti bakau, sheets for veneer, plywood or other wood, sawn lengthwise, sliced or peeled, planed or not, sanded or end-jointed, not thicker than 6mm",
  "440839":
    "Wood, of tropical wood; as in Subheading note 2 to this Chapter, n.e.c. in heading no. 4408.31, sheets for veneer or plywood, other wood sawn length wise, sliced or peeled, whether or not planed, sanded or end-jointed, not thicker than 6mm",
  "440890":
    "Wood; n.e.c. in heading no. 4408, sheets for veneer or plywood, other wood sawn lengthwise, sliced or peeled, whether or not planed, sanded or end-jointed, not exceeding 6mm in thickness",
  "440910":
    "Wood; coniferous (including unassembled strips and friezes for parquet flooring), continuously shaped along any edges, ends or faces, whether or not planed, sanded or end-jointed",
  "440920":
    "Wood; non-coniferous (including unassembled strips and friezes for parquet flooring), continuously shaped along any edges, ends or faces, whether or not planed, sanded or end-jointed",
  "440921":
    "Wood; bamboo (including unassembled strips and friezes for parquet flooring), continuously shaped along any edges, ends or faces, whether or not planed, sanded or end-jointed",
  "440922":
    "Wood; tropical (including unassembled strips and friezes for parquet flooring), continuously shaped along any edges, ends or faces, whether or not planed, sanded or end-jointed",
  "440929":
    "Wood; non-coniferous, other than bamboo or tropical wood, (including unassembled strips and friezes for parquet flooring), continuously shaped along any edges, ends or faces, whether or not planed, sanded or end-jointed",
  "441010":
    "Wood; particle and similar board of wood, whether or not agglomerated with resins or other organic binding substances",
  "441011":
    "Particle board of wood, whether or not agglomerated with resins or other organic binding substances",
  "441012":
    "Oriented strand board (OSB) of wood, whether or not agglomerated with resins or other organic binding substances",
  "441019":
    "Wafer board and similar board of wood n.e.c. in item no. 4410.1, whether or not agglomerated with resins or other organic binding substances",
  "441021":
    "Wood; particle board and similar board of wood, whether or not agglomerated with resins or other organic binding substances, waferboard and oriented strand board, unworked or not further worked than sanded",
  "441029":
    "Wood; particle board and similar board of wood, whether or not agglomerated with resins or other organic binding substances, waferboard and oriented strand board, other than unworked or not further worked than sanded",
  "441031":
    "Wood; particle board and similar board of wood, whether or not agglomerated with resins or other organic binding substances, other than waferboard and oriented strand board, unworked or not further worked than sanded",
  "441032":
    "Wood; particle board and similar board of wood, whether or not agglomerated with resins or other organic binding substances, other than waferboard and oriented strand board, surface-covered with malamine-impregnated paper",
  "441033":
    "Wood; particle board and similar board of wood, whether or not agglomerated with resins or other organic binding substances, other than waferboard and oriented strand board, surface-covered with decorative laminates of plastics",
  "441039":
    "Wood; particle board and similar board of wood, whether or not agglomerated with resins or other organic binding substances, n.e.c. in heading No.4410",
  "441090":
    "Particle board, oriented strand board (OSB) and similar board of ligneous materials other than wood, whether or not agglomerated with resins or other organic binding substances",
  "441111":
    "Wood; fibreboard of a density exceeding 0.8g/cm3, of wood or other ligneous materials, bonded or not with resins or other organic substances, not mechanically worked or surface covered",
  "441112":
    "Medium density fibreboard (MDF), of a thickness not exceeding 5 mm",
  "441113":
    "Medium density fibreboard (MDF), of a thickness exceeding 5 mm but not exceeding 9 mm",
  "441114": "Medium density fibreboard (MDF); thickness >9mm",
  "441119":
    "Wood; fibreboard of a density exceeding 0.8g/cm3, of wood or other ligneous materials, bonded or not with resins or other organic substances, mechanically worked or surface covered",
  "441121":
    "Wood; fibreboard of a density exceeding 0.5g/cm3 but not 0.8g/cm3, of wood or other ligneous materials, bonded or not with resins or other organic substances, not mechanically worked or surface covered",
  "441129":
    "Wood; fibreboard of a density exceeding 0.5g/cm3 but not 0.8g/cm3, of wood or other ligneous materials, bonded or not with resins or other organic substances, mechanically worked or surface covered",
  "441131":
    "Wood; fibreboard of a density exceeding 0.35g/cm3 but not 0.5g/cm3, of wood or other ligneous materials, bonded or not with resins or other organic substances, not mechanically worked or surface covered",
  "441139":
    "Wood; fibreboard of a density exceeding 0.35g/cm3 but not 0.5g/cm3, of wood or other ligneous materials, bonded or not with resins or other organic substances, mechanically worked or surface covered",
  "441191":
    "Wood; fibreboard of wood or other ligneous materials, not mechanically worked or surface coloured, whether or not bonded with resins or other organic substances, n.e.s. in heading no. 4411",
  "441192":
    "Fibreboard (other than MDF) of a density exceeding 0.8g/cm3, of wood or other ligneous materials, bonded or not with resins or other organic substances",
  "441193":
    "Fibreboard (other than MDF) of a density exceeding 0.5g/cm3 but not 0.8g/cm3, of wood or other ligneous materials, bonded or not with resins or other organic substances",
  "441194":
    "Fibreboard (other than MDF) of a density not exceeding 0.5g/cm3, of wood or other ligneous materials, bonded or not with resins or other organic substances",
  "441199":
    "Wood; fibreboard of wood or other ligneous materials, mechanically worked or surface coloured, whether or not bonded with resins or other organic substances, n.e.s. in heading no. 4411",
  "441210": "Plywood, veneered panels and similar laminated wood; of bamboo",
  "441211":
    "Plywood; wood only, each ply 6mm or thinner at least one outer ply of meranti, lauan, sipo, limba, okoume, acajou d'afrique, pallissandre du bresil, sapelli, obeche, baboen, mahogany, or bois de rose",
  "441212":
    "Plywood; wood only, each ply 6mm or thinner at least one outer ply of non-coniferous wood n.e.s. in item no. 4412.11",
  "441213":
    "Plywood; consisting only of sheets of wood, each ply 6mm or thinner, with at least one outer ply of tropical wood, (as specified in subheading note 1, chapter 44, customs tariff)",
  "441214":
    "Plywood; consisting only of sheets of wood, each ply 6mm or thinner, with at least one outer ply of non-coniferous wood, (without an outer ply of tropical wood as specified in subheading note 1, chapter 44, customs tariff)",
  "441219":
    "Plywood; consisting only of sheets of wood, each ply 6mm or thinner, not containing an outer ply of non-coniferous or tropical wood (as specified in subheading note 1, chapter 44, customs tariff)",
  "441221":
    "Plywood; containing at least one layer of particle board, with at least one outer ply of non-coniferous wood",
  "441222":
    "Plywood; (not consisting only of sheets of wood), with at least one outer ply of non-coniferous wood and at least one ply of tropical wood (as specified in subheading note 1, chapter 44, customs tariff)",
  "441223":
    "Plywood; (not consisting only of sheets of wood), with at least one outer ply of non-coniferous wood, with at least one layer of particle board, (without a ply of tropical wood as specified in subheading note 1, chapter 44, customs tariff)",
  "441229":
    "Plywood; (not consisting only of sheets of wood), with at least one outer ply of non-coniferous wood, not containing a layer of particle board or tropical wood (as specified in subheading note 1, chapter 44, customs tariff)",
  "441231":
    "Plywood; consisting only of sheets of wood (not bamboo), each ply 6mm or thinner, with at least one outer ply of tropical wood",
  "441232":
    "Plywood; as specified in Subheading Note 2 to this Chapter, consisting only of sheets of wood (not bamboo), each ply 6mm or thinner, with at least one outer ply of non-coniferous wood, without an outer ply of tropical wood",
  "441233":
    "Plywood; with sheets of wood only; not bamboo; each ply 6mm or less, with at least one outer ply of alder, ash, beech, birch, cherry, chestnut, elm, eucalyptus, hickory, horse chestnut, lime, maple, oak, plane, poplar, aspen, robinia, tulipwood or walnut",
  "441234":
    "Plywood; consisting only of sheets of wood (not bamboo), each ply 6mm or thinner, with at least one outer ply of non-coniferous wood not listed in subheading 4412.33",
  "441239":
    "Plywood; consisting only of sheets of wood (not bamboo), each ply 6mm or thinner, with both outer plies of coniferous wood",
  "441241":
    "Plywood, veneered panels and similar laminated wood; laminated veneered lumber (LVL); with at least one outer ply of tropical wood",
  "441242":
    "Laminated veneered lumber (LVL); with at least one outer ply of non-coniferous wood",
  "441249":
    "Laminated veneered lumber (LVL); with both outer plies of coniferous wood",
  "441251":
    "Blockboard, laminboard and battenboard; with at least one outer layer of tropical wood",
  "441252":
    "Blockboard, laminboard and battenboard; with at least one outer ply of non-coniferous wood, (not containing particle board)",
  "441259":
    "Blockboard, laminboard and battenboard; with both outer plies of coniferous wood",
  "441291":
    "Plywood; not containing an outer layer of non-coniferous wood, but containing at least one layer of particle board",
  "441292":
    "Plywood; (not consisting only of sheets of wood), with at least one ply of tropical wood (specified in subheading note 1, chapter 44, customs tariff), not containing an outer ply of non-coniferous wood",
  "441293":
    "Plywood; (not consisting only of sheets of wood), no outer ply of non-coniferous and no ply of tropical wood (in subheading note 1, chapter 44, customs tariff), but containing at least one layer of particle board",
  "441294":
    "Blockboard, laminboard and battenboard (not bamboo, and other than plywood consisting only of sheets of wood each ply 6mm or thinner)",
  "441299":
    "Plywood, veneered panels and similar laminated wood (other than blockboard, laminboard and battenboard, other than of bamboo, and other than plywood consisting only of sheets of wood each ply 6mm or thinner)",
  "441300": "Wood; densified wood, in blocks, plates, strips or profile shapes",
  "441400":
    "Wooden frames; for paintings, photographs, mirrors or similar objects",
  "441410":
    "Wooden frames; for paintings, photographs, mirrors or similar objects; of tropical wood",
  "441490":
    "Wooden frames; for paintings, photographs, mirrors or similar objects; not of tropical wood",
  "441510":
    "Wood; cases, boxes, crates, drums, similar packings and cable-drums",
  "441520": "Wood; pallets, box pallets and other load boards; pallet collars",
  "441600":
    "Wood; casks, barrels, vats, tubs and other coopers' products and parts thereof, of wood, including staves",
  "441700":
    "Wood; tools, tool bodies, tool handles, broom or brush bodies and handles, boot and shoe lasts and trees, of wood",
  "441810": "Wood; windows, French-windows and their frames",
  "441811": "Wood; windows, French-windows and their frames; of tropical wood",
  "441819":
    "Wood; windows, French-windows and their frames; (of other than tropical wood)",
  "441820": "Wood; doors and their frames and thresholds",
  "441821": "Wood; doors and their frames and thresholds, of tropical wood;",
  "441829":
    "Wood; doors and their frames and thresholds, (of other than tropical wood)",
  "441830": "Wood; parquet panels",
  "441840": "Wood; shuttering for concrete constructional work",
  "441850": "Wood; shingles and shakes",
  "441860": "Wood; posts and beams",
  "441871": "Wood; assembled flooring panels, for mosaic floors",
  "441872": "Wood; assembled flooring panels, multilayer, other than mosaic",
  "441873":
    "Wood; assembled flooring panels, of bamboo or with at least the top layer (wear layer) of bamboo",
  "441874":
    "Wood; assembled flooring panels, not of bamboo or with at least the top layer (wear layer) of bamboo, for mosaic floors",
  "441875":
    "Wood; assembled flooring panels, not of bamboo or with at least the top layer (wear layer) of bamboo, multilayer",
  "441879":
    "Wood; assembled flooring panels, n.e.c in headings 4418.73, 4418.74 or 4418.75",
  "441881":
    "Wood; engineered structural timber products, glue-laminated timber (glulam)",
  "441882":
    "Wood; engineered structural timber products, cross-laminated timber (CLT or X-lam)",
  "441883": "Wood; engineered structural timber products, I beams",
  "441889":
    "Wood; engineered structural timber products, other than glue-laminated timber (glulam), cross-laminated timber (CLT or X-lam), or I beams",
  "441890":
    "Wood; builders' joinery and carpentry of wood n.e.c. in heading no. 4418",
  "441891":
    "Wood; builders' joinery and carpentry of wood n.e.c. in heading no. 4418, of bamboo",
  "441892":
    "Wood; builders' joinery and carpentry of wood n.e.c. in heading no. 4418, cellular wood panels",
  "441899":
    "Wood; builders' joinery and carpentry of wood n.e.c. in heading no. 4418, other than of bamboo",
  "441900": "Wood; table and kitchenware",
  "441911":
    "Tableware and kitchenware, of wood; of bamboo, bread boards, chopping boards and similar boards",
  "441912": "Tableware and kitchenware, of wood; of bamboo, chopsticks",
  "441919":
    "Tableware and kitchenware, of wood; of bamboo, n.e.c. in heading 4419",
  "441920": "Tableware and kitchenware, of wood; of tropical wood",
  "441990": "Tableware and kitchenware, of wood; not of bamboo",
  "442010": "Wood; statuettes and other ornaments of wood",
  "442011": "Wood; statuettes and other ornaments, of tropical wood",
  "442019": "Wood; statuettes and other ornaments, of other than tropical wood",
  "442090":
    "Wood; marquetry and inlaid wood, caskets and cases for jewellery or cutlery and similar articles of wood, wooden articles of furniture not falling in chapter 94",
  "442110": "Wood; clothes hangers",
  "442120": "Wood; coffins",
  "442190":
    "Wood; articles of wood n.e.c. in heading no. 4414 to 4420 (excluding clothes hangers)",
  "442191":
    "Wood; of bamboo, articles n.e.c. in heading no. 4414 to 4420 (excluding clothes hangers)",
  "442199": "Wood articles; excl. bamboo (exclusionary category)",
  "450110": "Cork; natural cork, raw or simply prepared",
  "450190": "Cork; waste cork, crushed, granulated or ground cork",
  "450200":
    "Cork; natural cork, debacked or roughly squared, or in rectangular (including square) blocks, plates, sheets or strip, (including sharp-edged blanks for corks or stoppers)",
  "450310": "Cork; corks and stoppers, of natural cork",
  "450390": "Cork; articles of natural cork other than corks and stoppers",
  "450410":
    "Cork; blocks, plates, sheets and strip, tiles of any shape, solid cylinders (including discs), of agglomerated cork (with or without a binding substance)",
  "450490":
    "Cork; articles of agglomerated cork (with or without a binding substance), n.e.c. in heading no. 4504",
  "460110":
    "Plaiting materials; plaits and similar products of plaiting materials, whether or not assembled into strips",
  "460120":
    "Plaiting materials; mats, matting and screens, of vegetable materials",
  "460121":
    "Plaiting materials, plaits and similar products of plaiting materials; mats, matting and screens, of bamboo",
  "460122":
    "Plaiting materials, plaits and similar products of plaiting materials; mats, matting and screens, of rattan",
  "460129":
    "Plaiting materials, plaits and similar products of plaiting materials; mats, matting and screens, of vegetable materials other than bamboo or rattan",
  "460191":
    "Plaiting materials; products of vegetable materials n.e.s. in heading no. 4601",
  "460192":
    "Plaiting materials, plaits and similar products of plaiting materials; (not mats, matting or screens), of bamboo",
  "460193":
    "Plaiting materials, plaits and similar products of plaiting materials; (not mats, matting or screens), of rattan",
  "460194":
    "Plaiting materials, plaits and similar products of plaiting materials; (not mats, matting or screens), of vegetable materials other than bamboo or rattan",
  "460199":
    "Plaiting materials, plaits and similar products of plaiting materials; products of non-vegetable materials",
  "460210":
    "Basketwork, wickerwork and other articles; of vegetable materials, made directly to shape from plaiting materials or made up from goods of heading no. 4601; articles of loofah",
  "460211":
    "Basketwork, wickerwork and other articles; of bamboo, made directly to shape from plaiting materials or made up from goods of heading no. 4601",
  "460212":
    "Basketwork, wickerwork and other articles; of rattan, made directly to shape from plaiting materials or made up from goods of heading no. 4601",
  "460219":
    "Basketwork, wickerwork and other articles; of vegetable materials (not bamboo or rattan), made directly to shape from plaiting materials or made up from goods of heading no. 4601; articles of loofah",
  "460290":
    "Basketwork, wickerwork and other articles; of non-vegetable materials, made directly to shape from plaiting materials or made up from goods of heading no. 4601",
  "470100": "Wood pulp; mechanical wood pulp",
  "470200": "Chemical wood pulp; dissolving grades",
  "470311":
    "Wood pulp; chemical wood pulp, soda or sulphate, (other than dissolving grades), unbleached, of coniferous wood",
  "470319":
    "Wood pulp; chemical wood pulp, soda or sulphate, (other than dissolving grades), unbleached, of non-coniferous wood",
  "470321":
    "Chemical wood pulp; soda or sulphate, semi-bleached or bleached, coniferous; excl. dissolving grades",
  "470329":
    "Chemical wood pulp; soda or sulphate, semi-bleached or bleached, non-coniferous; excl. dissolving grades",
  "470411":
    "Wood pulp; chemical wood pulp, sulphite, (other than dissolving grades), unbleached, of coniferous wood",
  "470419":
    "Wood pulp; chemical wood pulp, sulphite, (other than dissolving grades), unbleached, of non-coniferous wood",
  "470421":
    "Wood pulp; chemical wood pulp, sulphite, (other than dissolving grades), semi-bleached or bleached, of coniferous wood",
  "470429":
    "Wood pulp; chemical wood pulp, sulphite, (other than dissolving grades), semi-bleached or bleached, of non-coniferous wood",
  "470500":
    "Wood pulp; obtained by a combination of mechanical and chemical pulping processes",
  "470610": "Pulp; cotton linters pulp",
  "470620":
    "Pulp; of fibres derived from recovered (waste and scrap) paper or paperboard",
  "470630": "Pulp; of bamboo",
  "470691":
    "Pulp; of fibrous cellulosic material, other than of bamboo or fibres derived from recovered (waste and scrap) paper or paperboard or from cotton linters pulp, mechanical",
  "470692":
    "Pulp; of fibrous cellulosic material, other than of bamboo or fibres derived from recovered (waste and scrap) paper or paperboard or from cotton linters pulp, chemical",
  "470693":
    "Pulp; of fibrous cellulosic material, other than of bamboo or fibres derived from recovered (waste and scrap) paper or paperboard or from cotton linters pulp, obtained by a combination of mechanical and chemical processes",
  "470710":
    "Waste and scrap of kraft paper/paperboard or corrugated paper/paperboard",
  "470720":
    "Paper or paperboard; waste and scrap, paper or paperboard made mainly of bleached chemical pulp, not coloured in the mass",
  "470730":
    "Paper or paperboard; waste and scrap, paper or paperboard made mainly of mechanical pulp (e.g. newspapers, journals and similar printed matter)",
  "470790":
    "Paper or paperboard; waste and scrap, of paper or paperboard n.e.c. in heading no. 4707 and of unsorted waste and scrap",
  "480100":
    "Newsprint; made of fibres obtained essentially by a chemi-mechanical process or of a weight, per m2, of more than 57g but not more than 65g, in rolls or sheets",
  "480210": "Hand-made paper or paperboard",
  "480220":
    "Uncoated paper and paperboard (not 4801 or 4803); of a kind used as a base for photo-sensitive, heat-sensitive or electro-sensitive paper or paperboard, in rolls or sheets",
  "480230":
    "Paper and paperboard; carbonising base paper, uncoated, of a kind used for writing, printing and other graphic purposes, in rolls or sheets",
  "480240":
    "Uncoated paper and paperboard (not 4801 or 4803); wallpaper base, in rolls or sheets",
  "480251":
    "Paper and paperboard; uncoated, containing no, or not more than 10% by weight of fibres obtained by mechanical process, weighing less than 40g/m2, in rolls or sheets",
  "480252":
    "Paper and paperboard; uncoated, containing no, or not more than 10% by weight of fibres obtained by mechanical process, weighing 40g/m2 or more but not more than 150g/m2, in rolls or sheets",
  "480253":
    "Paper and paperboard; uncoated, containing no, or not more than 10% by weight of fibres obtained by mechanical process, weighing more than 150g/m2, in rolls or sheets",
  "480254":
    "Uncoated paper and paperboard (not 4801 or 4803); printing, writing or graphic, 10% or less by weight of mechanical or chemi-mechanical processed fibre, weighing less than 40g/m2, in rolls or sheets",
  "480255":
    "Uncoated paper and paperboard (not 4801 or 4803); printing, writing or graphic, 10% or less by weight of mechanical or chemi-mechanical processed fibre, weighing 40g/m2 to 150g/m2, in rolls",
  "480256":
    "Uncoated paper and paperboard (not 4801 or 4803); printing, writing or graphic, 10% or less by weight of mechanical or chemi-mechanical processed fibre, weight 40-150g/m2, in sheets 435mm or less by 297mm or less (unfolded)",
  "480257":
    "Uncoated paper and paperboard (not 4801 or 4803); printing, writing or graphic, 10% or less by weight of mechanical or chemi-mechanical processed fibre, weight 40-150g/m2, n.e.c. in item no. 4802.55 or 4802.56",
  "480258":
    "Uncoated paper and paperboard (not 4801 or 4803); printing, writing or graphic, 10% or less by weight of mechanical or chemi-mechanical processed fibre, weighing more than 150g/m2",
  "480260":
    "Paper and paperboard; uncoated, with more than 10% by weight of the total fibre content obtained by a mechanical process, in rolls or sheets",
  "480261":
    "Uncoated paper and paperboard (not 4801 or 4803); over 10% by weight of mechanical or chemi-mechanical processed fibre, in rolls",
  "480262":
    "Uncoated paper and paperboard (not 4801 or 4803); over 10% by weight of mechanical or chemi-mechanical processed fibre, in sheets 435mm or less by 297mm or less (unfolded)",
  "480269":
    "Uncoated paper and paperboard (not 4801 or 4803); over 10% by weight of mechanical or chemi-mechanical processed fibre, other than rolls, other than sheets 435mm or less by 297mm or less (unfolded)",
  "480300":
    "Tissue, towel, napkin stock or similar; for household or sanitary use, cellulose, wadding webs of cellulose fibres, in rolls exceeding 36cm in width or rectangular sheets with one side more than 36cm in unfolded state",
  "480411":
    "Kraft paper and paperboard; kraftliner, uncoated, unbleached, in rolls or sheets, other than that of heading no. 4802 or 4803",
  "480419":
    "Kraft paper and paperboard; kraftliner, uncoated, bleached, in rolls or sheets, other than that of heading no. 4802 or 4803",
  "480421":
    "Kraft paper and paperboard; sack kraft paper, uncoated, unbleached, in rolls or sheets, other than that of heading no. 4802 or 4803",
  "480429":
    "Kraft paper and paperboard; sack kraft paper, uncoated, bleached, in rolls or sheets, other than that of heading no. 4802 or 4803",
  "480431":
    "Kraft paper and paperboard; uncoated, unbleached, weight 150g/m2 or less, in rolls or sheets, other than that of heading no. 4802 or 4803",
  "480439":
    "Kraft paper and paperboard; uncoated, bleached, weight 150g/m2 or less, in rolls or sheets, other than that of heading no. 4802 or 4803",
  "480441":
    "Kraft paper and paperboard; uncoated, unbleached, weight more than 150g/m2 but less than 225g/m2, in rolls or sheets, other than that of heading no. 4802 or 4803",
  "480442":
    "Kraft paper and paperboard; uncoated, weight between 150 and 225g/m2, bleached uniformly throughout, more than 95% of total fibre content consists of chemically processed wood fibres, in rolls or sheets",
  "480449":
    "Kraft paper and paperboard; uncoated, weight more than 150g/m2 but less than 225g/m2, in rolls or sheets, n.e.c. in item no. 4804.4, other than that of heading no. 4802 or 4803",
  "480451":
    "Kraft paper and paperboard; uncoated, unbleached, weight 225g/m2 or more, in rolls or sheets, other than that of heading no. 4802 or 4803",
  "480452":
    "Kraft paper and paperboard; uncoated, weight 225g/m2 or more, bleached uniformly throughout, more than 95% of total fibre content consists of chemically processed wood fibres, in rolls or sheets",
  "480459":
    "Kraft paper and paperboard; uncoated, weight 225g/m2 or more, in rolls or sheets, n.e.c. in item no. 4804.5, other than that of heading no. 4802 or 4803",
  "480510":
    "Paper and paperboard; semi-chemical fluting paper (corrugating medium), uncoated, in rolls or sheets",
  "480511":
    "Paper and paperboard; uncoated, semi-chemical fluting paper, rolls or sheets",
  "480512":
    "Paper and paperboard; uncoated, straw fluting paper, rolls or sheets",
  "480519":
    "Paper and paperboard; uncoated, fluting paper other than semi-chemical or straw, rolls or sheets",
  "480521":
    "Paper and paperboard; uncoated, multi-ply, each layer bleached, in rolls or sheets",
  "480522":
    "Paper and paperboard; uncoated, multi-ply, with only one outer layer bleached, in rolls or sheets",
  "480523":
    "Paper and paperboard; uncoated, multi-ply, having three or more layers with only the two outer layers bleached, in rolls or sheets",
  "480524":
    "Paper & paperboard; uncoated, testliner (recycled linerboard), weight 150g/m2, or less, in rolls or sheets",
  "480525":
    "Paper & paperboard; uncoated, testliner (recycled linerboard), weight over 150g/m2, in rolls or sheets",
  "480529":
    "Paper and paperboard; uncoated, multi-ply, in rolls or sheets, n.e.s. in item no. 4805.2",
  "480530":
    "Paper and paperboard; sulphite wrapping paper, uncoated, in rolls or sheets",
  "480540":
    "Paper and paperboard; filter paper and paperboard, uncoated, in rolls or sheets",
  "480550":
    "Paper and paperboard; felt paper and paperboard, uncoated, in rolls or sheets",
  "480560":
    "Paper and paperboard; uncoated, weight 150g/m2 or less, in rolls or sheets, n.e.s. in heading no. 4805",
  "480570":
    "Paper and paperboard; uncoated, weight between 150 and 225 g/m2, in rolls or sheets, n.e.s. in heading no. 4805",
  "480580":
    "Paper and paperboard; uncoated, weight 225/m2 or more, in rolls or sheets, n.e.s. in heading no. 4805",
  "480591":
    "Paper and paperboard; uncoated, weight 150g/m2 or less, in rolls or sheets, n.e.c. in heading no.4805",
  "480592":
    "Paper and paperboard; uncoated, weight more than 150g/m2 but less than 225 g/m2, in rolls or sheets, n.e.c. in heading no. 4805",
  "480593":
    "Paper and paperboard; uncoated, weight 225/m2 or more, in rolls or sheets, n.e.c. in heading no. 4805",
  "480610": "Paper; vegetable parchment, in rolls or sheets",
  "480620": "Paper; greaseproof papers, in rolls or sheets",
  "480630": "Paper; tracing papers, in rolls or sheets",
  "480640":
    "Paper; glassine and other glazed transparent or translucent papers, in rolls or sheets",
  "480700":
    "Paper and paperboard; composite (made by sticking layers together with an adhesive), not surface-coated or impregnated, whether or not internally reinforced, in rolls or sheets",
  "480710":
    "Paper and paperboard; composite, laminated internally with bitumen, tar or asphalt, not surface coated or impregnated, whether or not internally reinforced, in rolls or sheets",
  "480790":
    "Paper and paperboard; (other than laminated internally with bitumin, tar or asphalt), not surface-coated or impregnated, whether or not internally reinforced, in rolls or sheets",
  "480791":
    "Paper and paperboard; straw paper and paperboard, not surface-coated or impregnated, internally reinforced or not, whether or not covered with paper other than straw paper, in rolls or sheets",
  "480799":
    "Paper and paperboard; composite, not surface-coated or impregnated, whether or not internally reinforced, in rolls or sheets, n.e.s. in heading no. 4807",
  "480810":
    "Paper and paperboard; corrugated, whether or not perforated, in rolls or sheets, other than paper of heading 4803",
  "480820":
    "Paper and paperboard; sack kraft paper, creped or crinkled, whether or not embossed or perforated, in rolls or sheets, other than that of heading no. 4803 or 4818",
  "480830":
    "Paper and paperboard; kraft paper (other than sack), creped or crinkled, whether or not embossed or perforated, in rolls or sheets, other than that of heading no. 4803 or 4818",
  "480840":
    "Paper and paperboard; kraft paper, creped or crinkled, whether or not embossed or perforated, in rolls or sheets, other than paper of heading 4803",
  "480890":
    "Paper and paperboard; other than corrugated (with or without glued flat surface sheets) or kraft paper, creped or crinkled, whether or not embossed or perforated, in rolls or sheets, other than paper of heading 4803",
  "480910":
    "Paper; carbon and similar copying papers, whether or not printed, in rolls exceeding 36cm wide or in rectangular sheets with at least one side exceeding 36cm in unfolded state",
  "480920":
    "Paper; self-copy paper, whether or not printed, in rolls or sheets",
  "480990":
    "Paper; carbon paper and other copying or transfer papers (including coated or impregnated paper for duplicator stencils or offset plates), whether or not printed, in rolls or sheets",
  "481011":
    "Paper and paperboard; coated with inorganic substances only, having 10% or less of mechanically processed fibres, weight 150g/m2 or less, for writing, printing or other graphic purposes, in rolls or sheets",
  "481012":
    "Paper and paperboard; coated with inorganic substances only, having 10% or less of mechanically processed fibres, weight more than 150g/m2, for writing, printing or other graphic purposes, in rolls or sheets",
  "481013":
    "Paper and paperboard; coated with kaolin or other inorganic substances, for printing & writing, graphics, containing no, or not more than 10% by weight of total fibres obtained by mechanical or chemi-mechanical process, in rolls",
  "481014":
    "Paper and paperboard; coated with kaolin or other inorganic substances, for printing/writing/graphics, having 10% or less by weight of total fibres got mechanical/chemi-mechanical process, sheets, sides 435mm or less by 297mm or less, unfolded,",
  "481019":
    "Paper and paperboard; coated with kaolin or other inorganic substances, for printing/writing/graphics, having 10% or less by weight of total fibres got by mechanical/chemi-mechanical process, sides exceeding 435mm and 297mm, unfolded, sheets",
  "481021":
    "Paper and paperboard; light-weight coated paper, coated with kaolin or other inorganic substances only, having more than 10% of mechanically processed fibres, for writing, printing or other graphic purposes, in rolls or sheets",
  "481022":
    "Paper and paperboard; coated with kaolin or other inorganic substances only, having more than 10% of mechanical or chemi-mechanical processed fibres, for writing, printing or other graphic purposes, light-weight coated paper, in rolls or sheets",
  "481029":
    "Paper and paperboard; coated with kaolin or other inorganic substances only, having more than 10% of mechanically processed fibres, (excluding light-weight paper), for writing, printing or other graphic purposes, in rolls or sheets",
  "481031":
    "Kraft paper and paperboard; uniformly bleached throughout, coated with inorganic substances, more than 95% of chemically processed wood fibres, weight 150g/m2 or less, for non-graphic purposes, in rolls or sheets",
  "481032":
    "Kraft paper and paperboard; uniformly bleached throughout, coated with inorganic substances, more than 95% of chemically processed wood fibres, weight more than 150g/m2, for non-graphic purposes, in rolls or sheets",
  "481039":
    "Kraft paper and paperboard; coated with kaolin or other inorganic substances only, for non-graphic purposes, n.e.c. in item no. 4810.31 and 4810.32, in rolls or sheets",
  "481091":
    "Paper and paperboard; multi-ply, coated with kaolin or other inorganic substances only, for non-graphic purposes, n.e.s. in heading no. 4810, in rolls or sheets",
  "481092":
    "Paper and paperboard; multi-ply, coated with kaolin or other inorganic substances only, for non-graphic purposes, n.e.c. in heading no. 4810, in rolls or sheets",
  "481099":
    "Paper and paperboard; coated with inorganic substances only, whether or not surface-coloured, surface-decorated or printed, n.e.c. in heading no. 4810, in rolls or sheets",
  "481110":
    "Paper and paperboard; tarred, bituminised or asphalted, in rolls or sheets, other than goods of heading no. 4803, 4809, or 4810",
  "481121":
    "Paper and paperboard; self-adhesive, in rolls or sheets, other than goods of heading no. 4803, 4809, 4810 or 4818",
  "481129":
    "Paper and paperboard; gummed or adhesive paper and paperboard (excluding self-adhesive), in rolls or sheets, other than goods of heading no. 4803, 4809, 4810 or 4818",
  "481131":
    "Paper and paperboard; coated, impregnated or covered with plastics (excluding adhesives), bleached, weighing more than 150g/m2, other than goods of heading no. 4803, 4809, 4810 or 4818",
  "481139":
    "Paper and paperboard; coated, impregnated or covered with plastics (excluding adhesives), other than bleached and weighing more than 150g/m2, not goods of heading no. 4803, 4809, 4810 or 4818",
  "481140":
    "Paper and paperboard; coated or impregnated with wax, paraffin wax, stearin, oil or glycerol, other than goods of heading no. 4803, 4809, 4810 or 4818",
  "481141":
    "Paper and paperboard; self-adhesive, in rolls or sheets, other than goods of heading no. 4803, 4809, or 4810",
  "481149":
    "Paper and paperboard; gummed or adhesive paper and paperboard (excluding self-adhesive), in rolls or sheets, other than goods of heading no. 4803, 4809, or 4810",
  "481151":
    "Paper and paperboard; coated, impregnated or covered with plastics (excluding adhesives), bleached, weighing more than 150g/m2, other than goods of heading no. 4803, 4809, or 4810",
  "481159":
    "Paper and paperboard; coated, impregnated or covered with plastics (excluding adhesives), other than bleached and weighing more than 150g/m2, other than goods of heading no. 4803, 4809, or 4810",
  "481160":
    "Paper and paperboard; coated or impregnated with wax, paraffin wax, stearin, oil or glycerol, other than goods of heading no. 4803, 4809, or 4810",
  "481190":
    "Paper, paperboard, cellulose wadding and webs of soft cellulose fibres; coated, impregnated, covered, surface-decorated or surface-coloured, n.e.c. in heading no. 4811, in rolls or sheets",
  "481200": "Paper pulp; filter blocks, slabs and plates of paper pulp",
  "481310": "Paper, cigarette; in the form of booklets or tubes",
  "481320": "Paper, cigarette; in rolls of a width not exceeding 5cm",
  "481390":
    "Paper, cigarette; (other than in rolls of a width not exceeding 5cm, or in booklets or tubes)",
  "481410": "Wallpaper and similar wall coverings; ingrain paper",
  "481420":
    "Wallpaper and similar wall coverings; coated or covered on the face side, with a grained, embossed, coloured, design-printed or otherwise decorated layer of plastics",
  "481430":
    "Wallpaper and similar wall coverings; consisting of paper covered on the face side with plaiting material, whether or not bound together in parallel strands or woven",
  "481490":
    "Wallpaper and similar wall coverings and window transparencies of paper; n.e.c. in heading 4814",
  "481500":
    "Floor coverings; on a base of paper or of paperboard, whether or not cut to size",
  "481610":
    "Carbon paper; carbon or similar copying papers (other than those of heading no. 4809), whether or not put in boxes",
  "481620":
    "Paper; self-copy paper (other than those of heading no. 4809), whether or not put up in boxes",
  "481630":
    "Paper; duplicator stencils (other than those of heading no. 4809), whether or not put up in boxes",
  "481690":
    "Paper; carbon paper and other copying or transfer papers (other than those of heading no. 4809), n.e.c. in item no. 4816.20",
  "481710": "Paper and paperboard; envelopes",
  "481720":
    "Paper and paperboard; letter cards, plain postcards and correspondence cards",
  "481730":
    "Paper and paperboard; boxes, pouches, wallets and writing compendiums containing an assortment of paper stationery",
  "481810": "Paper articles; toilet paper",
  "481820":
    "Paper articles; handkerchiefs, cleansing or facial tissues and towels",
  "481830":
    "Paper articles; tablecloths and serviettes, of paper, cellulose wadding or fibres",
  "481840":
    "Paper articles; sanitary towels and tampons, napkins and napkin liners for babies and similar sanitary articles",
  "481850":
    "Paper articles; apparel and clothing accessories of paper, cellulose wadding or fibres",
  "481890":
    "Paper articles; articles of paper, cellulose wadding or fibres, n.e.c. in heading no. 4818",
  "481910":
    "Paper and paperboard; cartons, boxes and cases, of corrugated paper or paperboard",
  "481920":
    "Folding cartons, boxes, and cases; non-corrugated paper or paperboard",
  "481930":
    "Paper and paperboard; sacks and bags of paper, paperboard, cellulose wadding or fibres, having a base of a width of 40cm or more",
  "481940":
    "Paper and paperboard; sacks and bags, including cones, of paper, paperboard, cellulose wadding or fibres, having a base width less than 40cm",
  "481950":
    "Paper and paperboard; packing containers, including record sleeves, of paper, paperboard, cellulose wadding or fibres, n.e.c. in heading no. 4819",
  "481960":
    "Paper and paperboard; box files, letter trays, storage boxes and similar articles, used in offices, shops or the like of paper, paperboard, cellulose wadding or webs of cellulose fibres",
  "482010":
    "Paper and paperboard; registers, account books, note books, order books, receipt books, letter pads, memorandum pads, diaries and similar articles",
  "482020": "Paper and paperboard; exercise books",
  "482030": "Paper and paperboard; binders, folders and file covers",
  "482040":
    "Paper and paperboard; manifold business forms and interleaved carbon sets",
  "482050": "Paper and paperboard; albums for samples or for collections",
  "482090": "Paper or paperboard; stationery n.e.c. in heading no. 4820",
  "482110": "Paper and paperboard; labels or all kinds, printed",
  "482190": "Paper and paperboard; labels of all kinds, unprinted",
  "482210":
    "Paper pulp, paper or paperboard; bobbins, spools, cops and similar supports, of a kind used for winding textile yarn (whether or not perforated or hardened)",
  "482290":
    "Paper pulp, paper or paperboard; bobbins, spools, cops and similar supports, other than of a kind used for winding textile yarn (whether or not perforated or hardened)",
  "482311": "Paper and paperboard; self-adhesive paper, in strips or rolls",
  "482312": "Paper and paperboard; self-adhesive paper, in strips or rolls",
  "482319":
    "Paper and paperboard; gummed or adhesive paper, in strips or rolls, other than self-adhesive paper",
  "482320": "Paper and paperboard; filter paper and paperboard",
  "482330":
    "Paper and paperboard; cards, not punched, for punch card machines, whether or not in strips",
  "482340":
    "Paper and paperboard; rolls, sheets and dials, printed for self-recording apparatus",
  "482351":
    "Paper and paperboard; of a kind used for writing, printing or other graphic purposes, printed, embossed or perforated, n.e.s. in heading no. 4823",
  "482359":
    "Paper and paperboard; of a kind used for writing, printing or other graphic purposes, (not printed, embossed or perforated), n.e.s. in heading no. 4823",
  "482360": "Paper and paperboard; trays, dishes, plates, cups and the like",
  "482361":
    "Paper and paperboard; trays, dishes, plates, cups and the like, of bamboo paper or paperboard",
  "482369":
    "Paper and paperboard; trays, dishes, plates, cups and the like, of paper or paperboard other than of bamboo",
  "482370": "Paper pulp; moulded or pressed articles or paper pulp",
  "482390":
    "Paper pulp, paper, paperboard, cellulose wadding or webs of cellulose fibres; articles n.e.c. in heading no. 4823",
  "490110": "Printed matter; in single sheets, whether or not folded",
  "490191":
    "Printed matter; dictionaries, encyclopaedias and serial instalments thereof",
  "490199":
    "Printed matter; books, brochures, leaflets and similar printed matter n.e.c. in item no. 4901.10 or 4901.91",
  "490210":
    "Newspapers, journals and periodicals; whether or not illustrated or containing advertising material, appearing at least four times a week",
  "490290":
    "Newspapers, journals and periodicals; whether or not illustrated or containing advertising material, appearing less frequently than four times a week",
  "490300": "Printed matter; children's picture, drawing or colouring books",
  "490400":
    "Music; printed or in manuscript, whether or not bound or illustrated",
  "490510": "Globes; printed",
  "490520":
    "Maps and hydrographic or similar charts; printed in book form, including atlases, topographical plans and similar",
  "490590":
    "Maps and hydrographic or similar charts; (printed other than in book form), including wall maps, topographical plans and similar",
  "490591":
    "Maps and hydrographic or similar charts; printed in book form, including atlases, topographical plans and similar",
  "490599":
    "Maps and hydrographic or similar charts; (printed other than in book form), including wall maps, topographical plans and similar",
  "490600":
    "Plans and drawings; for architectural, engineering, industrial, commercial, topographical or similar, being originals drawn by hand; hand-written texts; photo- graphic reproductions; their carbon copies",
  "490700":
    "Unused postage, revenue or similar stamps of current or new issue in the country in which they have, or will have, a recognised face value; stamp-impressed paper; cheque forms; banknotes, stock, share or bond certificates and the like of similar title",
  "490810": "Printed matter; transfers (decalcomanias), vitrifiable",
  "490890": "Printed matter; transfers (decalcomanias), other than vitrifiable",
  "490900":
    "Printed or illustrated postcards; printed cards bearing personal greetings, messages or announcements, whether or not illustrated, with or without envelopes or trimmings",
  "491000": "Calendars; printed, of any kind, including calendar blocks",
  "491110":
    "Printed matter; trade advertising material, commercial catalogues and the like",
  "491191":
    "Printed matter; pictures, designs and photographs, n.e.c. in item no. 4911.10",
  "491199": "Printed matter; n.e.c. in heading no. 4911",
  "500100": "Silk; silk-worm cocoons suitable for reeling",
  "500200": "Silk; raw silk (not thrown)",
  "500300":
    "Silk waste (including cocoons unsuitable for reeling, yarn waste and garnetted stock)",
  "500310":
    "Silk; waste, not carded or combed (including cocoons unsuitable for reeling, yarn waste and garnetted stock)",
  "500390":
    "Silk; waste, carded or combed (including cocoons unsuitable for reeling, yarn waste and garnetted stock)",
  "500400":
    "Silk; yarn (other than yarn spun from silk waste), not put up for retail sale",
  "500500": "Silk; yarn spun from silk waste, not put up for retail sale",
  "500600":
    "Silk yarn and yarn spun from silk waste; put up for retail sale, and silk-worm gut",
  "500710": "Silk; woven fabrics of noil silk",
  "500720":
    "Silk; woven fabrics, containing 85% or more by weight of silk or of silk waste other than noil silk",
  "500790": "Silk; woven fabrics n.e.c. in heading no. 5007",
  "510111": "Wool; greasy, shorn",
  "510119":
    "Wool; (other than shorn), greasy (including fleece-washed wool), not carded or combed",
  "510121": "Wool; (not carded or combed), degreased, (not carbonised), shorn",
  "510129":
    "Wool; (not carded or combed), degreased, (not carbonised), (other than shorn)",
  "510130": "Wool; (not carded or combed), carbonised",
  "510210": "Hair; fine animal hair, not carded or combed",
  "510211":
    "Hair; fine animal hair, not carded or combed, of kashmir (cashmere) goats",
  "510219":
    "Hair; fine animal hair, not carded or combed, other than of kashmir (cashmere) goats",
  "510220": "Hair; coarse animal hair, not carded or combed",
  "510310":
    "Wool and hair; noils of wool or of fine animal hair, including yarn waste, but excluding garnetted stock",
  "510320":
    "Wool and hair; waste of wool or of fine animal hair, including yarn waste, but excluding garnetted stock and noils of wool or of fine animal hair",
  "510330":
    "Wool and hair; waste of coarse animal hair, including yarn waste, but excluding garnetted stock",
  "510400":
    "Wool and hair; garnetted stock of wool or of fine or coarse animal hair",
  "510510": "Wool; carded",
  "510521": "Wool; wool tops and other combed wool, in fragments",
  "510529": "Wool; wool tops and other combed wool, other than in fragments",
  "510530": "Hair; fine animal hair, carded or combed",
  "510531":
    "Hair; fine animal hair, carded or combed, of kashmir (cashmere) goats",
  "510539":
    "Hair; fine animal hair, carded or combed, other than of kashmir (cashmere) goats",
  "510540": "Hair; coarse animal hair, carded or combed",
  "510610":
    "Yarn; of carded wool, containing 85% or more by weight of wool, not put up for retail sale",
  "510620":
    "Yarn; of carded wool, containing less than 85% by weight of wool, not put up for retail sale",
  "510710":
    "Yarn; of combed wool, containing 85% or more by weight of wool, not put up for retail sale",
  "510720":
    "Yarn; of combed wool, containing less than 85% by weight of wool, not put up for retail sale",
  "510810": "Yarn; of fine animal hair, carded, not put up for retail sale",
  "510820": "Yarn; of fine animal hair, combed, not put up for retail sale",
  "510910":
    "Yarn; of wool or of fine animal hair, containing 85% or more by weight of wool or fine animal hair, put up for retail sale",
  "510990":
    "Yarn; of wool or of fine animal hair, containing less than 85% by weight of wool or fine animal hair, put up for retail sale",
  "511000":
    "Yarn; of coarse animal hair or of horsehair (including gimped horsehair yarn), whether or not put up for retail sale",
  "511111":
    "Fabrics, woven; of carded wool or of carded fine animal hair, containing 85% or more by weight of wool or of fine animal hair, of a weight not exceeding 300g/m2",
  "511119":
    "Fabrics, woven; of carded wool or of carded fine animal hair, containing 85% or more by weight of wool or of fine animal hair, of a weight exceeding 300g/m2",
  "511120":
    "Fabrics, woven; of carded wool or carded fine animal hair, containing less than 85% by weight of wool or fine animal hair, mixed mainly or solely with man-made filaments",
  "511130":
    "Fabrics, woven; of carded wool or carded fine animal hair, containing less than 85% by weight of wool or fine animal hair, mixed mainly or solely with man-made staple fibres",
  "511190":
    "Fabrics, woven; of carded wool or carded fine animal hair, containing less than 85% by weight of wool or fine animal hair, mixed mainly or solely with fibres n.e.c. in heading no. 5111",
  "511211":
    "Fabrics, woven; of combed wool or combed fine animal hair, containing 85% or more by weight of wool or fine animal hair, of a weight not exceeding 200g/m2",
  "511219":
    "Fabrics, woven; of combed wool or combed fine animal hair, containing 85% or more by weight of wool or fine animal hair, of a weight exceeding 200g/m2",
  "511220":
    "Fabrics, woven; of combed wool or combed fine animal hair, containing less than 85% by weight of wool or fine animal hair, mixed mainly or solely with man-made filaments",
  "511230":
    "Fabrics, woven; of combed wool or combed fine animal hair, containing less than 85% by weight of wool or fine animal hair, mixed mainly or solely with man-made staple fibres",
  "511290":
    "Fabrics, woven; of combed wool or combed fine animal hair, containing less than 85% by weight of wool or fine animal hair, mixed mainly or solely with fibres n.e.c. in heading no. 5112",
  "511300": "Fabrics, woven; of coarse animal hair or of horsehair",
  "520100": "Cotton; not carded or combed",
  "520210": "Cotton; yarn waste (including thread waste)",
  "520291": "Cotton; garnetted stock waste",
  "520299":
    "Cotton; waste other than garnetted stock and yarn (including thread) waste",
  "520300": "Cotton; carded or combed",
  "520411":
    "Cotton; sewing thread, containing 85% or more by weight of cotton, not put up for retail sale",
  "520419":
    "Cotton; sewing thread, containing less than 85% by weight of cotton, not put up for retail sale",
  "520420": "Cotton; sewing thread, put up for retail sale",
  "520511":
    "Cotton yarn; (not sewing thread), single, of uncombed fibres, 85% or more by weight of cotton, measuring 714.29 decitex or more, (not exceeding 14 metric number), not for retail sale",
  "520512":
    "Cotton yarn; (not sewing thread), single, of uncombed fibres, 85% or more by weight of cotton, less than 714.29 but not less than 232.56 decitex (exceeding 14 but not exceeding 43 metric number), not for retail sale",
  "520513":
    "Cotton yarn; (not sewing thread), single, of uncombed fibres, 85% or more by weight of cotton, less than 232.56 but not less than 192.31 decitex (exceeding 43 but not exceeding 52 metric number), not for retail sale",
  "520514":
    "Cotton yarn; (not sewing thread), single, of uncombed fibres, 85% or more by weight of cotton, less than 192.31 but not less than 125 decitex (exceeding 52 but not exceeding 80 metric number), not for retail sale",
  "520515":
    "Cotton yarn; (not sewing thread), single, of uncombed fibres, 85% or more by weight of cotton, measuring less than 125 decitex (exceeding 80 metric number), not for retail sale",
  "520521":
    "Cotton yarn; (not sewing thread), single, of combed fibres, 85% or more by weight of cotton, measuring 714.29 decitex or more, (not exceeding 14 metric number), not for retail sale",
  "520522":
    "Cotton yarn; (not sewing thread), single, of combed fibres, 85% or more by weight of cotton, less than 714.29 but not less than 232.56 decitex (exceeding 14 but not exceeding 43 metric number), not for retail sale",
  "520523":
    "Cotton yarn; (not sewing thread), single, of combed fibres, 85% or more by weight of cotton, less than 232.56 but not less than 192.31 decitex (exceeding 43 but not exceeding 52 metric number), not for retail sale",
  "520524":
    "Cotton yarn; (not sewing thread), single, of combed fibres, 85% or more by weight of cotton, less than 192.31 but not less than 125 decitex (exceeding 52 but not exceeding 80 metric number), not for retail sale",
  "520525":
    "Cotton yarn; (not sewing thread), single, of combed fibres, 85% or more by weight of cotton, measuring less than 125 decitex (exceeding 80 metric number), not for retail sale",
  "520526":
    "Cotton yarn; (not sewing thread), single, of combed fibres, 85% or more by weight of cotton, less than 125 but not less than 106.38 decitex (over 80 but not over 94 metric number), not for retail sale",
  "520527":
    "Cotton yarn; (not sewing thread), single, of combed fibres, 85% or more by weight of cotton, less than 106.38 but not less than 83.33 decitex (over 94 but not over 120 metric number), not for retail sale",
  "520528":
    "Cotton yarn; (not sewing thread), single, of combed fibres, 85% or more by weight of cotton, measuring less than 83.33 decitex (exceeding 120 metric number), not for retail sale",
  "520531":
    "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, 85% or more by weight of cotton, 714.29 decitex or more (not exceeding 14 metric number) per single yarn, not for retail sale",
  "520532":
    "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, 85% or more by weight of cotton, 714.28 to 232.56 decitex (15 to 43 metric number) per single yarn, not for retail sale",
  "520533":
    "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, 85% or more by weight of cotton, 232.55 to 192.31 decitex (44 to 52 metric number) per single yarn, not for retail sale",
  "520534":
    "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, 85% or more by weight of cotton, 192.30 to 125 decitex (53 to 80 metric number) per single yarn, not for retail sale",
  "520535":
    "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, 85% or more by weight of cotton, less than 125 decitex (exceeding 80 metric number), per single yarn, not for retail sale",
  "520541":
    "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, 85% or more by weight of cotton, 714.29 decitex or more (not exceeding 14 metric number) per single yarn, not for retail sale",
  "520542":
    "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, 85% or more by weight of cotton, 714.28 to 232.56 decitex (15 to 43 metric number) per single yarn, not for retail sale",
  "520543":
    "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, 85% or more by weight of cotton, 232.55 to 192.31 decitex (44 to 52 metric number) per single yarn, not for retail sale",
  "520544":
    "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, 85% or more by weight of cotton, 192.30 to 125 decitex (53 to 80 metric number) per single yarn, not for retail sale",
  "520545":
    "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, 85% or more by weight of cotton, less than 125 decitex (exceeding 80 metric number), per single yarn, not for retail sale",
  "520546":
    "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, 85% or more by weight of cotton, 124 to 106.38 decitex (81 to 94 metric number) per single yarn, not for retail sale",
  "520547":
    "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, 85% or more by weight of cotton, 106.37 to 83.33 decitex (95 to 120 metric number) per single yarn, not for retail sale",
  "520548":
    "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, 85% or more by weight of cotton, less than 83.33 decitex (exceeding 120 metric number) per single yarn, not for retail sale",
  "520611":
    "Cotton yarn; (not sewing thread), single, of uncombed fibres, less than 85% by weight of cotton, measuring 714.29 decitex or more (not exceeding 14 metric number), not for retail sale",
  "520612":
    "Cotton yarn; (not sewing thread), single, of uncombed fibres, less than 85% by weight of cotton, less than 714.29 but not less than 232.56 decitex (exceeding 14 but not exceeding 43 metric number), not for retail sale",
  "520613":
    "Cotton yarn; (not sewing thread), single, of uncombed fibres, less than 85% by weight of cotton, less than 232.56 but not less than 192.31 decitex (exceeding 43 but not exceeding 52 metric number), not for retail sale",
  "520614":
    "Cotton yarn; (not sewing thread), single, of uncombed fibres, less than 85% by weight of cotton, less than 192.31 but not less than 125 decitex (exceeding 52 but not exceeding 80 metric number), not for retail sale",
  "520615":
    "Cotton yarn; (not sewing thread), single, of uncombed fibres, less than 85% by weight of cotton, measuring less than 125 decitex (exceeding 80 metric number), not for retail sale",
  "520621":
    "Cotton yarn; (not sewing thread), single, of combed fibres, less than 85% by weight of cotton, measuring 714.29 decitex or more, (not exceeding 14 metric number), not for retail sale",
  "520622":
    "Cotton yarn; (not sewing thread), single, of combed fibres, less than 85% by weight of cotton, less than 714.29 but not less than 232.56 decitex (exceeding 14 but not exceeding 43 metric number), not for retail sale",
  "520623":
    "Cotton yarn; (not sewing thread), single, of combed fibres, less than 85% by weight of cotton, less than 232.56 but not less than 192.31 decitex (exceeding 43 but not exceeding 52 metric number), not for retail sale",
  "520624":
    "Cotton yarn; (not sewing thread), single, of combed fibres, less than 85% by weight of cotton, less than 192.31 but not less than 125 decitex (exceeding 52 but not exceeding 80 metric number), not for retail sale",
  "520625":
    "Cotton yarn; (not sewing thread), single, of combed fibres, less than 85% by weight of cotton, measuring less than 125 decitex (exceeding 80 metric number), not for retail sale",
  "520631":
    "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, less than 85% by weight of cotton, 714.29 decitex or more (not exceeding 14 metric number) per single yarn, not for retail sale",
  "520632":
    "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, less than 85% by weight of cotton, 714.28 to 232.56 decitex (15 to 43 metric number) per single yarn, not for retail sale",
  "520633":
    "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, less than 85% by weight of cotton, 232.55 to 192.31 decitex (44 to 52 metric number) per single yarn, not for retail sale",
  "520634":
    "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, less than 85% by weight of cotton, 192.30 to 125 decitex (53 to 80 metric number) per single yarn, not for retail sale",
  "520635":
    "Cotton yarn; (not sewing thread), multiple or cabled, of uncombed fibres, less than 85% by weight of cotton, less than 125 decitex (exceeding 80 metric number) per single yarn, not for retail sale",
  "520641":
    "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, less than 85% by weight of cotton, 714.29 decitex or more (not exceeding 14 metric number) per single yarn, not for retail sale",
  "520642":
    "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, less than 85% by weight of cotton, 714.28 to 232.56 decitex (15 to 43 metric number) per single yarn, not for retail sale",
  "520643":
    "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, less than 85% by weight of cotton, 232.55 to 192.31 decitex (44 to 52 metric number) per single yarn, not for retail sale",
  "520644":
    "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, less than 85% by weight of cotton, 192.30 to 125 decitex (53 to 80 metric number) per single yarn, not for retail sale",
  "520645":
    "Cotton yarn; (not sewing thread), multiple or cabled, of combed fibres, less than 85% by weight of cotton, less than 125 decitex (exceeding 80 metric number) per single yarn, not for retail sale",
  "520710":
    "Cotton yarn; (not sewing thread), containing 85% or more by weight of cotton, put up for retail sale",
  "520790":
    "Cotton yarn; (not sewing thread), containing less than 85% by weight of cotton, put up for retail sale",
  "520811":
    "Fabrics, woven; containing 85% or more by weight of cotton, unbleached, plain weave, weighing not more than 100g/m2",
  "520812":
    "Fabrics, woven; containing 85% or more by weight of cotton, unbleached, plain weave, weighing more than 100g/m2 but not more than 200g/m2",
  "520813":
    "Fabrics, woven; containing 85% or more by weight of cotton, unbleached, 3-thread or 4-thread twill, including cross twill, weighing not more than 200g/m2",
  "520819":
    "Fabrics, woven; containing 85% or more by weight of cotton, unbleached, of weaves n.e.c. in item no. 5208.1, weighing not more than 200g/m2",
  "520821":
    "Fabrics, woven; containing 85% or more by weight of cotton, bleached, plain weave, weighing not more than 100g/m2",
  "520822":
    "Fabrics, woven; containing 85% or more by weight of cotton, bleached, plain weave, weighing more than 100g/m2 but not more than 200g/m2",
  "520823":
    "Fabrics, woven; containing 85% or more by weight of cotton, bleached, 3-thread or 4-thread twill, including cross twill, weighing not more than 200g/m2",
  "520829":
    "Fabrics, woven; containing 85% or more by weight of cotton, bleached, of weaves n.e.c. in item no. 5208.2, weighing not more than 200g/m2",
  "520831":
    "Fabrics, woven; containing 85% or more by weight of cotton, dyed, plain weave, weighing not more than 100g/m2",
  "520832":
    "Fabrics, woven; containing 85% or more by weight of cotton, dyed, plain weave, weighing more than 100g/m2 but not more than 200g/m2",
  "520833":
    "Fabrics, woven; containing 85% or more by weight of cotton, dyed, 3-thread or 4-thread twill, including cross twill, weighing not more than 200g/m2",
  "520839":
    "Fabrics, woven; containing 85% or more by weight of cotton, dyed, of weaves n.e.c. in item no. 5208.3 weighing not more than 200g/m2",
  "520841":
    "Fabrics, woven; containing 85% or more by weight of cotton, of yarns of different colours, plain weave, weighing not more than 100g/m2",
  "520842":
    "Fabrics, woven; containing 85% or more by weight of cotton, of yarns of different colours, weighing more than 100g/m2 but not more than 200g/m2",
  "520843":
    "Fabrics, woven; containing 85% or more by weight of cotton, of yarns of different colours, 3-thread or 4-thread twill, including cross twill, weighing not more than 200g/m2",
  "520849":
    "Fabrics, woven; containing 85% or more by weight of cotton, of yarns of different colours, of weaves n.e.c. in item no. 5208.4, weighing not more than 200g/m2",
  "520851":
    "Fabrics, woven; containing 85% or more by weight of cotton, printed, plain weave, weighing not more than 100g/m2",
  "520852":
    "Fabrics, woven; containing 85% or more by weight of cotton, printed, plain weave, weighing more than 100g/m2 but not more than 200g/m2",
  "520853":
    "Fabrics, woven; containing 85% or more by weight of cotton, printed, 3-thread or 4-thread twill, including cross twill, weighing not more than 200g/m2",
  "520859":
    "Fabrics, woven; containing 85% or more by weight of cotton, printed, of weaves n.e.c. in item no. 5208.5, weighing not more than 200g/m2",
  "520911":
    "Fabrics, woven; containing 85% or more by weight of cotton, unbleached, plain weave, weighing more than 200g/m2",
  "520912":
    "Fabrics, woven; containing 85% or more by weight of cotton, unbleached, 3-thread or 4-thread twill, including cross twill, weighing more than 200g/m2",
  "520919":
    "Fabrics, woven; containing 85% or more by weight of cotton, unbleached, of weaves n.e.c. in item no. 5209.1, weighing more than 200g/m2",
  "520921":
    "Fabrics, woven; containing 85% or more by weight of cotton, bleached, plain weave, weighing more than 200g/m2",
  "520922":
    "Fabrics, woven; containing 85% or more by weight of cotton, bleached, 3-thread or 4-thread twill, including cross twill, weighing more than 200g/m2",
  "520929":
    "Fabrics, woven; containing 85% or more by weight of cotton, bleached, of weaves n.e.c. in item no. 5209.2, weighing more than 200g/m2",
  "520931":
    "Fabrics, woven; containing 85% or more by weight of cotton, dyed, plain weave, weighing more than 200g/m2",
  "520932":
    "Fabrics, woven; containing 85% or more by weight of cotton, dyed, 3-thread or 4-thread twill, including cross twill, weighing more than 200g/m2",
  "520939":
    "Fabrics, woven; containing 85% or more by weight of cotton, dyed, of weaves n.e.c. in item no. 5209.3, weighing more than 200g/m2",
  "520941":
    "Fabrics, woven; containing 85% or more by weight of cotton, of yarns of different colours, plain weave, weighing more than 200g/m2",
  "520942":
    "Fabrics, woven; containing 85% or more by weight of cotton, of yarns of different colours, weighing more than 200g/m2, denim",
  "520943":
    "Fabrics, woven; containing 85% or more by weight of cotton, of yarns of different colours, 3-thread or 4-thread twill, including cross twill, weighing more than 200g/m2",
  "520949":
    "Fabrics, woven; containing 85% or more by weight of cotton, of yarns of different colours, of weaves n.e.c. in item no. 5209.4, weighing more than 200g/m2",
  "520951":
    "Fabrics, woven; containing 85% or more by weight of cotton, printed, plain weave, weighing more than 200g/m2",
  "520952":
    "Fabrics, woven; containing 85% or more by weight of cotton, printed, 3-thread or 4-thread twill, including cross twill, weighing more than 200g/m2",
  "520959":
    "Fabrics, woven; containing 85% or more by weight of cotton, printed, of weaves n.e.c. in item no. 5209.5, weighing more than 200g/m2",
  "521011":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, unbleached, plain weave, weighing 200g/m2 or less",
  "521012":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, unbleached, 3-thread or 4-thread twill, including cross twill, weighing 200g/m2 or less",
  "521019":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, unbleached, of weaves n.e.c. in item no. 5210.1, weighing 200g/m2 or less",
  "521021":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, bleached, plain weave, weighing 200g/m2 or less",
  "521022":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, bleached, 3-thread or 4-thread twill, including cross twill, weighing 200g/m2 or less",
  "521029":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, bleached, of weaves n.e.c. in item no. 5210.2",
  "521031":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, dyed, plain weave",
  "521032":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, dyed, 3-thread or 4-thread twill, including cross twill",
  "521039":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, dyed, of weaves n.e.c. in item no. 5210.3",
  "521041":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, of yarns of different colours, plain weave",
  "521042":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, of yarns of different colours, 3-thread or 4-thread twill, including cross twill",
  "521049":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, of yarns of different colours, of weaves n.e.c. in item no. 5210.4",
  "521051":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, printed, plain weave",
  "521052":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly of solely with man-made fibres, weighing 200g/m2 or less, printed, 3-thread or 4-thread twill, including cross twill",
  "521059":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing 200g/m2 or less, printed, of weaves n.e.c. in item no. 5210.5",
  "521111":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, unbleached, plain weave, weighing more than 200g/m2",
  "521112":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, unbleached, 3- or 4-thread twill, including cross twill, weighing more than 200g/m2",
  "521119":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, unbleached, of weaves n.e.c. in item no. 5211.1, weighing more than 200g/m2",
  "521120":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, bleached",
  "521121":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, bleached, plain weave",
  "521122":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, bleached, 3-thread or 4-thread twill, including cross twill",
  "521129":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, bleached, of weaves n.e.s. in item no. 5211.2",
  "521131":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, dyed, plain weave",
  "521132":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, dyed, 3-thread or 4-thread twill, including cross twill",
  "521139":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, dyed, of weaves n.e.c. in item no. 5211.3",
  "521141":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, of yarns of different colours, plain weave",
  "521142":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, of yarns of different colours, denim",
  "521143":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, of yarns of different colours, 3-thread or 4-thread twill, including cross twill",
  "521149":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, of yarns of different colours, of weaves n.e.c. in item no. 5211.4",
  "521151":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, printed, plain weave",
  "521152":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, printed, 3-thread or 4-thread twill, including cross twill",
  "521159":
    "Fabrics, woven; containing less than 85% by weight of cotton, mixed mainly or solely with man-made fibres, weighing more than 200g/m2, printed, of weaves n.e.c. in item no. 5211.5",
  "521211":
    "Fabrics, woven; of cotton, unbleached, weighing not more than 200g/m2, n.e.c. in chapter 52",
  "521212":
    "Fabrics, woven; of cotton, bleached, weighing not more than 200g/m2, n.e.c. in chapter 52",
  "521213":
    "Fabrics, woven; of cotton, dyed, weighing not more than 200g/m2, n.e.c. in chapter 52",
  "521214":
    "Fabrics, woven; of cotton, of yarns of different colours, weighing not more than 200g/m2, n.e.c. in chapter 52",
  "521215":
    "Fabrics, woven; of cotton, printed, weighing not more than 200g/m2, n.e.c. in chapter 52",
  "521221":
    "Fabrics, woven; of cotton, unbleached, weighing more than 200g/m2, n.e.c. in chapter 52",
  "521222":
    "Fabrics, woven; of cotton, bleached, weighing more than 200g/m2, n.e.c. in chapter 52",
  "521223":
    "Fabrics, woven; of cotton, dyed, weighing more than 200g/m2, n.e.c. in chapter 52",
  "521224":
    "Fabrics, woven; of cotton, of yarns of different colours, weighing more than 200g/m2, n.e.c. in chapter 52",
  "521225":
    "Fabrics, woven; of cotton, printed, weighing more than 200g/m2, n.e.c. in chapter 52",
  "530110": "Flax; raw or retted, but not spun",
  "530121": "Flax; broken or scutched, but not spun",
  "530129": "Flax; hackled or otherwise processed, but not spun",
  "530130": "Flax; tow and waste, including yarn waste and garnetted stock",
  "530210": "Hemp (cannabis sativa L.); raw or retted, but not spun",
  "530290":
    "Hemp (cannabis sativa L.); processed (other than retted) (but not spun), true hemp tow and waste (including yarn waste and garnetted stock)",
  "530310":
    "Jute and other textile bast fibres; raw or retted, but not spun, (excluding flax, hemp (cannabis sativa L.), and ramie)",
  "530390":
    "Jute and other textile bast fibres; processed but not spun, tow and waste of these fibres, including yarn waste and garnetted stock (excluding flax, hemp (cannabis sativa L.), and ramie)",
  "530410":
    "Sisal and other textile fibres of the genus agave; raw, but not spun",
  "530490":
    "Sisal and other textile fibres of the genus agave; processed (but not spun), tow and waste of these fibres, including yarn waste and garnetted stock",
  "530500":
    "Coconut, abaca (Manila hemp or Musa textilis Nee), ramie and other vegetable textile fibres n.e.c., raw or processed but not spun; tow, noils and waste of these fibres (including yarn waste and garnetted stock)",
  "530511": "Coconut (coir); raw, but not spun",
  "530519":
    "Coconut (coir); processed (but not spun), tow, noils and waste, including yarn waste and garnetted stock",
  "530521": "Abaca (manila hemp or musa textilis nee); raw",
  "530529":
    "Abaca (manila hemp or musa textilis nee); processed but not spun, tow, noils and waste, including yarn waste and garnetted stock",
  "530590":
    "Vegetable textile fibres; other than coconut (coir) and abaca (manila hemp, or musa textilis nee), raw or processed (but not spun); tow, noils and waste of these fibres, including yarn waste and garnetted stock",
  "530591":
    "Ramie and other vegetable textile fibres; n.e.s. in chapter 53, raw",
  "530599":
    "Ramie and other vegetable textile fibres; n.e.s. in chapter 53, processed (but not spun); tow, noils and waste of these fibres, including yarn waste and garnetted stock",
  "530610": "Yarn; of flax, single",
  "530620": "Yarn; of flax, multiple (folded) or cabled",
  "530710": "Yarn; of jute or of other textile bast fibres, single",
  "530720":
    "Yarn; of jute or of other textile bast fibres, multiple (folded) or cabled",
  "530810": "Yarn; of coir",
  "530820": "Yarn; of hemp (cannabis sativa L.)",
  "530830": "Yarn; of paper",
  "530890":
    "Yarn; of vegetable textile fibres n.e.c. in heading no. 5306, 5307 and 5308",
  "530911":
    "Fabrics, woven; of flax, containing 85% or more flax, unbleached or bleached",
  "530919":
    "Fabrics, woven; of flax, containing 85% or more flax, other than bleached or unbleached",
  "530921":
    "Fabrics, woven; of flax, containing less than 85% flax, unbleached or bleached",
  "530929":
    "Fabrics, woven; of flax, containing less than 85% flax, other than unbleached or bleached",
  "531010":
    "Fabrics, woven; of jute or of other textile bast fibres of heading no. 5303, unbleached",
  "531090":
    "Fabrics, woven; of jute or of other textile bast fibres of heading no. 5303, other than unbleached",
  "531100":
    "Fabrics, woven; of vegetable textile fibres n.e.c. in heading no. 5309 and 5310, woven fabrics of paper yarn",
  "540110":
    "Sewing thread; of synthetic filaments, whether or not put up for retail sale",
  "540120":
    "Sewing thread; of artificial filaments, whether or not put up for retail sale",
  "540210":
    "Yarn; (not sewing thread), high tenacity yarn of nylon or other polyamides (including synthetic monofilament of less than 67 decitex), not put up for retail sale",
  "540211":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), of high tenacity yarn of nylon or other polyamides, textured or not; of aramids, not for retail sale, not sewing thread",
  "540219":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), of high tenacity nylon or other polyamides, textured or not; other than aramids, not for retail sale, not sewing thread",
  "540220":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), of high tenacity yarn of polyesters, whether or not textured, not for retail sale, not sewing thread",
  "540231":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), textured, of nylon or other polyamides, measuring per single yarn not more than 50 decitex, not for retail sale, not sewing thread",
  "540232":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), textured, of nylon or other polyamides, measuring per single yarn more than 50 decitex, not for retail sale, not sewing thread",
  "540233":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), textured, of polyesters, not for retail sale, not sewing thread",
  "540234":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), textured, of polypropylene, not for retail sale, not sewing thread",
  "540239":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), textured, other than of nylon or other polymides, polyesters, or polypropylene, not for retail sale, not sewing thread",
  "540241":
    "Yarn; (not sewing thread), single, of nylon or other polyamides (including synthetic monofilament of less than 67 decitex), untwisted or with a twist not exceeding 50 turns per metre, not for retail sale, not textured, not high tenacity",
  "540242":
    "Yarn; (not sewing thread), single, of polyesters, partially oriented (including synthetic monofilament of less than 67 decitex), untwisted or with twist not over 50 turns per metre, not for retail sale, not textured, not high tenacity",
  "540243":
    "Yarn; (not sewing thread), single, of polyesters not partially oriented (including synthetic monofilament of less than 67 decitex), untwisted or with twist not over 50 turns per metre, not for retail sale, not textured, not high tenacity",
  "540244":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), other than high tenacity or textured yarn, elastomeric, single, untwisted or twisted 50 turns or less per metre, not for retail sale, not sewing thread",
  "540245":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), of nylon or other polymides (not high tenacity or textured), single, untwisted or twisted 50 turns or less per metre, not for retail sale, not sewing thread",
  "540246":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), of polyesters (not high tenacity or textured), partially oriented, single, untwisted or twisted 50 turns or less per metre, not for retail sale, not sewing thread",
  "540247":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), polyesters (not high tenacity or textured), not partially oriented, single, untwisted or twisted 50 turns or less per metre, not for retail sale, not sewing thread",
  "540248":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), of polypropylene (not high tenacity or textured), single, untwisted or twisted 50 turns or less per metre, not for retail sale, not sewing thread",
  "540249":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), other than high tenacity or textured yarn, single, untwisted or twisted 50 turns or less per metre, n.e.c. in heading no. 5402, not for retail sale, not sewing thread",
  "540251":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), of nylon or other polymides (not high tenacity or textured), single, twisted more than 50 turns per metre, not for retail sale, not sewing thread",
  "540252":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), of polyesters (not high tenacity or textured), single, twisted more than 50 turns per metre, not for retail sale, not sewing thread",
  "540253":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), of polypropylene (not high tenacity or textured), single, twisted more than 50 turns per metre, not for retail sale, not sewing thread",
  "540259":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), other than high tenacity or textured yarn, single, twisted more than 50 turns per metre, n.e.c. in heading no. 5402, not for retail sale, not sewing thread",
  "540261":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), of nylon or other polymides (not high tenacity or textured), multiple (folded) or cabled, not for retail sale, not sewing thread",
  "540262":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), of polyesters (not high tenacity or textured), multiple (folded) or cabled, not for retail sale, not sewing thread",
  "540263":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), of polypropylene, other than high tenacity or textured yarn, multiple (folded) or cabled, not for retail sale, not sewing thread",
  "540269":
    "Yarn, synthetic; filament, monofilament (less than 67 decitex), other than high tenacity or textured yarn, multiple (folded) or cabled, n.e.c. in heading no. 5402, not for retail sale, not sewing thread",
  "540310":
    "Yarn, artificial; filament, monofilament (less than 67 decitex), of high tenacity viscose rayon, not for retail sale, not sewing thread",
  "540320":
    "Yarn; textured, (not sewing thread), artificial filament yarn, (including artificial monofilament of less than 67 decitex), not for retail sale",
  "540331":
    "Yarn, artificial; filament, monofilament (less than 67 decitex), of viscose rayon (not high tenacity), single, untwisted or twisted 120 turns per metre or less, not for retail sale, not sewing thread",
  "540332":
    "Yarn, artificial; filament, monofilament (less than 67 decitex), of viscose rayon (not high tenacity), single, twisted more than 120 turns per metre, not for retail sale, not sewing thread",
  "540333":
    "Yarn, artificial; filament, monofilament (less than 67 decitex), of cellulose acetate, single, not for retail sale, not sewing thread",
  "540339":
    "Yarn, artificial; filament, monofilament (less than 67 decitex), single, n.e.c. in heading no. 5403, not for retail sale, not sewing thread",
  "540341":
    "Yarn, artificial; filament, monofilament (less than 67 decitex), of viscose rayon (not high tenacity), multiple (folded) or cabled, not for retail sale, not sewing thread",
  "540342":
    "Yarn, artificial; filament, monofilament (less than 67 decitex), of cellulose acetate, multiple (folded) or cabled, not for retail sale, not sewing thread",
  "540349":
    "Yarn, artificial; filament, monofilament (less than 67 decitex), multiple (folded) or cabled, n.e.c. in heading no. 5403, not for retail sale, not sewing thread",
  "540410":
    "Monofilament, synthetic; of 67 decitex or more and of which no cross-sectional dimension exceeds 1mm",
  "540411":
    "Elastomeric monofilament; of 67 decitex or more and of which no cross-sectional dimension exceeds 1mm",
  "540412":
    "Monofilament of polypropylene; of 67 decitex or more and of which no cross-sectional dimension exceeds 1mm",
  "540419":
    "Monofilament n.e.c. in heading no 5404; of 67 decitex or more and of which no cross-sectional dimension exceeds 1mm",
  "540490":
    "Filament, synthetic; strip and the like (e.g.. artificial straw), of synthetic textile materials of an apparent width not exceeding 5mm",
  "540500":
    "Monofilament, synthetic; of 67 decitex or more and of which no cross-sectional dimension exceeds 1mm, strip and the like (e.g. artificial straw), of synthetic textile materials with width not over 5mm",
  "540600":
    "Man-made filament yarn (other than sewing thread), put up for retail sale",
  "540610":
    "Yarn; (not sewing thread), synthetic filament yarn, put up for retail sale",
  "540620":
    "Yarn; (not sewing thread), artificial filament yarn, put up for retail sale",
  "540710":
    "Fabrics, woven; from high tenacity yarn, of nylon, other polyamides or of polyesters",
  "540720":
    "Fabrics, woven; from strip or the like, of synthetic textile materials",
  "540730":
    "Fabrics, woven; from synthetic filament yarn, adhesive or thermal bonded",
  "540741":
    "Fabrics, woven; containing 85% or more by weight of filaments of nylon or other polyamides, unbleached or bleached",
  "540742":
    "Fabrics, woven; containing 85% or more by weight of filaments of nylon or other polyamides, dyed",
  "540743":
    "Fabrics, woven; containing 85% or more by weight of filaments of nylon or other polyamides, of yarns of different colours",
  "540744":
    "Fabrics, woven; containing 85% or more by weight of filaments of nylon or other polyamides, printed",
  "540751":
    "Fabrics, woven; containing 85% or more by weight of textured polyester filaments, unbleached or bleached",
  "540752":
    "Fabrics, woven; containing 85% or more by weight of textured polyester filaments, dyed",
  "540753":
    "Fabrics, woven; containing 85% or more by weight of textured polyester filaments, of yarns of different colours",
  "540754":
    "Fabrics, woven; containing 85% or more by weight of textured polyester filaments, printed",
  "540760":
    "Fabrics, woven; containing 85% or more by weight of non-textured polyester filaments",
  "540761":
    "Fabrics, woven; containing 85% or more by weight of non-textured polyester filaments",
  "540769":
    "Fabrics, woven; containing less than 85% by weight of non-textured polyester filaments",
  "540771":
    "Fabrics, woven; containing 85% or more by weight of synthetic filaments (excluding nylon or other polyamides and polyesters), unbleached or bleached",
  "540772":
    "Fabrics, woven; containing 85% or more by weight of synthetic filaments (excluding nylon or other polyamides and polyesters), dyed",
  "540773":
    "Fabrics, woven; containing 85% or more by weight of synthetic filaments (excluding nylon or other polyamides and polyesters), of yarns of different colours",
  "540774":
    "Fabrics, woven; containing 85% or more by weight of synthetic filaments (excluding nylon or other polyamides and polyesters), printed",
  "540781":
    "Fabrics, woven; of synthetic filament yarn, containing less than 85% by weight of synthetic filaments, mixed mainly or solely with cotton, bleached or unbleached",
  "540782":
    "Fabrics, woven; of synthetic filament yarn, containing less than 85% by weight of synthetic filaments, mixed mainly or solely with cotton, dyed",
  "540783":
    "Fabrics, woven; of synthetic filament yarn, containing less than 85% by weight of synthetic filaments, mixed mainly or solely with cotton, of yarns of different colours",
  "540784":
    "Fabrics, woven; of synthetic filament yarn, containing less than 85% by weight of synthetic filaments, printed",
  "540791":
    "Fabrics, woven; of synthetic filament yarn, bleached or unbleached, n.e.c. in heading no. 5407",
  "540792":
    "Fabrics, woven; of synthetic filament yarn, dyed, n.e.c. in heading 5407",
  "540793":
    "Fabrics, woven; of synthetic filament yarn, of yarns of different colours, n.e.c. in heading no. 5407",
  "540794":
    "Fabrics, woven; of synthetic filament yarn, printed, n.e.c. in heading no. 5407",
  "540810":
    "Fabrics, woven; of viscose rayon, high tenacity, artificial filament yarn",
  "540821":
    "Fabrics, woven; of artificial filament yarn, containing 85% or more by weight of artificial filament, strip or the like, bleached or unbleached",
  "540822":
    "Fabrics, woven; of artificial filament yarn, containing 85% or more by weight of artificial filament, strip or the like, dyed",
  "540823":
    "Fabrics, woven; containing 85% or more by weight of artificial filament, strip or the like, of yarns of different colours",
  "540824":
    "Fabrics, woven; of artificial filament yarn, containing 85% or more by weight of artificial filament, strip or the like, printed",
  "540831":
    "Fabrics, woven; of artificial filament yarn, of artificial monofilament, strip and the like, n.e.c. in heading no. 5408, unbleached or bleached",
  "540832":
    "Fabrics, woven; of artificial filament yarn, of artificial monofilament, strip and the like, n.e.c. in heading no. 5408, dyed",
  "540833":
    "Fabrics, woven; of artificial filament yarn, of artificial monofilament, strip and the like, n.e.c. in heading no. 5408, of yarns of different colours",
  "540834":
    "Fabrics, woven; of artificial filament yarn, of artificial monofilament, strip and the like, n.e.c. in heading no. 5408, printed",
  "550110": "Fibres; synthetic filament tow, of nylon or other polyamides",
  "550111":
    "Fibres; synthetic filament tow, of nylon or other polyamides, of aramids",
  "550119":
    "Fibres; synthetic filament tow, of nylon or other polyamides, of other than aramids",
  "550120": "Fibres; synthetic filament tow, of polyesters",
  "550130": "Fibres; synthetic filament tow, acrylic or modacrylic",
  "550140": "Fibres; synthetic filament tow, of polypropylene",
  "550190":
    "Fibres; synthetic filament tow, of synthetic materials n.e.c. in heading no. 5501",
  "550200": "Fibres; artificial filament tow",
  "550210": "Fibres; artificial filament tow of cellulose acetate",
  "550290": "Fibres; artificial filament tow, other than cellulose acetate",
  "550310":
    "Fibres; synthetic staple fibres, of nylon or other polyamides, not carded, combed or otherwise processed for spinning",
  "550311":
    "Fibres; synthetic staple fibres, of aramids, not carded, combed or otherwise processed for spinning",
  "550319":
    "Fibres; synthetic staple fibres, of nylon or other polyamides other than aramids, not carded, combed or otherwise processed for spinning",
  "550320":
    "Fibres; synthetic staple fibres, of polyesters, not carded, combed or otherwise processed for spinning",
  "550330":
    "Fibres; synthetic staple fibres, acrylic or modacrylic, not carded, combed or otherwise processed for spinning",
  "550340":
    "Fibres; synthetic staple fibres, of polypropylene, not carded, combed or otherwise processed for spinning",
  "550390":
    "Fibres; synthetic staple fibres, of synthetic materials n.e.c. in heading no. 5503, not carded, combed or otherwise processed for spinning",
  "550410":
    "Fibres; artificial staple fibres, of viscose, not carded, combed or otherwise processed for spinning",
  "550490":
    "Fibres; artificial staple fibres, other than of viscose, not carded, combed or otherwise processed for spinning",
  "550510":
    "Fibres; waste (including noils, yarn waste and garnetted stock), of synthetic fibres",
  "550520":
    "Fibres; waste (including noils, yarn waste and garnetted stock), of artificial fibres",
  "550610":
    "Fibres; synthetic staple fibres, of nylon or other polyamides, carded, combed or otherwise processed for spinning",
  "550620":
    "Fibres; synthetic staple fibres, of polyesters, carded, combed or otherwise processed for spinning",
  "550630":
    "Fibres; synthetic staple fibres, acrylic or modacrylic, carded, combed or otherwise processed for spinning",
  "550640":
    "Fibres; synthetic staple fibres, of polypropylene, carded, combed or otherwise processed for spinning",
  "550690":
    "Fibres; synthetic staple fibres, n.e.c. in heading no. 5506, carded, combed or otherwise processed for spinning",
  "550700":
    "Fibres; artificial staple fibres, carded, combed or otherwise processed for spinning",
  "550810":
    "Sewing thread; of synthetic staple fibres, whether or not put up for retail sale",
  "550820":
    "Sewing thread; of artificial staple fibres, whether or not put up for retail sale",
  "550911":
    "Yarn; (not sewing thread), single, of synthetic staple fibres, containing 85% or more by weight of nylon or other polyamides, not put up for retail sale",
  "550912":
    "Yarn; (not sewing thread), multiple (folded) or cabled yarn, of synthetic staple fibres, containing 85% or more by weight of nylon or other polyamides, not put up for retail sale",
  "550921":
    "Yarn; (not sewing thread), single, of synthetic staple fibres, containing 85% or more by weight of polyester, not put up for retail sale",
  "550922":
    "Yarn; (not sewing thread), multiple (folded) or cabled yarn, of synthetic staple fibres, containing 85% or more by weight of polyester, not put up for retail sale",
  "550931":
    "Yarn; (not sewing thread), single, of synthetic staple fibres, containing 85% or more by weight of acrylic or modacrylic, not put up for retail sale",
  "550932":
    "Yarn; (not sewing thread), multiple (folded) or cabled, of synthetic staple fibres, containing 85% or more by weight of acrylic or modacrylic, not put up for retail sale",
  "550941":
    "Yarn; (not sewing thread), single, containing 85% or more by weight of synthetic staple fibres, n.e.c. in heading no. 5509, not put up for retail sale",
  "550942":
    "Yarn; (not sewing thread), multiple (folded) or cabled yarn, containing 85% or more by weight of synthetic staple fibres, n.e.c. in heading no. 5509, not put up for retail sale",
  "550951":
    "Yarn; (not sewing thread), of polyester staple fibres, mixed mainly or solely with artificial staple fibres, not put up for retail sale",
  "550952":
    "Yarn; (not sewing thread), of polyester staple fibres, mixed mainly or solely with wool or fine animal hair, not put up for retail sale",
  "550953":
    "Yarn; (not sewing thread), of polyester staple fibres, mixed mainly or solely with cotton, not put up for retail sale",
  "550959":
    "Yarn; (not sewing thread), of polyester staple fibres, mixed mainly or solely with fibres n.e.c. in item no. 5509.5, not put up for retail sale",
  "550961":
    "Yarn; (not sewing thread), of acrylic or modacrylic staple fibres, mixed mainly or solely with wool or fine animal hair, not put up for retail sale",
  "550962":
    "Yarn; (not sewing thread), of acrylic or modacrylic staple fibres, mixed mainly or solely with cotton, not put up for retail sale",
  "550969":
    "Yarn; (not sewing thread), of acrylic or modacrylic staple fibres, mixed mainly or solely with fibres n.e.c. in item no. 5509.6, not put up for retail sale",
  "550991":
    "Yarn; (not sewing thread), of synthetic staple fibres, mixed mainly or solely with wool or fine animal hair, n.e.c. in heading no. 5509, not put up for retail sale",
  "550992":
    "Yarn; (not sewing thread), of synthetic staple fibres, mixed mainly or solely with cotton, n.e.c. in heading no. 5509, not put up for retail sale",
  "550999":
    "Yarn; (not sewing thread), of synthetic staple fibres, mixed mainly or solely with fibres (other than wool, fine animal hair or cotton), n.e.c. in heading no. 5509, not put up for retail sale",
  "551011":
    "Yarn; (not sewing thread), single, of artificial staple fibres, containing 85% or more by weight of artificial staple fibres, not put up for retail sale",
  "551012":
    "Yarn; (not sewing thread), multiple (folded) or cabled yarn, of artificial staple fibres, containing 85% or more by weight of artificial staple fibres, not put up for retail sale",
  "551020":
    "Yarn; (not sewing thread), of artificial staple fibres, mixed mainly or solely with wool or fine animal hair, not put up for retail sale",
  "551030":
    "Yarn; (not sewing thread), of artificial staple fibres, mixed mainly or solely with cotton, not put up for retail sale",
  "551090":
    "Yarn; (not sewing thread), of artificial staple fibres, mixed mainly or solely with fibres (other than wool, fine animal hair or cotton), not put up for retail sale",
  "551110":
    "Yarn; (not sewing thread), of synthetic staple fibres, containing 85% or more by weight of synthetic staple fibres, put up for retail sale",
  "551120":
    "Yarn; (not sewing thread), of synthetic staple fibres, containing less than 85% by weight of synthetic staple fibres, put up for retail sale",
  "551130":
    "Yarn; (not sewing thread), of artificial staple fibres, put up for retail sale",
  "551211":
    "Fabrics, woven; of synthetic staple fibres, containing 85% or more by weight of polyester staple fibres, unbleached or bleached",
  "551219":
    "Fabrics, woven; of synthetic staple fibres, containing 85% or more by weight of polyester staple fibres, other than unbleached or bleached",
  "551221":
    "Fabrics, woven; of synthetic staple fibres, containing 85% or more by weight of acrylic or modacrylic staple fibres, unbleached or bleached",
  "551229":
    "Fabrics, woven; of synthetic staple fibres, containing 85% or more by weight of acrylic or modacrylic staple fibres, other than unbleached or bleached",
  "551291":
    "Fabrics, woven; of synthetic staple fibres, containing 85% or more by weight of such fibres n.e.c. in heading no. 5512, unbleached or bleached",
  "551299":
    "Fabrics, woven; of synthetic staple fibres, containing 85% or more by weight of such fibres n.e.c. in heading no. 5512, other than unbleached or bleached",
  "551311":
    "Fabrics, woven; plain weave, of polyester staple fibres, containing less than 85% by weight of such fibres, mixed mainly or solely with cotton, of a weight not exceeding 170g/m2, unbleached or bleached",
  "551312":
    "Fabrics, woven; 3-thread or 4-thread twill, of polyester staple fibres, containing less than 85% by weight of such, mixed mainly or solely with cotton, not exceeding 170g/m2, unbleached or bleached",
  "551313":
    "Fabrics, woven; of polyester staple fibres, containing less than 85% by weight of such fibres, mixed mainly or solely with cotton, not exceeding 170g/m2, unbleached or bleached",
  "551319":
    "Fabrics, woven; containing less than 85% by weight of synthetic staple fibres (other than polyesters), mixed mainly or solely with cotton, not exceeding 170g/m2, unbleached or bleached",
  "551321":
    "Fabrics, woven; plain weave, dyed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, not exceeding 170g/m2",
  "551322":
    "Fabrics, woven; 3- or 4-thread twill, including cross twill, dyed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, not exceeding 170g/m2",
  "551323":
    "Fabrics, woven; dyed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, not exceeding 170g/m2",
  "551329":
    "Fabrics, woven; dyed, containing less than 85% by weight of synthetic staple fibres (other than polyesters), mixed mainly or solely with cotton, not exceeding 170g/m2",
  "551331":
    "Fabrics, woven; plain weave, of yarns of different colours, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, not exceeding 170g/m2",
  "551332":
    "Fabrics, woven; 3- or 4-thread twill, including cross twill, of yarns of different colours, less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, not exceeding 170g/m2",
  "551333":
    "Fabrics, woven; of yarns of different colours, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, not exceeding 170g/m2, n.e.s. in heading no. 5513",
  "551339":
    "Fabrics, woven; of yarns of different colours, containing less than 85% of synthetic staple fibres (other than polyester, plain weave), mixed mainly or solely with cotton, not exceeding 170g/m2",
  "551341":
    "Fabrics, woven; plain weave, printed, of polyester staple fibres, containing less than 85% by weight of such fibres, mixed mainly or solely with cotton, not exceeding 170g/m2",
  "551342":
    "Fabrics, woven; 3- or 4-thread twill, including cross twill, printed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, not exceeding 170g/m2",
  "551343":
    "Fabrics, woven; printed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, not exceeding 170g/m2, n.e.s. in heading no. 5513",
  "551349":
    "Fabrics, woven; printed, containing less than 85% by weight of synthetic staple fibres (other than polyester, plain weave), mixed mainly or solely with cotton, not exceeding 170g/m2",
  "551411":
    "Fabrics, woven; plain weave, unbleached or bleached, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2",
  "551412":
    "Fabrics, woven; 3- or 4-thread twill, including cross twill, unbleached or bleached, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, over 170g/m2",
  "551413":
    "Fabrics, woven; unbleached or bleached, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2, n.e.s. in heading no. 5514",
  "551419":
    "Fabrics, woven; unbleached or bleached, containing less than 85% by weight of synthetic staple fibres n.e.c. in item no. 55.14.1, mixed mainly or solely with cotton, exceeding 170g/m2",
  "551421":
    "Fabrics, woven; plain weave, dyed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2",
  "551422":
    "Fabrics, woven; 3- or 4-thread twill, including cross twill, dyed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2",
  "551423":
    "Fabrics, woven; dyed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2, n.e.c. in heading no. 5514",
  "551429":
    "Fabrics, woven; dyed, containing less than 85% by weight of synthetic staple fibres (other than polyesters), mixed mainly or solely with cotton, exceeding 170g/m2",
  "551430":
    "Fabrics, woven; of yarns of different colours, containing less than 85% by weight of synthetic staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2",
  "551431":
    "Fabrics, woven; plain weave, of yarns of different colours, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2",
  "551432":
    "Fabrics, woven; 3- or 4-thread twill, including cross twill, of yarns of different colours, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2",
  "551433":
    "Fabrics, woven; of yarns of different colours, of polyester staple fibres, containing less than 85% by weight of such, mixed mainly or solely with cotton, over 170g/m2, n.e.s. in heading no. 5514",
  "551439":
    "Fabrics, woven; of yarns of different colours, containing less than 85% by weight of synthetic staple fibres (other than polyesters), mixed mainly or solely with cotton, exceeding 170g/m2",
  "551441":
    "Fabrics, woven; plain weave, printed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2",
  "551442":
    "Fabrics, woven; 3- or 4-thread twill, including cross twill, printed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, exceeding 170g/m2",
  "551443":
    "Fabrics, woven; printed, containing less than 85% by weight of polyester staple fibres, mixed mainly or solely with cotton, weight exceeding 170g/m2, n.e.c. in heading no. 5514",
  "551449":
    "Fabrics, woven; printed, containing less than 85% by weight of synthetic staple fibres (other than polyesters), mixed mainly or solely with cotton, exceeding 170g/m2",
  "551511":
    "Fabrics, woven; of polyester staple fibres n.e.c. in chapter 55, mixed mainly or solely with viscose rayon staple fibres",
  "551512":
    "Fabrics, woven; of polyester staple fibres n.e.c. in chapter 55, mixed mainly or solely with man-made filaments",
  "551513":
    "Fabrics, woven; of polyester staple fibres n.e.c. in chapter 55, mixed mainly or solely with wool or fine animal hair",
  "551519":
    "Fabrics, woven; of polyester staple fibres n.e.c. in chapter 55, mixed mainly or solely with fibres n.e.c. in item no. 5515.1",
  "551521":
    "Fabrics, woven; of acrylic or modacrylic staple fibres n.e.c. in chapter 55, mixed mainly or solely with man-made filaments",
  "551522":
    "Fabrics, woven; of acrylic or modacrylic staple fibres n.e.c. in chapter 55, mixed mainly or solely with wool or fine animal hair",
  "551529":
    "Fabrics, woven; of acrylic or modacrylic staple fibres n.e.c. in chapter 55, mixed mainly or solely with fibres n.e.c. in item no. 5515.2",
  "551591":
    "Fabrics, woven; of synthetic staple fibres n.e.c. in chapter 55, mixed mainly or solely with man-made filaments",
  "551592":
    "Fabrics, woven; of synthetic staple fibres n.e.s. in chapter 55, mixed mainly or solely with wool or fine animal hair",
  "551599":
    "Fabrics, woven; of synthetic staple fibres n.e.c. in chapter 55, mixed mainly or solely with fibres n.e.c. in heading no. 5515",
  "551611":
    "Fabrics, woven; unbleached or bleached, containing 85% or more by weight of artificial staple fibres",
  "551612":
    "Fabrics, woven; dyed, containing 85% or more by weight of artificial staple fibres",
  "551613":
    "Fabrics, woven; of yarns of different colours, containing 85% or more by weight of artificial staple fibres",
  "551614":
    "Fabrics, woven; printed, containing 85% or more by weight of artificial staple fibres",
  "551621":
    "Fabrics, woven; unbleached or bleached, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with manmade filaments",
  "551622":
    "Fabrics, woven; dyed, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with man-made filaments",
  "551623":
    "Fabrics, woven; of yarns of different colours, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with man-made filaments",
  "551624":
    "Fabrics, woven; printed, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with man-made filaments",
  "551631":
    "Fabrics, woven; unbleached or bleached, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with wool or fine animal hair",
  "551632":
    "Fabrics, woven; dyed, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with wool or fine animal hair",
  "551633":
    "Fabrics, woven; of yarns of different colours, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with wool or fine animal hair",
  "551634":
    "Fabrics, woven; printed, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with wool or fine animal hair",
  "551641":
    "Fabrics, woven; unbleached or bleached, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with cotton",
  "551642":
    "Fabrics, woven; dyed, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with cotton",
  "551643":
    "Fabrics, woven; of yarns of different colours, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with cotton",
  "551644":
    "Fabrics, woven; printed, containing less than 85% by weight of artificial staple fibres, mixed mainly or solely with cotton",
  "551691":
    "Fabrics, woven; unbleached or bleached, of artificial staple fibres, n.e.c. in heading no. 5516",
  "551692":
    "Fabrics, woven; dyed, of artificial staple fibres, n.e.c. in heading no. 5516",
  "551693":
    "Fabrics, woven; of yarns of different colours, of artificial staple fibres, n.e.c. in heading no. 5516",
  "551694":
    "Fabrics, woven; printed, of artificial staple fibres, n.e.c. in heading no. 5516",
  "560110":
    "Wadding, other articles thereof, sanitary towels and tampons, napkins and napkin liners for babies and similar",
  "560121": "Wadding; other articles thereof, of cotton",
  "560122": "Wadding; other articles thereof, of man-made fibres",
  "560129":
    "Wadding; other articles thereof, other than of cotton or man-made fibres",
  "560130": "Wadding; textile flock and dust and mill neps",
  "560210":
    "Felt; needleloom felt and stitch-bonded fibre fabrics, whether or not impregnated, coated, covered or laminated",
  "560221":
    "Felt; of wool or fine animal hair (excluding needleloom felt or stitch-bonded fibre fabrics), not impregnated, coated, covered nor laminated",
  "560229":
    "Felt; of textile materials other than wool or fine animal hair (excluding needleloom felt and stitch-bonded fibre fabrics), not impregnated, coated, covered or laminated",
  "560290":
    "Felt; impregnated, coated, covered or laminated (excluding needleloom felt and stitch-bonded fibre fabrics)",
  "560300":
    "Nonwovens; whether or not impregnated, coated, covered or laminated",
  "560311":
    "Nonwovens; whether or not impregnated, coated, covered or laminated, of man-made filaments, (weighing not more than 25g/m2)",
  "560312":
    "Nonwovens; whether or not impregnated, coated, covered or laminated, of man-made filaments, (weighing more than 25g/m2 but not more than 70g/m2)",
  "560313":
    "Nonwovens; whether or not impregnated, coated, covered or laminated, of man-made filaments, (weighing more than 70g/m2 but not more than 150g/m2)",
  "560314":
    "Nonwovens; whether or not impregnated, coated, covered or laminated, of man-made filaments, (weighing more than 150g/m2)",
  "560391":
    "Nonwovens; whether or not impregnated, coated, covered or laminated, not of man-made filaments, (weighing not more than 25g/m2)",
  "560392":
    "Nonwovens; whether or not impregnated, coated, covered or laminated, not of man-made filaments, (weighing more than 25g/m2 but not more than 70g/m2)",
  "560393":
    "Nonwovens; whether or not impregnated, coated, covered or laminated, not of man-made filaments, (weighing more than 70g/m2 but not more than 150g/m2)",
  "560394":
    "Nonwovens; whether or not impregnated, coated, covered or laminated, not of man-made filaments, (weighing more than 150g/m2)",
  "560410": "Rubber thread and cord; textile covered",
  "560420":
    "Yarn; high tenacity yarn of polyesters, nylon, other polyamides or of viscose rayon, impregnated or coated",
  "560490":
    "Yarn; textile yarn, strip, and the like of heading no. 5404 or 5405, impregnated, coated, covered, or sheathed with rubber or plastics, n.e.c. in heading no. 5604",
  "560500":
    "Yarn; metallised, whether or not gimped, of textile yarn, or strip or the like of heading no. 5404 or 5405, combined with metal in the form of thread, strip or powder or covered with metal",
  "560600":
    "Yarn and strip and the like of heading no. 5404 or 5405; gimped, (other than those of heading no. 5406 and gimped horsehair yarn); chenille yarn (including flock chenille yarn); loop wale-yarn",
  "560710":
    "Twine, cordage, ropes and cables; whether or not plaited, braided or impregnated, coated, covered or sheathed with rubber or plastics; of jute or other textile bast fibres of heading no. 5303",
  "560721":
    "Twine; binder or baler twine, of sisal or other textile fibres of the genus agave",
  "560729":
    "Twine, cordage, ropes, cables; of sisal or other textile fibres of the genus agave (excluding binder or baler twine), whether or not plaited, braided or rubber or plastic impregnated, coated, covered or sheathed",
  "560730":
    "Twine, cordage, ropes, cables; of abaca (manila hemp or musa textilis nee) or other hard (leaf) fibres",
  "560741": "Twine; binder or baler twine, of polyethylene or polypropylene",
  "560749":
    "Twine, cordage, ropes, cables; of polyethylene or polypropylene (excluding binder or baler twine), whether or not plaited, braided or rubber or plastic impregnated, coated, covered or sheathed",
  "560750":
    "Twine, cordage, ropes, cables; of synthetic fibres other than polyethylene or polypropylene, whether or not plaited, braided or impregnated, coated, covered or sheathed with rubber or plastics",
  "560790":
    "Twine, cordage, ropes, cables; of materials n.e.c. in heading no. 5607, whether or not plaited, braided or impregnated, coated, covered, or sheathed with rubber or plastics",
  "560811":
    "Twine, cordage or rope; fishing nets, made up, of man made textile materials",
  "560819":
    "Twine, cordage or rope; knotted netting, for other than fishing, of man-made textile materials",
  "560890":
    "Twine, cordage or rope; knotted netting, of other than man-made textiles",
  "560900":
    "Yarn; articles of yarn, strip or the like of heading no. 5404 and 5405, twine, cordage, rope or cables n.e.c. or included",
  "570110":
    "Carpets and other textile floor coverings; knotted, of wool or fine animal hair, whether or not made up",
  "570190":
    "Carpets and other textile floor coverings; knotted, of textile materials (other than wool or fine animal hair), whether or not made up",
  "570210":
    "Carpets and other textile floor coverings; woven, (not tufted or flocked), whether or not made up, including kelem, schumacks, karamanie and similar hand-woven rugs",
  "570220":
    "Carpets and other textile floor coverings; woven, (not tufted or flocked), whether or not made up, of coconut fibres (coir)",
  "570231":
    "Carpets and other textile floor coverings; woven, (not tufted or flocked), of wool or fine animal hair, of pile construction, not made up, n.e.c. in item no. 5702.10 or 5702.20",
  "570232":
    "Carpets and other textile floor coverings; woven, (not tufted or flocked), of man-made textile materials, of pile construction, not made up, n.e.c. in item no. 5702.10 or 5702.20",
  "570239":
    "Carpets and other textile floor coverings; woven, (not tufted or flocked), of textile materials (other than man-made, wool or fine animal hair), of pile construction, not made up, n.e.c. in item no. 5702.10 or 5702.20",
  "570241":
    "Carpets and other textile floor coverings; woven, (not tufted or flocked), of wool or fine animal hair, of pile construction, made up, n.e.c. in item no. 5702.10 or 5702.20",
  "570242":
    "Carpets and other textile floor coverings; woven, (not tufted or flocked), of man-made textile materials, of pile construction, made up, n.e.c. in item no. 5702.10 or 5702.20",
  "570249":
    "Carpets and other textile floor coverings; woven, (not tufted or flocked), of textile materials (other than man-made, wool or fine animal hair), of pile construction, made up, n.e.c. in item no. 5702.10 or 5702.20",
  "570250":
    "Carpets and other textile floor coverings; woven, (not tufted or flocked), not of pile construction, not made up, n.e.c. in item no. 5702.10 or 5702.20",
  "570251":
    "Carpets and other textile floor coverings; woven, (not tufted or flocked), of wool or fine animal hair, not of pile construction, not made up, n.e.s. in item no. 5702.10 or 5702.20",
  "570252":
    "Carpets and other textile floor coverings; woven, (not tufted or flocked), of man-made textile materials, not of pile construction, not made up, n.e.s. in item no. 5702.10 or 5702.20",
  "570259":
    "Carpets and other textile floor coverings; woven, (not tufted or flocked), of textile materials (other than man-made or wool or fine animal hair), not of pile construction, not made up, n.e.s. in item no. 5702.10 or 5702.20",
  "570291":
    "Carpets and other textile floor coverings; woven, (not tufted or flocked), of wool or fine animal hair, (not of pile construction), made up, n.e.c. in item no. 5702.10 or 5702.20",
  "570292":
    "Carpets and other textile floor coverings; woven, (not tufted or flocked), of man-made textile materials, (not of pile construction), made up, n.e.c. in item no. 5702.10 or 5702.20",
  "570299":
    "Carpets and other textile floor coverings; woven, (not tufted or flocked), of textile materials (other than man-made or wool or fine animal hair, not of pile construction), made up, n.e.c. in item no. 5702.10 or 5702.20",
  "570310":
    "Carpets and other textile floor coverings; tufted, of wool or fine animal hair, whether or not made up",
  "570320":
    "Carpets and other textile floor coverings; tufted, of nylon or other polyamides, whether or not made up",
  "570321":
    "Carpets and other textile floor coverings; tufted, of nylon or other polyamides, whether or not made up",
  "570329":
    "Carpets; tufted, of nylon or other polyamides, whether or not made up",
  "570330":
    "Carpets and other textile floor coverings; tufted, of man-made textile materials (other than polyamides), whether or not made up",
  "570331":
    "Carpets and other textile floor coverings; tufted, of other man-made textile materials (other than polyamides), whether or not made up",
  "570339":
    "Carpets; tufted, of man-made textile materials (other than polyamides), whether of not made up",
  "570390":
    "Carpets and other textile floor coverings; tufted, of textile materials (other than man-made, wool or fine animal hair), whether or not made up",
  "570410":
    "Textile floor coverings; felt tiles, (not tufted or flocked), whether or not made up, having a maximum surface area of 0.3m2",
  "570420":
    "Carpets and other textile floor coverings; of felt, (not tufted or flocked), whether or not made up, having a maximum surface area exceeding 0.3 m2 but not exceeding 1 m2",
  "570490":
    "Carpets and other textile floor coverings; of felt, (not tufted or flocked), in the piece,  whether or not made up, having a maximum surface area exceeding 1 m2",
  "570500":
    "Carpets and other textile floor coverings; n.e.c. in chapter 57, whether or not made up",
  "580110":
    "Fabrics; woven pile, of wool or fine animal hair, other than fabrics of heading no. 5802 or 5806",
  "580121":
    "Fabrics; woven pile, of cotton, uncut weft pile fabrics, other than fabrics of heading no. 5802 or 5806",
  "580122":
    "Fabrics; woven pile, of cotton, cut corduroy, other than fabrics of heading no. 5802 or 5806",
  "580123":
    "Fabrics; woven pile, of cotton, weft pile fabrics other than uncut and corduroy, other than fabrics of heading no. 5802 or 5806",
  "580124":
    "Fabrics; woven pile, of cotton, warp pile fabrics, epingle (uncut), other than fabrics of heading no. 5802 or 5806",
  "580125":
    "Fabrics; woven pile, of cotton, warp pile fabrics, cut, other than fabrics of heading no. 5802 or 5806",
  "580126":
    "Fabrics; chenille, of cotton, other than fabrics of heading no. 5802 or 5806",
  "580127":
    "Fabrics; woven pile, of cotton, warp pile fabrics, other than fabrics of heading no. 5802 or 5806",
  "580131":
    "Fabrics; woven pile, of man-made fibres, uncut weft pile fabrics, other than fabrics of heading no. 5802 or 5806",
  "580132":
    "Fabrics; woven pile, of man-made fibres, cut corduroy, other than fabrics of heading no. 5802 or 5806",
  "580133":
    "Fabrics; woven pile, of man-made fibres, other weft pile fabrics, other than fabrics of heading no. 5802 or 5806",
  "580134":
    "Fabrics; woven pile, of man-made fibres, warp pile fabrics, epingle (uncut), other than fabrics of heading no. 5802 or 5806",
  "580135":
    "Fabrics; woven pile, of man-made fibres, warp pile fabrics, cut, other than fabrics of heading no. 5802 or 5806",
  "580136":
    "Fabrics; chenille, of man-made fibres, other than fabrics of heading no. 5802 or 5806",
  "580137":
    "Fabrics; woven pile, of man-made fibres, warp pile fabrics, other than fabrics of heading no. 5802 or 5806",
  "580190":
    "Fabrics; woven pile and chenille, of textile materials n.e.c. in heading no. 5801, other than fabrics of heading no. 5802 or 5806",
  "580210":
    "Fabrics; terry towelling and similar woven terry fabrics, of cotton, whether bleached or unbleached, excluding narrow fabrics of heading no. 5806",
  "580211":
    "Fabrics; terry towelling and similar woven terry fabrics, of cotton, unbleached, excluding narrow fabrics of heading no. 5806",
  "580219":
    "Fabrics; terry towelling and similar woven terry fabrics, of cotton, bleached, excluding narrow fabrics of heading no. 5806",
  "580220":
    "Fabrics; terry towelling and similar woven terry fabrics, of textile materials, excluding cotton, excluding narrow fabrics of heading no. 5806",
  "580230":
    "Fabrics; tufted textile fabrics, excluding products of heading no. 5703",
  "580300": "Gauze; other than narrow fabrics of heading no. 5806",
  "580310": "Gauze; of cotton, other than narrow fabrics of heading no. 5806",
  "580390":
    "Gauze; of textile materials other than cotton, (excluding narrow fabrics of heading no. 5806)",
  "580410":
    "Tulles and other net fabrics; excluding woven, knitted or crocheted fabrics, (other than fabrics of headings 60.02 to 60.06)",
  "580421":
    "Lace; mechanically made, of man-made fibres in the piece, in strips or in motifs, (other than fabrics of headings 60.02 to 60.06)",
  "580429":
    "Lace; mechanically made, of textile materials, (other than man-made fibres), in the piece, in strips or motifs, (other than fabrics of headings 60.02 to 60.06)",
  "580430":
    "Lace; hand-made, in the piece, in strips or motifs, (other than fabrics of headings 60.02 to 60.06)",
  "580500":
    "Tapestries; hand-woven, (Gobelins, Flanders, Aubusson, Beauvais and the like) and needle-worked tapestries (e.g. petit point, cross-stitch) whether or not made up",
  "580610":
    "Fabrics; woven pile (including terry towelling and similar terry fabrics) and chenille fabrics (excluding goods of heading no. 5807)",
  "580620":
    "Fabrics; narrow (excluding pile fabrics), containing by weight 5% or more of elastomeric yarn or rubber thread",
  "580631":
    "Fabrics; narrow woven fabrics, n.e.c. in heading no. 5806, of cotton (excluding goods of heading no. 5807)",
  "580632":
    "Fabrics, narrow woven fabrics, n.e.c. in heading no. 5806, of man-made fibres (excluding goods of heading no. 5807)",
  "580639":
    "Fabrics; narrow woven fabrics, n.e.c. in heading no. 5806, of textile materials n.e.c. in item no. 5806.3 (excluding goods of heading no. 5807)",
  "580640":
    "Fabrics; narrow woven, consisting of warp without weft, assembled by means of an adhesive (bolducs)",
  "580710":
    "Labels, badges and similar articles; woven, of textile materials, in the piece, in strips or cut to shape or size, not embroidered",
  "580790":
    "Labels, badges and similar articles; (other than woven), of textile materials, in the piece, in strips or cut to shape or size, not embroidered",
  "580810": "Braids; in the piece",
  "580890":
    "Ornamental trimmings; tassels, pompons and similar articles; ornamental trimmings in the piece, without embroidery, other than knitted or crocheted",
  "580900":
    "Fabrics, woven; of metal thread and metallised yarn of heading no. 5605, of a kind used in apparel, as furnishing fabrics or similar purposes; n.e.c. or included",
  "581010":
    "Embroidery; without visible ground, in the piece, in strips or in motifs",
  "581091":
    "Embroidery; with visible ground, of cotton, in the piece, in strips or in motifs",
  "581092":
    "Embroidery; with visible ground, of man-made fibres, in the piece, in strips or in motifs",
  "581099":
    "Embroidery; with visible ground, of textile materials (other than cotton and man-made fibres), in the piece, in strips or in motifs",
  "581100":
    "Quilted textile products; in the piece, composed of one or more layers of textile materials assembled with padding by stitching or otherwise (excluding embroidery of heading no. 5810)",
  "590110":
    "Textile fabrics; coated with gum or amylaceous substances, of a kind used for the outer covers of books or the like",
  "590190":
    "Textile fabrics; coated with gum or amylaceous substances, tracing cloth, prepared painting canvas, buckram and similar stiffened textile fabrics for hat foundations, (excluding book covers)",
  "590210":
    "Textile fabrics; tyrecord of high tenacity yarn of nylon or other polyamides",
  "590220": "Textile fabrics; tyrecord of high tenacity yarn of polyester",
  "590290": "Textile fabrics; tyrecord of high tenacity yarn of viscose rayon",
  "590310":
    "Textile fabrics; impregnated, coated, covered or laminated with poly(vinyl chloride)",
  "590320":
    "Textile fabrics; impregnated, coated, covered or laminated with polyurethane",
  "590390":
    "Textile fabrics; impregnated, coated, covered or laminated with plastics, (excluding polyvinyl chloride, polyurethane and those of heading no. 5902)",
  "590410": "Linoleum, whether or not cut to shape",
  "590490":
    "Textiles floor coverings; consisting of a coating or covering applied on a textile backing, whether or not cut to shape, other than linoleum",
  "590491":
    "Textiles; floor coverings (excluding linoleum) consisting of a coating or covering applied on a base of needleloom felt or nonwovens, whether or not cut to shape",
  "590492":
    "Textiles; floor coverings (excluding linoleum) consisting of a coating or covering applied on a textile base (excluding needleloom felt or nonwovens), whether or not cut to shape",
  "590500":
    "Textile wall coverings of fabrics impregnated, coated, covered or laminated",
  "590610":
    "Textile fabrics, rubberised; (excluding those of heading no. 5902), adhesive tape of a width not exceeding 20cm",
  "590691":
    "Textile fabrics, rubberised; (excluding those of heading no. 5902 and adhesive tape of a width not exceeding 20cm), knitted or crocheted",
  "590699":
    "Textile fabrics, rubberised; (excluding those of heading no. 5902 and adhesive tape of a width not exceeding 20cm), not knitted or crocheted",
  "590700":
    "Textile fabrics; otherwise impregnated, coated or covered, painted canvas being theatrical scenery, studio back-cloths or the like",
  "590800":
    "Textile wicks, woven, plaited or knitted; for lamps, stoves, lighters, candles or the like; incandescent gas mantles and tubular knitted gas mantle fabric therefor, whether or not impregnated",
  "590900":
    "Textile hosepiping and similar textile tubing; with or without lining, armour or accessories of other materials",
  "591000":
    "Textiles; transmission or conveyor belts or belting, of textile material, whether or not impregnated, coated, covered or laminated with plastics, or reinforced with metal or other material",
  "591110":
    "Textile fabric, felt & felt-lined woven fabrics, coated/covered/laminated with rubber, leather or other material, for card clothing, similar fabrics used for technical purposes, including rubber impregnated narrow velvet fabrics to cover weaving spindles",
  "591120":
    "Textile products and articles for technical uses; bolting cloth, whether or not made up",
  "591131":
    "Textiles; fabrics and felts, endless or fitted with linking devices, of a kind used in paper-making or similar machines, weighing less than 650g/m2",
  "591132":
    "Textiles; fabrics and felts, endless or fitted with linking devices, of a kind used in paper-making or similar machines, weighing 650g/m2 or more",
  "591140":
    "Textile products and articles for technical uses; straining cloth of a kind used in oil presses and the like, including that of human hair",
  "591190":
    "Textile products and articles for technical uses; n.e.c. in heading no. 5911",
  "600110": "Fabrics; long pile fabrics, knitted or crocheted",
  "600121": "Fabrics; looped pile fabrics, of cotton, knitted or crocheted",
  "600122":
    "Fabrics; looped pile fabrics, of man-made fibres, knitted or crocheted",
  "600129":
    "Fabrics; looped pile fabrics, of textile materials (other than cotton or man-made fibres), knitted or crocheted",
  "600191":
    "Fabrics; pile fabrics (excluding long pile and loop pile), of cotton, knitted or crocheted",
  "600192":
    "Fabrics; pile fabrics (excluding long pile and loop pile), of man-made fibres, knitted or crocheted",
  "600199":
    "Fabrics; pile fabrics (excluding long pile and loop pile), of textile materials (other than cotton or man-made fibres), knitted or crocheted",
  "600210":
    "Fabrics; knitted or crocheted (excluding pile fabrics), 30cm wide or less, containing 5% or more by weight of elastomeric yarn or rubber thread",
  "600220":
    "Fabrics; knitted or crocheted (excluding pile fabrics), 30cm or less wide",
  "600230":
    "Fabrics; knitted or crocheted (excluding pile fabrics), wider than 30cm, containing 5% or more by weight of elastomeric yarn or rubber thread",
  "600240":
    "Fabrics; knitted or crocheted, other than those of heading 60.01, of a width not exceeding 30 cm, containing by weight 5% or more of elastomeric yarn but not containing rubber thread",
  "600241":
    "Fabrics; warp knit, (including those made on galloon knitting machines, excluding pile fabrics), of wool or fine animal hair",
  "600242":
    "Fabrics; warp knit, (including those made on galloon knitting machines, excluding pile fabrics), of cotton",
  "600243":
    "Fabrics; warp knit, (including those made on galloon knitting machines, excluding pile fabrics), of man-made fibres",
  "600249":
    "Fabrics; warp knit, (including those made on galloon knitting machines, excluding pile fabrics), of fibres n.e.s. in item no. 6002.4",
  "600290":
    "Fabrics; knitted or crocheted, other than those of heading 60.01, of a width not exceeding 30 cm, containing by weight 5% or more of elastomeric yarn or rubber thread",
  "600291":
    "Fabrics; knitted or crocheted (excluding pile fabrics and warp knit), of wool or fine animal hair",
  "600292":
    "Fabrics; knitted or crocheted (excluding pile fabrics and warp knit), of cotton",
  "600293":
    "Fabrics; knitted or crocheted (excluding pile fabrics and warp knit), of man-made fibres",
  "600299":
    "Fabrics; knitted or crocheted (excluding pile fabrics and warp knit), of fibres n.e.s. in item no. 6002.9",
  "600310":
    "Fabrics; knitted or crocheted fabrics, other than those of heading 60.01 and 60.02, of a width not exceeding 30 cm, of wool or fine animal hair",
  "600320":
    "Fabrics; knitted or crocheted fabrics, other than those of heading 60.01 and 60.02, of a width not exceeding 30 cm, of cotton",
  "600330":
    "Fabrics; knitted or crocheted fabrics, other than those of heading 60.01 and 60.02, of a width not exceeding 30 cm, of synthetic fibres",
  "600340":
    "Fabrics; knitted or crocheted fabrics, other than those of heading 60.01 and 60.02, of a width not exceeding 30 cm, of artificial fibres",
  "600390":
    "Fabrics; knitted or crocheted fabrics, other than those of heading 60.01 and 60.02, of a width not exceeding 30 cm, other than of wool and fine animal hair, cotton, synthetic or artificial fibres",
  "600410":
    "Knitted or crocheted fabrics; width >30cm, >5% elastomeric yarn (not rubber); excl. pile",
  "600490":
    "Fabrics; knitted or crocheted, other than those of heading 60.01, of a width exceeding 30 cm, containing by weight 5% or more of elastomeric yarn or rubber thread,",
  "600510":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of wool or fine animal hair",
  "600521":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of cotton, unbleached or bleached",
  "600522":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of cotton, dyed",
  "600523":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of cotton, yarns of different colours",
  "600524":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of cotton, printed",
  "600531":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of synthetic fibres, bleached or unbleached",
  "600532":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of synthetic fibres, dyed",
  "600533":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of synthetic fibres, of yarns of different colours",
  "600534":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of synthetic fibres, printed",
  "600535":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of synthetic fibres specified in Subheading Note 1 to this Chapter",
  "600536":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of synthetic fibres, bleached or unbleached",
  "600537":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of synthetic fibres, dyed",
  "600538":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of synthetic fibres, yarns of different colours",
  "600539":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of synthetic fibres, printed",
  "600541":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of artificial fibres, bleached or unbleached",
  "600542":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of artificial fibres, dyed",
  "600543":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of artificial fibres, of yarns of different colours",
  "600544":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, of artificial fibres, printed",
  "600590":
    "Fabrics; warp knit (including those made on galloon knitting machines), other than those of headings 60.01 to 60.04, excluding those made from cotton or synthetic or artificial fibres",
  "600610":
    "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of wool or fine animal hair",
  "600621":
    "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of cotton, unbleached or bleached",
  "600622":
    "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of cotton, dyed",
  "600623":
    "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of cotton, of yarns of different colours",
  "600624":
    "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of cotton, printed",
  "600631":
    "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of synthetic fibres, unbleached or bleached",
  "600632": "Knitted or crocheted fabrics of syntetic fibres; dyed",
  "600633":
    "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of synthetic fibres, of yarns of different colours",
  "600634":
    "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of synthetic fibres, printed",
  "600641":
    "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of artificial fibres, unbleached or bleached",
  "600642":
    "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of artificial fibres, dyed",
  "600643":
    "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of artificial fibres, of yarns of different colours",
  "600644":
    "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04, of artificial fibres, printed",
  "600690":
    "Fabrics; knitted or crocheted fabrics, other than those of headings 60.01 to 60.04,and other than those made of wool, fine animal hair, cotton, synthetic or artificial fibres",
  "610110":
    "Coats; men's or boys' overcoats, car-coats, capes, anoraks, wind-jackets and similar articles, of wool or fine animal hair, knitted or crocheted (excluding those of heading no. 6103)",
  "610120":
    "Coats; men's or boys' overcoats, car-coats, capes, anoraks, wind-jackets and similar articles, of cotton, knitted or crocheted (excluding those of heading no. 6103)",
  "610130":
    "Coats; men's or boys' overcoats, car-coats, capes, anoraks, wind-jackets and similar articles, of man-made fibres, knitted or crocheted, (excluding those of heading no. 6103)",
  "610190":
    "Coats; men's or boys' overcoats, car-coats, capes, anoraks, wind-jackets and similar articles, of textile materials n.e.c. in heading no. 6101, knitted or crocheted (excluding those of heading no. 6103)",
  "610210":
    "Coats; women's or girls' overcoats, car-coats, capes, anoraks, wind-jackets and similar articles, of wool or fine animal hair, knitted or crocheted (excluding those of heading no. 6104)",
  "610220":
    "Coats; women's or girls' overcoats, car-coats, capes, anoraks, wind-jackets and similar articles, of cotton, knitted or crocheted (excluding those of heading no. 6104)",
  "610230":
    "Coats; women's or girls' overcoats, car-coats, capes, anoraks, wind-jackets and similar articles, of man-made fibres, knitted or crocheted (excluding those of heading no. 6104)",
  "610290":
    "Coats; women's or girls' overcoats, car-coats, capes, anoraks, wind-jackets and similar articles, of textile materials n.e.c. in heading no. 6102, knitted or crocheted (excluding those of heading no. 6104)",
  "610310": "Suits; men's or boys', knitted or crocheted",
  "610311":
    "Suits; men's or boys', of wool or fine animal hair, knitted or crocheted",
  "610312": "Suits; men's or boys', of synthetic fibres, knitted or crocheted",
  "610319":
    "Suits; men's or boys', of textile materials (other than wool, fine animal hair or synthetic fibres), knitted or crocheted",
  "610321":
    "Ensembles; men's or boys', of wool or fine animal hair, knitted or crocheted",
  "610322": "Ensembles; men's or boys', of cotton, knitted or crocheted",
  "610323":
    "Ensembles; men's or boys', of synthetic fibres, knitted or crocheted",
  "610329":
    "Ensembles; men's or boys', of textile materials (other than cotton or synthetic fibres), knitted or crocheted",
  "610331":
    "Jackets and blazers; men's or boys', of wool or fine animal hair, knitted or crocheted",
  "610332":
    "Jackets and blazers; men's or boys', of cotton, knitted or crocheted",
  "610333":
    "Jackets and blazers; men's or boys', of synthetic fibres, knitted or crocheted",
  "610339":
    "Jackets and blazers; men's or boys', of textile materials (other than wool or fine animal hair, cotton or synthetic fibres), knitted or crocheted",
  "610341":
    "Trousers, bib and brace overalls, breeches and shorts; men's or boys', of wool or fine animal hair, knitted or crocheted",
  "610342":
    "Trousers, bib and brace overalls, breeches and shorts; men's or boys', of cotton, knitted or crocheted",
  "610343":
    "Trousers, bib and brace overalls, breeches and shorts; men's or boys', of synthetic fibres, knitted or crocheted",
  "610349":
    "Trousers, bib and brace overalls, breeches and shorts; men's or boys', of textile materials (other than wool or fine animal hair, cotton or synthetic fibres), knitted or crocheted",
  "610411":
    "Suits; women's or girls', of wool or fine animal hair, knitted or crocheted",
  "610412": "Suits; women's or girls', of cotton, knitted or crocheted",
  "610413":
    "Suits; women's or girls', of synthetic fibres, knitted or crocheted",
  "610419":
    "Suits; women's or girls', of textile materials (other than synthetic fibres), knitted or crocheted",
  "610421":
    "Ensembles; women's or girls', of wool or fine animal hair, knitted or crocheted",
  "610422": "Ensembles; women's or girls', of cotton, knitted or crocheted",
  "610423":
    "Ensembles; women's or girls', of synthetic fibres, knitted or crocheted",
  "610429":
    "Ensembles; women's or girls', of textile materials (other than cotton or synthetic fibres), knitted or crocheted",
  "610431":
    "Jackets; women's or girls', of wool or fine animal hair, knitted or crocheted",
  "610432": "Jackets; women's or girls', of cotton, knitted or crocheted",
  "610433":
    "Jackets; women's or girls', of synthetic fibres, knitted or crocheted",
  "610439":
    "Jackets; women's or girls', of textile materials (other than wool or fine animal hair, cotton or synthetic fibres), knitted or crocheted",
  "610441":
    "Dresses; women's or girls', of wool or fine animal hair, knitted or crocheted",
  "610442": "Dresses; women's or girls', of cotton, knitted or crocheted",
  "610443":
    "Dresses; women's or girls', of synthetic fibres, knitted or crocheted",
  "610444":
    "Dresses; women's or girls', of artificial fibres, knitted or crocheted",
  "610449":
    "Dresses; women's or girls', of textile materials (other than wool or fine animal hair, cotton, synthetic or artificial fibres), knitted or crocheted",
  "610451":
    "Skirts and divided skirts; women's or girls', of wool or fine animal hair, knitted or crocheted",
  "610452":
    "Skirts and divided skirts; women's or girls', of cotton, knitted or crocheted",
  "610453":
    "Skirts and divided skirts; women's or girls', of synthetic fibres, knitted or crocheted",
  "610459":
    "Skirts and divided skirts; women's or girls', of textile materials (other than wool or fine animal hair, cotton or synthetic fibres), knitted or crocheted",
  "610461":
    "Trousers, bib and brace overalls, breeches and shorts; women's or girls', of wool or fine animal hair, knitted or crocheted",
  "610462": "Cotton pants for women or girls; knitted",
  "610463": "Synthetic pants for women or girls; knitted",
  "610469":
    "Trousers, bib and brace overalls, breeches and shorts; women's or girls', of textile materials (other than wool or fine animal hair, cotton or synthetic fibres), knitted or crocheted",
  "610510": "Shirts; men's or boys', of cotton, knitted or crocheted",
  "610520": "Shirts; men's or boys', of man-made fibres, knitted or crocheted",
  "610590":
    "Shirts; men's or boys', of textile materials (other than cotton or man-made fibres), knitted or crocheted",
  "610610":
    "Blouses, shirts and shirt-blouses; women's or girls', of cotton, knitted or crocheted",
  "610620":
    "Blouses, shirts and shirt-blouses; women's or girls', of man-made fibres, knitted or crocheted",
  "610690":
    "Blouses, shirts and shirt-blouses; women's or girls', of textile materials (other than cotton or man-made fibres), knitted or crocheted",
  "610711":
    "Underpants and briefs; men's or boys', of cotton, knitted or crocheted",
  "610712":
    "Underpants and briefs; men's or boys', of man-made fibres, knitted or crocheted",
  "610719":
    "Underpants and briefs; men's or boys', of textile materials (other than cotton or man-made fibres), knitted or crocheted",
  "610721":
    "Nightshirts and pyjamas; men's or boys', of cotton, knitted or crocheted",
  "610722":
    "Nightshirts and pyjamas; men's or boys', of man-made fibres, knitted or crocheted",
  "610729":
    "Nightshirts and pyjamas; men's or boys', of textile materials (other than cotton or man-made fibres), knitted or crocheted",
  "610791":
    "Bathrobes, dressing gowns and similar articles; men's or boys', of cotton, knitted or crocheted",
  "610792":
    "Bathrobes, dressing gowns and similar articles; men's or boys', of man-made fibres, knitted or crocheted",
  "610799":
    "Bathrobes, dressing gowns and similar articles; men's or boys', of textile materials (other than cotton), knitted or crocheted",
  "610811":
    "Slips and petticoats; women's or girls', of man-made fibres, knitted or crocheted",
  "610819":
    "Slips and petticoats; women's or girls', of textile materials (other than man-made fibres), knitted or crocheted",
  "610821":
    "Briefs and panties; women's or girls', of cotton, knitted or crocheted",
  "610822":
    "Briefs and panties; women's or girls', of man-made fibres, knitted or crocheted",
  "610829":
    "Briefs and panties; women's or girls', of textile materials (other than cotton or man-made fibres), knitted or crocheted",
  "610831":
    "Nightdresses and pyjamas; women's or girls', of cotton, knitted or crocheted",
  "610832":
    "Nightdresses and pyjamas; women's or girls', of man-made fibres, knitted or crocheted",
  "610839":
    "Nightdresses and pyjamas; women's or girls', of textile materials (other than cotton or man-made fibres), knitted or crocheted",
  "610891":
    "Negligees, bathrobes, dressing gowns and similar articles; women's or girls', of cotton, knitted or crocheted",
  "610892":
    "Negligees, bathrobes, dressing gowns and similar articles; women's or girls', of man-made fibres, knitted or crocheted",
  "610899":
    "Negligees, bathrobes, dressing gowns and similar articles; women's or girls', of textile materials (other than cotton or man-made fibres), knitted or crocheted",
  "610910": "Cotton tops; knitted",
  "610990": "Tops; knitted; excl. cotton",
  "611010":
    "Jerseys, pullovers, cardigans, waistcoats and similar articles; of wool or fine animal hair, knitted or crocheted",
  "611011":
    "Jerseys, pullovers, cardigans, waistcoats and similar articles; knitted or crocheted, of wool or fine animal hair",
  "611012":
    "Jerseys, pullovers, cardigans, waistcoats and similar articles; knitted or crocheted, of fibres from kashmir (cashmere) goats",
  "611019":
    "Jerseys, pullovers, cardigans, waistcoats and similar articles; knitted or crocheted, of fine animal hair other than that of kashmir (cashmere) goats",
  "611020": "Cotton sweaters and cardigans; knitted",
  "611030": "Sweaters and cardigans of man-made fibres; knitted",
  "611090":
    "Jerseys, pullovers, cardigans, waistcoats and similar articles; of textile materials (other than wool or fine animal hair, cotton or man-made fibres), knitted or crocheted",
  "611110":
    "Garments and clothing accessories; babies', of wool or fine animal hair, knitted or crocheted",
  "611120": "Cotton garments and clothing accessories for babies; knitted",
  "611130":
    "Garments and clothing accessories; babies', of synthetic fibres, knitted or crocheted",
  "611190":
    "Garments and clothing accessories; babies', of textile materials (other than cotton or synthetic fibres), knitted or crocheted",
  "611211": "Track suits; of cotton, knitted or crocheted",
  "611212": "Track suits; of synthetic fibres, knitted or crocheted",
  "611219":
    "Track suits; of textile materials (other than cotton or synthetic fibres), knitted or crocheted",
  "611220": "Ski suits; knitted or crocheted",
  "611231":
    "Swimwear; men's or boys', of synthetic fibres, knitted or crocheted",
  "611239":
    "Swimwear; men's or boys', of textile materials (other than synthetic fibres), knitted or crocheted",
  "611241":
    "Swimwear; women's or girls', of synthetic fibres, knitted or crocheted",
  "611249":
    "Swimwear; women's or girls', of textile materials (other than synthetic fibres), knitted or crocheted",
  "611300":
    "Garments made up of knitted or crocheted fabrics of heading no. 5903, 5906 and 5907",
  "611410":
    "Garments; of wool or fine animal hair, knitted or crocheted, n.e.s. in chapter 61",
  "611420": "Garments; of cotton, knitted or crocheted, n.e.c. in chapter 61",
  "611430":
    "Garments; of man-made fibres, knitted or crocheted, n.e.c. in chapter 61",
  "611490":
    "Garments; of textile materials (other than cotton or man-made fibres), knitted or crocheted, n.e.c. in chapter 61",
  "611510":
    "Graduated compression hosiery (for example, stockings for varicose veins), knitted or crocheted",
  "611511":
    "Hosiery; panty hose and tights, of synthetic fibres, measuring per single yarn less than 67 decitex, knitted or crocheted",
  "611512":
    "Hosiery; panty hose and tights, of synthetic fibres, measuring per single yarn 67 decitex or more, knitted or crocheted",
  "611519":
    "Hosiery; panty hose and tights, of textile materials (other than synthetic fibres), knitted or crocheted",
  "611520":
    "Hosiery; women's, full-length or knee-length, measuring per single yarn less than 67 decitex, knitted or crocheted",
  "611521":
    "Hosiery; panty hose and tights (other than graduated compression hosiery), of synthetic fibres, measuring per single yarn less than 67 decitex, knitted or crocheted",
  "611522":
    "Hosiery; panty hose and tights (other than graduated compression hosiery), of synthetic fibres, measuring per single yarn 67 decitex or more, knitted or crocheted",
  "611529":
    "Hosiery; panty hose and tights (other than graduated compression hosiery), of textile materials (other than synthetic fibres), knitted or crocheted",
  "611530":
    "Hosiery; women's, full-length or knee-length (other than graduated compression hosiery), measuring per single yarn less than 67 decitex, knitted or crocheted",
  "611591":
    "Hosiery and footwear; without applied soles, of wool or fine animal hair, knitted or crocheted (excluding tights, women's full or knee-length hosiery measuring per single yarn less than 67 decitex)",
  "611592":
    "Hosiery and footwear; without applied soles, of cotton, knitted or crocheted (excluding panty hose, tights, full or knee-length hosiery measuring per single yarn less than 67 decitex)",
  "611593":
    "Hosiery and footwear; without applied soles, of synthetic fibres, knitted or crocheted (excluding panty hose, tights, full or knee-length hosiery measuring per single yarn less than 67 decitex)",
  "611594":
    "Hosiery and footwear; without applied soles, of wool or fine animal hair, knitted or crocheted (excluding graduated compression hosiery, panty hose, tights, women's full or knee-length hosiery measuring per single yarn less than 67 decitex)",
  "611595":
    "Hosiery and footwear; without applied soles, of cotton, knitted or crocheted (excluding graduated compression hosiery, panty hose, tights, full or knee-length hosiery measuring per single yarn less than 67 decitex)",
  "611596":
    "Hosiery and footwear; without applied soles, of synthetic fibres, knitted or crocheted (excluding graduated compression hosiery, panty hose, tights, full or knee-length hosiery measuring per single yarn less than 67 decitex)",
  "611599":
    "Hosiery and footwear; without applied soles, of textile materials n.e.c. in item no. 6115.9, knitted or crocheted (excluding graduated compression hosiery, panty hose, tights, full or knee-length hosiery measuring per single yarn less than 67 decitex)",
  "611610":
    "Gloves, mittens and mitts; knitted or crocheted, impregnated, coated or covered with plastics or rubber",
  "611691":
    "Gloves, mittens and mitts; of wool or fine animal hair, knitted or crocheted, (other than impregnated, coated or covered with plastics or rubber)",
  "611692":
    "Gloves, mittens and mitts; of cotton, knitted or crocheted, (other than impregnated, coated or covered with plastics or rubber)",
  "611693":
    "Gloves, mittens and mitts; of synthetic fibres, knitted or crocheted, (other than impregnated, coated or covered with plastics or rubber)",
  "611699":
    "Gloves, mittens and mitts; of textile materials (other than wool or fine animal hair, cotton or synthetic fibres), knitted or crocheted, (other than impregnated, coated or covered with plastics or rubber)",
  "611710":
    "Shawls, scarves, mufflers, mantillas, veils and the like; knitted or crocheted",
  "611720": "Ties, bow ties and cravats; knitted or crocheted",
  "611780":
    "Clothing accessories; knitted or crocheted, n.e.c. in heading no. 6117",
  "611790": "Clothing; parts, knitted or crocheted",
  "620111":
    "Coats; men's or boys', overcoats, raincoats, car-coats, capes, cloaks and similar articles, of wool or fine animal hair, other than those of heading no. 6203 (not knitted or crocheted)",
  "620112":
    "Coats; men's or boys', overcoats, raincoats, car-coats, capes, cloaks and similar articles, of cotton, other than those of heading no. 6203 (not knitted or crocheted)",
  "620113":
    "Coats; men's or boys', overcoats, raincoats, car-coats, capes, cloaks and similar articles, of man-made fibres, other than those of heading no. 6203 (not knitted or crocheted)",
  "620119":
    "Coats; men's or boys', overcoats, raincoats, car-coats, capes, cloaks and similar articles, of textile materials (other than wool or fine animal hair, cotton or man-made fibres), other than those of heading no. 6203 (not knitted or crocheted)",
  "620120":
    "Coats; men's or boys', overcoats, raincoats, car-coats, capes, cloaks, anoraks (including ski-jackets) and similar articles, of wool or fine animal hair, other than those of heading no. 6203 (not knitted or crocheted)",
  "620130":
    "Coats; men's or boys', overcoats, raincoats, car-coats, capes, cloaks, anoraks (including ski-jackets) and similar articles, of cotton, other than those of heading no. 6203 (not knitted or crocheted)",
  "620140":
    "Coats; men's or boys', overcoats, raincoats, car-coats, capes, cloaks, anoraks (including ski-jackets) and similar articles, of man-made fibres, other than those of heading no. 6203 (not knitted or crocheted)",
  "620190":
    "Coats; men's or boys', overcoats, rain-coats, car-coats, capes, cloaks and similar, of textile materials (other than wool, fine animal hair, cotton or man-made fibres), other than those of heading no. 6203 (not knitted or crocheted)",
  "620191":
    "Anoraks (including ski-jackets), wind-cheaters, wind-jackets and similar articles; men's or boys', of wool or fine animal hair, other than those of heading no. 6203 (not knitted or crocheted)",
  "620192":
    "Anoraks (including ski-jackets), wind-cheaters, wind-jackets and similar articles; men's or boys', of cotton, other than those of heading no. 6203 (not knitted or crocheted)",
  "620193": "Anoraks for men or boys, of man-made fibres; not knitted",
  "620199":
    "Anoraks (including ski-jackets), wind-cheaters, wind-jackets and similar articles; men's or boys', of textile materials (other than wool or fine animal hair, cotton or man-made fibres), other than those of heading no. 6203 (not knitted or crocheted)",
  "620211":
    "Coats; women's or girls', overcoats, raincoats, car-coats, capes, cloaks and similar articles, of wool or fine animal hair, other than those of heading no. 6204 (not knitted or crocheted)",
  "620212":
    "Coats; women's or girls', overcoats, raincoats, car-coats, capes, cloaks and similar articles, of cotton, other than those of heading no. 6204 (not knitted or crocheted)",
  "620213":
    "Coats; women's or girls', overcoats, raincoats, car-coats, capes, cloaks and similar articles, of man-made fibres, other than those of heading no. 6204 (not knitted or crocheted)",
  "620219":
    "Coats; women's or girls', overcoats, raincoats, car-coats, capes, cloaks and similar articles, of textile materials (other than wool or fine animal hair, cotton or man-made fibres), other than those of heading no. 6204 (not knitted or crocheted)",
  "620220":
    "Coats; women's or girls', overcoats, raincoats, car-coats, capes, cloaks anoraks (including ski-jackets) and similar articles, of wool or fine animal hair, other than those of heading no. 6204 (not knitted or crocheted)",
  "620230":
    "Coats; women's or girls', overcoats, raincoats, car-coats, capes, cloaks anoraks (including ski-jackets) and similar articles, of cotton, other than those of heading no. 6204 (not knitted or crocheted)",
  "620240":
    "Coats; women's or girls', overcoats, raincoats, car-coats, capes, cloaks anoraks (including ski-jackets) and similar articles, of man-made fibres, other than those of heading no. 6204 (not knitted or crocheted)",
  "620290":
    "Coats; women's or girls', overcoats, raincoats, car-coats, capes, cloaks and similar articles, of textile materials (other than wool, fine animal hair, cotton or man-made fibres), other than those of heading no. 6204 (not knitted or crocheted)",
  "620291":
    "Anoraks (including ski-jackets), wind-cheaters, wind-jackets and similar articles; women's or girls', of wool or fine animal hair, other than those of heading no. 6204 (not knitted or crocheted)",
  "620292":
    "Anoraks (including ski-jackets), wind-cheaters, wind-jackets and similar articles; women's or girls', of cotton, other than those of heading no. 6204 (not knitted or crocheted)",
  "620293": "Anoraks for women or girls, of man-made fibres; not knitted",
  "620299":
    "Anoraks (including ski-jackets), wind-cheaters, wind-jackets and similar articles; women's or girls', of textile materials n.e.c. in item no. 6202.9, other than those of heading no. 6204, (not knitted or crocheted)",
  "620311":
    "Suits; men's or boys', of wool or fine animal hair (not knitted or crocheted)",
  "620312":
    "Suits; men's or boys', of synthetic fibres (not knitted or crocheted)",
  "620319":
    "Suits; men's or boys', of textile materials n.e.c. in item no. 6203.1 (not knitted or crocheted)",
  "620321":
    "Ensembles; men's or boys', of wool or fine animal hair (not knitted or crocheted)",
  "620322": "Ensembles; men's or boys', of cotton (not knitted or crocheted)",
  "620323":
    "Ensembles; men's or boys', of synthetic fibres (not knitted or crocheted)",
  "620329":
    "Ensembles; men's or boys', of textile materials n.e.c. in item no. 6203.2 (not knitted or crocheted)",
  "620331":
    "Jackets and blazers; men's or boys', of wool or fine animal hair (not knitted or crocheted)",
  "620332":
    "Jackets and blazers; men's or boys', of cotton (not knitted or crocheted)",
  "620333":
    "Jackets and blazers; men's or boys', of synthetic fibres (not knitted or crocheted)",
  "620339":
    "Jackets and blazers; men's or boys', of textile materials n.e.c. in item no. 6203.3 (not knitted or crocheted)",
  "620341":
    "Trousers, bib and brace overalls, breeches and shorts; men's or boys', of wool or fine animal hair (not knitted or crocheted)",
  "620342": "Cotton pants for men or boys; not knitted",
  "620343": "Synthetic pants for men or boys; not knitted",
  "620349":
    "Trousers, bib and brace overalls, breeches and shorts; men's or boys', of textile materials (other than wool, fine animal hair, cotton or synthetic fibres), (not knitted or crocheted)",
  "620411":
    "Suits; women's or girls', of wool or fine animal hair (not knitted or crocheted)",
  "620412": "Suits; women's or girls', of cotton (not knitted or crocheted)",
  "620413":
    "Suits; women's or girls', of synthetic fibres (not knitted or crocheted)",
  "620419":
    "Suits; women's or girls', of textile materials n.e.c. in item no. 6204.1 (not knitted or crocheted)",
  "620421":
    "Ensembles; women's or girls', of wool or fine animal hair (not knitted or crocheted)",
  "620422":
    "Ensembles; women's or girls', of cotton (not knitted or crocheted)",
  "620423":
    "Ensembles; women's or girls', of synthetic fibres (not knitted or crocheted)",
  "620429":
    "Ensembles; women's or girls', of textile materials n.e.c. in item no. 6204.2 (not knitted or crocheted)",
  "620431":
    "Jackets and blazers; women's or girls', of wool or fine animal hair (not knitted or crocheted)",
  "620432":
    "Jackets and blazers; women's or girls', of cotton (not knitted or crocheted)",
  "620433":
    "Jackets and blazers; women's or girls', of synthetic fibres (not knitted or crocheted)",
  "620439":
    "Jackets and blazers; women's or girls', of textile materials n.e.c. in item no. 6204.3 (not knitted or crocheted)",
  "620441":
    "Dresses; women's or girls', of wool or fine animal hair (not knitted or crocheted)",
  "620442": "Dresses; women's or girls', of cotton (not knitted or crocheted)",
  "620443":
    "Dresses; women's or girls', of synthetic fibres (not knitted or crocheted)",
  "620444":
    "Dresses; women's or girls', of artificial fibres (not knitted or crocheted)",
  "620449":
    "Dresses; women's or girls', of textile materials n.e.c. in item no. 6204.4 (not knitted or crocheted)",
  "620451":
    "Skirts and divided skirts; women's or girls', of wool or fine animal hair (not knitted or crocheted)",
  "620452":
    "Skirts and divided skirts; women's or girls', of cotton (not knitted or crocheted)",
  "620453":
    "Skirts and divided skirts; women's or girls', of synthetic fibres (not knitted or crocheted)",
  "620459":
    "Skirts and divided skirts; women's or girls', of textile materials n.e.c. in item no. 6204.5 (not knitted or crocheted)",
  "620461":
    "Trousers, bib and brace overalls, breeches and shorts; women's or girls', of wool or fine animal hair (not knitted or crocheted)",
  "620462": "Cotton pants for women or girls; not knitted",
  "620463": "Synthetic pants for women or girls; not knitted",
  "620469":
    "Trousers, bib and brace overalls, breeches and shorts; women's or girls', of textile materials (other than wool, fine animal hair, cotton or synthetic fibres), (not knitted or crocheted)",
  "620510":
    "Shirts; men's or boys', of wool or fine animal hair (not knitted or crocheted)",
  "620520": "Cotton shirts for men or boys; not knitted",
  "620530":
    "Shirts; men's or boys', of man-made fibres (not knitted or crocheted)",
  "620590":
    "Shirts; men's or boys', of textile materials n.e.c. in heading no. 6205 (not knitted or crocheted)",
  "620610":
    "Blouses, shirts and shirt-blouses; women's or girls', of silk or silk waste (not knitted or crocheted)",
  "620620":
    "Blouses, shirts and shirt-blouses; women's or girls', of wool or fine animal hair (not knitted or crocheted)",
  "620630":
    "Blouses, shirts and shirt-blouses; women's or girls', of cotton (not knitted or crocheted)",
  "620640":
    "Blouses, shirts and shirt-blouses; women's or girls', of man-made fibres (not knitted or crocheted)",
  "620690":
    "Blouses, shirts and shirt-blouses; women's or girls', of textile materials n.e.c. in heading no. 6206 (not knitted or crocheted)",
  "620711":
    "Underpants and briefs; men's or boys', of cotton (not knitted or crocheted)",
  "620719":
    "Underpants and briefs; men's or boys', of textile materials other than cotton (not knitted or crocheted)",
  "620721":
    "Nightshirts and pyjamas; men's or boys', of cotton (not knitted or crocheted)",
  "620722":
    "Nightshirts and pyjamas; men's or boys', of man-made fibres (not knitted or crocheted)",
  "620729":
    "Nightshirts and pyjamas; men's or boys', of textile materials other than cotton or man-made fibres (not knitted or crocheted)",
  "620791":
    "Singlets and other vests, bathrobes, dressing gowns and similar articles; men's or boys', of cotton (not knitted or crocheted)",
  "620792":
    "Singlets and other vests, bathrobes, dressing gowns and similar articles; men's or boys', of man-made fibres (not knitted or crocheted)",
  "620799":
    "Singlets and other vests, bathrobes, dressing gowns and similar articles; men's or boys', of textile materials other than cotton (not knitted or crocheted)",
  "620811":
    "Slips and petticoats; women's or girls', of man-made fibres (not knitted or crocheted)",
  "620819":
    "Slips and petticoats; women's or girls', of textile materials other than man-made fibres (not knitted or crocheted)",
  "620821":
    "Nightdresses and pyjamas; women's or girls', of cotton (not knitted or crocheted)",
  "620822":
    "Nightdresses and pyjamas; women's or girls', of man-made fibres (not knitted or crocheted)",
  "620829":
    "Nightdresses and pyjamas; women's or girls', of textile materials other than cotton or man-made fibres (not knitted or crocheted)",
  "620891":
    "Singlets and other vests, briefs, panties, negligees, bathrobes, dressing gowns and similar articles; women's or girls', of cotton (not knitted or crocheted)",
  "620892":
    "Singlets and other vests, briefs, panties, negligees, bathrobes, dressing gowns etc.; women's or girls', of man-made fibres (not knitted or crocheted), excluding incontinence or other sanitary garments or garment liners of heading no. 96.19",
  "620899":
    "Singlets and other vests, briefs, panties, negligees, bathrobes, dressing gowns and similar articles; women's or girls', of textile materials other than cotton or man-made fibres (not knitted or crocheted)",
  "620910":
    "Garments and clothing accessories; babies', of wool or fine animal hair (not knitted or crocheted)",
  "620920":
    "Garments and clothing accessories; babies', of cotton (not knitted or crocheted)",
  "620930":
    "Garments and clothing accessories; babies', of synthetic fibres (not knitted or crocheted)",
  "620990":
    "Garments and clothing accessories; babies', of textile materials other than cotton or synthetic fibres (not knitted or crocheted)",
  "621010": "Garments; of felt or non-wovens (not knitted or crocheted)",
  "621020":
    "Garments; overcoats, raincoats, car-coats, capes, cloaks and similar articles, men's or boys', of the fabrics of heading no. 5602, 5603, 5903, 5906 or 5907 (not knitted or crocheted)",
  "621030":
    "Garments; overcoats, raincoats, car-coats, capes, cloaks and similar articles, women's or girls', of the fabrics of heading no. 5602, 5603, 5903, 5906 or 5907 (not knitted or crocheted)",
  "621040":
    "Garments; men's or boys', n.e.c. in item no. 6210.2, of the fabrics of heading no. 5602, 5603, 5903, 5906 or 5907 (not knitted or crocheted)",
  "621050":
    "Garments; women's or girls', n.e.c. in item no. 6210.3, of the fabrics of heading no. 5602, 5603, 5903, 5906 or 5907 (not knitted or crocheted)",
  "621111": "Swimwear; men's or boys', (not knitted or crocheted)",
  "621112": "Swimwear; women's or girls', (not knitted or crocheted)",
  "621120": "Ski suits; (not knitted or crocheted)",
  "621131":
    "Track suits and other garments n.e.s.; men's or boys', of wool or fine animal hair (not knitted or crocheted)",
  "621132":
    "Track suits and other garments n.e.c.; men's or boys', of cotton (not knitted or crocheted)",
  "621133":
    "Track suits and other garments n.e.c.; men's or boys', of man-made fibres (not knitted or crocheted)",
  "621139":
    "Track suits and other garments n.e.c.; men's or boys', of textile materials n.e.c. in item no. 6211.3 (not knitted or crocheted)",
  "621141":
    "Track suits and other garments n.e.c.; women's or girls', of wool or fine animal hair (not knitted or crocheted)",
  "621142":
    "Track suits and other garments n.e.c.; women's or girls', of cotton (not knitted or crocheted)",
  "621143":
    "Track suits and other garments n.e.c.; women's or girls', of man-made fibres (not knitted or crocheted)",
  "621149":
    "Track suits and other garments n.e.c.; women's or girls', of textile materials n.e.c. in item no. 6211.4 (not knitted or crocheted)",
  "621210": "Brassieres",
  "621220": "Girdles and panty-girdles; whether or not knitted or crocheted",
  "621230": "Corselettes; whether or not knitted or crocheted",
  "621290":
    "Braces, suspenders, garters and similar articles; whether or not knitted or crocheted, n.e.c. in heading no. 6212",
  "621310": "Handkerchiefs; of silk or silk waste (not knitted or crocheted)",
  "621320": "Handkerchiefs; of cotton (not knitted or crocheted)",
  "621390":
    "Handkerchiefs; of textile materials other than cotton (not knitted or crocheted)",
  "621410":
    "Shawls, scarves, mufflers, mantillas, veils and the like; of silk or silk waste (not knitted or crocheted)",
  "621420":
    "Shawls, scarves, mufflers, mantillas, veils and the like; of wool or fine animal hair (not knitted or crocheted)",
  "621430":
    "Shawls, scarves, mufflers, mantillas, veils and the like; of synthetic fibres (not knitted or crocheted)",
  "621440":
    "Shawls, scarves, mufflers, mantillas, veils and the like; of artificial fibres (not knitted or crocheted)",
  "621490":
    "Shawls, scarves, mufflers, mantillas, veils and the like; of textile materials n.e.c. in heading no. 6214 (not knitted or crocheted)",
  "621510":
    "Ties, bow ties and cravats; of silk or silk waste (not knitted or crocheted)",
  "621520":
    "Ties, bow ties and cravats; of man-made fibres (not knitted or crocheted)",
  "621590":
    "Ties, bow ties and cravats; of textile materials other than silk or man-made fibres (not knitted or crocheted)",
  "621600": "Gloves, mittens and mitts (not knitted or crocheted)",
  "621710":
    "Clothing accessories; other than those of heading no. 6212 (not knitted or crocheted)",
  "621790":
    "Clothing; parts of garments or of clothing accessories, other than those of heading no. 6212 (not knitted or crocheted)",
  "630110": "Blankets; electric",
  "630120":
    "Blankets (other than electric blankets) and travelling rugs; of wool or fine animal hair",
  "630130":
    "Blankets (other than electric blankets) and travelling rugs; of cotton",
  "630140":
    "Blankets (other than electric blankets) and travelling rugs; of synthetic fibres",
  "630190": "Blankets and travelling rugs; n.e.c. in heading no. 6301",
  "630210": "Bed linen; knitted or crocheted",
  "630221": "Bed linen; of cotton, printed, not knitted or crocheted",
  "630222": "Bed linen; of man-made fibres, printed, not knitted or crocheted",
  "630229":
    "Bed linen; of textile materials (other than cotton or man-made fibres), printed, not knitted or crocheted",
  "630231": "Bed linen; of cotton (not printed, knitted or crocheted)",
  "630232": "Bed linen; of man-made fibres (not printed, knitted or crocheted)",
  "630239":
    "Bed linen; of textile materials other than cotton or man-made fibres (not printed, knitted or crocheted)",
  "630240": "Table linen; knitted or crocheted",
  "630251": "Table linen; of cotton, not knitted or crocheted",
  "630252": "Table linen; of flax, not knitted or crocheted",
  "630253": "Table linen; of man-made fibres, not knitted or crocheted",
  "630259":
    "Table linen; of textile materials (other than cotton or man-made fibres), not knitted or crocheted",
  "630260":
    "Kitchen and toilet linen; of terry towelling or similar terry fabrics, of cotton",
  "630291":
    "Toilet and kitchen linen; of cotton, excluding terry towelling or similar terry fabrics",
  "630292": "Toilet and kitchen linen; of flax",
  "630293": "Toilet and kitchen linen; of man-made fibres",
  "630299":
    "Toilet and kitchen linen; of textile materials (other than cotton or man-made fibres)",
  "630311":
    "Curtains (including drapes) and interior blinds; curtain or bed valances, knitted or crocheted, of cotton",
  "630312":
    "Curtains (including drapes) and interior blinds; curtain or bed valances, knitted or crocheted, of synthetic fibres",
  "630319":
    "Curtains (including drapes) and interior blinds; curtain or bed valances, knitted or crocheted, of textile materials other than synthetic fibres",
  "630391":
    "Curtains (including drapes) and interior blinds, curtain or bed valances; of cotton, not knitted or crocheted",
  "630392":
    "Curtains (including drapes) and interior blinds, curtain or bed valances; of synthetic fibres, not knitted or crocheted",
  "630399":
    "Curtains (including drapes) and interior blinds, curtain or bed valances; of textile materials other than cotton or synthetic fibres, not knitted or crocheted",
  "630411": "Bedspreads; knitted or crocheted",
  "630419": "Bedspreads; not knitted or crocheted",
  "630420":
    "Furnishing articles; excluding those of heading no. 9404, bed nets, specified in Subheading Note 1 to this Chapter",
  "630491":
    "Furnishing articles; excluding those of heading no. 9404, n.e.c. in heading 6304, knitted or crocheted",
  "630492":
    "Furnishing articles; of cotton, not knitted or crocheted (excluding bedspreads and articles of heading no. 9404)",
  "630493":
    "Furnishing articles; of synthetic fibres, not knitted or crocheted (excluding bedspreads and articles of heading no. 9404)",
  "630499":
    "Furnishing articles; of textile materials other than cotton or synthetic fibres, not knitted or crocheted (excluding bedspreads and articles of heading no. 9404)",
  "630510":
    "Sacks and bags; of a kind used for the packing of goods, of jute or of other textile bast fibres of heading no. 5303",
  "630520":
    "Sacks and bags; of a kind used for the packing of goods, of cotton",
  "630531":
    "Sacks and bags; of a kind used for the packing of goods, of polyethylene or polypropylene strip or the like",
  "630532":
    "Sacks and bags; of a kind used for the packing of goods, of man-made textile materials, flexible intermediate bulk containers",
  "630533":
    "Sacks and bags; of a kind used for the packing of goods, of man-made textile materials, of polyethylene or polypropylene strip or the like, not flexible intermediate bulk containers",
  "630539":
    "Sacks and bags; of a kind used for the packing of goods, of man-made textile materials, not of polyethylene or polypropylene strip or the like, not flexible intermediate bulk containers",
  "630590":
    "Sacks and bags; of a kind used for the packing of goods, of textile materials (other than jute, cotton or man-made textile materials)",
  "630611": "Tarpaulins, awnings and sunblinds; of cotton",
  "630612": "Tarpaulins, awnings and sunblinds; of synthetic fibres",
  "630619":
    "Tarpaulins, awnings and sunblinds; of textile materials other than synthetic fibres",
  "630621": "Tents; of cotton",
  "630622": "Tents; of synthetic fibres",
  "630629": "Tents; of textile materials other than synthetic fibres",
  "630630": "Sails; for boats, sailboards or landcraft",
  "630631": "Sails; of synthetic fibres",
  "630639": "Sails; of textile materials other than synthetic fibres",
  "630640": "Camping goods; pneumatic mattresses",
  "630641": "Pneumatic mattresses; of cotton",
  "630649": "Pneumatic mattresses; of textile materials other than cotton",
  "630690": "Camping goods; (of textile materials), n.e.c in heading no. 6306",
  "630691": "Sailboards, landcraft or camping goods; of cotton",
  "630699":
    "Sailboards, landcraft or camping goods; of textile materials other than cotton",
  "630710":
    "Cloths; floor cloths, dish-cloths, dusters and similar cleaning cloths",
  "630720": "Life-jackets and life-belts",
  "630790":
    "Textiles; made up articles (including dress patterns), n.e.c. in chapter 63, n.e.c. in heading no. 6307",
  "630800":
    "Fabrics, woven and yarn; in sets, whether or not with accessories, for making up into rugs, tapestries, embroidered table cloths or serviettes or similar textile articles, packaged for retail sale",
  "630900": "Clothing; worn, and other worn articles",
  "631010":
    "Rags; used or new, scrap twine, cordage, rope and cables and worn out articles of twine, cordage, rope or cables, of textile materials; sorted",
  "631090":
    "Rags; used or new, scrap twine, cordage, rope and cables and worn out articles of twine, cordage, rope or cables, of textile materials; other than sorted",
  "640110":
    "Footwear; waterproof with metal toe-cap, rubber or plastic outer soles and uppers (not assembled by stitch, rivet, nail, screw, plug or similar)",
  "640191":
    "Footwear; waterproof, covering the knee, rubber or plastic outer soles and uppers (not assembled by stitch, rivet, nail, screw, plug or similar)",
  "640192":
    "Footwear; waterproof, covering the ankle (but not the knee), rubber or plastic outer soles and uppers (not assembled by stitch, rivet, nail, screw, plug or similar)",
  "640199":
    "Footwear; waterproof, n.e.c. in heading no. 6401, rubber or plastic outer soles and uppers (not assembled by stitch, rivet, nail, screw, plug or similar)",
  "640211":
    "Sports footwear; ski boots and cross-country ski footwear, with outer soles and uppers of rubber or plastics",
  "640212":
    "Sports footwear; with outer soles and uppers of rubber or plastics, ski-boots, cross-country ski footwear and snowboard boots",
  "640219":
    "Sports footwear; (other than ski-boots, snowboard boots or cross-country ski footwear), with outer soles and uppers of rubber or plastics",
  "640220":
    "Footwear; with outer soles and uppers of rubber or plastics, upper straps or thongs assembled to the sole by plugs",
  "640230":
    "Footwear; with metal toe-caps, outer soles and uppers of rubber or plastics",
  "640291":
    "Footwear; n.e.c. in heading no. 6402, covering the ankle, with outer soles and uppers of rubber or plastics",
  "640299": "Other footwear of rubber or plastics (exclusionary category)",
  "640311":
    "Sports footwear; ski-boots and cross-country ski footwear, outer soles of rubber, plastics, leather or composition leather, uppers of leather",
  "640312":
    "Sports footwear; with outer soles of rubber, plastics, leather or composition leather and uppers of leather, ski-boots, snowboard boots and cross-country ski footwear",
  "640319":
    "Sports footwear; (other than ski-boots, snowboard boots or cross-country ski footwear), with outer soles of rubber, plastics, leather or composition leather and uppers of leather",
  "640320":
    "Footwear; with outer soles of leather, uppers consisting of leather straps across instep and around the big toe",
  "640330":
    "Footwear; made on wooden base or platform, without inner sole or metal toe cap, outer sole of rubber, plastic, leather or composition leather, uppers of leather",
  "640340":
    "Footwear; with metal toe-cap, outer soles of rubber, plastics, leather or composition leather, uppers of leather",
  "640351":
    "Footwear; n.e.c. in heading no. 6403, with outer soles and uppers of leather, covering the ankle",
  "640359":
    "Footwear; n.e.c. in heading no. 6403, (not covering the ankle), outer soles and uppers of leather",
  "640391":
    "Footwear; n.e.c. in heading no. 6403, covering the ankle, outer soles of rubber, plastics or composition leather, uppers of leather",
  "640399":
    "Other footwear; sole rubber, plastics, or leather, upper leather (exclusionary category)",
  "640411": "Sports footwear of rubber and textile",
  "640419":
    "Footwear; sole rubber or plastics, upper textile; excl. sportswear",
  "640420":
    "Footwear; outer soles of leather or composition leather, uppers of textile materials",
  "640510":
    "Footwear; with uppers of leather or composition leather, n.e.c. in chapter 64",
  "640520": "Footwear; with uppers of textile materials, n.e.c. in chapter 64",
  "640590": "Footwear; n.e.c. in chapter 64",
  "640610": "Footwear; parts, uppers and parts thereof, other than stiffeners",
  "640620": "Footwear; parts, outer soles and heels, of rubber or plastics",
  "640690": "Footwear; parts, n.e.c. in heading 6406",
  "640691": "Footwear; parts, of wood",
  "640699": "Footwear; of materials n.e.c. in heading no. 6406",
  "650100":
    "Hat-forms, hat bodies and hoods of felt, neither blocked to shape nor with made brims; plateaux and manchons (including slit manchons) of felt",
  "650200":
    "Hat-shapes; plaited or made by assembling strips of any material, neither blocked to shape, nor with made brims, nor lined, nor trimmed",
  "650300":
    "Hats and other felt headgear; made from the hat bodies, hoods or plateaux of heading no. 6501, whether or not lined or trimmed",
  "650400":
    "Hats and other headgear; plaited or made by assembling strips of any material, whether or not lined or trimmed",
  "650500": "Hats and other headgear",
  "650510": "Hair-nets; of any material, whether or not lined or trimmed",
  "650590":
    "Hats and other headgear; knitted or crocheted, or made up from lace, felt or other textile fabrics, in the piece (but not in strips), whether or not lined or trimmed",
  "650610": "Headgear; safety, whether or not lined or trimmed",
  "650691":
    "Headgear; (other than safety headgear), of rubber or plastics, whether or not lined or trimmed",
  "650692":
    "Headgear; (other than safety headgear), of furskin, whether or not lined or trimmed",
  "650699":
    "Headgear; (other than safety headgear), (of materials other than rubber or plastic), whether or not lined or trimmed",
  "650700":
    "Head-bands, linings, covers, hat foundations, hat frames, peaks and chinstraps; for headgear",
  "660110": "Umbrellas and sun umbrellas; garden or similar umbrellas",
  "660191":
    "Umbrellas and sun umbrellas; having a telescopic shaft, (excluding garden or similar umbrellas)",
  "660199":
    "Umbrellas and sun umbrellas; n.e.c. in heading no. 6601 (including walking stick umbrellas)",
  "660200": "Walking-sticks, seat-sticks, whips, riding-crops and the like",
  "660310": "Handles and knobs; of articles of heading no. 6601 or 6602",
  "660320": "Umbrella frames; including frames mounted on shafts (sticks)",
  "660390":
    "Trimmings, accessories and parts of articles of heading no. 6601 or 6602; n.e.c. in heading no. 6603",
  "670100":
    "Skins and other parts of birds with their feathers or down; feathers, parts of feathers, down and articles thereof (other than goods of heading no. 0505 and worked quills and scapes)",
  "670210":
    "Flowers, foliage and fruit, artificial, and parts thereof; articles made of artificial flowers, foliage or fruit, of plastics",
  "670290":
    "Flowers, foliage and fruit, artificial, and parts thereof; articles made of artificial flowers, foliage or fruit, of materials other than plastics",
  "670300":
    "Human hair, dressed, thinned, bleached or otherwise worked; wool or other animal hair or other textile materials, prepared for use in making wigs or the like",
  "670411": "Wigs; complete, of synthetic textile materials",
  "670419":
    "False beards, eyebrows and eyelashes, switches and the like; of synthetic textile materials",
  "670420":
    "Wigs, false beards, eyebrows and eyelashes, switches and the like and other articles n.e.c.; of human hair",
  "670490":
    "Wigs, false beards, eyebrows and eyelashes, switches and the like and other articles n.e.c.; of animal hair or of textile materials other than synthetic",
  "680100":
    "Stone; setts, curbstones and flagstones, of natural stone (except slate)",
  "680210":
    "Tiles, cubes and similar articles; whether or not rectangular (including square), largest surface area of which is capable of being enclosed in square, side less than 7cm, coloured granules, chippings, powder",
  "680221":
    "Marble, travertine and alabaster; simply cut or sawn, with a flat or even surface",
  "680222":
    "Stone; calcareous (excluding marble, travertine, alabaster), articles thereof, simply cut or sawn, with a flat or even surface",
  "680223":
    "Granite; articles thereof, simply cut or sawn, with a flat or even surface",
  "680229":
    "Stone; monumental or building stone, n.e.c. in item no. 6802.2, articles thereof, simply cut or sawn, with a flat or even surface",
  "680291":
    "Marble, travertine and alabaster; articles thereof, (other than simply cut or sawn, with a flat or even surface)",
  "680292":
    "Stone; calcareous (excluding marble, travertine, alabaster) articles thereof, (other than simply cut or sawn, with a flat or even surface)",
  "680293": "Worked granite articles",
  "680299":
    "Stone; natural (excluding marble, travertine, alabaster, other calcareous stone or granite), monumental or building stone, (other than simply cut or sawn, with a flat or even surface)",
  "680300": "Slate, worked; and articles of slate or of agglomerated slate",
  "680410": "Millstones and grindstones; for milling, grinding or pulping",
  "680421":
    "Millstones, grindstones, grinding wheels and the like; of agglomerated synthetic or natural diamond",
  "680422":
    "Millstones, grindstones, grinding wheels and the like; of other agglomerated abrasives or of ceramics",
  "680423":
    "Millstones, grindstones, grinding wheels and the like; of natural stone",
  "680430":
    "Stones; hand sharpening or polishing stones, of natural stone, agglomerated natural or artificial abrasives or ceramics, with or without parts of other materials",
  "680510":
    "Abrasive powder or grain; natural or artificial, on a base of woven textile fabric only, whether or not cut to shape or sewn or otherwise made up",
  "680520":
    "Abrasive powder or grain; natural or artificial, on a base of paper or paperboard only, whether or not cut to shape or sewn or otherwise made up",
  "680530":
    "Abrasive powder or grain; natural or artificial, on a base of materials n.e.c. in heading no. 6805, whether or not cut to shape or sewn or otherwise made up",
  "680610":
    "Slag wool, rock wool and similar mineral wools (including intermixtures thereof), in bulk, sheets or rolls",
  "680620":
    "Exfoliated vermiculite, expanded clays, foamed slag and similar expanded mineral materials (including intermixtures thereof)",
  "680690":
    "Minerals; mixtures and articles of heat-insulating, sound-insulating or sound-absorbing mineral materials, other than those of heading no. 6811 or 6812 or of chapter 69",
  "680710":
    "Asphalt or similar material; articles (e.g. petroleum bitumen or coal tar pitch) in rolls",
  "680790":
    "Asphalt or similar material; articles (e.g. petroleum bitumen or coal tar pitch) other than in rolls",
  "680800":
    "Panels, boards, tiles, blocks and the like; of vegetable fibre, of straw, shavings, chips, particles, sawdust or other waste, of wood, agglomerated with cement, plaster or other mineral binders",
  "680911":
    "Plaster, or plaster compositions; boards, sheets, panels, tiles and similar articles, faced or reinforced with paper or paperboard only, not ornamented",
  "680919":
    "Plaster, or plaster compositions; boards, sheets, panels, tiles and similar articles, (other than faced or reinforced with paper or paperboard only), not ornamented",
  "680990":
    "Plaster articles or articles of compositions based on plaster; n.e.c. in heading no. 6809",
  "681011":
    "Cement, concrete or artificial stone; building blocks or bricks, whether or not reinforced",
  "681019":
    "Cement, concrete or artificial stone; tiles, flagstones and similar, (excluding building blocks and bricks) whether or not reinforced",
  "681020":
    "Cement, concrete or artificial stone; pipes, whether or not reinforced",
  "681091":
    "Cement, concrete or artificial stone; prefabricated structural components for building or civil engineering, whether or not reinforced",
  "681099":
    "Cement, concrete or artificial stone; articles (other than prefabricated structural components for building or civil engineering), whether or not reinforced, n.e.c. in heading no. 6810",
  "681110":
    "Asbestos-cement, cellulose fibre-cement articles or the like; corrugated sheets",
  "681120":
    "Asbestos-cement, cellulose fibre-cement articles or the like; sheets, panels, tiles and similar articles, other than corrugated sheets",
  "681130":
    "Asbestos-cement, cellulose fibre-cement articles or the like; tubes, pipes and tube or pipe fittings",
  "681140": "Asbestos-cement; articles or the like, containing asbestos",
  "681181":
    "Cellulose fibre-cement; articles or the like; corrugated sheets, not containing asbestos",
  "681182":
    "Cellulose fibre-cement; articles or the like, sheets, panels, tiles and similar articles (other than corrugated sheets), not containing asbestos",
  "681183":
    "Cellulose fibre-cement articles or the like; tubes, pipes and tube or pipe fittings",
  "681189":
    "Cellulose fibre-cement; articles or the like, other than corrugated sheets and other sheets, panels, tiles and similar articles, not containing asbestos",
  "681190":
    "Asbestos-cement, cellulose fibre-cement articles or the like; articles n.e.s. in heading no. 6811",
  "681210":
    "Asbestos fibres, fabricated; mixtures with a basis of asbestos or with a basis of asbestos and magnesium carbonate",
  "681220":
    "Asbestos; articles thereof, yarn and thread, whether or not reinforced, (excluding goods of heading no. 6811 or 6813)",
  "681230":
    "Asbestos; cords and string, whether or not plaited, of a mixture with a basis of asbestos or asbestos and magnesium carbonate, whether or not reinforced, (excluding goods of heading no. 6811 or 6813)",
  "681240":
    "Asbestos; woven or knitted fabric, of a mixture with a basis of asbestos or asbestos and magnesium carbonate, whether or not reinforced, (excluding goods of heading no. 6811 or 6813)",
  "681250":
    "Asbestos; clothing, clothing accessories, footwear and headgear, of a mixture with a basis of asbestos or asbestos and magnesium carbonate, whether or not reinforced (excluding heading no. 6811 or 6813)",
  "681260":
    "Asbestos; paper, millboard and felt, of a mixture with a basis of asbestos or asbestos and magnesium carbonate, whether or not reinforced (excluding goods of heading no. 6811 or 6813)",
  "681270":
    "Asbestos fibres, fabricated; compressed asbestos fibre jointing, in sheets or rolls",
  "681280":
    "Fabricated crocidolite (blue asbestos) fibres, mixtures with a basis of crocidolite (blue asbestos), articles of crocidolite (blue asbestos), whether or not reinforced, not goods of heading 6811 or 6813",
  "681290":
    "Asbestos; goods n.e.s. in heading no. 6812, of a mixture with a basis of asbestos and magnesium carbonate, whether or not reinforced (excluding goods of heading no. 6811 or 6813)",
  "681291":
    "Asbestos or mixtures with a basis of asbestos (other than crocidolite); clothing, clothing accessories, footwear and headgear, whether or not reinforced, not goods of heading 6811 or 6813",
  "681292":
    "Asbestos or mixtures with a basis of asbestos (other than crocidolite); paper, millboard and felt, whether or not reinforced, not goods of heading 6811 or 6813",
  "681293":
    "Asbestos or mixtures with a basis of asbestos (other than crocidolite); compressed asbestos fibre jointing, in sheets or rolls, whether or not reinforced, not goods of heading 6811 or 6813",
  "681299":
    "Asbestos or mixtures with a basis of asbestos (other than crocidolite); fibres, mixtures or articles n.e.c. in heading no. 6812, whether or not reinforced, not goods of heading 6811 or 6813",
  "681310":
    "Brake linings and pads; with a basis of asbestos, of other mineral substances or of cellulose",
  "681320":
    "Friction material and articles thereof (e.g. sheets, rolls, strips, segments, discs, washers, pads) not mounted; for brakes, clutches or the like, with a basis of asbestos",
  "681381":
    "Brake linings and pads; with a basis of mineral substances or cellulose (other than asbestos)",
  "681389":
    "Friction material and articles thereof (e.g. sheets, rolls, strips, segments, discs, washers, pads) not mounted; for clutches or the like (not brake linings and pads), with a basis of mineral substances or cellulose (other than asbestos)",
  "681390":
    "Friction material; unmounted, for clutches or the like, with a basis of asbestos, of other mineral substances or of cellulose, other than brake linings and pads",
  "681410":
    "Mica; plates, sheets and strips of agglomerated or reconstituted mica, whether or not on a support of paper, paperboard or other materials",
  "681490":
    "Mica; worked mica and articles of mica (excluding plates, sheets and strips) whether or not on a support of paper, paperboard or other materials",
  "681510": "Articles of graphite or other carbon; non-electrical",
  "681511":
    "Stone or other mineral substances not elsewhere specified or included; carbon fibres for non-electrical uses",
  "681512":
    "Stone or other mineral substances not elsewhere specified or included; fabrics of carbon fibres for non-electrical uses",
  "681513":
    "Stone or other mineral substances not elsewhere specified or included; articles of carbon fibres for non-electrical uses",
  "681519":
    "Stone or other mineral substances not elsewhere specified or included; non-electrical articles of graphite or carbon n.e.c. in heading 6815",
  "681520": "Peat; articles of peat n.e.c. or included",
  "681591":
    "Stone articles and articles of other mineral substances; containing magnesite, dolomite or chromite",
  "681599":
    "Stone articles and articles of other mineral substances; n.e.c. or included in heading no. 6815",
  "690100":
    "Bricks, blocks, tiles and other ceramic goods of siliceous fossil meals (e.g. kieselguhr, tripolite or diatomite) or of similar siliceous earths",
  "690210":
    "Refractory bricks, blocks, tiles and similar refractory ceramic constructional goods; containing by weight, singly or together, more than 50% of the elements Mg, Ca or Cr, expressed as MgO, CaO or Cr2o3",
  "690220":
    "Refractory bricks, blocks, tiles and similar refractory ceramic constructional goods; containing by weight more than 50% of alumina (Al2o3), of silica (SiO2) or of a mixture or compound of these",
  "690290":
    "Refractory bricks, blocks, tiles and similar refractory ceramic constructional goods; n.e.c. in item no. 6902.1 or 6902.2",
  "690310":
    "Refractory ceramic goods; containing by weight more than 50% of graphite or other forms of carbon or of a mixture of these products, excluding those of siliceous fossil meals or similar earths",
  "690320":
    "Refractory ceramic goods; containing by weight more than 50% of alumina or of a mixture or compound of alumina and of silica, excluding those of siliceous fossil meals or similar earths",
  "690390":
    "Refractory ceramic goods; composition of which n.e.c. in heading no. 6903, other than those of siliceous fossil meals or similar earths",
  "690410": "Ceramic building bricks",
  "690490":
    "Ceramic flooring blocks, supports or filler tiles and the like (excluding building bricks)",
  "690510": "Ceramic roofing tiles",
  "690590":
    "Ceramic chimney-pots, cowls, chimney liners, architectural ornaments and other constructional goods (excluding roofing tiles)",
  "690600": "Ceramic pipes, conduits, guttering and pipe fittings",
  "690710":
    "Ceramic tiles, cubes and similar articles; unglazed, whether or not rectangular, the largest surface area of which is capable of being enclosed in a square the side of which is less than 7cm",
  "690721":
    "Ceramic tiles; flags and paving, hearth or wall tiles other than those of subheadings 6907.30 and 6907.40, of a water absorption coefficient by weight not over 0.5%",
  "690722":
    "Ceramic tiles; flags and paving, hearth or wall tiles other than those of subheadings 6907.30 and 6907.40, of a water absorption coefficient by weight over 0.5% but not over 10%",
  "690723":
    "Ceramic tiles; flags and paving, hearth or wall tiles other than those of subheadings 6907.30 and 6907.40, of a water absorption coefficient by weight over 10%",
  "690730": "Mosaic cubes and the like, other than those of subheading 6907.40",
  "690740": "Finishing ceramics",
  "690790": "Ceramic flags and paving; unglazed",
  "690810":
    "Ceramic tiles, cubes and similar articles; glazed, whether or not rectangular or on a backing, with the largest surface area less than a 7cm square",
  "690890": "Ceramic flags and pavings; glazed",
  "690911":
    "Ceramic wares; for laboratory, chemical or other technical uses, of porcelain or china",
  "690912":
    "Ceramic wares; for laboratory, chemical or other technical uses, articles having a hardness equivalent to 9 or more on the Mohs scale",
  "690919":
    "Ceramic wares; for laboratory, chemical or other technical uses, other than articles having a hardness equivalent to 9 or more on the Mohs scale or of porcelain or china",
  "690990":
    "Ceramic wares; pots, jars and similar articles of a kind used for the conveyance or packing of goods and ceramic troughs, tubs and similar receptacles used in agriculture",
  "691010":
    "Ceramic sinks, wash basins, wash basin pedestals, baths, bidets, water closet pans, flushing cisterns, urinals and similar sanitary fixtures; of porcelain or china",
  "691090":
    "Ceramic sinks, wash basins, wash basin pedestals, baths, bidets, water closet pans, flushing cisterns, urinals and similar sanitary fixtures; of other than porcelain or china",
  "691110": "Tableware and kitchenware; of porcelain or china",
  "691190":
    "Household and toilet articles; n.e.c. in heading no. 6911, of porcelain or china",
  "691200": "Ceramic housewares; excl. porcelain and china",
  "691310":
    "Ceramic statuettes and other ornamental ceramic articles, of porcelain or china",
  "691390":
    "Ceramic statuettes and other ornamental ceramic articles; other than of porcelain or china",
  "691410": "Ceramic articles n.e.c. in chapter 69; of porcelain or china",
  "691490":
    "Ceramic articles n.e.c. in chapter 69; other than of porcelain or china",
  "700100":
    "Glass; cullet and other waste and scrap of glass, glass in the mass",
  "700210":
    "Glass; unworked, in balls (other than microspheres of heading no. 7018)",
  "700220": "Glass; unworked, in rods",
  "700231": "Glass; unworked, in tubes, of fused quartz or other fused silica",
  "700232":
    "Glass; unworked, tubes, of glass having a linear coefficient of expansion not exceeding 5 x 10 (to the minus 6), (or 0.000005) per Kelvin within a temperature range of 0-300 degrees C",
  "700239":
    "Glass; unworked, in tubes, other than of glass having a linear coefficient of expansion not exceeding 5 x 10 (to the minus 6, (or 0.000005) ) per Kelvin within a temperature range of 0-300 degrees C, not fused quartz or other fused silica",
  "700311":
    "Glass; cast glass and rolled glass, non-wired sheets, coloured throughout the mass (body tinted), opacified, flashed or having an absorbent or reflecting layer",
  "700312":
    "Glass; cast glass and rolled glass, non-wired sheets, coloured through the mass (body tinted), opacified, flashed or having an absorbent, reflecting or non-reflecting layer",
  "700319":
    "Glass; cast glass and rolled glass, non-wired sheets, (excluding those coloured throughout the mass (body tinted) opacified, flashed or having an absorbent or reflecting layer)",
  "700320":
    "Glass; cast glass and rolled glass, wired sheets, whether or not having an absorbent or reflecting layer but not otherwise worked",
  "700330":
    "Glass; cast glass and rolled glass, profiles, not otherwise worked",
  "700410":
    "Glass; drawn and blown, in sheets, coloured throughout the mass (body tinted), opacified, flashed or having an absorbent or reflecting layer but not otherwise worked",
  "700420":
    "Glass; drawn and blown, in sheets, coloured throughout the mass (body tinted), opacified, flashed or having an absorbent, reflecting or non-reflecting layer, but not otherwise worked",
  "700490":
    "Glass; drawn and blown, in sheets, (other than glass coloured throughout the mass (body tinted), opacified, flashed or having an absorbent, reflecting or non-reflecting layer)",
  "700510":
    "Glass; float glass and surface ground or polished glass, in sheets, non-wired, having an absorbent reflecting or non-reflecting layer",
  "700521":
    "Glass; float glass and surface ground or polished glass, in sheets, non-wired, coloured throughout the mass (body tinted), opacified, flashed or merely surface ground",
  "700529":
    "Glass; float glass and surface ground or polished glass, in sheets, non-wired, (other than coloured throughout the mass (body tinted), opacified, flashed or merely surface ground)",
  "700530":
    "Glass; float glass and surface ground or polished glass, in sheets, wired glass, whether or not having an absorbent or reflecting layer",
  "700600":
    "Glass of heading no. 7003, 7004 or 7005; bent, edge-worked, engraved, drilled, enamelled or otherwise worked, but not framed or fitted with other materials",
  "700711":
    "Glass; safety glass, toughened (tempered), of size and shape suitable for incorporation in vehicles, aircraft, spacecraft or vessels",
  "700719":
    "Glass; safety glass, toughened (tempered), (not of a size and shape suitable for incorporation in vehicles, aircraft, spacecraft or vessels)",
  "700721":
    "Glass; safety glass, laminated, of size and shape suitable for incorporation in vehicles, aircraft, spacecraft or vessels",
  "700729":
    "Glass; safety glass, laminated, (not of a size and shape suitable for incorporation in vehicles, aircraft, spacecraft or vessels)",
  "700800": "Glass; multiple-walled insulating units of glass",
  "700910": "Rear-view mirrors for vehicles",
  "700991": "Glass mirrors; unframed, excluding rear-view mirrors for vehicles",
  "700992": "Glass mirrors; framed, excluding rear-view mirrors for vehicles",
  "701010":
    "Glass; ampoules, of a kind used for the conveyance or packing of goods",
  "701020": "Glass; stoppers, lids and other closures",
  "701090":
    "Glass; carboys, bottles, flasks, jars, pots, phials and other containers of glass, (not ampoules), used for the conveyance or packing of goods",
  "701091":
    "Glass; carboys, bottles, flasks, jars, pots, phials and other containers of glass, (not ampoules), used for the conveyance or packing of goods, of a capacity exceeding 1l",
  "701092":
    "Glass; carboys, bottles, flasks, jars, pots, phials and other containers of glass, (not ampoules), used for the conveyance or packing of goods, of a capacity exceeding 0.33l but not exceeding 1l",
  "701093":
    "Glass; carboys, bottles, flasks, jars, pots, phials and other containers of glass, (not ampoules), used for the conveyance or packing of goods, of a capacity exceeding 0.15l but not exceeding 0.33l",
  "701094":
    "Glass; carboys, bottles, flasks, jars, pots, phials and other containers of glass, (not ampoules), used for the conveyance or packing of goods, of a capacity not exceeding 0.15l",
  "701110":
    "Glass envelopes (including bulbs and tubes); open, and glass parts thereof, without fittings, for electric lighting",
  "701120":
    "Glass envelopes (including bulbs and tubes); open, and glass parts thereof, without fittings, for cathode-ray tubes",
  "701190":
    "Glass envelopes (including bulbs and tubes); open, and glass parts thereof, without fittings, other than for electric lighting and cathode-ray tubes",
  "701200": "Glass; inners for vacuum flasks or other vacuum vessels",
  "701310":
    "Glassware; of a kind used for table, kitchen, toilet, office, indoor decoration or similar purposes (other than of heading no. 7010 or 7018), of glass-ceramics",
  "701321": "Glassware; drinking glasses, of lead crystal",
  "701322": "Stemware drinking glasses, of lead crystal",
  "701328":
    "Stemware drinking glasses, other than of lead crystal or glass-ceramics",
  "701329":
    "Glassware; drinking glasses, not of glass-ceramics or lead crystal",
  "701331":
    "Glassware; of a kind used for table or kitchen purposes, (excluding drinking glasses), of lead crystal",
  "701332":
    "Glassware; of a kind used for table or kitchen purposes, of glass having a linear co-efficient of expansion not exceeding 5 x 10-6 per kelvin within a temperature range of 0-300 degrees C, (not of glass-ceramics)",
  "701333": "Glassware; drinking glasses (not stemware), of lead crystal",
  "701337":
    "Glassware; drinking glasses (not stemware), other than of lead crystal or glass-ceramics",
  "701339":
    "Glassware; used for table or kitchen purposes, (not of lead crystal or glass-ceramics or glass having a linear co-efficient of expansion not exceeding 5 x 10-6 per kelvin with a temperature range of 0-300 degrees c)",
  "701341":
    "Glassware of a kind used for table or kitchen purposes (not drinking glasses), of lead crystal",
  "701342":
    "Glassware of a kind used for table or kitchen purposes (not drinking glasses), of glass having a linear coefficient of expansion not exceeding 5 x 10 (to the minus 6), (or 0.000005) per Kelvin within a temperature range of 0-300 degrees C",
  "701349":
    "Glassware of a kind used for table or kitchen purposes (not drinking glasses or of glass-ceramics), of glass n.e.c. in item no. 7013.4",
  "701391": "Glassware; n.e.c. in heading no. 7013, of lead crystal",
  "701399": "Glassware; n.e.c. in heading no. 7013, other than of lead crystal",
  "701400": "Glassware; signalling, (not optically worked)",
  "701510":
    "Glasses for corrective spectacles; curved, bent, hollowed or the like, not optically worked",
  "701590":
    "Glasses; clock or watch and similar, glasses for non-corrective spectacles, curved, bent, hollowed etc, (not optically worked), hollow glass spheres and segments, for the manufacture of such glasses",
  "701610":
    "Glass cubes and other glass smallwares; whether or not on a backing, for mosaics or similar decorative purposes",
  "701690":
    "Multicellular or foam glass; in blocks, panels, plates, shells or similar forms; paving blocks, slabs, bricks and other articles of pressed or moulded glass",
  "701710":
    "Glassware; laboratory, hygienic or pharmaceutical, whether or not graduated or calibrated, of fused quartz or other fused silica",
  "701720":
    "Glassware; laboratory, hygienic or pharmaceutical, whether or not graduated or calibrated, having a linear co-efficient of expansion not over 5 x 10 (to the minus 6), (or 0.000005)) per Kelvin with a temperature of 0-300 degrees C",
  "701790":
    "Glassware; laboratory, hygienic or pharmaceutical, whether or not graduated or calibrated, of glass n.e.c. in heading no. 7017",
  "701810":
    "Glass; beads, imitation pearls, imitation precious or semi-precious stones and similar glass smallwares",
  "701820": "Glass microspheres; not exceeding 1mm in diameter",
  "701890":
    "Glass; articles thereof, statuettes and other ornaments of lamp worked glass, other than imitation jewellery",
  "701910":
    "Glass fibres (including glass wool); slivers, rovings, yarn and chopped strands",
  "701911":
    "Glass fibres; (including glass wool), chopped strands, of a length of not more than 50mm",
  "701912": "Glass fibres; (including glass wool), rovings",
  "701913": "Glass fibres; (including glass wool), yarns and slivers",
  "701914": "Glass fibres; (including glass wool), mechanically bonded mats",
  "701915": "Glass fibres; (including glass wool), chemically bonded mats",
  "701919": "Glass fibres; (including glass wool), slivers, yarns and threads",
  "701920": "Glass fibres; woven fabrics, including narrow fabrics",
  "701931": "Glass fibres; non-woven products, mats",
  "701932": "Glass fibres; non-woven products, thin sheets (voiles)",
  "701939":
    "Glass fibres; webs, mattresses, boards and similar non-woven products excluding mats and thin sheets",
  "701940": "Glass fibres; woven fabrics of rovings",
  "701951":
    "Glass fibres; woven fabrics (other than of rovings), of a width not exceeding 30cm",
  "701952":
    "Glass fibres; woven fabrics (other than of rovings), of a width exceeding 30cm, plain weave, weighing less than 250g/m2, of filaments measuring per single yarn not more than 136 tex",
  "701959":
    "Glass fibres; woven fabrics (other than of rovings), n.e.c. in item no. 7019.5",
  "701961":
    "Glass fibres; mechanically bonded fabrics and closed woven fabrics of rovings",
  "701962":
    "Glass fibres; non-woven mechanically bonded fabrics and closed fabrics of rovings",
  "701963":
    "Glass fibres; mechanically bonded fabrics and closed woven fabrics, plain weave, of yarns, not coated or laminated (other than rovings)",
  "701964":
    "Glass fibres; closed woven fabrics, plain weave, of yarns, coated or laminated, (other than rovings)",
  "701965": "Glass fibres; open woven fabrics of a width not exceeding 30cm",
  "701966": "Glass fibres; open woven fabrics of a width exceeding 30cm",
  "701969": "Glass fibres; fabrics n.e.c. in item no. 7019.6",
  "701971": "Glass fibres; chemically bonded fabrics",
  "701972":
    "Glass fibres; chemically bonded fabrics, closed fabrics n.e.c. in heading 7019",
  "701973":
    "Glass fibres; chemically bonded fabrics, open fabrics n.e.c. in heading 7019",
  "701980": "Glass fibres; glass wool and articles thereof",
  "701990": "Other glass fibres; incl. articles (exclusionary category)",
  "702000": "Other glass articles (exclusionary category)",
  "710110":
    "Pearls; natural, whether or not worked or graded (but not strung, mounted or set), temporarily strung for the convenience of transport",
  "710121":
    "Pearls; cultured, unworked, whether or not graded (but not strung, mounted or set), temporarily strung for the convenience of transport",
  "710122":
    "Pearls; cultured, worked, whether or not graded (but not strung, mounted or set), temporarily strung for the convenience of transport",
  "710210": "Diamonds; whether or not worked, but not mounted or set, unsorted",
  "710221":
    "Diamonds; industrial, unworked or simply sawn, cleaved or bruted, but not mounted or set",
  "710229":
    "Diamonds; industrial, (other than unworked or simply sawn, cleaved or bruted), but not mounted or set",
  "710231":
    "Diamonds; non-industrial, unworked or simply sawn, cleaved or bruted, but not mounted or set",
  "710239":
    "Diamonds; non-industrial, (other than unworked or simply sawn, cleaved or bruted), but not mounted or set",
  "710310":
    "Stones; precious (other than diamonds) and semi-precious stones, unworked or simply sawn or roughly shaped, not strung, mounted or set",
  "710391":
    "Stones; rubies, sapphires and emeralds, worked (other than simply sawn or roughly shaped), not strung, mounted or set",
  "710399":
    "Stones; precious (other than diamonds) and semi-precious stones, (other than rubies, sapphires and emeralds), worked other than simply sawn or roughly shaped, not strung, mounted or set",
  "710410":
    "Stones; precious or semi-precious, synthetic or reconstructed, piezo-electric quartz, whether or not worked or graded (but not strung, mounted or set), temporarily strung for transport convenience",
  "710420":
    "Stones; precious or semi-precious, synthetic or reconstructed, (not piezo-electric quartz), unworked or simply sawn, roughly shaped, (not strung, mounted or set), temporarily strung for transport convenience",
  "710421": "Stones; diamonds, unworked or simply sawn or roughly shaped",
  "710429":
    "Stones; synthetic or reconstructed precious or semi-precious n.e.c. in heading 7104, unworked or simply sawn or roughly shaped",
  "710490":
    "Stones; precious or semi-precious, synthetic or reconstructed, (not piezo-electric quartz), worked or graded or not, (but not strung, mounted or set), temporarily strung for transport convenience, n.e.c. in item no. 7104.20",
  "710491":
    "Stones; diamonds, n.e.c. in heading 7104, worked or graded but not strung, mounted or set; ungraded synthetic or reconstructed precious or semi-precious stones, temporarily strung for convenience of transport",
  "710499":
    "Stones; synthetic or reconstructed precious or semi-precious n.e.c. in heading 7104, worked or graded but not strung, mounted or set; ungraded synthetic or reconstructed precious or semi-precious stones, temporarily strung for convenience of transport",
  "710510": "Stones; precious and semi-precious, dust and powder, of diamonds",
  "710590":
    "Stones; precious and semi-precious, dust and powder, of natural or synthetic precious or semi-precious stones, excluding diamonds",
  "710610": "Metals; silver powder",
  "710691": "Silver; unwrought",
  "710692": "Metals; silver, semi-manufactured",
  "710700":
    "Base metals clad with silver; not further worked than semi-manufactured",
  "710811": "Metals; gold, non-monetary, powder",
  "710812":
    "Gold; unwrought but not powder; excl. reserve assets from monetary authorities",
  "710813": "Gold; semi-manufactured",
  "710900":
    "Base metals or silver; clad with gold, not further worked than semi-manufactured",
  "711011": "Metals; platinum, unwrought or in powder form",
  "711019": "Metals; platinum, semi-manufactured",
  "711021": "Palladium; unwrought or in powder form",
  "711029": "Metals; palladium, semi-manufactured",
  "711031": "Rhodium; unwrought or in powder form",
  "711039": "Metals; rhodium, semi-manufactured",
  "711041": "Metals; iridium, osmium, ruthenium, unwrought or in powder form",
  "711049": "Metals; iridium, osmium, ruthenium, semi-manufactured",
  "711100":
    "Base metals, silver or gold, clad with platinum; not further worked than semi-manufactured",
  "711210":
    "Metals; waste and scrap of gold, including metal clad with gold but excluding sweepings containing other precious metals",
  "711220":
    "Metals; waste and scrap of platinum, including metal clad with platinum but excluding sweepings containing other precious metals",
  "711230":
    "Waste and scrap of precious metal or of metal clad with precious metal; ash containing precious metal or precious metal compounds",
  "711290":
    "Metals; waste and scrap of precious metal other than gold or platinum but excluding sweepings containing other precious metals",
  "711291":
    "Waste and scrap of precious metals; of gold, including metal clad with gold but excluding sweepings containing other precious metals",
  "711292": "Platinum waste and scrap",
  "711299": "Precious metals waste and scrap; excl. gold and platinum",
  "711311":
    "Jewellery; of silver, whether or not plated or clad with other precious metal, and parts thereof",
  "711319": "Jewellery; of precious metal, incl. parts; excl. Silver",
  "711320":
    "Jewellery; of base metal clad with precious metal, and parts thereof",
  "711411":
    "Silversmiths' wares; and parts thereof, of silver, whether or not plated or clad with other precious metal",
  "711419":
    "Goldsmiths' wares; articles of and parts thereof, of precious metal (excluding silver) whether or not plated or clad with precious metal",
  "711420":
    "Goldsmiths' and silversmiths' wares; articles of and parts thereof, of base metal clad with precious metal",
  "711510": "Metal; catalysts in the form of wire cloth or grill, of platinum",
  "711590":
    "Metal; precious or metal clad with precious metal, other than that of item no. 7115.10",
  "711610": "Pearls; articles of natural or cultured pearls",
  "711620":
    "Stones; precious or semi-precious stones (natural, synthetic or reconstructed) articles of",
  "711711":
    "Jewellery; imitation, cuff links and studs, of base metal, whether or not plated with precious metal",
  "711719":
    "Jewellery; imitation, (excluding cuff links and studs), of base metal, whether or not plated with precious metal",
  "711790":
    "Jewellery; imitation, of other than base metal, whether or not plated with precious metal",
  "711810": "Coin (other than gold coin), not being legal tender",
  "720110":
    "Iron; non-alloy pig iron containing by weight 0.5% or less of phosphorus, in pigs, blocks or other primary forms",
  "720120":
    "Iron; non-alloy pig iron containing by weight more than 0.5% of phosphorus, in pigs, blocks or other primary forms",
  "720130": "Iron; alloy pig iron, in pigs, blocks or other primary forms",
  "720140": "Iron; spiegeleisen, in pigs, blocks or other primary forms",
  "720150":
    "Iron; alloy pig iron, spiegeleisen, in pigs, blocks or other primary forms",
  "720211":
    "Ferro-alloys; ferro-manganese, containing by weight more than 2% of carbon",
  "720219":
    "Ferro-alloys; ferro-manganese, containing by weight 2% or less of carbon",
  "720221":
    "Ferro-alloys; ferro-silicon, containing by weight more than 55% of silicon",
  "720229":
    "Ferro-alloys; ferro-silicon, containing by weight 55% or less of silicon",
  "720230": "Ferro-alloys; ferro-silico-manganese",
  "720241":
    "Ferro-alloys; ferro-chromium, containing by weight more than 4% of carbon",
  "720249":
    "Ferro-alloys; ferro-chromium, containing by weight 4% or less of carbon",
  "720250": "Ferro-alloys; ferro-silico-chromium",
  "720260": "Ferro-alloys; ferro-nickel",
  "720270": "Ferro-alloys; ferro-molybdenum",
  "720280": "Ferro-alloys; ferro-tungsten and ferro-silico-tungsten",
  "720291": "Ferro-alloys; ferro-titanium and ferro-silico-titanium",
  "720292": "Ferro-alloys; ferro-vanadium",
  "720293": "Ferro-alloys; ferro-niobium",
  "720299": "Ferro-alloys; n.e.c. in heading no. 7202",
  "720310":
    "Ferrous products; obtained by direct reduction of iron ore, in lumps, pellets or similar forms",
  "720390":
    "Ferrous products; spongy ferrous products and iron having a minimum purity by weight of 99.94%, in lumps, pellets or similar forms",
  "720410": "Ferrous waste and scrap; of cast iron",
  "720421": "Ferrous waste and scrap; of stainless steel",
  "720429": "Ferrous waste and scrap; of alloy steel (excluding stainless)",
  "720430": "Ferrous waste and scrap; of tinned iron or steel",
  "720441":
    "Ferrous waste and scrap; turnings, shavings, chips, milling waste, sawdust, fillings, trimmings and stampings, whether or not in bundles",
  "720449": "Other ferrous waste or scrap (exclusionary category)",
  "720450": "Ferrous products; remelting scrap ingots",
  "720510": "Iron or steel, pig iron, spiegeleisen; granules thereof",
  "720521": "Alloy steel powders",
  "720529":
    "Iron or steel, pig iron, spiegeleisen; powders (excluding alloy steel)",
  "720610":
    "Iron or non-alloy steel; ingots (excluding iron of heading no. 7203)",
  "720690":
    "Iron or non-alloy steel; primary forms (excluding ingots and iron of heading no. 7203)",
  "720711": "Low-carbon steel; square bar",
  "720712": "Low-carbon steel; flat bar",
  "720719":
    "Iron or non-alloy steel; semi-finished products of iron or non-alloy steel, containing by weight less than 0.25% of carbon, other than rectangular or square cross-section",
  "720720":
    "Iron or non-alloy steel; semi-finished products of iron or non-alloy steel, containing by weight 0.25% or more of carbon",
  "720810":
    "Iron or non-alloy steel; in coils, flat-rolled, of a width 600mm or more, hot-rolled, with patterns in relief",
  "720811":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, hot-rolled, having a minimum yield point of 355MPa, thickness exceeding 10mm",
  "720812":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, hot-rolled, minimum yield point of 355MPa, thickness 4.75mm or more but not exceeding 10mm",
  "720813":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, hot-rolled, of a thickness of 3mm or more but less than 4.75mm, having a minimum yield point of 355MPa",
  "720814":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, hot-rolled, thickness less than 3mm and having a minimum yield point of 275MPa",
  "720821":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, hot-rolled, of a thickness exceeding 10mm, excluding minimum yield point of 355MPa",
  "720822":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, hot-rolled, thickness of 4.75mm or more but not exceeding 10mm, excluding minimum yield point of 355MPa",
  "720823":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, hot-rolled, thickness of 3mm or more but less than 4.75mm, other than minimum yield point of 355MPa",
  "720824":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, hot-rolled, less than 3mm thick, excluding minimum yield point of 275MPa",
  "720825":
    "Iron or non-alloy steel; in coils, without patterns in relief, flat-rolled, of a width 600mm or more, hot-rolled, pickled, of a thickness of 4.75mm or more",
  "720826":
    "Iron or non-alloy steel; in coils, without patterns in relief, flat-rolled, of a width 600mm or more, hot-rolled, pickled, of a thickness of 3mm or more but less than 4.75mm",
  "720827":
    "Iron or non-alloy steel; in coils, without patterns in relief, flat-rolled, of a width 600mm or more, hot-rolled, pickled, of a thickness of less than 3mm",
  "720831":
    "Iron or non-alloy steel; not in coils, flat-rolled, width not over 1250mm hot-rolled, thickness not less than 4mm, having a minimum yield point of 355MPa, without patterns in relief",
  "720832":
    "Iron or non-alloy steel; not in coils, flat-rolled, hot-rolled, thickness exceeding 10mm, and a minimum yield point of 355MPa",
  "720833":
    "Iron or non-alloy steel; not in coils, flat-rolled, hot-rolled, thickness of 4.75mm or more but not exceeding 10mm, having a minimum yield point of 355MPa",
  "720834":
    "Iron or non-alloy steel; not in coils, flat-rolled, hot-rolled, thickness of 3mm or more but less than 4.75mm, having a minimum yield point of 355MPa",
  "720835":
    "Iron or non-alloy steel; not in coils, flat-rolled, hot-rolled, thickness less than 3mm, having a minimum yield point of 275MPa",
  "720836":
    "Iron or non-alloy steel; in coils, without patterns in relief, flat-rolled, of a width 600mm or more, hot-rolled, of a thickness exceeding 10mm",
  "720837":
    "Iron or non-alloy steel; in coils, without patterns in relief, flat-rolled, of a width 600mm or more, hot-rolled, of a thickness of 4.75mm or more but not exceeding 10mm",
  "720838":
    "Iron or non-alloy steel; in coils, without patterns in relief, flat-rolled, of a width 600mm or more, hot-rolled, of a thickness of 3mm or more but less than 4.75mm",
  "720839":
    "Flat rolled iron or non-alloy steel coils; without patterns, width >600mm, hot-rolled, thickness <3mm",
  "720840":
    "Iron or non-alloy steel; (not in coils), flat-rolled, of a width 600mm or more, hot-rolled, with patterns in relief",
  "720841":
    "Iron or non-alloy steel; not in coils, flat-rolled, hot-rolled, width not exceeding 1250mm and not less than 4mm thick, without patterns in relief, excluding minimum yield point of 355MPa",
  "720842":
    "Iron or non-alloy steel; not in coils, flat-rolled, hot-rolled, thickness exceeding 10mm, excluding minimum yield point of 355MPa",
  "720843":
    "Iron or non-alloy steel; not in coils, flat-rolled, hot-rolled, thickness of 4.75mm or more but not exceeding 10mm, excluding minimum yield point of 355MPa",
  "720844":
    "Iron or non-alloy steel; not in coils, flat-rolled, hot-rolled, thickness of 3mm or more but less than 4.75mm, excluding minimum yield point of 355MPa",
  "720845":
    "Iron or non-alloy steel; not in coils, flat-rolled, hot-rolled, thickness less than 3mm, excluding minimum yield point of 275MPa",
  "720851":
    "Iron or non-alloy steel; (not in coils), flat-rolled, of a width 600mm or more, hot-rolled, without patterns in relief, of a thickness exceeding 10mm",
  "720852":
    "Iron or non-alloy steel; (not in coils), flat-rolled, of a width 600mm or more, hot-rolled, without patterns in relief, of a thickness of 4.75mm or more but not exceeding 10mm",
  "720853":
    "Iron or non-alloy steel; (not in coils), flat-rolled, of a width 600mm or more, hot-rolled, without patterns in relief, of a thickness of 3mm or more but less than 4.75mm",
  "720854":
    "Iron or non-alloy steel; (not in coils), flat-rolled, of a width 600mm or more, hot-rolled, without patterns in relief, of a thickness of less than 3mm",
  "720890":
    "Iron or non-alloy steel; flat-rolled, hot-rolled, of a width 600mm or more, n.e.c. in heading no. 7208",
  "720911":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, cold-rolled, thickness of 3mm or more and having a minimum yield point of 355MPa",
  "720912":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, cold-rolled, thickness exceeding 1mm but less than 3mm and having a minimum yield point of 275MPa",
  "720913":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, cold-rolled, thickness of 0.5mm or more but not exceeding 1mm and having a minimum yield point of 275MPa",
  "720914":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, cold-rolled, thickness less than 0.5mm and having a minimum yield point of 275MPa",
  "720915":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, cold-rolled, of a thickness of 3mm or more",
  "720916":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, cold-rolled, of a thickness exceeding 1mm but less than 3mm",
  "720917":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, cold-rolled, of a thickness of 0.5mm or more but not exceeding 1mm",
  "720918":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, cold-rolled, of a thickness of less than 0.5mm",
  "720921":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, cold-rolled, thickness 3mm or more, excluding minimum yield point of 355MPa",
  "720922":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, cold-rolled, thickness exceeding 1mm but less than 3mm, excluding minimum yield point of 275MPa",
  "720923":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, cold-rolled of a thickness of 0.5mm or more but not exceeding 1mm, excluding minimum yield point of 275MPa",
  "720924":
    "Iron or non-alloy steel; in coils, flat-rolled, width 600mm or more, cold-rolled of a thickness of less than 0.5mm, excluding minimum yield point of 275MPa",
  "720925":
    "Iron or non-alloy steel; (not in coils), flat-rolled, width 600mm or more, cold-rolled, of a thickness of 3mm or more",
  "720926":
    "Iron or non-alloy steel; (not in coils), flat-rolled, width 600mm or more, cold-rolled, of a thickness exceeding 1mm but less than 3mm",
  "720927":
    "Iron or non-alloy steel; (not in coils), flat-rolled, width 600mm or more, cold-rolled, of a thickness of 0.5mm or more but not exceeding 1mm",
  "720928":
    "Iron or non-alloy steel; (not in coils), flat-rolled, width 600mm or more, cold-rolled, of a thickness of less than 0.5mm",
  "720931":
    "Iron or non-alloy steel; not in coils, flat-rolled, width 600mm or more, cold-rolled of a thickness of 3mm or more, having a minimum yield point of 355MPa",
  "720932":
    "Iron or non-alloy steel; not in coils, flat-rolled, width 600mm or more, cold-rolled, thickness exceeding 1mm but less than 3mm, having a minimum yield point of 275MPa",
  "720933":
    "Iron or non-alloy steel; not in coils, flat-rolled, width 600mm or more, cold-rolled, thickness of 0.5mm or more but not exceeding 1mm, having a minimum yield point of 275MPa",
  "720934":
    "Iron or non-alloy steel; not in coils, flat-rolled, width 600mm or more, cold-rolled, thickness of less than 0.5mm, having a minimum yield point of 275MPa",
  "720941":
    "Iron or non-alloy steel; not in coils, flat-rolled, width 600mm or more, cold-rolled, thickness of 3mm or more, excluding minimum yield point of 355MPa",
  "720942":
    "Iron or non-alloy steel; not in coils, flat-rolled, width 600mm or more, cold-rolled, thickness exceeding 1mm but less than 3mm, excluding minimum yield point of 275MPa",
  "720943":
    "Iron or non-alloy steel; not in coils, flat-rolled, width 600mm or more, cold-rolled, thickness of 0.5mm or more but not exceeding 1mm, excluding minimum yield point of 275MPa",
  "720944":
    "Iron or non-alloy steel; not in coils, flat-rolled, width 600mm or more, cold-rolled, thickness less than 0.5mm, excluding minimum yield point of 275MPa",
  "720990":
    "Iron or non-alloy steel; flat-rolled, width 600mm or more, cold-rolled, n.e.c. in heading no. 7209",
  "721011":
    "Iron or non-alloy steel; flat-rolled, width 600mm or more, plated or coated with tin, thickness of 0.5mm or more",
  "721012":
    "Iron or non-alloy steel; flat-rolled, width 600mm or more, plated or coated with tin, thickness of less than 0.5mm",
  "721020":
    "Iron or non-alloy steel; flat-rolled, width 600mm or more, plated or coated with lead, including terne-plate",
  "721030":
    "Iron or non-alloy steel; flat-rolled, width 600mm or more, electrolytically plated or coated with zinc",
  "721031":
    "Iron or non-alloy steel; flat-rolled, width 600mm or more, less than 3mm thick with minimum yield point 275MPa or 3mm or more thick with minimum yield point of 355MPa, electrolytically coated with zinc",
  "721039":
    "Iron or non-alloy steel; flat-rolled, width 600mm or more, n.e.s. in item no. 7210.31, electrolytically plated or coated with zinc",
  "721041":
    "Iron or non-alloy steel; flat-rolled, width 600mm or more, corrugated, plated or coated with zinc (not electrolytically)",
  "721049":
    "Flat rolled iron or non-alloy steel; width >600mm, coated with zinc",
  "721050":
    "Iron or non-alloy steel; flat-rolled, width 600mm or more, plated or coated with chromium oxides or with chromium and chromium oxides",
  "721060":
    "Iron or non-alloy steel; flat-rolled, width 600mm or more, plated or coated with aluminium",
  "721061":
    "Iron or non-alloy steel; flat-rolled, width 600mm or more, plated or coated with aluminium zinc-alloys",
  "721069":
    "Iron or non-alloy steel; flat-rolled, width 600mm or more, plated or coated with aluminium, other than plated or coated with aluminium zinc-alloys",
  "721070":
    "Flat rolled iron or non-alloy steel; width >600mm, coated with plastics",
  "721090":
    "Iron or non-alloy steel; flat-rolled, width 600mm or more, plated or coated with materials n.e.c. in heading no. 7210",
  "721111":
    "Iron or non-alloy steel; flat-rolled, hot-rolled, width exceeding 150mm, 4mm or more thick, minimum yield point of 355MPa, not in coils and without patterns in relief",
  "721112":
    "Iron or non-alloy steel; flat-rolled, hot-rolled, 4.75mm or more thick, minimum yield point of 355MPa, width less than 600mm",
  "721113":
    "Iron or non-alloy steel; flat-rolled, hot-rolled, rolled on four faces or in a closed box pass, of a width more than 150mm but less than 600mm, 4mm thick or more, not in coils, without patterns in relief",
  "721114":
    "Iron or non-alloy steel; flat-rolled, hot-rolled, of a width less than 600mm, 4.75mm thick or more, excluding those of item no. 7211.13",
  "721119":
    "Iron or non-alloy steel; flat-rolled, hot-rolled, of a width less than 600mm, less than 4.75mm thick, excluding those of item no. 7211.13",
  "721121":
    "Iron or non-alloy steel; flat-rolled, hot-rolled, 4mm or more thick, width over 150mm but less than 600mm, not in coils and without patterns in relief",
  "721122":
    "Iron or non-alloy steel; flat-rolled, hot-rolled, 4.75mm or more thick, width less than 600mm",
  "721123":
    "Iron or non-alloy steel; flat-rolled, cold-rolled, of a width less than 600mm, containing by weight less than 0.25% of carbon",
  "721129":
    "Iron or non-alloy steel; flat-rolled, cold-rolled, of a width less than 600mm, containing by weight 0.25% or more of carbon",
  "721130":
    "Iron or non-alloy steel; flat-rolled, cold-rolled, width less than 600mm, less than 3mm thick with minimum yield point of 275MPa or 3mm or more thick with minimum yield point of 355MPa",
  "721141":
    "Iron or non-alloy steel; flat-rolled, cold-rolled, width less than 600mm, containing by weight less than 0.25% of carbon",
  "721149":
    "Iron or non-alloy steel; flat-rolled, cold-rolled, containing by weight 0.25% or more of carbon, width less than 600mm",
  "721190":
    "Iron or non-alloy steel; flat-rolled, n.e.c. in heading no. 7211, width less than 600mm",
  "721210":
    "Iron or non-alloy steel; flat-rolled, width less than 600mm, plated or coated with tin",
  "721220":
    "Iron or non-alloy steel; flat-rolled, of a width less than 600mm, electrolytically plated or coated with zinc",
  "721221":
    "Iron or non-alloy steel; flat-rolled, width less than 600mm, less than 3mm thick with minimum yield point 275MPa or 3mm or more thick with minimum yield point 355MPa, electrolytically coated with zinc",
  "721229":
    "Iron or non-alloy steel; flat-rolled, width less than 600mm, electrolytically plated or coated with zinc",
  "721230":
    "Iron or non-alloy steel; flat-rolled, width less than 600mm, plated or coated with zinc (not electrolytically)",
  "721240":
    "Iron or non-alloy steel; flat-rolled, width less than 600mm, painted, varnished or coated with plastics",
  "721250":
    "Iron or non-alloy steel; flat-rolled, width less than 600mm, plated or coated, (excluding tin, zinc or plastic)",
  "721260": "Iron or non-alloy steel; flat-rolled, width less than 600mm, clad",
  "721310":
    "Iron or non-alloy steel; bars and rods, hot-rolled, in irregularly wound coils, containing indentations, ribs, grooves or other deformations produced during the rolling process",
  "721320":
    "Iron or non-alloy steel; bars and rods, hot-rolled, in irregularly wound coils, of free-cutting steel",
  "721331":
    "Iron or non-alloy steel; bars and rods, hot-rolled, in irregularly wound coils, containing by weight less than 0.25% of carbon, of circular cross-section measuring less than 14mm in diameter",
  "721339":
    "Iron or non-alloy steel; bars and rods, hot-rolled, in irregularly wound coils, containing by weight less than 0.25% of carbon, not of circular cross-section measuring less than 14mm in diameter",
  "721341":
    "Iron or non-alloy steel; bars and rods, hot-rolled, in irregularly wound coils, containing by weight 0.25% or more but less than 0.6% of carbon, of circular cross-section less than 14mm in diameter",
  "721349":
    "Iron or non-alloy steel; bars and rods, hot-rolled, in irregularly wound coils, containing by weight 0.25% or more but less than 0.6% of carbon, other than circular cross-section less than 14mm in diameter",
  "721350":
    "Iron or non-alloy steel; bars and rods, hot-rolled, in irregularly wound coils, containing by weight 0.6% or more of carbon",
  "721391":
    "Iron or non-alloy steel; bars and rods, hot-rolled, in irregularly wound coils, n.e.c. in heading no. 7213, of circular cross-section measuring less than 14mm in diameter",
  "721399":
    "Iron or non-alloy steel; bars and rods, hot-rolled, in irregularly wound coils, n.e.c. in heading no. 7213, of circular cross-section measuring 14mm or more in diameter",
  "721410":
    "Iron or non-alloy steel; bars and rods, forged, hot-rolled, hot-drawn or hot-extruded, but including those twisted after rolling",
  "721420":
    "Iron or non-alloy steel bars and rods; hot-rolled, hot-drawn or hot-extruded, uneven surface",
  "721430":
    "Iron or non-alloy steel; bars and rods, hot-rolled, hot-drawn or hot-extruded, including those twisted after rolling, of free-cutting steel",
  "721440":
    "Iron or non-alloy steel; bars and rods, hot-rolled, hot-drawn or hot-extruded, containing by weight less than 0.25% of carbon, including those twisted after rolling",
  "721450":
    "Iron or non-alloy steel; bars and rods, hot-rolled, hot-drawn or hot-extruded, containing by weight 0.25% or more but less than 0.6% of carbon, including those twisted after rolling",
  "721460":
    "Iron or non-alloy steel; bars and rods, hot-rolled, hot-drawn or hot-extruded, containing by weight 0.6% or more of carbon, including those twisted after rolling",
  "721491":
    "Iron or non-alloy steel; bars and rods, hot-rolled, hot-drawn or hot-extruded, n.e.c. in heading no. 7214, of rectangular (other than square) cross-section",
  "721499":
    "Iron or non-alloy steel; bars and rods, hot-rolled, hot-drawn or hot-extruded, n.e.c. in heading no. 7214, other than of rectangular cross-section",
  "721510":
    "Iron or non-alloy steel; bars and rods, of free-cutting steel, cold-formed or cold-finished, n.e.c. in chapter 72",
  "721520":
    "Iron or non-alloy steel; bars and rods, cold-formed or cold-finished, containing by weight less than 0.25% of carbon",
  "721530":
    "Iron or non-alloy steel; bars and rods, cold-formed or cold-finished, containing by weight 0.25% or more but less than 0.6% of carbon",
  "721540":
    "Iron or non-alloy steel; bars and rods, cold-formed or cold-finished, containing by weight 0.6% or more of carbon",
  "721550":
    "Iron or non-alloy steel; bars and rods, n.e.c. in chapter 72, cold-formed or cold-finished, (not free-cutting)",
  "721590":
    "Iron or non-alloy steel; bars and rods, n.e.c. in chapter 72, n.e.c. in heading no. 7215",
  "721610":
    "Iron or non-alloy steel; U, I or H sections, hot-rolled, hot-drawn or extruded, of a height of less than 80mm",
  "721621":
    "Iron or non-alloy steel; L sections, hot-rolled, hot-drawn or extruded, of a height of less than 80mm",
  "721622":
    "Iron or non-alloy steel; T sections, hot-rolled, hot-drawn or extruded, of a height less than 80mm",
  "721631":
    "Iron or non-alloy steel; U sections, hot-rolled, hot-drawn or extruded, of a height of 80mm or more",
  "721632":
    "Iron or non-alloy steel; I sections, hot-rolled, hot-drawn or extruded, of a height of 80mm or more",
  "721633":
    "Iron or non-alloy steel; H sections, hot-rolled, hot-drawn or extruded, of a height of 80mm or more",
  "721640":
    "Iron or non-alloy steel; L or T sections, hot-rolled, hot-drawn or extruded, of a height of 80mm or more",
  "721650":
    "Iron or non-alloy steel; angles, shapes and sections, n.e.c. in heading no. 7216, hot-rolled, hot-drawn or extruded",
  "721660":
    "Iron or non-alloy steel; angles, shapes and sections, n.e.s. in heading no.7216, cold-formed or cold-finished",
  "721661":
    "Iron or non-alloy steel; angles, shapes and sections, cold-formed or cold-finished, obtained from flat-rolled products",
  "721669":
    "Iron or non-alloy steel; angles, shapes and sections, cold-formed or cold-finished, (not obtained from flat-rolled products)",
  "721690":
    "Iron or non-alloy steel; angles, shapes and sections n.e.s. in heading no. 7216",
  "721691":
    "Iron or non-alloy steel; angles, shapes and sections, n.e.c. in heading no. 7216, cold-formed or cold-finished, from flat-rolled products",
  "721699":
    "Iron or non-alloy steel; angles, shapes and sections, n.e.c. in heading no. 7216",
  "721710":
    "Iron or non-alloy steel; wire, (not plated or coated), whether or not polished",
  "721711":
    "Iron or non-alloy steel; wire, containing by weight less than 0.25% of carbon, not plated or coated, whether or not polished",
  "721712":
    "Iron or non-alloy steel; wire, containing by weight less than 0.25% of carbon, plated or coated with zinc",
  "721713":
    "Iron or non-alloy steel; wire, containing by weight less than 0.25% of carbon, plated or coated with base metals, excluding zinc",
  "721719":
    "Iron or non-alloy steel; wire, containing by weight less than 0.25% of carbon, plated or coated with materials n.e.s. in item no. 7217.1",
  "721720": "Iron or non-alloy steel; wire, plated or coated with zinc",
  "721721":
    "Iron or non-alloy steel; wire, containing by weight 0.25% or more but less than 0.6% of carbon, not plated or coated, whether or not polished",
  "721722":
    "Iron or non-alloy steel; wire, containing by weight 0.25% or more but less than 0.6% of carbon, plated or coated with zinc",
  "721723":
    "Iron or non-alloy steel; wire, containing by weight 0.25% or more but less than 0.6% of carbon, plated or coated with base metals, excluding zinc",
  "721729":
    "Iron or non-alloy steel; wire, containing by weight 0.25% or more but less than 0.6% of carbon, plated or coated with materials n.e.s. in item no. 7217.2",
  "721730":
    "Iron or non-alloy steel; wire, plated or coated with base metals (other than zinc)",
  "721731":
    "Iron or non-alloy steel; wire, containing by weight 0.6% or more of carbon, not plated or coated, whether or not polished",
  "721732":
    "Iron or non-alloy steel; wire, containing by weight 0.6% or more of carbon, plated or coated with zinc",
  "721733":
    "Iron or non-alloy steel; wire, containing by weight 0.6% or more of carbon, plated or coated with base metals, excluding zinc",
  "721739":
    "Iron or non-alloy steel; wire, containing by weight 0.6% or more of carbon, plated or coated with materials n.e.s. in item no. 7217.3",
  "721790": "Iron or non-alloy steel; wire, n.e.c. in heading no. 7217",
  "721810": "Steel, stainless; ingots and other primary forms",
  "721890": "Steel, stainless; semi-finished products",
  "721891":
    "Steel, stainless; semi-finished products, of rectangular (other than square) cross-section",
  "721899":
    "Steel, stainless; semi-finished products, other than of rectangular cross-section",
  "721911":
    "Steel, stainless; flat-rolled, width 600mm or more, hot-rolled, in coils, of a thickness exceeding 10mm",
  "721912":
    "Steel, stainless; flat-rolled, width 600mm or more, hot-rolled, in coils, of a thickness of 4.75mm or more but not exceeding 10mm",
  "721913":
    "Steel, stainless; flat-rolled, width 600mm or more, hot-rolled, in coils, of a thickness of 3mm or more but less than 4.75mm",
  "721914":
    "Steel, stainless; flat-rolled, width 600mm or more, hot-rolled, in coils, of a thickness of less than 3mm",
  "721921":
    "Steel, stainless; flat-rolled, width 600mm or more, hot-rolled, (not in coils), of a thickness exceeding 10mm",
  "721922":
    "Steel, stainless; flat-rolled, width 600mm or more, hot-rolled, (not in coils), of a thickness of 4.75mm or more but not exceeding 10mm",
  "721923":
    "Steel, stainless; flat-rolled, width 600mm or more, hot-rolled, (not in coils), of a thickness of 3mm or more but less than 4.75mm",
  "721924":
    "Steel, stainless; flat-rolled, width 600mm or more, hot-rolled, (not in coils), of a thickness of less than 3mm",
  "721931":
    "Steel, stainless; flat-rolled, width 600mm or more, cold-rolled or cold-reduced, of a thickness of 4.75mm or more",
  "721932":
    "Steel, stainless; flat-rolled, width 600mm or more, cold-rolled, of a thickness of 3mm or more but less than 4.75mm",
  "721933":
    "Steel, stainless; flat-rolled, width 600mm or more, cold-rolled, of a thickness exceeding 1mm but less than 3mm",
  "721934":
    "Steel, stainless; flat-rolled, width 600mm or more, cold-rolled, of a thickness of 0.5mm or more but not exceeding 1mm",
  "721935":
    "Steel, stainless; flat-rolled, width 600mm or more, cold-rolled, of a thickness of less than 0.5mm",
  "721990":
    "Steel, stainless; flat-rolled, width 600mm or more, n.e.c. in heading no. 7219",
  "722011":
    "Steel, stainless; flat-rolled, width less than 600mm, hot-rolled, of a thickness of 4.75mm or more",
  "722012":
    "Steel, stainless; flat-rolled, width less than 600mm, hot-rolled, of a thickness of less than 4.75mm",
  "722020": "Steel, stainless; flat-rolled, width less than 600mm, cold-rolled",
  "722090":
    "Steel, stainless; flat-rolled, width less than 600mm, n.e.c. in heading no 7220",
  "722100":
    "Steel, stainless; bars and rods, hot-rolled, in irregularly wound coils",
  "722210":
    "Steel, stainless; bars and rods, hot-rolled, hot-drawn or extruded",
  "722211":
    "Steel, stainless; bars and rods, hot-rolled, hot-drawn or extruded, of circular cross-section",
  "722219":
    "Steel, stainless; bars and rods, hot-rolled, hot-drawn or extruded, other than of circular cross-section",
  "722220": "Steel, stainless; bars and rods, cold-formed or cold-finished",
  "722230": "Steel, stainless; bars and rods, n.e.c. in heading no. 7222",
  "722240": "Steel, stainless; angles, shapes and sections",
  "722300": "Steel, stainless; wire",
  "722410": "Steel, alloy; ingots and other primary forms",
  "722490": "Steel, alloy; semi-finished products",
  "722510":
    "Steel, alloy; flat-rolled, width 600mm or more, of silicon-electrical steel",
  "722511":
    "Steel, alloy; flat-rolled, width 600mm or more, of silicon-electrical steel, grain-oriented",
  "722519":
    "Steel, alloy; flat-rolled, width 600mm or more, of silicon-electrical steel, (other than grain-oriented)",
  "722520":
    "Steel, alloy; flat-rolled, width 600mm or more, of high speed steel",
  "722530":
    "Steel, alloy; flat-rolled, width 600mm or more, hot-rolled, in coils",
  "722540":
    "Steel, alloy; flat-rolled, width 600mm or more, hot-rolled, not in coils",
  "722550": "Steel, alloy; flat-rolled, width 600mm or more, cold-rolled",
  "722590":
    "Steel, alloy; flat-rolled, width 600mm or more, n.e.s. in heading no. 7225",
  "722591":
    "Steel, alloy; flat-rolled, width 600mm or more, n.e.c. in heading no. 7225, electrolytically plated or coated with zinc",
  "722592":
    "Steel, alloy; flat-rolled, width 600mm or more, n.e.c. in heading no. 7225, plated or coated with zinc (other than electrolytically)",
  "722599":
    "Steel, alloy; flat-rolled, width 600mm or more, n.e.c. in heading no. 7225, (other than plated or coated with zinc)",
  "722610":
    "Steel, alloy; flat-rolled, width less than 600mm, of silicon-electrical steel",
  "722611":
    "Steel, alloy; flat-rolled, width less than 600mm, of silicon-electrical steel, grain-oriented",
  "722619":
    "Steel, alloy; flat-rolled, width less than 600mm, of silicon-electrical steel, other than grain-oriented",
  "722620":
    "Steel, alloy; flat-rolled, width less than 600mm, of high speed steel",
  "722691":
    "Steel, alloy; flat-rolled, width less than 600mm, (excluding silicon-electrical or high speed steel), hot-rolled",
  "722692":
    "Steel, alloy; flat-rolled, width less than 600mm, (excluding silicon-electrical or high speed steel), cold-rolled",
  "722693":
    "Steel, alloy; flat-rolled, width less than 600mm, n.e.s. in heading no. 7226, electrolytically plated or coated with zinc",
  "722694":
    "Steel, alloy; flat-rolled, width less than 600mm, n.e.s. in heading no. 7226, plated or coated with zinc (other than electrolytically)",
  "722699":
    "Steel, alloy; flat-rolled, width less than 600mm, n.e.c. in item no. 7226.9",
  "722710":
    "Steel, alloy; bars and rods, hot-rolled, in irregularly wound coils, of high speed steel",
  "722720":
    "Steel, alloy; bars and rods, hot-rolled, in irregularly wound coils, of silico-manganese steel",
  "722790":
    "Steel, alloy; bars and rods, hot-rolled, in irregularly wound coils, n.e.c. in heading no. 7227",
  "722810": "Steel, alloy; bars and rods, of high speed steel",
  "722820": "Steel, alloy; bars and rods, of silico-manganese steel",
  "722830": "Steel, alloy; bars and rods, hot-rolled, hot-drawn or extruded",
  "722840": "Steel, alloy; bars and rods, forged",
  "722850": "Steel, alloy; bars and rods, cold-formed or cold-finished",
  "722860": "Steel, alloy; bars and rods n.e.c. in heading no. 7228",
  "722870": "Steel, alloy; angles, shapes and sections",
  "722880": "Steel, alloy or non-alloy; hollow drill bars and rods",
  "722910": "Steel, alloy; wire, of high speed steel",
  "722920": "Steel, alloy; wire, of silico-manganese steel",
  "722990":
    "Steel, alloy; wire, of materials other than silico-manganese steel",
  "730110":
    "Iron or steel; sheet piling, whether or not drilled, punched or made from assembled elements",
  "730120": "Iron or steel; angles, shapes and sections, welded",
  "730210":
    "Iron or steel, railway or tramway track construction material; rails",
  "730220":
    "Iron or steel, railway or tramway track construction material; sleepers (cross-ties)",
  "730230":
    "Iron or steel, railway or tramway track construction material; switch blades, crossing frogs, point rods and other crossing pieces",
  "730240":
    "Iron or steel, railway or tramway track construction material; fish-plates and sole plates",
  "730290":
    "Iron or steel, railway or tramway track construction material; n.e.c. in heading no. 7302",
  "730300": "Cast iron; tubes, pipes and hollow profiles",
  "730410":
    "Iron or steel (other than cast iron); seamless, line pipe of a kind used for oil or gas pipelines",
  "730411":
    "Iron or steel (excluding cast iron); seamless, line pipe of a kind used for oil or gas pipelines, of stainless steel",
  "730419":
    "Iron or steel (excluding cast iron or stainless steel); seamless, line pipe of a kind used for oil or gas pipelines",
  "730420":
    "Iron or steel (other than cast iron); seamless casing, tubing and drill pipe, of a kind used in drilling for oil or gas",
  "730421":
    "Iron or steel; drill pipe, of a kind used in drilling for oil or gas",
  "730422":
    "Steel, stainless; seamless, drill pipe, of a kind used in drilling for oil or gas",
  "730423":
    "Iron or steel (excluding cast iron or stainless steel); seamless, drill pipe, of a kind used in drilling for oil or gas",
  "730424":
    "Steel, stainless; seamless, casing and tubing, of a kind used in drilling for oil or gas",
  "730429":
    "Iron or steel (excluding cast iron or stainless steel); seamless, casing and tubing, of a kind used in drilling for oil or gas",
  "730431":
    "Iron or non-alloy steel (excluding cast iron); seamless, cold-drawn or cold-rolled, tubes, pipes and hollow profiles of circular cross-section",
  "730439":
    "Iron or non-alloy steel (excluding cast iron); seamless, (excluding cold-drawn or cold-rolled), tubes, pipes and hollow profiles of circular cross-section",
  "730441":
    "Steel, stainless; cold-drawn or cold-rolled (cold-reduced), tubes and pipes of circular cross-section",
  "730449":
    "Steel, stainless; (excluding cold-drawn or cold-rolled), tubes pipes and hollow profiles of circular cross-section",
  "730451":
    "Steel, alloy (not stainless steel); seamless, cold-drawn or cold-rolled (cold-reduced), tubes, pipes and hollow profiles of circular cross-section",
  "730459":
    "Steel, alloy (not stainless steel); (excluding cold-drawn or cold-rolled), tubes, pipes and hollow profiles of circular cross-section",
  "730490":
    "Iron or steel (excluding cast iron); seamless, tubes, pipes and hollow profiles, seamless, n.e.c. in heading no. 7304",
  "730511":
    "Iron or steel (excluding cast iron); line pipe of a kind used for oil or gas pipelines (not seamless), longitudinally submerged arc welded, having circular cross-sections, external diameter exceeds 406.4mm",
  "730512":
    "Iron or steel (excluding cast iron); line pipe of a kind used for oil or gas pipelines (not seamless), longitudinally welded (not submerged arc welded), having circular cross-sections, external diameter exceeds 406.4mm",
  "730519":
    "Iron or steel (excluding cast iron); line pipe of a kind used for oil or gas pipelines (not seamless), (not longitudinally welded), having circular cross-sections, external diameter exceeds 406.4mm",
  "730520":
    "Iron or steel (excluding cast iron); casing of a kind used in drilling for oil or gas (not seamless), having circular cross-sections, external diameter exceeds 406.4mm",
  "730531":
    "Iron or steel (excluding cast iron); tubes and pipes (other than line pipe or casing of a kind used for oil or gas pipelines), longitudinally welded, having circular cross-sections, external diameter exceeds 406.4mm, (not seamless)",
  "730539":
    "Iron or steel (excluding cast iron); tubes and pipes (other than line pipe or casing of a kind used for oil or gas pipelines), welded (not longitudinally welded), having circular cross-sections, external diameter exceeds 406.4mm, (not seamless)",
  "730590":
    "Iron or steel (excluding cast iron); tubes and pipes n.e.c. in heading no. 7305, having circular cross-sections, external diameter exceeds 406.4mm, (not seamless)",
  "730610":
    "Iron or steel; line pipe of a kind used for oil or gas pipelines, n.e.s.",
  "730611":
    "Steel; stainless; line pipe of a kind used for oil or gas pipelines n.e.c. in chapter 73, welded, (not seamless)",
  "730619":
    "Iron or steel (excluding cast iron); line pipe of a kind used for oil or gas pipelines (other than of stainless steel or seamless), n.e.c. in chapter 73",
  "730620":
    "Iron or steel; casing and tubing of a kind used in drilling for oil and gas, n.e.s.",
  "730621":
    "Steel, stainless; casing and tubing of a kind used in drilling for oil and gas, n.e.c. in chapter 73, welded, (not seamless)",
  "730629":
    "Iron or steel (excluding cast iron); casing and tubing of a kind used in drilling for oil and gas (other than stainless steel or seamless), n.e.c. in chapter 73",
  "730630":
    "Iron or non-alloy steel (excluding cast iron); tubes and pipes (not seamless), welded, of circular cross-section, n.e.c. in chapter 73",
  "730640":
    "Steel, stainless; tubes, pipes and hollow profiles, welded, of circular cross-section, n.e.c. in chapter 73",
  "730650":
    "Steel, alloy; tubes, pipes and hollow profiles (other than stainless steel or seamless), welded, of circular cross-section, n.e.c. in chapter 73",
  "730660":
    "Iron or steel; n.e.s. in heading no. 7306, tubes, pipes and hollow profiles, welded, of non-circular cross-section",
  "730661":
    "Iron or steel (excluding cast iron); tubes, pipes and hollow profiles (not seamless), welded, of square or rectangular cross-section, n.e.c. in chapter 73",
  "730669":
    "Iron or steel (excluding cast iron); tubes, pipes and hollow profiles (not seamless), n.e.c. in chapter 73, welded, of non-circular cross-section (not square or rectangular cross-section)",
  "730690":
    "Iron or steel (excluding cast iron); tubes, pipes and hollow profiles (not seamless), n.e.c. in chapter 73",
  "730711": "Cast iron; cast fittings, of non-malleable cast iron",
  "730719":
    "Iron or steel; cast fittings, other than of non-malleable cast iron",
  "730721":
    "Steel, stainless; tube or pipe fittings, flanges, of stainless steel",
  "730722":
    "Steel, stainless; tube or pipe fittings, threaded elbows, bends and sleeves",
  "730723": "Steel, stainless; tube or pipe fittings, butt welding fittings",
  "730729":
    "Steel, stainless; tube or pipe fittings, n.e.c. in item no. 7307.2",
  "730791":
    "Iron or steel; tube or pipe fittings, flanges, other than stainless steel",
  "730792":
    "Iron or steel; tube or pipe fittings, threaded elbows, bends and sleeves, other than stainless steel",
  "730793":
    "Iron or steel; tube or pipe fittings, butt welding fittings, other than stainless steel",
  "730799":
    "Iron or steel; tube or pipe fittings, n.e.c. in item no. 7307.9, other than stainless steel",
  "730810":
    "Iron or steel; structures and parts thereof, bridges and bridge-sections",
  "730820":
    "Iron or steel; structures and parts thereof, towers and lattice masts",
  "730830":
    "Iron or steel; structures and parts thereof, doors, windows and their frames and thresholds for doors",
  "730840":
    "Iron or steel; structures and parts thereof, props and similar equipment for scaffolding, shuttering or pit-propping",
  "730890": "Other iron or steel structures and parts (exclusionary category)",
  "730900":
    "Reservoirs, tanks, vats and similar containers; for any material (excluding compressed or liquefied gas), of iron or steel, capacity exceeding 300l, whether or not lined or heat insulated",
  "731010":
    "Tanks, casks, drums, cans, boxes and similar containers, for any material (excluding compressed or liquefied gas), 50l or more capacity but not exceeding 300l",
  "731021":
    "Cans; which are to be closed by soldering or crimping, for any material (excluding compressed or liquefied gas), less than 50l capacity, of iron or steel",
  "731029":
    "Tanks, casks, drums, boxes and similar containers for any material (excluding compressed or liquefied gas) less than 50l capacity, n.e.c. in item no. 7310.2, of iron or steel",
  "731100": "Containers for compressed or liquefied gas, of iron or steel",
  "731210":
    "Iron or steel; stranded wire, ropes and cables, not electrically insulated",
  "731290":
    "Iron or steel; plaited bands, slings and the like, not electrically insulated",
  "731300":
    "Iron of steel; barbed wire, twisted hoop or single flat wire and loosely twisted double wire, used for fencing",
  "731411":
    "Iron or steel; wire cloth (including endless bands), woven products, of stainless steel",
  "731412":
    "Iron or steel; woven cloth, endless bands for machinery, of stainless steel",
  "731413":
    "Iron or steel; woven cloth, endless bands for machinery, (not of stainless steel)",
  "731414":
    "Iron or steel; woven cloth, of stainless steel, (other than endless bands for machinery)",
  "731419": "Iron or steel; woven cloth, other than of stainless steel",
  "731420":
    "Iron or steel wire; grill, netting and fencing, welded at intersections, of wire with a maximum cross-sectional dimension of 3mm or more and mesh size 100cm2 or more",
  "731430":
    "Iron or steel wire; grill, netting and fencing, welded at intersections, n.e.s. in item no. 7314.2",
  "731431":
    "Iron or steel wire; grill, netting and fencing, welded at the intersection, n.e.c. in item no. 7314.20, plated or coated with zinc",
  "731439":
    "Iron or steel wire; grill, netting and fencing, welded at the intersection, n.e.c. in item no. 7314.20, (other than plated or coated with zinc)",
  "731441":
    "Iron or steel wire; grill, netting and fencing, plated or coated with zinc",
  "731442":
    "Iron or steel wire; grill, netting and fencing, coated with plastic",
  "731449":
    "Iron or steel wire; grill, netting and fencing, coated with materials other than zinc or plastic",
  "731450": "Iron or steel; expanded metal",
  "731511": "Chain; articulated link, roller, of iron or steel",
  "731512": "Chain; articulated link, (other than roller), of iron or steel",
  "731519": "Chain; articulated link parts, of iron or steel",
  "731520":
    "Chain; skid, articulated link chain and parts thereof, of iron or steel",
  "731581": "Chain; stud-link chain, of iron or steel",
  "731582": "Chain; welded link chain, of iron or steel",
  "731589": "Chain; n.e.c. in heading no. 7315, of iron or steel",
  "731590": "Chain; parts n.e.c. in heading no. 7315, of iron or steel",
  "731600": "Iron or steel; anchors, grapnels and parts thereof",
  "731700":
    "Iron or steel; nails, tacks, drawing pins, corrugated nails, staples (not those of heading no. 8305) and the like, with heads of other material or not, but excluding articles with heads of copper",
  "731811": "Iron or steel; threaded coach screws",
  "731812": "Iron or steel; threaded wood screws other than coach screws",
  "731813": "Iron or steel; threaded screw hooks and screw rings",
  "731814": "Iron or steel; threaded self-tapping screws",
  "731815":
    "Other iron or steel threaded screws and bolts (exclusionary category)",
  "731816": "Iron or steel; threaded nuts",
  "731819":
    "Iron or steel; threaded screws, bolts and nuts n.e.c. in item no. 7318.1",
  "731821": "Iron or steel; non-threaded spring washers and other lock washers",
  "731822": "Iron or steel; non-threaded washers, excluding spring and lock",
  "731823": "Iron or steel; non-threaded rivets",
  "731824": "Iron or steel; non-threaded cotters and cotter-pins",
  "731829": "Iron or steel; non-threaded articles, n.e.c. in item no. 7318.2",
  "731910":
    "Iron or steel; sewing, darning or embroidery needles, for use in the hand",
  "731920": "Safety pins, of iron or steel",
  "731930":
    "Pins (other than safety pins), of iron or steel, not elsewhere specified or included",
  "731940": "Safety pins and other pins; of iron or steel",
  "731990":
    "Sewing and knitting needles, bodkins, crochet hooks, embroidery stilettos and similar articles, for use in the hand, not elsewhere specified or included, of iron or steel",
  "732010": "Iron or steel; leaf-springs and leaves therefor",
  "732020": "Iron or steel; helical springs and leaves for springs",
  "732090": "Iron or steel; springs n.e.c. in heading no. 7320",
  "732111":
    "Cooking appliances and plate warmers; for gas fuel or for both gas and other fuels, of iron or steel",
  "732112":
    "Cooking appliances and plate warmers; for liquid fuel, of iron or steel",
  "732113":
    "Cooking appliances and plate warmers; for solid fuel, of iron or steel",
  "732119":
    "Cooking appliances and plate warmers; for solid fuel and fuels other than gas or liquid, of iron or steel",
  "732181":
    "Domestic appliances; non-electric, (other than cookers and plate warmers), for gas fuel or for both gas and other fuels, of iron or steel",
  "732182":
    "Domestic appliances; non-electric, (other than cookers and plate warmers), for liquid fuel, of iron or steel",
  "732183":
    "Domestic appliances; non-electric, (other than cookers and plate warmers), for solid fuel, of iron or steel",
  "732189":
    "Domestic appliances; non-electric, (other than cookers and plate warmers), for solid fuel and fuels other than gas or liquid, of iron or steel",
  "732190":
    "Domestic appliances; non-electric, parts thereof, of iron or steel",
  "732211":
    "Radiators and parts thereof; for central heating, (not electrically heated), of cast iron",
  "732219":
    "Radiators and parts thereof; for central heating, (not electrically heated), of iron or steel other than cast iron",
  "732290":
    "Air heaters and hot air distributors, (not electrically heated), incorporating a motor-driven fan or blower and parts thereof, of iron or steel",
  "732310":
    "Iron or steel; wool, pot scourers and scouring or polishing pads, gloves and the like",
  "732391":
    "Cast iron; table, kitchen and other household articles and parts thereof, of cast iron, not enamelled",
  "732392":
    "Cast iron; table, kitchen and other household articles and parts thereof, of cast iron, enamelled",
  "732393":
    "Steel, stainless; table, kitchen and other household articles and parts thereof",
  "732394":
    "Iron (excluding cast) or steel; table, kitchen and other household articles and parts thereof, enamelled",
  "732399":
    "Iron or steel; table, kitchen and other household articles and parts thereof, of iron or steel n.e.c. in heading no. 7323",
  "732410": "Steel; sinks and wash basins, of stainless steel",
  "732421": "Cast iron, baths, whether or not enamelled",
  "732429": "Iron (other than cast) or steel; baths",
  "732490":
    "Iron or steel; sanitary ware and parts thereof, excluding sinks, wash basins and baths",
  "732510": "Iron; articles of non-malleable cast iron",
  "732591":
    "Iron; grinding balls and similar articles for mills, other than of non-malleable cast iron",
  "732599":
    "Iron or steel; cast articles, excluding grinding balls and similar articles for mills, other than of non-malleable cast iron",
  "732611":
    "Iron or steel; grinding balls and similar articles for mills, forged or stamped, but not further worked",
  "732619":
    "Iron or steel; articles n.e.c. in item no. 7326.11, forged or stamped, but not further worked",
  "732620": "Iron or steel; wire articles",
  "732690": "Other iron or steel articles (exclusionary category)",
  "740100": "Copper mattes; cement copper (precipitated copper)",
  "740110": "Copper; copper mattes",
  "740120": "Copper; cement copper (precipitated copper)",
  "740200": "Copper; copper anodes for electrolytic refining, unrefined",
  "740311": "Copper cathodes and sections of cathodes; refined, unwrought",
  "740312": "Copper; refined, unwrought, wire-bars",
  "740313": "Copper; refined, unwrought, billets",
  "740319": "Copper; refined, unwrought, n.e.c. in item no. 7403.1",
  "740321": "Copper; copper-zinc base alloys (brass) unwrought",
  "740322": "Copper; copper-tin base alloys (bronze) unwrought",
  "740323":
    "Copper; copper-nickel base alloys (cupro-nickel) or copper-nickel-zinc base alloys (nickel silver) unwrought",
  "740329":
    "Copper; copper alloys n.e.c. in heading no. 7403 (other than master alloys of heading no. 7405)",
  "740400": "Copper waste and scrap",
  "740500": "Copper; master alloys of copper",
  "740610": "Copper; powders of non-lamellar structure",
  "740620": "Copper; powders of lamellar structure, flakes",
  "740710": "Copper; bars, rods and profiles, of refined copper",
  "740721":
    "Copper; bars, rods and profiles, of copper-zinc base alloys (brass)",
  "740722":
    "Copper; bars, rods and profiles, of copper-nickel base alloys (cupro-nickel) or copper-nickel-zinc base alloys (nickel silver)",
  "740729":
    "Copper; bars, rods and profiles, of copper alloys (other than copper-zinc base alloys)",
  "740811": "Refined copper wire; cross-section >6mm",
  "740819":
    "Copper; wire, of refined copper, of which the maximum cross-sectional dimension is 6mm or less",
  "740821": "Copper; wire, of copper-zinc base alloys (brass)",
  "740822":
    "Copper; wire, of copper-nickel base alloys (cupro-nickel) or copper-nickel-zinc base alloys (nickel silver)",
  "740829":
    "Copper; wire, of copper alloys (other than copper-zinc base alloys, copper-nickel base alloys or copper-nickel-zinc base alloys)",
  "740911":
    "Copper; strip, of a thickness exceeding 0.15mm, of refined copper, in coils",
  "740919":
    "Copper; plates and sheets, of a thickness exceeding 0.15mm, of refined copper, not in coils",
  "740921":
    "Copper; strip, of a thickness exceeding 0.15mm, of copper-zinc base alloys (brass), in coils",
  "740929":
    "Copper; plates and sheets, of a thickness exceeding 0.15mm, of copper-zinc base alloys (brass), not in coils",
  "740931":
    "Copper; strip, of a thickness exceeding 0.15mm, of copper-tin base alloys (bronze), in coils",
  "740939":
    "Copper; plates and sheets, of a thickness exceeding 0.15mm, of copper-tin base alloys, not in coils",
  "740940":
    "Copper; plates, sheets and strip, of a thickness exceeding 0.15mm, of copper-nickel base alloys (cupro-nickel) or copper-nickel-zinc base alloys (nickel silver)",
  "740990":
    "Copper; plates, sheets and strip, of a thickness exceeding 0.15mm, of copper alloys (other than copper-zinc base alloys, copper-tin base alloys, copper-nickel base alloys or copper-nickel-zinc base alloys)",
  "741011":
    "Copper; foil, not backed, of a thickness not exceeding 0.15mm, of refined copper",
  "741012":
    "Copper; foil, not backed, of a thickness not exceeding 0.15mm, of copper alloys",
  "741021":
    "Copper; foil, backed with paper, paperboard, plastics or similar backing material, of a thickness (excluding any backing) not exceeding 0.15mm, of refined copper",
  "741022":
    "Copper; foil, backed with paper, paperboard, plastics or similar backing material, of a thickness (excluding any backing) not exceeding 0.15mm, of copper alloys",
  "741110": "Copper; tubes and pipes, of refined copper",
  "741121": "Copper; tubes and pipes, of copper-zinc base alloys (brass)",
  "741122":
    "Copper; tubes and pipes, of copper-nickel base alloys (cupro-nickel) or copper-nickel-zinc base alloys (nickel silver)",
  "741129":
    "Copper; tubes and pipes, of copper alloys (other than copper-zinc, copper-nickel base alloys (cupro-nickel) or copper-nickel-zinc base alloys (nickel-silver))",
  "741210":
    "Copper; tube or pipe fittings (e.g. couplings, elbows, sleeves) of refined copper",
  "741220":
    "Copper; tube or pipe fittings (e.g. couplings, elbows, sleeves) of copper alloys",
  "741300":
    "Copper; stranded wire, cables, plaited bands and the like, not electrically insulated",
  "741410": "Copper; cloth, endless bands, for machinery, of copper wire",
  "741420": "Copper; cloth of copper wire",
  "741490":
    "Copper; grill and netting, of copper wire, expanded metal of copper",
  "741510":
    "Copper; nails and tacks, drawing pins, staples and similar articles of copper, or of iron or steel with copper heads",
  "741521": "Copper; washers, (including spring washers), not threaded",
  "741529":
    "Copper; rivets, cotters, cotter-pins and similar articles, not threaded",
  "741531": "Copper; screws for wood, threaded",
  "741532":
    "Copper; screws (excluding screws for wood), bolts and nuts, threaded",
  "741533": "Copper; screws, bolts and nuts, threaded",
  "741539": "Copper; articles n.e.c. in heading no. 7415",
  "741600": "Copper springs",
  "741700":
    "Copper; cooking or heating apparatus of a kind used for domestic purposes, non-electric, and parts thereof",
  "741810":
    "Copper; table, kitchen or other household articles and parts thereof; pot scourers and scouring or polishing pads, gloves and the like",
  "741811":
    "Copper; pot scourers and scouring or polishing pads, gloves and the like",
  "741819":
    "Copper; table, kitchen or other household articles and parts thereof, (other than pot scourers and scouring or polishing pads, gloves and the like)",
  "741820": "Copper; sanitary ware and parts thereof",
  "741910": "Copper; chain and parts thereof",
  "741920": "Copper; cast, moulded, stamped or forged, but not further worked",
  "741980": "Copper; articles thereof n.e.c. in chapter 74",
  "741991": "Copper; cast, moulded, stamped or forged, but not further worked",
  "741999": "Copper; articles n.e.c. in heading no. 7419",
  "750110": "Nickel; nickel mattes",
  "750120":
    "Nickel; oxide sinters and other intermediate products of nickel metallurgy",
  "750210": "Nickel; unwrought, not alloyed",
  "750220": "Nickel; unwrought, alloys",
  "750300": "Nickel; waste and scrap",
  "750400": "Nickel; powders and flakes",
  "750511": "Nickel; bars, rods and profiles, not alloyed",
  "750512": "Nickel; bars, rods and profiles, of nickel alloys",
  "750521": "Nickel; wire, not alloyed",
  "750522": "Nickel; wire, of nickel alloys",
  "750610": "Nickel; plates, sheets, strip and foil, not alloyed",
  "750620": "Nickel; plates, sheets, strip and foil, of nickel alloys",
  "750711": "Nickel; tubes and pipes, not alloyed",
  "750712": "Nickel; tubes and pipes, of nickel alloys",
  "750720": "Nickel; tube and pipe fittings",
  "750800": "Nickel; other articles thereof n.e.s.",
  "750810": "Nickel; cloth, grill and netting, of nickel wire",
  "750890": "Nickel; articles thereof n.e.c. in item no. 7508.1",
  "760110": "Aluminium unwrought; not alloyed",
  "760120": "Aluminium unwrought; alloyed",
  "760200": "Aluminium waste and scrap",
  "760310": "Aluminium; powders of non-lamellar structure",
  "760320": "Aluminium; powders of lamellar structure, flakes",
  "760410": "Aluminium; (not alloyed), bars, rods and profiles",
  "760421": "Aluminium; alloys, hollow profiles",
  "760429": "Aluminium; alloys, bars, rods and profiles, other than hollow",
  "760511":
    "Aluminium; (not alloyed), wire, maximum cross-sectional dimension exceeds 7mm",
  "760519":
    "Aluminium; (not alloyed), wire, maximum cross-sectional dimension is 7mm or less",
  "760521":
    "Aluminium; alloys, wire, maximum cross-sectional dimension exceeding 7mm",
  "760529":
    "Aluminium; alloys, wire, maximum cross-sectional dimension is 7mm or less",
  "760611":
    "Aluminium; plates, sheets and strip, thickness exceeding 0.2mm, (not alloyed), rectangular (including square)",
  "760612": "Aluminium alloy rectangular plate/sheet/strip; thickness >0.2mm",
  "760691":
    "Aluminium; plates, sheets and strip, thickness exceeding 0.2mm, not alloyed, (not rectangular or square)",
  "760692":
    "Aluminium; plates, sheets and strip, thickness exceeding 0.2mm, alloys, (not rectangular or square)",
  "760711":
    "Aluminium; foil, (not backed), rolled (but not further worked), of a thickness not exceeding 0.2mm",
  "760719":
    "Aluminium; foil, (not backed), of a thickness not exceeding 0.2mm, not rolled",
  "760720":
    "Aluminium; foil, backed with paper, paperboard, plastics or similar backing materials, of a thickness (excluding any backing) not exceeding 0.2mm",
  "760810": "Aluminium; tubes and pipes, not alloyed",
  "760820": "Aluminium; tubes and pipes, alloys",
  "760900":
    "Aluminium; tube or pipe fittings (e.g. couplings, elbows, sleeves)",
  "761010":
    "Aluminium; structures (excluding prefabricated buildings of heading no. 9406) and parts of structures, doors, windows and their frames and thresholds for doors",
  "761090":
    "Aluminium; structures (excluding prefabricated buildings of heading no. 9406) and parts of structures, n.e.c. in heading no. 7610, plates, rods, profiles, tubes and the like",
  "761100":
    "Aluminium; reservoirs, tanks, vats and similar containers, for material (not compressed or liquefied gas), of a capacity over 300l, whether or not lined, not fitted with mechanical/thermal equipment",
  "761210":
    "Aluminium; collapsible tubular containers, for any material, (not compressed or liquefied gas), 300l capacity or less, whether or not lined, not fitted with mechanical/thermal equipment",
  "761290":
    "Aluminium; casks, drums, cans, boxes and the like for any material (not compressed or liquefied gas), 300l capacity or less, whether or not lined or heat-insulated, no mechanical or thermal equipment",
  "761300": "Aluminium; containers for compressed or liquefied gas",
  "761410":
    "Aluminium; stranded wire, cables, plaited bands and the like, (not electrically insulated), with steel core",
  "761490":
    "Aluminium; stranded wire, cables, plaited bands and the like, (not electrically insulated), other than steel core",
  "761510":
    "Aluminium; table, kitchen or other household articles and parts thereof; pot scourers and scouring or polishing pads, gloves and the like",
  "761511":
    "Aluminium; pot scourers and scouring or polishing pads, gloves and the like",
  "761519":
    "Aluminium; table, kitchen or other household articles and parts thereof, n.e.c. in item no. 7615.11",
  "761520": "Aluminium; sanitary ware and parts thereof",
  "761610":
    "Aluminium; nails, tacks, staples (other than those of heading no. 8305), screws, bolts, nuts, screw hooks, rivets, cotters, cotter-pins, washers and similar articles",
  "761690": "Aluminium; articles n.e.s. in heading no. 7616",
  "761691": "Aluminium; cloth, grill, netting and fencing, of aluminium wire",
  "761699": "Other aluminium articles (exclusionary category)",
  "780110": "Lead; unwrought, refined",
  "780191":
    "Lead; unwrought, unrefined, containing by weight antimony as the principal other element",
  "780199":
    "Lead; unwrought, unrefined, not containing by weight antimony as the principal other element",
  "780200": "Lead; waste and scrap",
  "780300": "Lead; bars, rods, profiles and wire",
  "780411":
    "Lead; sheets, strip and foil, of a thickness (excluding any backing) not exceeding 0.2mm",
  "780419":
    "Lead; plates, sheets, strip and foil, of a thickness (excluding any backing) exceeding 0.2mm",
  "780420": "Lead; powders and flakes",
  "780500":
    "Lead; tubes, pipes and tube or pipe fittings (eg couplings, elbows, and sleeves)",
  "780600": "Lead; articles n.e.c. in chapter 78",
  "790111":
    "Zinc; unwrought, (not alloyed), containing by weight 99.99% or more of zinc",
  "790112":
    "Zinc; unwrought, (not alloyed), containing by weight less than 99.99% of zinc",
  "790120": "Zinc; unwrought, alloys",
  "790200": "Zinc; waste and scrap",
  "790310": "Zinc dust",
  "790390": "Zinc; powders and flakes",
  "790400": "Zinc; bars, rods, profiles and wire",
  "790500": "Zinc; plates, sheets, strip and foil",
  "790600":
    "Zinc; tubes, pipes and tube or pipe fittings (eg couplings, elbows, sleeves)",
  "790700": "Zinc; articles n.e.c. in chapter 79",
  "790710":
    "Zinc; gutters, roof capping, skylight frames and other fabricated building components",
  "790790": "Zinc; articles n.e.s. in chapter 79",
  "800110": "Tin; unwrought, not alloyed",
  "800120": "Tin; unwrought, alloys",
  "800200": "Tin; waste and scrap",
  "800300": "Tin; bars, rods, profiles and wire",
  "800400": "Tin; plates, sheets and strip, of a thickness exceeding 0.2mm",
  "800500":
    "Tin; foil (whether or not printed or backed with paper, paperboard, plastics or similar backing materials), of a thickness (excluding any backing) not exceeding 0.2mm, tin powders and flakes",
  "800510":
    "Tin foil; (whether or not printed or backed with paper, paperboard, plastics or similar backing materials), of a thickness (excluding any backing) not exceeding 0.2mm",
  "800520": "Tin; powders and flakes",
  "800600":
    "Tin; tubes, pipes and tube or pipe fittings (eg couplings, elbows, sleeves)",
  "800700": "Tin; articles n.e.c. in chapter 80",
  "810110":
    "Tungsten (wolfram); articles thereof, including waste and scrap, powders",
  "810191":
    "Tungsten (wolfram); unwrought, including bars and rods obtained simply by sintering, waste and scrap",
  "810192":
    "Tungsten (wolfram); bars and rods, other than those obtained simply by sintering, profiles, plates, sheets, strip and foil",
  "810193": "Tungsten (wolfram); wire",
  "810194":
    "Tungsten (wolfram); unwrought, including bars and rods obtained simply by sintering",
  "810195":
    "Tungsten (wolfram); bars and rods, other than those obtained simply by sintering, profiles, plates, sheets, strip and foil",
  "810196": "Tungsten (wolfram); wire",
  "810197": "Tungsten (wolfram); waste and scrap",
  "810199": "Tungsten (wolfram); articles n.e.c. in heading no. 8101",
  "810210": "Molybdenum; articles thereof, including waste and scrap, powders",
  "810291":
    "Molybdenum; unwrought, including bars and rods obtained simply by sintering, waste and scrap",
  "810292":
    "Molybdenum; bars and rods, other than those obtained simply by sintering, profiles, plates, sheets, strip and foil",
  "810293": "Molybdenum; wire",
  "810294":
    "Molybdenum; unwrought, including bars and rods obtained simply by sintering",
  "810295":
    "Molybdenum; bars and rods, other than those obtained simply by sintering, profiles, plates, sheets, strip and foil",
  "810296": "Molybdenum; wire",
  "810297": "Molybdenum; waste and scrap",
  "810299": "Molybdenum; articles n.e.c. in heading no. 8102",
  "810310":
    "Tantalum; unwrought, including bars and rods obtained simply by sintering, waste and scrap, powders",
  "810320":
    "Tantalum; unwrought, including bars and rods obtained simply by sintering, powders",
  "810330": "Tantalum; waste and scrap",
  "810390": "Tantalum; articles n.e.c. in heading no. 8103",
  "810391": "Tantalum; crucibles",
  "810399": "Tantalum; articles n.e.c. in heading no. 8103",
  "810411":
    "Magnesium; unwrought, containing at least 99.8% by weight of magnesium",
  "810419":
    "Magnesium; unwrought, containing less than 99.8% by weight of magnesium",
  "810420": "Magnesium; waste and scrap",
  "810430":
    "Magnesium; raspings, turnings and granules, graded according to size, powders",
  "810490": "Magnesium; articles n.e.c. in heading no. 8104",
  "810510":
    "Cobalt; mattes and other intermediate products of cobalt metallurgy, unwrought cobalt, waste and scrap, powders",
  "810520":
    "Cobalt; mattes and other intermediate products of cobalt metallurgy, unwrought cobalt, powders",
  "810530": "Cobalt; waste and scrap",
  "810590": "Cobalt; articles n.e.c. in heading no. 8105",
  "810600": "Bismuth; articles thereof, including waste and scrap",
  "810610":
    "Bismuth; articles thereof, including waste and scrap, containing more than 99.99% of bismuth, by weight",
  "810690":
    "Bismuth; including articles n.e.c. in heading 8106, including waste and scrap, containing less than or equal to 99.99% of bismuth, by weight",
  "810710": "Cadmium; unwrought, waste and scrap, powders",
  "810720": "Cadmium; unwrought, powders",
  "810730": "Cadmium; waste and scrap",
  "810790": "Cadmium; other than unwrought, n.e.c. in heading no. 8107",
  "810810": "Titanium; unwrought, waste and scrap",
  "810820": "Titanium; unwrought, powders",
  "810830": "Titanium; waste and scrap",
  "810890": "Titanium; other than unwrought, n.e.c. in heading no. 8108",
  "810910": "Zirconium; unwrought, waste and scrap, powders",
  "810920": "Zirconium; unwrought, powders",
  "810921":
    "Zirconium; unwrought, powders, containing less than 1 part hafnium to 500 parts zirconium by weight",
  "810929":
    "Zirconium; unwrought, powders, containing not less than 1 part hafnium to 500 parts zirconium by weight",
  "810930": "Zirconium; waste and scrap",
  "810931":
    "Zirconium; waste and scrap, containing less than 1 part hafnium to 500 parts zirconium by weight",
  "810939":
    "Zirconium; waste and scrap, containing not less than 1 part hafnium to 500 parts zirconium by weight",
  "810990": "Zirconium; other than unwrought, n.e.c. in heading no. 8109",
  "810991":
    "Zirconium; other than unwrought, n.e.c. in heading no. 8109, containing less than 1 part hafnium to 500 parts zirconium by weight",
  "810999":
    "Zirconium; other than unwrought, n.e.c. in heading no. 8109, containing not less than 1 part hafnium to 500 parts zirconium by weight",
  "811000": "Antimony; articles thereof, including waste and scrap",
  "811010": "Antimony and articles thereof; unwrought antimony, powders",
  "811020": "Antimony; waste and scrap",
  "811090":
    "Antimony and articles thereof; wrought, other than waste and scrap",
  "811100": "Manganese; articles thereof, including waste and scrap",
  "811211": "Beryllium; unwrought, waste and scrap, powders",
  "811212": "Beryllium and articles thereof; unwrought beryllium, powders",
  "811213": "Beryllium; waste and scrap",
  "811219":
    "Beryllium and articles thereof; wrought other than waste and scrap",
  "811220": "Chromium; including waste and scrap",
  "811221": "Chromium and articles thereof; unwrought chromium, powders",
  "811222": "Chromium; waste and scrap",
  "811229": "Chromium and articles thereof; wrought other than waste and scrap",
  "811230": "Germanium; including waste and scrap",
  "811231": "Hafnium and articles thereof; unwrought, powders, waste and scrap",
  "811239":
    "Hafnium and articles thereof; wrought, other than powders, waste and scrap",
  "811240": "Vanadium; including waste and scrap",
  "811241": "Rhenium and articles thereof; unwrought, powders, waste and scrap",
  "811249":
    "Rhenium and articles thereof; wrought, other than powders, waste and scrap",
  "811251": "Thallium and articles thereof; unwrought thallium, powders",
  "811252": "Thallium; waste and scrap",
  "811259":
    "Thallium and articles thereof; other than unwrought thallium, powders or waste and scrap",
  "811261": "Cadmium; waste and scrap",
  "811269": "Cadmium; other than waste and scrap",
  "811291":
    "Gallium, hafnium, indium, niobium (columbium), rhenium and thallium; articles thereof, unwrought, waste and scrap, powders",
  "811292":
    "Gallium, germanium, hafnium, indium, niobium (columbium), rhenium and vanadium; articles thereof, unwrought, including waste and scrap, powders",
  "811299":
    "Gallium, germanium, hafnium, indium, niobium (columbium), rhenium and vanadium; articles thereof, other than unwrought including waste and scrap and powders",
  "811300": "Cermets; articles thereof, including waste and scrap",
  "820110": "Tools, hand; spades and shovels",
  "820120": "Tools, hand; forks",
  "820130": "Tools, hand; mattocks, picks, hoes and rakes",
  "820140":
    "Tools, hand; axes, bill hooks and similar hewing tools, of a kind used in agriculture, horticulture or forestry",
  "820150": "Tools, hand; one-handed secateurs (including poultry shears)",
  "820160":
    "Tools, hand; hedge shears, two-handed pruning shears and similar two-handed shears",
  "820190":
    "Tools, hand; forks, scythes, sickles, hay knives, timber wedges, and other hand tools of a kind used in agriculture, horticulture or forestry n.e.c. in heading 8201",
  "820210": "Tools, hand; hand saws",
  "820220": "Tools, hand; band saw blades",
  "820231":
    "Tools, hand; circular saw blades (including slitting or slotting saw blades), with working part of steel",
  "820232":
    "Tools, hand; circular (including slitting or slotting) saw blades, with working part of materials other than steel",
  "820239":
    "Tools, hand; circular saw blades (including slitting or slotting saw blades), with working part of materials (other than steel)",
  "820240": "Tools, hand; chain saw blades",
  "820291": "Tools, hand; straight saw blades, for working metal",
  "820299": "Tools, hand; saw blades n.e.c. in heading no. 8202",
  "820310": "Tools, hand; files, rasps and similar tools",
  "820320":
    "Tools, hand; pliers (including cutting pliers), pincers, tweezers and similar tools",
  "820330": "Tools, hand; metal cutting shears and similar tools",
  "820340":
    "Tools, hand; pipe-cutters, bolt croppers, perforating punches and similar tools",
  "820411":
    "Tools, hand; hand-operated spanners and wrenches (including torque meter wrenches but not including tap wrenches), non-adjustable",
  "820412":
    "Tools, hand; hand-operated spanners and wrenches (including torque meter wrenches but not including tap wrenches), adjustable",
  "820420":
    "Tools, hand; interchangeable spanner sockets, with or without handles",
  "820510": "Tools, hand; drilling, threading or tapping tools",
  "820520": "Tools, hand; hammers and sledge hammers",
  "820530":
    "Tools, hand; planes, chisels, gauges and similar cutting tools for working wood",
  "820540": "Tools, hand; screwdrivers",
  "820551": "Tools, hand; household tools",
  "820559":
    "Tools, hand; other hand tools (including glaziers diamonds), excluding household tools, drilling, threading or tapping tools, hammers and sledge hammers, planes, chisels, gouges and similar cutting tools for working wood, and screwdrivers",
  "820560": "Tools, hand; blow lamps",
  "820570": "Tools, hand; vices, clamps and the like",
  "820580":
    "Tools, hand; anvils, portable forges, hand or pedal-operated grinding wheels with frameworks",
  "820590":
    "Tools, hand; n.e.c. in heading 8205, including anvils, portable forges, hand or pedal-operated grinding wheels with frameworks, and sets of articles of two or more of the subheadings in heading 8205",
  "820600":
    "Tools, hand; two or more of heading no. 8202 to 8205, put up in sets for retail sale",
  "820711":
    "Tools, interchangeable; rock drilling or earth-boring tools, whether or not power-operated, with working part of sintered metal carbide or cermets",
  "820712":
    "Tools, interchangeable; rock drilling or earth-boring tools, with working part of materials other than sintered metal carbide or cermets, for machine or hand tools, whether or not power-operated",
  "820713":
    "Tools, interchangeable; rock drilling or earth boring tools, with working part of cermets, whether or not power operated",
  "820719":
    "Tools, interchangeable; rock drilling or earth boring tools, with working part (other than of cermets), whether or not power operated, including parts",
  "820720":
    "Tools, interchangeable; (for machine or hand tools, whether or not power-operated), dies for drawing or extruding metal",
  "820730":
    "Tools, interchangeable; (for machine or hand tools, whether or not power-operated), tools for pressing, stamping or punching",
  "820740":
    "Tools, interchangeable; (for machine or hand tools, whether or not power-operated), tools for tapping or threading",
  "820750":
    "Tools, interchangeable; (for machine or hand tools, whether or not power-operated), tools for drilling (other than rock)",
  "820760":
    "Tools, interchangeable; (for machine or hand tools, whether or not power-operated), for boring or broaching",
  "820770":
    "Tools, interchangeable; (for machine or hand tools, whether or not power-operated), for milling",
  "820780":
    "Tools, interchangeable; (for machine or hand tools, whether or not power-operated), for turning",
  "820790":
    "Tools, interchangeable; (for machine or hand tools, whether or not power-operated), for screw-driving or uses n.e.c. in heading no. 8207",
  "820810":
    "Tools; knives and cutting blades, for machines or for mechanical appliances, for metal working",
  "820820":
    "Tools; knives and cutting blades, for wood working machines or mechanical appliances",
  "820830":
    "Tools; knives and cutting blades, for kitchen appliances or for machines used by the food industry",
  "820840":
    "Tools; knives and cutting blades, for agricultural, horticultural or forestry machines or mechanical appliances",
  "820890":
    "Tools; knives and cutting blades, for machines or mechanical appliances, n.e.c. in heading no. 8208",
  "820900":
    "Tools; plates, sticks, tips and the like for tools, unmounted, of sintered metal carbides or cermets",
  "821000":
    "Tools; hand-operated mechanical appliances, weighing 10kg or less, used in the preparation, conditioning or serving of food or drink",
  "821110":
    "Knives; with cutting blades, serrated or not (including pruning knives), sets of assorted articles, excluding knives and blades of heading no. 8208",
  "821191":
    "Knives; table knives, having fixed cutting blades, serrated or not, excluding knives and blades of heading no. 8208",
  "821192":
    "Knives; having fixed cutting blades, (other than table knives), serrated or not, excluding knives and blades of heading no. 8208",
  "821193":
    "Knives; with cutting blades, (having other than fixed blades), serrated or not, excluding knives and blades of heading no. 8208",
  "821194":
    "Blades; cutting, serrated or not, excluding those of heading no. 8208",
  "821195": "Knives; with handles of base metal",
  "821210": "Razors",
  "821220":
    "Razors; safety razor blades, including razor blade blanks in strips",
  "821290": "Razors; parts n.e.c. in heading no. 8212",
  "821300": "Scissors; tailors' shears, similar shears and blades therefore",
  "821410":
    "Cutlery; paper knives, letter openers, erasing knives, pencil sharpeners and blades therefore",
  "821420": "Manicure or pedicure sets and instruments; (including nail files)",
  "821490": "Cutlery; hair clippers and mincing knives",
  "821510":
    "Cutlery; sets of assorted articles (e.g. spoons, forks, ladles, skimmers, cake-servers, fish-knives, butter-knives, sugar tongs and similar), with at least one article plated with precious metal",
  "821520":
    "Cutlery; sets of assorted articles (e.g. spoons, forks, ladles, skimmers, cake-servers, fish-knives, butter knives, sugar tongs and similar), not plated with precious metal",
  "821591":
    "Cutlery; (e.g. spoons, forks, ladles, skimmers, cake-servers, fish-knives, butter-knives, sugar tongs and similar), plated with precious metal, not in sets",
  "821599": "Cutlery; other than plated with precious metal",
  "830110":
    "Padlocks; (key, combination or electrically operated), of base metal",
  "830120":
    "Locks; of a kind used for motor vehicles (key, combination or electrically operated), of base metal",
  "830130":
    "Locks; of a kind used for furniture (key, combination or electrically operated), of base metal",
  "830140":
    "Locks; (other than those for motor vehicles or furniture), (key, combination or electrically operated), of base metal",
  "830150": "Clasps and frames with clasps; incorporating locks, of base metal",
  "830160":
    "Locks; parts of padlocks, locks, clasps and frames with clasps incorporating locks, of base metal",
  "830170": "Keys; presented separately, of base metal",
  "830210":
    "Hinges; suitable for furniture, doors, staircases, windows, blinds, coachwork, saddlery, trunks, chests, caskets or the like, of base metal",
  "830220": "Castors; with mountings, of base metal",
  "830230":
    "Mountings, fittings and similar articles; for motor vehicles, of base metal",
  "830241":
    "Mountings, fittings and similar articles; of base metal, suitable for buildings",
  "830242":
    "Mountings, fittings and similar articles; suitable for furniture of base metal",
  "830249":
    "Mountings, fittings and similar articles; suitable for other than buildings or furniture, of base metal",
  "830250": "Hat-racks, hat-pegs, brackets and similar fixtures, of base metal",
  "830260": "Automatic door closures; of base metal",
  "830300":
    "Safes; armoured or reinforced, strong-boxes, doors and safe deposit lockers for strong-rooms, cash or deed boxes and the like, of base metal",
  "830400":
    "Office equipment; filing cabinets, card-index cabinets, paper trays, paper rests, pen trays, office-stamp stands and similar office or desk equipment, of base metal, other than office furniture of heading no. 9403",
  "830510":
    "Stationery; fittings for loose-leaf binders or files, of base metal",
  "830520":
    "Stationery; staples in strips, (e.g. for offices, upholstery, packaging), of base metal",
  "830590":
    "Stationery; letter clips, letter corners, paper clips, indexing tags and similar office articles, including parts, of base metal",
  "830610": "Bells, gongs and the like; non-electric, of base metal",
  "830621":
    "Statuettes and other ornaments; of base metal plated with precious metal",
  "830629":
    "Statuettes and other ornaments; of base metal other than plated with precious metal",
  "830630": "Photograph, picture or similar frames, mirrors; of base metal",
  "830710": "Tubing; flexible, with or without fittings, of iron or steel",
  "830790":
    "Tubing; flexible, with or without fittings of base metal, other than those of iron or steel",
  "830810":
    "Hooks, eyes and eyelets; of base metal, of a kind used for clothing, footwear, awnings, handbags, travel goods or other made up articles",
  "830820": "Rivets; tubular or bifurcated, of base metal",
  "830890":
    "Clasps, frames with clasps, buckles, buckle clasps; of base metal, of a kind used for clothing & accessories, footwear, jewellery, wrist-watches, books, awnings, leather goods, travel goods, saddlery etc, including parts",
  "830910": "Stoppers; corks, of base metal",
  "830990": "Stoppers; caps and lids, of base metal",
  "831000":
    "Sign plates, name-plates, address-plates and similar plates, numbers, letters and other symbols; of base metal, excluding those of heading no. 9405",
  "831110": "Electrodes; coated, of base metal, for electric arc-welding",
  "831120": "Wire; cored, of base metal, for electric arc-welding",
  "831130":
    "Rods and wire; coated rods and cored wire, of base metal, for soldering, brazing or welding by flame",
  "831190":
    "Wires, rods, tubes, plates, electrodes of base metal or metal carbides; of a kind used for soldering, brazing, welding; wires and rods for metal spraying; n.e.c. in item no. 8311",
  "840110": "Nuclear reactors",
  "840120":
    "Machinery and apparatus; for isotopic separation, and parts thereof",
  "840130": "Fuel elements (cartridges); non-irradiated",
  "840140": "Nuclear reactors; parts thereof",
  "840211":
    "Boilers; watertube boilers with a steam production exceeding 45t per hour",
  "840212":
    "Boilers; watertube boilers with a steam production not exceeding 45t per hour",
  "840219":
    "Boilers; vapour generating boilers, including hybrid boilers n.e.c. in heading no. 8402",
  "840220": "Boilers; super-heated water boilers",
  "840290": "Boilers; parts of steam or other vapour generating boilers",
  "840310":
    "Boilers; central heating boilers (excluding those of heading no. 8402)",
  "840390":
    "Boilers; parts of central heating boilers (excluding those of heading no. 8402)",
  "840410":
    "Boilers; auxiliary plant, for use with boilers of heading no. 8402 or 8403 (e.g. economisers, super-heaters, soot removers, gas recoverers)",
  "840420": "Boilers; condensers, for steam or other vapour power units",
  "840490":
    "Boilers; parts of auxiliary plant, for use with boilers of heading no. 8402 and 8403 and parts of condensers for steam or other vapour power units",
  "840510":
    "Generators; producer gas, water gas, acetylene gas and similar water process gas generators, with or without their purifiers",
  "840590":
    "Generators; parts of producer gas, water gas, acetylene gas and similar water process gas generators, with or without their purifiers",
  "840610": "Turbines; steam and other vapour turbines, for marine propulsion",
  "840611": "Turbines; steam and other vapour turbines, for marine propulsion",
  "840619":
    "Turbines; steam and other vapour turbines, for other than marine propulsion",
  "840681":
    "Turbines; steam and other vapour turbines, (for other than marine propulsion), of an output exceeding 40MW",
  "840682":
    "Turbines; steam and other vapour turbines, (for other than marine propulsion), of an output not exceeding 40MW",
  "840690": "Turbines; parts of steam and other vapour turbines",
  "840710":
    "Engines; for aircraft, spark-ignition reciprocating or rotary internal combustion piston engines",
  "840721":
    "Engines; outboard motors for marine propulsion, spark-ignition reciprocating or rotary internal combustion piston engines",
  "840729":
    "Engines; for marine propulsion, (other than outboard motors), spark-ignition reciprocating or rotary internal combustion piston engines",
  "840731":
    "Engines; reciprocating piston engines, of a kind used for the propulsion of vehicles of chapter 87, of a cylinder capacity not exceeding 50cc",
  "840732":
    "Engines; reciprocating piston engines, of a kind used for the propulsion of vehicles of chapter 87, of a cylinder capacity exceeding 50cc but not exceeding 250cc",
  "840733":
    "Engines; reciprocating piston engines, of a kind used for the propulsion of vehicles of chapter 87, of a cylinder capacity exceeding 250cc but not exceeding 1000cc",
  "840734": "Engines; spark-ignition reciprocating, >1000cc",
  "840790":
    "Engines; rotary internal combustion piston engines, for other than aircraft or marine propulsion",
  "840810":
    "Engines; for marine propulsion, compression-ignition internal combustion piston engines (diesel or semi-diesel engines)",
  "840820": "Diesel or semi-diesel engines for motor vehicles",
  "840890": "Diesel or semi-diesel engines; excl. motor vehicle and marine",
  "840910":
    "Engines; parts of aircraft engines (spark-ignition reciprocating or rotary internal combustion piston engines)",
  "840991": "Parts for spark-ignition engines; not for aircrafts",
  "840999":
    "Parts for internal combustion piston engines; excl. spark-ignition",
  "841011":
    "Turbines; hydraulic turbines and water wheels, of a power not exceeding 1000kW",
  "841012":
    "Turbines; hydraulic turbines and water wheels, of a power exceeding 1000kW but not exceeding 10000kW",
  "841013":
    "Turbines; hydraulic turbines and water wheels, of a power exceeding 10000kW",
  "841090":
    "Turbines; parts of hydraulic turbines and water wheels, including regulators",
  "841111": "Turbo-jets; of a thrust not exceeding 25kN",
  "841112": "Turbo-jets of a thrust >25kN",
  "841121": "Turbo-propellers; of a power not exceeding 1100kW",
  "841122": "Turbo-propellers; of a power exceeding 1100kW",
  "841181":
    "Turbines; gas-turbines (excluding turbo-jets and turbo-propellers), of a power not exceeding 5000kW",
  "841182":
    "Turbines; gas-turbines (excluding turbo-jets and turbo-propellers), of a power exceeding 5000kW",
  "841191": "Parts for turbo-jets and turbo-propellers",
  "841199": "Parts for gas turbines; excl. turbo-jets and turbo-propellers",
  "841210": "Engines; reaction engines, other than turbo-jets",
  "841221":
    "Engines; hydraulic power engines and motors, linear acting (cylinders)",
  "841229":
    "Engines; hydraulic power engines and motors, other than linear acting (cylinders)",
  "841231":
    "Engines; pneumatic power engines and motors, linear acting (cylinders)",
  "841239":
    "Engines; pneumatic power engines and motors, other than linear acting (cylinders)",
  "841280":
    "Engines; pneumatic power engines and motors, n.e.c. in heading no. 8412",
  "841290": "Engines; parts, for engines and motors of heading no. 8412",
  "841311":
    "Pumps; fitted or designed to be fitted with a measuring device, for dispensing fuel or lubricants, of the type used in filling-stations or in garages",
  "841319":
    "Pumps; for liquids, fitted or designed to be fitted with a measuring device, other than pumps for dispensing fuel or lubricants",
  "841320":
    "Pumps; hand, fitted or designed to be fitted with a measuring device, for liquids, other than those of item no. 8413.11 or 8413.19",
  "841330":
    "Fuel, lubricating, and cooling medium pumps for internal combustion piston engines",
  "841340": "Pumps; concrete pumps",
  "841350":
    "Pumps; reciprocating positive displacement pumps, n.e.c. in heading no. 8413, for liquids",
  "841360":
    "Pumps; rotary positive displacement pumps, n.e.c. in heading no. 8413, for liquids",
  "841370": "Other centrifugal pumps for liquids (exclusionary category)",
  "841381": "Pumps and liquid elevators; n.e.c. in heading no. 8413",
  "841382": "Liquid elevators",
  "841391": "Pump parts",
  "841392": "Liquid elevators; parts thereof",
  "841410": "Pumps; vacuum",
  "841420": "Pumps; hand or foot-operated air pumps",
  "841430": "Compressors for refrigerating equipment",
  "841440":
    "Compressors; air compressors mounted on a wheeled chassis for towing",
  "841451":
    "Fans; table, floor, wall, window, ceiling or roof fans, with a self-contained electric motor of an output not exceeding 125W",
  "841459": "Fans; n.e.c. in item no. 8414.51",
  "841460":
    "Hoods; ventilating or recycling hoods incorporating a fan, whether or not fitted with filters, having a maximum horizontal side not exceeding 120cm",
  "841470":
    "Gas-tight biological safety cabinets; whether or not fitted with filters, having a maximum horizontal side not exceeding 120cm",
  "841480":
    "Other pumps and compressors for air, vacuum, or gas (exclusionary category)",
  "841490":
    "Parts for air or vacuum pumps, compressors, fans, and hoods incorporating a fan",
  "841510": "Air conditioners; fixed to surface, self-contained",
  "841520":
    "Air conditioning machines; comprising a motor driven fan and elements for changing the temperature and humidity, of a kind used for persons, in motor vehicles",
  "841581":
    "Air conditioning machines; containing a motor driven fan, other than window or wall types, incorporating a refrigerating unit and a valve for reversal of the cooling/heat cycle (reversible heat pumps)",
  "841582":
    "Air conditioning machines; containing a motor driven fan, other than window or wall types, incorporating a refrigerating unit",
  "841583":
    "Air conditioning machines; containing a motor driven fan, other than window or wall types, not incorporating a refrigerating unit",
  "841590": "Parts for air conditioners",
  "841610": "Furnaces; furnace burners, for liquid fuel",
  "841620":
    "Furnaces; furnace burners, for pulverized solid fuel or gas, including combination burners",
  "841630":
    "Furnace accessories; mechanical stokers, mechanical grates, mechanical ash dischargers and similar appliances",
  "841690":
    "Furnaces; parts of furnace burners, for liquid fuel, pulverized solid fuel or gas, mechanical stokers, grates, ash dischargers and the like",
  "841710":
    "Furnaces and ovens; non-electric, for the roasting, melting or other heat-treatment of ores, pyrites or of metals, for industrial or laboratory use",
  "841720": "Ovens; non-electric, bakery ovens, including biscuit ovens",
  "841780":
    "Furnaces and ovens; including incinerators, non-electric, for industrial or laboratory use, n.e.c. in heading no. 8417",
  "841790":
    "Furnaces and ovens; parts of non-electric furnaces and ovens (including incinerators), of industrial or laboratory use",
  "841810":
    "Refrigerators and freezers; combined refrigerator-freezers, fitted with separate external doors, electric or other",
  "841821":
    "Refrigerators; for household use, compression-type, electric or other",
  "841822": "Refrigerators; for household use, absorption-type, electrical",
  "841829":
    "Refrigerators; household, electric or not, other than compression-type",
  "841830": "Freezers; of the chest type, not exceeding 800l capacity",
  "841840": "Freezers; of the upright type, not exceeding 900l capacity",
  "841850":
    "Furniture incorporating refrigerating or freezing equipment; for storage and display, n.e.c. in item no. 8418.1, 8418.2, 8418.3 or 8418.4 (chests, cabinets, display counters, show-cases and the like)",
  "841861":
    "Heat pumps; other than air conditioning machines of heading no. 8415",
  "841869": "Refrigerating or freezing equipment; n.e.c. in heading no. 8418",
  "841891":
    "Refrigerating or freezing equipment; parts, furniture designed to receive refrigerating or freezing equipment",
  "841899":
    "Refrigerating or freezing equipment; parts thereof, other than furniture",
  "841911":
    "Heaters; instantaneous gas water heaters, for domestic or other purposes",
  "841912": "Heaters; solar water heaters, non-electric",
  "841919":
    "Heaters; instantaneous or storage water heaters, non-electric, other than instantaneous gas water heaters",
  "841920":
    "Sterilizers; for medical, surgical or laboratory use, not used for domestic purposes",
  "841931": "Dryers; for agricultural products, not used for domestic purposes",
  "841932":
    "Dryers; for wood, paper pulp, paper or paperboard, not used for domestic purposes",
  "841933":
    "Dryers; lyophilisation apparatus, freeze drying units and spray dryers, not used for domestic purposes",
  "841934": "Dryers; for agricultural products, not used for domestic purposes",
  "841935":
    "Dryers; for wood, paper pulp, paper or paperboard, not used for domestic purposes",
  "841939":
    "Dryers; for products n.e.c. in heading no. 8419, not used for domestic purposes",
  "841940": "Distilling or rectifying plant; not used for domestic purposes",
  "841950": "Heat exchange units; not used for domestic purposes",
  "841960":
    "Machinery; for liquefying air or gas, not used for domestic purposes",
  "841981":
    "Machinery, plant and equipment; for making hot drinks, for cooking or heating food",
  "841989":
    "Machinery, plant and laboratory equipment; for treating materials by change of temperature, other than for making hot drinks or cooking or heating food",
  "841990":
    "Machinery, plant and laboratory equipment; parts of equipment for treating materials by a process involving a change of temperature",
  "842010":
    "Machines; calendering or other rolling machines, for other than metal or glass",
  "842091":
    "Machines; parts, cylinders for calendering or other rolling machines, for other than metal or glass",
  "842099":
    "Machines; parts, (other than cylinders), for calendering or other rolling machines, for other than metal or glass",
  "842111": "Centrifuges; cream separators",
  "842112": "Centrifuges; clothes-dryers",
  "842119":
    "Centrifuges; n.e.c. in heading no. 8421, including centrifugal dryers (but not clothes-dryers)",
  "842121": "Machinery; for filtering or purifying water",
  "842122": "Machinery; for filtering or purifying beverages other than water",
  "842123":
    "Machinery; filtering or purifying machinery, oil or petrol filters for internal combustion engines",
  "842129":
    "Machinery; for filtering or purifying liquids, n.e.c. in item no. 8421.2",
  "842131": "Machinery; intake air filters for internal combustion engines",
  "842132":
    "Machinery; catalytic converters or particulate filters, whether or not combined, for purifying or filtering exhaust gases from internal combustion engines",
  "842139":
    "Filtering or purifying machinery for gases; excl. intake air filters for internal combustion engines",
  "842191":
    "Centrifuges; parts thereof, including parts for centrifugal dryers",
  "842199": "Parts for filter/purifying machines for liquids/gases",
  "842211": "Dish washing machines; of the household type",
  "842219": "Dish washing machines; of other than household type",
  "842220": "Machinery; for cleaning or drying bottles or other containers",
  "842230":
    "Machinery; for filling, closing, sealing, capsuling or labelling bottles, cans, bags or other containers, machinery for aerating beverages",
  "842240": "Machinery; for packing or wrapping",
  "842290": "Machinery; parts of machinery of heading no. 8422",
  "842310":
    "Weighing machines; personal (including baby scales) and household scales",
  "842320":
    "Weighing machines; scales for continuous weighing of goods on conveyors",
  "842330":
    "Weighing machines; constant weight scales and scales for discharging a predetermined weight of material into a bag or container, including hopper scales",
  "842381":
    "Weighing machines; having a maximum weighing capacity not exceeding 30kg (excluding balances of a sensitivity of 5cg or better)",
  "842382":
    "Weighing machines; having a maximum weighing capacity exceeding 30kg but not exceeding 5000kg",
  "842389":
    "Weighing machines; having a maximum weighing capacity exceeding 5000kg",
  "842390":
    "Weighing machines; weights of all kinds, parts of weighing machinery",
  "842410": "Fire extinguishers; whether or not charged",
  "842420": "Spray guns and similar appliances",
  "842430":
    "Mechanical appliances; steam or sand blasting machines and similar jet projecting machines",
  "842441":
    "Mechanical appliances; agricultural or horticultural sprayers; portable sprayers",
  "842449":
    "Mechanical appliances; agricultural or horticultural sprayers; other than portable sprayers",
  "842481":
    "Mechanical appliances; for projecting, dispersing or spraying liquids or powders, for agricultural or horticultural use, whether or not hand-operated",
  "842482":
    "Mechanical appliances; agricultural or horticultural, n.e.c. in heading 8424",
  "842489":
    "Mechanical appliances; for projecting, dispersing or spraying liquids or powders, for other than agricultural or horticultural use, whether or not hand-operated",
  "842490":
    "Mechanical appliances; parts of machines projecting, dispersing or spraying liquids or powders, whether or not hand-operated",
  "842511":
    "Pulley tackle and hoists; powered by an electric motor (excluding skip hoists or hoists of a kind used for raising vehicles)",
  "842519":
    "Pulley tackle and hoists; not powered by an electric motor (excluding skip hoists or hoists of a kind used for raising vehicles)",
  "842520":
    "Winches; pit-head winding gear and winches specially designed for use underground",
  "842531": "Winches; capstans; powered by an electric motor",
  "842539": "Winches; capstans; not powered by an electric motor",
  "842541":
    "Jacks; built-in jacking systems of a type used in garages, for raising vehicles",
  "842542": "Jacks and hoists; hydraulic, of a kind used for raising vehicles",
  "842549":
    "Jacks and hoists; (other than hydraulic), of a kind used for raising vehicles",
  "842611": "Cranes; overhead travelling cranes on fixed support",
  "842612": "Cranes; mobile lifting frames on tyres and straddle carriers",
  "842619": "Cranes; transporter, gantry and bridge cranes",
  "842620": "Cranes; tower cranes",
  "842630": "Cranes; portal or pedestal jib cranes",
  "842641":
    "Cranes; self-propelled derricks and cranes, on tyres, n.e.c. in heading no. 8426",
  "842649":
    "Cranes; self-propelled derricks and cranes, not on tyres, n.e.c. in heading no. 8426",
  "842691": "Cranes and derricks; designed for mounting on road vehicles",
  "842699":
    "Cranes and derricks; for other than mounting on road vehicles, n.e.c. in heading no. 8426",
  "842710":
    "Fork-lift and other works trucks; fitted with lifting or handling equipment, self-propelled by electric motor",
  "842720":
    "Fork-lift and other works trucks; fitted with lifting or handling equipment, self-propelled by other than electric motor",
  "842790":
    "Fork-lift and other works trucks; fitted with lifting or handling equipment, not self-propelled",
  "842810": "Lifts and skip hoists",
  "842820": "Elevators and conveyors; pneumatic",
  "842831":
    "Elevators and conveyors; continuous-action, for goods and materials, specially designed for underground use, n.e.c. in item no. 8428.20",
  "842832":
    "Elevators and conveyors; continuous-action, for goods or materials, bucket type, n.e.c. in item no. 8428.20 or 8428.31",
  "842833":
    "Elevators and conveyors; continuous-action, for goods or materials, belt type, n.e.c. in item no. 8428.20 or 8428.31",
  "842839":
    "Elevators and conveyors; continuous-action, for goods or materials, n.e.c. in item no. 8428.20, 8428.31, 8428.32 or 8428.33",
  "842840": "Escalators and moving walkways",
  "842850":
    "Wagons; mine wagon pushers, locomotive or wagon traversers, wagon tippers and similar railway wagon handling equipment",
  "842860":
    "Teleferics, chair-lifts, ski-draglines, traction mechanisms for funiculars",
  "842870": "Industrial robots",
  "842890":
    "Lifting, handling, loading or unloading machinery; n.e.c. in heading no. 8425, 8426, 8427 or 8428",
  "842911": "Bulldozers and angledozers; self-propelled, track laying",
  "842919":
    "Bulldozers and angledozers; self-propelled, other than track laying",
  "842920": "Graders and levellers",
  "842930": "Scrapers; self-propelled",
  "842940": "Tamping machines and road rollers; self-propelled",
  "842951": "Front-end shovel loaders",
  "842952": "Mechanical shovels, excavators, and shovel loaders",
  "842959":
    "Mechanical shovels, excavators and shovel loaders; n.e.c. in item no. 8429.50",
  "843010": "Pile-drivers and pile-extractors",
  "843020": "Snow-ploughs and snow-blowers",
  "843031": "Coal or rock cutters and tunnelling machinery; self-propelled",
  "843039": "Coal or rock cutters and tunnelling machinery; not self-propelled",
  "843041":
    "Boring or sinking machinery; self-propelled, n.e.c. in heading no. 8430",
  "843049": "Boring and sinking machinery; not self-propelled",
  "843050":
    "Machinery; for handling earth, minerals or ores, self-propelled, n.e.c. in heading no. 8430",
  "843061": "Machinery; for tamping or compacting, not self-propelled",
  "843062": "Scrapers; not self-propelled",
  "843069":
    "Machinery; for moving, levelling, scraping, grading, excavating earth minerals or ores; not self propelled n.e.c in 84.30",
  "843110": "Machinery; parts of the machinery of heading no. 8425",
  "843120": "Machinery; parts of the machinery of heading no. 8427",
  "843131": "Lifts, skip hoists or escalators; parts thereof",
  "843139":
    "Machinery; parts of the machinery of heading no. 8428, (other than lifts, skip hoists or escalators)",
  "843141":
    "Machinery parts; buckets, shovels, grabs and grips, for the machinery of heading no. 8426 and 8430",
  "843142": "Machinery parts; bulldozer or angledozer blades",
  "843143":
    "Boring or sinking machinery; parts of the machinery of item no. 8430.41 or 8430.41",
  "843149": "Parts for machines handling earth, minerals, or ores",
  "843210": "Ploughs; for soil preparation",
  "843221": "Harrows; disc harrows",
  "843229":
    "Harrows; (excluding disc), scarifiers, cultivators, weeders and hoes",
  "843230": "Seeders, planters and transplanters",
  "843231":
    "Seeders, planters and transplanters; no-till direct seeders, planters and transplanters",
  "843239":
    "Seeders, planters and transplanters; other than no-till direct seeders, planters and transplanters",
  "843240":
    "Spreaders and distributors; for manure and fertilizers, for agricultural, horticultural or forestry use",
  "843241":
    "Spreaders and distributors; for manure and fertilizers, for agricultural, horticultural or forestry use; manure spreaders",
  "843242":
    "Spreaders and distributors; for manure and fertilizers, for agricultural, horticultural or forestry use; fertiliser distributors",
  "843280": "Rollers; for lawns or sports-grounds",
  "843290":
    "Machinery; parts of machinery for soil preparation or cultivation or for rollers for lawns or sports-grounds",
  "843311":
    "Mowers; lawn, parks or sports-grounds, powered, with the cutting device rotating in a horizontal plane",
  "843319":
    "Mowers; for lawns, parks or sports-grounds, other than with the cutting device rotating in a horizontal plane",
  "843320":
    "Mowers; n.e.c. in item no. 8433.1 (including cutter bars for tractor mounting)",
  "843330": "Haymaking machinery",
  "843340": "Balers; straw or fodder balers, including pick-up balers",
  "843351": "Combine harvester-threshers",
  "843352": "Threshing machinery; other than combine harvester-threshers",
  "843353": "Harvesting machinery; for roots or tubers",
  "843359": "Harvesting machinery; n.e.c. in heading no. 8433",
  "843360":
    "Machines; for cleaning, sorting or grading eggs, fruit or other agricultural produce",
  "843390":
    "Harvesting machinery; parts, including parts of threshing machinery, straw or fodder balers and grass or hay mowers",
  "843410": "Milking machines",
  "843420": "Dairy machinery",
  "843490": "Milking machines and dairy machinery; parts thereof",
  "843510":
    "Presses, crushers and similar machinery; used in the manufacture of wine, cider, fruit juices or similar beverages",
  "843590":
    "Presses, crushers and similar machinery; parts, used in the manufacture of wine, cider, fruit juices or similar beverages",
  "843610": "Machinery; for preparing animal feeding stuffs",
  "843621": "Poultry incubators and brooders",
  "843629": "Poultry-keeping machinery; other than incubators and brooders",
  "843680":
    "Machinery; for agricultural, horticultural or forestry use and n.e.c. in heading no. 8436",
  "843691":
    "Machinery; parts of poultry-keeping machinery or poultry incubators and brooders",
  "843699":
    "Machinery; parts of that machinery for agricultural, horticultural or forestry use n.e.c. in heading no. 8436",
  "843710":
    "Machines; for cleaning, sorting or grading seed, grain or dried leguminous vegetables",
  "843780":
    "Machinery; for use in the milling industry or for the working of cereals or dried leguminous vegetables, other than farm-type machinery",
  "843790":
    "Machines; parts of those for cleaning, sorting or grading seed, grain or dried leguminous vegetables or for milling or working cereals or dried leguminous vegetables (not farm-type machinery)",
  "843810":
    "Machinery; industrial, for bakery and for the manufacture of macaroni, spaghetti or similar products",
  "843820":
    "Machinery; industrial, for the manufacture of confectionery, cocoa or chocolate",
  "843830": "Machinery; industrial, for sugar manufacture",
  "843840": "Machinery; industrial, brewery machinery",
  "843850": "Machinery; industrial, for the preparation of meat or poultry",
  "843860":
    "Machinery; industrial, for the preparation of fruits, nuts or vegetables",
  "843880":
    "Machinery; used in the industrial preparation or manufacture of food or drink, n.e.c. in heading no. 8438",
  "843890":
    "Machinery; parts of those machines used in the industrial preparation or manufacture of food or drink",
  "843910": "Machinery; for making pulp of fibrous cellulosic material",
  "843920": "Machinery; for making paper or paperboard",
  "843930": "Machinery; for finishing paper or paperboard",
  "843991":
    "Machinery; parts of machinery for making pulp of fibrous cellulosic material",
  "843999":
    "Machinery; parts of machinery for making or finishing paper or paperboard",
  "844010": "Book-binding machinery; including book-sewing machines",
  "844090":
    "Book-binding machinery; including book-sewing machines, parts thereof",
  "844110":
    "Machines; cutting, of all kinds, for making up paper pulp, paper or paperboard",
  "844120":
    "Machines; for making bags, sacks or envelopes of paper pulp, paper or paperboard",
  "844130":
    "Machines; for making cartons, boxes, cases, tubes, drums or similar containers (other than by moulding), of paper pulp, paper or paperboard",
  "844140":
    "Machines; for moulding articles, in paper pulp, paper or paperboard",
  "844180":
    "Machinery; n.e.c. in heading no. 8441, for making up paper pulp, paper or paperboard",
  "844190":
    "Machinery; parts of machinery for making up paper pulp, paper or paperboard, including cutting machines of all kinds",
  "844210":
    "Machinery; phototype-setting and composing, excluding machine-tools of heading no. 8456 to 8465",
  "844220":
    "Machinery; apparatus and equipment, for type-setting or composing by processes other than photo-type, with or without founding device",
  "844230":
    "Machinery, apparatus and equipment (excluding machines of heading no. 8456 to 8465) for preparing or making printing components",
  "844240":
    "Machinery, apparatus and equipment (excluding machines of heading no. 8456 to 8465) for preparing or making printing components; parts thereof",
  "844250":
    "Plates, cylinders and other printing components; lithographic stones prepared for printing purposes (for example, planed, grained or polished)",
  "844311": "Printing machinery; offset, reel-fed",
  "844312":
    "Printing machinery; offset, sheet-fed, office type (sheet size not exceeding 22 x 36cm in the unfolded state)",
  "844313": "Printing machinery; offset, n.e.c. in item no. 8443.1",
  "844314":
    "Printing machinery; letterpress, reel-fed, excluding flexographic printing",
  "844315":
    "Printing machinery; letterpress, other than reel-fed, excluding flexographic printing",
  "844316": "Printing machinery; flexographic",
  "844317": "Printing machinery; gravure",
  "844319":
    "Printing machinery; used for printing by means of plates, cylinders and other printing components of heading 84.42, n.e.c. in item no. 8443.1",
  "844321":
    "Printing machinery; letterpress, reel fed, excluding flexographic printing",
  "844329":
    "Printing machinery; letterpress, other than reel fed, excluding flexographic printing",
  "844330": "Printing machinery; flexographic",
  "844331":
    "Multi-function printing, copying or facsimile machines; connectable to computer or network",
  "844332":
    "Single-function printing, copying or facsimile machines; connectable to computer or network",
  "844339":
    "Printing, copying, and facsimile machines; single-function printing, copying or facsimile machines, not capable of connecting to an automatic data processing machine or to a network",
  "844340": "Printing machinery; gravure",
  "844350": "Printing machinery; of a type n.e.s. in heading no. 8443",
  "844351":
    "Printing machinery; (not letterpress, offset, flexographic or gravure), ink-jet printing machines",
  "844359":
    "Printing machinery; of a type n.e.s. in heading no. 8443, (eg other than letterpress, offset, flexographic, gravure or ink-jet printing machines)",
  "844360": "Printing machinery; machines for uses ancillary to printing",
  "844390": "Printing machinery; parts thereof",
  "844391":
    "Printing machinery used for printing by means of plates, cylinders and other printing components of heading 8442; parts and accessories",
  "844399":
    "Other parts and accessories for printing machinery (exclusionary category)",
  "844400":
    "Textile machinery; for extruding, drawing, texturing or cutting man-made textile materials",
  "844511": "Textile machinery; carding machines for preparing textile fibres",
  "844512": "Textile machinery; combing machines for preparing textile fibres",
  "844513":
    "Textile machinery; drawing or roving machines for preparing textile fibres",
  "844519":
    "Textile machinery; n.e.c. in heading no. 8445, for preparing textile fibres",
  "844520": "Textile machinery; spinning machines",
  "844530": "Textile machinery; doubling or twisting machines",
  "844540":
    "Textile machinery; winding (including weft-winding) or reeling machines",
  "844590":
    "Textile machinery; involved in textile fibre or textile yarn preparation and n.e.c. in heading no. 8445",
  "844610":
    "Weaving machines (looms); for weaving fabrics of a width 30cm or less",
  "844621":
    "Weaving machines (looms); for weaving fabrics of a width exceeding 30cm, shuttle type, power looms",
  "844629":
    "Weaving machines (looms); for weaving fabrics of a width exceeding 30cm, shuttle type, other than power looms",
  "844630":
    "Weaving machines (looms); for weaving fabrics of a width exceeding 30cm, shuttleless type",
  "844711":
    "Knitting machines; circular, with cylinder diameter not exceeding 165mm",
  "844712":
    "Knitting machines; circular, with cylinder diameter exceeding 165mm",
  "844720": "Knitting machines; flat, stitch-bonding machines",
  "844790":
    "Machines; for making gimped yarn, tulle, lace, embroidery, trimmings, braid or net and machines for tufting",
  "844811":
    "Machinery, auxiliary; dobbies and jacquards, card reducing, copying, punching or assembling machines for use therewith",
  "844819":
    "Machinery, auxiliary; for machines of heading no. 8444, 8445, 8446 or 8447, n.e.c. in item no. 8448.11",
  "844820":
    "Machines; parts and accessories of machines or auxiliary machinery of heading no. 8444",
  "844831": "Machines, card clothing; parts and accessories",
  "844832":
    "Machines; parts and accessories of machines or auxiliary machinery for preparing textile fibres, other than card clothing",
  "844833":
    "Machines; parts and accessories of machines or auxiliary machinery, spindles, spindle flyers, spinning rings and ring travellers",
  "844839":
    "Machines; parts and accessories of machines or auxiliary machinery of heading no. 8445, n.e.c. in item no. 8448.3",
  "844841":
    "Weaving machines (looms); parts and accessories of machines or auxiliary machinery shuttles",
  "844842":
    "Weaving machines (looms); parts including their auxiliary machinery, and accessories thereof, reeds for looms, healds and heald-frames",
  "844849":
    "Weaving machines (looms); parts including their auxiliary machinery, and accessories thereof n.e.c. in item no. 8448.4",
  "844851":
    "Machines; parts and accessories of machines of heading no. 8447 or auxiliary machinery, sinkers, needles and other articles used in forming stitches",
  "844859":
    "Machines; parts and accessories of machines or auxiliary machinery of heading no. 8447, other than sinkers, needles and other articles used in forming stitches",
  "844900":
    "Machinery; for manufacture or finishing felt or non-wovens in the piece or in shapes, including machinery for making felt hats, blocks for making hats",
  "845011":
    "Washing machines; household or laundry-type, fully-automatic, (of a dry linen capacity not exceeding 10kg)",
  "845012":
    "Washing machines; household or laundry-type, with built-in centrifugal drier, (not fully-automatic), of a dry linen capacity not exceeding 10kg",
  "845019":
    "Washing machines; household or laundry-type, not fully-automatic, without built-in centrifugal drier, of a dry linen capacity not exceeding 10kg",
  "845020":
    "Washing machines; household or laundry-type, of a dry linen capacity exceeding 10kg",
  "845090": "Washing machines; parts for household or laundry-type",
  "845110": "Dry-cleaning machines",
  "845121": "Drying machines; of a dry linen capacity not exceeding 10kg",
  "845129": "Drying machines; of a dry linen capacity exceeding 10kg",
  "845130": "Ironing machines and presses (including fusing presses)",
  "845140": "Machines; for washing, bleaching or dyeing",
  "845150":
    "Machines; for reeling, unreeling, folding, cutting or pinking textile fabrics",
  "845180":
    "Machinery; for wringing, dressing, finishing, coating or impregnating textile yarns, fabrics or made up textile articles; for applying paste to base fabric used in manufacture of floor coverings",
  "845190": "Machinery; parts, of the machinery of heading no. 8451",
  "845210": "Sewing machines; of the household type",
  "845221": "Sewing machines; (not household type), automatic units",
  "845229": "Sewing machines; not household or automatic unit type",
  "845230": "Sewing machine needles",
  "845240": "Sewing machine furniture; bases and covers and parts thereof",
  "845290":
    "Sewing machines; furniture, bases and covers for sewing machines and parts thereof, and other parts of sewing machines",
  "845310":
    "Machinery; for preparing, tanning or working hides, skins or leather, other than sewing machines",
  "845320":
    "Machinery; for making or repairing footwear, other than sewing machines",
  "845380":
    "Machinery; for making or repairing articles of hides, skins or leather, other than sewing machines",
  "845390":
    "Machinery; parts of those for preparing, tanning or working hides, skins or leather, for making or repairing footwear or other articles of hides, skin or leather, other than sewing machines",
  "845410": "Converters; of a type used in metallurgy or in metal foundries",
  "845420":
    "Ingot moulds and ladles; of a kind used in metallurgy or in metal foundries",
  "845430":
    "Casting machines; of a kind used in metallurgy or in metal foundries",
  "845490":
    "Machines; parts of converters, ladles, ingot moulds and casting machines, of a kind used in metallurgy or in metal foundries",
  "845510": "Metal-rolling mills; tube mills",
  "845521":
    "Metal-rolling mills; hot or combination hot and cold rolling mills",
  "845522": "Metal-rolling mills; cold",
  "845530": "Metal-rolling mills; rolls thereof",
  "845590": "Metal-rolling mills; parts thereof",
  "845610":
    "Machine-tools; for working any material by removal of material, operated by laser or other light or photon beam processes",
  "845611":
    "Machine-tools; for working any material by removal of material; operated by laser",
  "845612":
    "Machine-tools; for working any material by removal of material; operated by other light or photon beam processes (not laser)",
  "845620":
    "Machine-tools; for working any material by removal of material, operated by ultrasonic processes",
  "845630":
    "Machine-tools; for working any material by removal of material, operated by electro-discharge processes",
  "845640":
    "Machine tools; for working any material by removal of material; operated by plasma arc processes;",
  "845650":
    "Machine tools; for working any material by removal of material; operated by water-jet cutting machines",
  "845690":
    "Machine tools; for working any material by removal of material; operated by other processes n.e.c. in heading 8456",
  "845691":
    "Machine tools; operated by electro-chemical, electron-beam, ionic-beam or plasma-arc processes, for dry-etching patterns on semiconductor materials",
  "845699":
    "Machine tools; operated by electro-chemical, electron-beam, ionic beam or plasma-arc processes, other than for dry-etching patterns on semiconductor materials",
  "845710": "Machining centres; for working metal",
  "845720":
    "Machines; unit construction machines (single station), for working metal",
  "845730":
    "Metal machines; multi-station transfer machines, for working metal",
  "845811": "Lathes; for removing metal, horizontal, numerically controlled",
  "845819":
    "Lathes; for removing metal, horizontal, other than numerically controlled",
  "845891":
    "Lathes; for removing metal, numerically controlled, other than horizontal lathes",
  "845899":
    "Lathes; for removing metal, other than horizontal or numerically controlled lathes",
  "845910":
    "Machine-tools; way-type unit head machines, for drilling, boring, milling, threading or tapping by removing metal, other than lathes of heading no. 8458",
  "845921":
    "Machine-tools; for drilling by removing metal, numerically controlled",
  "845929":
    "Machine-tools; for drilling by removing metal, other than numerically controlled",
  "845931":
    "Machine-tools; for boring-milling by removing metal, numerically controlled",
  "845939":
    "Machine-tools; for boring-milling by removing metal, other than numerically controlled",
  "845940":
    "Machine-tools; for boring by removing metal, n.e.c. in item no. 8459.31 and 8459.39",
  "845941":
    "Machine-tools; for boring by removing metal, numerically controlled boring machines, n.e.c. in heading 8459",
  "845949":
    "Machine-tools; for boring by removing metal, not numerically controlled boring machines, n.e.c. in heading 8459",
  "845951":
    "Machine-tools; for milling by removing metal, knee-type, numerically controlled",
  "845959":
    "Machine-tools; for milling by removing metal, knee-type, other than numerically controlled",
  "845961":
    "Machine-tools; for milling by removing metal, (not knee-type), numerically controlled",
  "845969":
    "Machine-tools; for milling by removing metal, not knee-type, other than numerically controlled",
  "845970": "Machine-tools; for threading or tapping by removing metal",
  "846011":
    "Machine-tools; flat-surface grinding machines, in which positioning in any one axis can be set up to an accuracy of 0.01mm or better, numerically controlled",
  "846012":
    "Machine-tools; flat-surface grinding machines, numerically controlled",
  "846019":
    "Machine-tools; flat-surface grinding machines, other than numerically controlled",
  "846021":
    "Machine-tools; grinding machines (other than flat-surface), in which positioning in any one axis can be set up to at least an accuracy of 0.01mm, numerically controlled",
  "846022":
    "Machine-tools; grinding machines (excluding flat-surface), centreless, numerically controlled",
  "846023":
    "Machine-tools; cylindrical grinding machines (excluding flat-surface and centreless), numerically controlled",
  "846024":
    "Machine-tools; grinding machines (excluding flat-surface, cylindrical and centreless), numerically controlled",
  "846029":
    "Machine-tools; grinding machines (excluding flat-surface), other than numerically controlled",
  "846031":
    "Machine-tools; sharpening (tool or cutter grinding) machines, numerically controlled",
  "846039":
    "Machine-tools; sharpening (tool or cutter grinding) machines, other than numerically controlled",
  "846040": "Machine-tools; for honing or lapping",
  "846090":
    "Machine-tools; for deburring, grinding, polishing or otherwise finishing metal, sintered metal carbides or cermets by means of grinding stones, abrasives or polishing products, n.e.c. in heading no. 8460",
  "846110":
    "Machine-tools; planing machines, working by removing metal, sintered metal carbides or cermets",
  "846120":
    "Machine-tools; shaping or slotting machines, working by removing metal, sintered metal carbides or cermets",
  "846130":
    "Machine-tools; broaching machines, working by removing metal, sintered metal carbides or cermets",
  "846140":
    "Machine-tools; gear cutting, gear grinding or gear finishing machines, working by removing metal, sintered metal carbides or cermets",
  "846150":
    "Machine-tools; sawing or cutting-off machines, working by removing metal, sintered metal carbides or cermets",
  "846190":
    "Machine-tools; planing machines, and other machine-tools n.e.c. in heading no. 8461; working by removing metal, sinistered metal carbides or cerments.",
  "846210":
    "Machine-tools; forging or die-stamping machines (including presses) and hammers, for working metal",
  "846211":
    "Machine-tools; forging and die-forging machines (including presses), closed die forging machines, for working metal",
  "846219":
    "Machine-tools; hot forming machines, hot hammers, for working metal",
  "846221":
    "Machine-tools; bending, folding, straightening or flattening machines (including presses), numerically controlled, for working metal",
  "846222":
    "Machine-tools; bending, folding, straightening or flattening machines (including press brakes) for flat products, for working metal, numerically controlled",
  "846223":
    "Machine-tools; bending, folding, straightening or flattening machines (including presses), for working metal, numerically controlled press brakes",
  "846224":
    "Machine-tools; bending, folding, straightening or flattening machines (including presses), for working metal, numerically controlled panel benders",
  "846225":
    "Machine-tools; bending, folding, straightening or flattening machines (including presses), for working metal, numerically controlled roll forming machines",
  "846226":
    "Machine-tools; bending, folding, straightening or flattening machines (including presses), for working metal, numerically controlled bending, folding, straightening or fattening machines (not press brakes, panel benders or roll forming machines)",
  "846229":
    "Machine-tools; bending, folding, straightening or flattening machines (including presses), (other than numerically controlled), for working metal",
  "846231":
    "Machine-tools; shearing machines (including presses), (other than combined punching and shearing machines), numerically controlled, for working metal",
  "846232":
    "Machine-tools; slitting lines and cut-to-length lines, for working metal",
  "846233":
    "Machine-tools; shearing machines (excluding presses) for flat products, numerically controlled, other than combined punching and shearing machines, for working metal",
  "846239":
    "Machine-tools; shearing machines (including presses), (other than combined punching and shearing machines, other than numerically controlled), for working metal",
  "846241":
    "Machine-tools; punching or notching machines (including presses), including combined punching and shearing machines, numerically controlled, for working metal",
  "846242":
    "Machine-tools; punching, notching or nibbling machines (excluding presses) for flat products including combined punching and shearing machines, numerically controlled, for working metal",
  "846249":
    "Machine-tools; punching or notching machines (including presses), including combined punching and shearing machines, (not numerically controlled), for working metal",
  "846251":
    "Machine-tools; for working tube, pipe, hollow section and bar (excluding presses), for working metal, numerically controlled",
  "846259":
    "Machine-tools; for working tube, pipe, hollow section and bar (excluding presses), for working metal, not numerically controlled",
  "846261": "Machine-tools; cold metal working presses, hydraulic presses",
  "846262": "Machine-tools; cold metal working presses, mechanical presses",
  "846263": "Machine-tools; cold metal working presses, servo-presses",
  "846269":
    "Machine-tools; cold metal working presses, other than hydraulic, mechanical or servo-presses",
  "846290":
    "Machine-tools; (including presses) for working metal by forging, hammering or die-forging, for bending, folding, straightening, flattening, shearing, punching, notching or nibbling metal, n.e.c. in heading 8462",
  "846291":
    "Machine-tools; presses for working metal or metal carbides, n.e.c. in heading no. 8462, hydraulic presses",
  "846299":
    "Machine-tools; presses for working metal or metal carbides, n.e.c. in heading no. 8462, other than hydraulic presses",
  "846310":
    "Machine-tools; for working metal, sintered metal carbides or cermets, without removing material, draw-benches for bars, tubes, profiles, wire or the like",
  "846320":
    "Machine-tools; for working metal, sintered metal carbides or cermets, without removing material, thread rolling machines",
  "846330":
    "Machine-tools; machines for working wire, without removing material",
  "846390":
    "Machine-tools; for working metal, sintered metal carbides or cermets, without removing material, n.e.c. in heading no. 8463",
  "846410":
    "Machine-tools; sawing machines, for working stone, ceramics, concrete, asbestos-cement or like mineral materials or for cold working glass",
  "846420":
    "Machine-tools; grinding or polishing machines, for working stone, ceramics, concrete, asbestos-cement or like mineral materials or for cold working glass",
  "846490":
    "Machine-tools; for working stone, ceramics, concrete, asbestos-cement or like mineral materials or for cold working glass, (other than sawing, grinding or polishing machines)",
  "846510":
    "Machine-tools; which can carry out different types of machining operations without tool change between such operations, for working wood, cork, bone, hard rubber, hard plastics or similar",
  "846520":
    "Machine-tools; for working wood, cork, bone, hard rubber, hard plastics or similar hard materials; machining centres",
  "846591":
    "Machine-tools; for working wood, cork, bone, hard rubber, hard plastics or similar hard materials; sawing machines",
  "846592":
    "Machine-tools; for working wood, cork, bone, hard rubber, hard plastics or similar hard materials; planing, milling or moulding (by cutting) machines",
  "846593":
    "Machine-tools; for working wood, cork, bone, hard rubber, hard plastics or similar hard materials; grinding, sanding or polishing machines",
  "846594":
    "Machine-tools; for working wood, cork, bone, hard rubber, hard plastics or similar hard materials; bending or assembling machines",
  "846595":
    "Machine-tools; for working wood, cork, bone, hard rubber, hard plastics or similar hard materials; drilling or morticing machines",
  "846596":
    "Machine-tools; for working wood, cork, bone, hard rubber, hard plastics or similar hard materials; splitting, slicing or paring machines",
  "846599":
    "Machine-tools; for working wood, cork, bone, hard rubber, hard plastics or similar hard materials; n.e.c. in heading no. 8465",
  "846610":
    "Parts & accessories suited for use solely/principally with machines of headings 8456-8465; tool holders and self-opening dieheads",
  "846620":
    "Parts & accessories suited for use solely/principally with machines of headings 8456-8465; work holders",
  "846630":
    "Parts & accessories suited for use solely/principally with machines of headings 8456-8465; dividing heads and other special attachments for machines",
  "846691":
    "Parts & accessories suited for use solely/principally; for the machines of heading no. 8464, n.e.c. in heading no. 8466",
  "846692":
    "Parts & accessories suited for use solely/principally for the machines of heading no. 8465, n.e.c. in heading no. 8466",
  "846693":
    "Parts & accessories suited for use solely/principally with machines of headings 8456-8465; n.e.c. in heading no. 8466",
  "846694":
    "Machine-tools; parts and accessories, for the machines of heading no. 8462 or 8463, n.e.c. in heading no. 8466",
  "846711":
    "Tools; for working in the hand, pneumatic, rotary type (including combined rotary-percussion)",
  "846719": "Tools; for working in the hand, pneumatic, other than rotary type",
  "846721":
    "Tools; for working in the hand, with self-contained electric motor; drills of all kinds",
  "846722":
    "Tools; for working in the hand, with self-contained electric motor; saws",
  "846729":
    "Hand-held tools with self-contained electric motor; excl. saws and drills",
  "846781":
    "Tools; for working in the hand, chain saws with self-contained non-electric motor",
  "846789":
    "Tools; for working in the hand, (other than chain saws), hydraulic or with self-contained non-electric motor, (not pneumatic)",
  "846791":
    "Tools; for working in the hand, parts of chain saws, with self-contained non-electric motor",
  "846792": "Tools; for working in the hand, parts of pneumatic tools",
  "846799":
    "Tools; for working in the hand, parts thereof for other than chain saws and pneumatic tools",
  "846810":
    "Machinery and apparatus; hand-held blow pipes for soldering, brazing or welding, whether or not capable of cutting",
  "846820":
    "Machinery and apparatus; gas operated machinery and apparatus n.e.c. in item no. 8468.10, for soldering, brazing or welding, whether or not capable of cutting",
  "846880":
    "Machinery and apparatus; for soldering, brazing or welding, whether or not capable of cutting, n.e.c. in heading no. 8468",
  "846890":
    "Machinery and apparatus; parts, soldering, brazing or welding, whether or not capable of cutting, parts thereof",
  "846900":
    "Typewriters (other than printers of heading no. 8443) and word-processing machines",
  "846910": "Typewriters, automatic and word processing machines",
  "846911": "Word-processing machines",
  "846912": "Typewriters; automatic, other than printers of heading no. 8471",
  "846920":
    "Typewriters; electric, (not automatic), other than printers of heading no. 8471",
  "846921":
    "Typewriters; electric, weighing not more than 12kg, excluding case",
  "846929": "Typewriters; electric, weighing more than 12kg, excluding case",
  "846930":
    "Typewriters; non-electric, (not automatic), other than printers of heading no. 8471",
  "846931":
    "Typewriters; non-electric, weighing not more than 12kg, excluding case",
  "846939":
    "Typewriters; non-electric, weighing more than 12kg, excluding case",
  "847010":
    "Calculating machines; electronic calculators capable of operation without an external source of electric power and pocket-size data recording, reproducing and displaying machines with calculating functions",
  "847021":
    "Calculating machines; electronic, incorporating a printing device, needing an external source of power",
  "847029":
    "Calculating machines; electronic, (not incorporating a printing device), needing an external power source",
  "847030": "Calculating machines; non-electronic",
  "847040": "Accounting machines",
  "847050": "Cash registers",
  "847090":
    "Machines incorporating a calculating device; n.e.c. in heading no. 8470",
  "847110": "Data processing machines; analogue or hybrid automatic type",
  "847120":
    "Data processing machines; digital automatic, containing in the same housing at least a central processing unit and input and output unit, whether or not combined",
  "847130": "Laptops",
  "847141":
    "Automatic data processing machines; comprising in the same housing at least a central processing unit and an input and output unit, whether or not combined, n.e.c. in item no. 8471.30",
  "847149": "Other computer systems (exclusionary category)",
  "847150": "Computer units; storage, input, output",
  "847160":
    "Units of automatic data processing machines; input or output units, whether or not containing storage units in the same housing",
  "847170": "Storage units for computers",
  "847180": "Other computer units (exclusionary category)",
  "847190":
    "Magnetic or optical readers, machines for transcribing data onto data media in coded form and machines for processing such data, not elsewhere specified or included",
  "847191":
    "Digital processing units; whether or not presented with the rest of a system, which may contain in the same housing one or two of the following: storage units, input units, output units",
  "847192":
    "Data processing machinery; input or output units, whether or not presented with the rest of a system or containing storage units in the same housing",
  "847193":
    "Data processing machinery; storage units, whether or not presented with the rest of a system",
  "847199": "Data processing machinery; n.e.s in heading no. 8471",
  "847210": "Office machines; duplicating machines",
  "847220": "Addressing machines and address plate embossing machines",
  "847230":
    "Office machines; for sorting or folding mail or for inserting mail in envelopes or bands, machines for opening, closing or sealing mail and machines for affixing or cancelling postage stamps",
  "847290": "Office machines; not elsewhere classified",
  "847310":
    "Typewriters and word-processing machines; parts and accessories of the machines of heading 84.69 (other than covers, carrying cases and the like)",
  "847321":
    "Calculating machines; parts and accessories of the electronic calculating machines of item no. 8470.10, 8470.21 or 8470.29 (other than covers, carrying cases and the like)",
  "847329":
    "Machinery; parts and accessories of the machines of item no. 8470.30. 8470.50 or 8470.90 (other than covers, carrying cases and the like)",
  "847330": "Parts and accessories for computers",
  "847340":
    "Machinery; parts and accessories (other than covers, carrying cases and the like) of the machines of heading no. 8472",
  "847350":
    "Machines; parts and accessories (other than covers, carrying cases and the like) equally suitable for use with machines of two or more of the headings 8470 to 8472",
  "847410":
    "Machines; for sorting, screening, separating or washing earth, stone, ores or other mineral substances",
  "847420":
    "Machines; for crushing or grinding earth, stone, ores or other mineral substances",
  "847431": "Machines; concrete or mortar mixers",
  "847432": "Machines; for mixing mineral substances with bitumen",
  "847439":
    "Machines; for mixing or kneading mineral substances, excluding concrete mixers and machines for mixing mineral substances with bitumen",
  "847480":
    "Machines; for agglomerating, shaping or moulding solid mineral fuels, ceramic paste, unhardened cements, plastering materials in powder or paste form, machines for forming foundry moulds of sand",
  "847490":
    "Machines, for sorting, screening, separating, washing, crushing etc mineral substances, for agglomerating, shaping or moulding solid fuels, ceramic pastes etc, for forming foundry moulds of sand; parts",
  "847510":
    "Machines; for assembling electric or electronic lamps, tubes, valves or flash-bulbs, in glass envelopes",
  "847520": "Machines; for manufacturing or hot working glass or glassware",
  "847521":
    "Machines; for manufacturing or hot working glass or glassware, for making optical fibres and preforms thereof",
  "847529":
    "Machines; for manufacturing or hot working glass or glassware, not for making optical fibres and preforms thereof",
  "847590":
    "Machines; parts, of those for assembling electric or electronic lamps, tubes, valves or flash-bulbs, in glass envelopes and manufacturing or hot working glass or glassware",
  "847611":
    "Machines; automatic goods-vending machines, incorporating heating or refrigerating devices (eg food or beverage machines)",
  "847619":
    "Machines; automatic goods-vending machines, not incorporating heating or refrigerating devices (eg postage stamp, cigarette, food or beverages and money-changing machines)",
  "847621":
    "Machines; automatic beverage-vending machines, incorporating heating or refrigerating devices",
  "847629":
    "Machines; automatic beverage-vending machines, not incorporating heating or refrigerating devices",
  "847681":
    "Machines; automatic goods-vending machines, (e.g. postage stamp, cigarette, food or money-changing machines, excluding beverage-vending machines), incorporating heating or refrigerating devices",
  "847689":
    "Machines; automatic goods-vending machines, (e.g. postage stamp, cigarette, food or money-changing machines, excluding beverage-vending machines), not incorporating heating or refrigerating devices",
  "847690": "Machines; parts of automatic goods-vending machines",
  "847710": "Rubber or plastics injection-moulding machines",
  "847720":
    "Machinery; extruders, for working rubber or plastics or for the manufacture of products from these materials",
  "847730":
    "Machinery; blow moulding machines, for working rubber or plastics or for the manufacture of products from these materials",
  "847740":
    "Machinery; vacuum moulding machines and other thermoforming machines, for working rubber or plastics or for the manufacture of products from these materials",
  "847751":
    "Machinery; for moulding or retreading pneumatic tyres or for moulding or otherwise forming inner tubes",
  "847759":
    "Machinery; for moulding or forming, for working rubber or plastics or for the manufacture of products from these materials, n.e.c. in this chapter",
  "847780":
    "Machinery; for working rubber or plastics or for the manufacture of products from these materials, n.e.c. in this chapter",
  "847790":
    "Machinery; parts of the machines of heading no. 8477, n.e.c. in item no. 8477.90",
  "847810":
    "Machinery; for preparing or making up tobacco, n.e.c. in this chapter",
  "847890":
    "Machinery; parts of those for preparing or making up tobacco, n.e.c. in this chapter",
  "847910":
    "Machinery and mechanical appliances; for public works, building or the like",
  "847920":
    "Machinery; for the extraction or preparation of animal or fixed vegetable fats or oils",
  "847930":
    "Machinery and mechanical appliances; presses for the manufacture of particle or fibre building board of wood or other ligneous materials and other machinery for treating wood or cork",
  "847940": "Machines; for making rope or cable",
  "847950":
    "Machinery and mechanical appliances; industrial robots, n.e.c. or included",
  "847960": "Machinery and mechanical appliances; evaporative air coolers",
  "847971":
    "Machinery and mechanical appliances; passenger boarding bridges, of a kind used in airports",
  "847979":
    "Machinery and mechanical appliances; passenger boarding bridges, other than of a kind used in airports",
  "847981":
    "Machines and mechanical appliances; for treating metal, including electric wire coil-winders",
  "847982":
    "Machines; for mixing, kneading, crushing, grinding, screening, sifting, homogenising, emulsifying or stirring",
  "847983": "Machines and mechanical appliances; cold isostatic presses",
  "847989":
    "Other machines and mechanical appliances with individual functions (exclusionary category)",
  "847990": "Parts for other machines and mechanical appliances",
  "848010": "Moulding boxes; for metal foundry",
  "848020":
    "Mould bases; for metal, metal carbides, glass, mineral materials, rubber or plastics",
  "848030":
    "Moulding patterns; of metal, metal carbides, glass, mineral materials, rubber or plastics",
  "848041":
    "Moulds; for metal or metal carbides, injection or compression types",
  "848049":
    "Moulds; for metal or metal carbides, other than injection or compression types",
  "848050": "Moulds; for glass",
  "848060": "Moulds; for mineral materials",
  "848071": "Moulds; for rubber or plastics, injection or compression types",
  "848079":
    "Moulds; for rubber or plastics, other than injection or compression types",
  "848110":
    "Valves; pressure reducing, for pipes, boiler shells, tanks, vats or the like",
  "848120": "Valves for oleohydraulic or pneumatic transmissions",
  "848130":
    "Valves; check (nonreturn) valves, for pipes, boiler shells, tanks, vats or the like",
  "848140":
    "Valves; safety or relief valves, for pipes, boiler shells, tanks, vats or the like",
  "848180": "Taps, cocks, valves and similar appliances",
  "848190": "Parts for taps, cocks, valves or similar appliances",
  "848210": "Ball bearings",
  "848220":
    "Bearings; tapered roller bearings, including cone and tapered roller assemblies",
  "848230": "Bearings; spherical roller bearings",
  "848240": "Bearings; needle roller bearings",
  "848250": "Bearings; cylindrical roller bearings n.e.c. in heading no. 8482",
  "848280":
    "Bearings; n.e.c. in heading no. 8482, including combined ball/roller",
  "848291": "Bearings; parts, balls, needles and rollers",
  "848299": "Bearings; parts, (other than balls, needles and rollers)",
  "848310": "Transmission shafts and cranks",
  "848320": "Bearing housings, incorporating ball or roller bearings",
  "848330":
    "Bearing housings, not incorporating ball or roller bearings and plain shaft bearings",
  "848340": "Gearing, ball or roller screws, speed changers, torque converters",
  "848350": "Pulleys and flywheels, including pulley blocks",
  "848360": "Clutches and shaft couplings (including universal joints)",
  "848390": "Parts for transmission components",
  "848410":
    "Gaskets and similar joints; of metal sheeting combined with other material or two or more layers of metal",
  "848420": "Seals; mechanical",
  "848490":
    "Gasket sets or assortments of gaskets and similar joints; dissimilar in composition, put up in pouches, envelopes or similar packings",
  "848510": "Ships' propellers and blades therefor",
  "848520": "Machines for additive manufacturing; by plastic or rubber deposit",
  "848530":
    "Machines for additive manufacturing; by plaster, cement, ceramics or glass deposit",
  "848580":
    "Machines for additive manufacturing; by other than metal, plastic, rubber, plaster, cement, ceramics or glass deposits",
  "848590":
    "Machinery; parts, not containing electrical connectors, insulators, coils, contacts or other electrical features, n.e.s. in chapter 84",
  "848610":
    "Machines and apparatus of a kind used solely or principally for the manufacture of semiconductor boules or wafers",
  "848620":
    "Machines and apparatus for manufacture of semiconductor devices or of electronic integrated circuits",
  "848630":
    "Machines and apparatus of a kind used solely or principally for the manufacture of flat panel displays",
  "848640":
    "Machines and apparatus of a kind used solely or principally for the manufacture or repair of masks and reticles, assembling semiconductor devices or electronic integrated circuits, or for lifting, handling, loading or unloading items of heading 8486",
  "848690":
    "Parts and accessories for machines and apparatus used for the manufacture of semiconductor boules or wafers, semiconductor devices, chips, or flat panel displays",
  "848710": "Ships' or boats' propellers and blades therefor",
  "848790":
    "Machinery parts; not containing electrical connectors, insulators, coils, contacts or other electrical features, n.e.c. in chapter 84, other than ships' or boats' propellers and blades therefor",
  "850110": "Electrical motors; output <37.5W",
  "850120": "Electric motors; universal AC/DC of an output exceeding 37.5W",
  "850131":
    "Electric motors and generators; DC, of an output not exceeding 750W",
  "850132":
    "Electric motors and generators; DC, of an output exceeding 750W but not exceeding 75kW",
  "850133":
    "Electric motors and generators; DC, of an output exceeding 75kW but not exceeding 375kW",
  "850134": "Electric motors and generators; DC, of an output exceeding 375kW",
  "850140": "Electric motors; AC motors, single-phase",
  "850151":
    "Electric motors; AC motors, multi-phase, of an output not exceeding 750W",
  "850152":
    "Electric motors; AC motors, multi-phase, of an output exceeding 750W but not exceeding 75kW",
  "850153":
    "Electric motors; AC motors, multi-phase, of an output exceeding 75kW",
  "850161":
    "Generators; AC generators, (alternators), of an output not exceeding 75kVA",
  "850162":
    "Electric generators; AC generators, (alternators), of an output exceeding 75kVA but not exceeding 375kVA",
  "850163":
    "Electric generators; AC generators, (alternators), of an output exceeding 375kVA but not exceeding 750kVA",
  "850164":
    "Electric generators; AC generators, (alternators), of an output exceeding 750kVA",
  "850171":
    "Electric generators; photovoltaic DC generators, of an output not exceeding 50W",
  "850172":
    "Electric generators; photovoltaic DC generators, of an output exceeding 50W",
  "850180":
    "Electric generators; (excluding generating sets), photovoltaic AC generators (alternators)",
  "850211":
    "Electric generating sets; with compression-ignition internal combustion piston engines (diesel or semi-diesel engines), of an output not exceeding 75kVA",
  "850212":
    "Electric generating sets; with compression-ignition internal combustion piston engines (diesel or semi-diesel engines), of an output exceeding 75kVA but not exceeding 375kVA",
  "850213":
    "Electric generating sets; with compression-ignition internal combustion piston engines (diesel or semi-diesel engines), of an output exceeding 375kVA",
  "850220":
    "Electric generating sets; with spark-ignition internal combustion piston engines",
  "850230": "Electric generating sets; n.e.s. in heading no. 8502",
  "850231":
    "Electric generating sets; wind-powered, (excluding those with spark-ignition or compression-ignition internal combustion piston engines)",
  "850239":
    "Electric generating sets; (excluding those with spark-ignition or compression-ignition internal combustion piston engines), other than wind powered",
  "850240": "Electric rotary converters",
  "850300": "Parts for electric motors, generators, and rotary converters",
  "850410": "Discharge lamps or tubes; ballasts therefor",
  "850421":
    "Electrical transformers; liquid dielectric, having a power handling capacity not exceeding 650kVA",
  "850422":
    "Electrical transformers; liquid dielectric, having a power handling capacity exceeding 650kVA but not exceeding 10,000kVA",
  "850423":
    "Electrical transformers; liquid dielectric, having a power handling capacity exceeding 10,000kVA",
  "850431":
    "Electrical transformers; n.e.c. in item no. 8504.2, having a power handling capacity not exceeding 1kVA",
  "850432":
    "Transformers; n.e.c. in item no. 8504.2, having a power handling capacity exceeding 1kVA but not exceeding 16kVA",
  "850433":
    "Transformers; n.e.c. in item no. 8504.2, having a power handling capacity exceeding 16kVA but not exceeding 500kVA",
  "850434":
    "Transformers; n.e.c. in item no. 8504.2, having a power handling capacity exceeding 500kVA",
  "850440": "Electrical static converters",
  "850450": "Electrical inductors; n.e.c. in heading no. 8504",
  "850490":
    "Electrical transformers, static converters and inductors; parts thereof",
  "850511":
    "Magnets; permanent magnets and articles intended to become permanent magnets after magnetisation, of metal",
  "850519":
    "Magnets; permanent magnets and articles intended to become permanent magnets after magnetisation, other than of metal",
  "850520": "Magnets; electro-magnetic couplings, clutches and brakes",
  "850530": "Magnets; electro-magnetic lifting heads",
  "850590":
    "Magnets; electro-magnets, holding devices and parts n.e.c. in heading no. 8505",
  "850610": "Cells and batteries; primary, manganese dioxide",
  "850611":
    "Cells and batteries; primary, of an external volume not exceeding 300cm3, manganese dioxide",
  "850612":
    "Cells and batteries; primary, of an external volume not exceeding 300cm3, mercuric oxide",
  "850613":
    "Cells and batteries; primary, of an external volume not exceeding 300cm3, silver oxide",
  "850619":
    "Cells and batteries; primary, of an external volume not exceeding 300cm3, n.e.s. in heading no. 8506",
  "850620":
    "Cells and batteries; primary, of an external volume exceeding 300cm3",
  "850630": "Cells and batteries; primary, mercuric oxide",
  "850640": "Cells and batteries; primary, silver oxide",
  "850650": "Cells and batteries; primary, lithium",
  "850660": "Cells and batteries; primary, air-zinc",
  "850680":
    "Cells and batteries; primary, (other than manganese dioxide, mercuric oxide, silver oxide, lithium or air-zinc)",
  "850690": "Cells and batteries; primary, parts thereof",
  "850710":
    "Electric accumulators; lead-acid, of a kind used for starting piston engines, including separators, whether or not rectangular (including square)",
  "850720":
    "Electric accumulators; lead-acid, (other than for starting piston engines), including separators, whether or not rectangular (including square)",
  "850730":
    "Electric accumulators; nickel-cadmium, including separators, whether or not rectangular (including square)",
  "850740":
    "Electric accumulators; nickel-iron, including separators, whether or not rectangular (including square)",
  "850750":
    "Electric accumulators; nickel-metal hydride, including separators, whether or not rectangular (including square)",
  "850760": "Li-ion batteries",
  "850780":
    "Electric accumulators; other than lead-acid, nickel-cadmium, nickel-iron, nickel-metal hydride and lithium-ion, including separators, whether or not rectangular (including square)",
  "850790": "Electric accumulators; parts n.e.c. in heading no. 8507",
  "850810":
    "Electro-mechanical tools; drills of all kinds, for working in the hand, with self-contained electric motor",
  "850811":
    "Vacuum cleaners, with self-contained electric motor, of a power not exceeding 1,500 W and having a dust bag or other receptacle capacity not exceeding 20L",
  "850819":
    "Vacuum cleaners, with self-contained electric motor, n.e.c. in item no. 8508.1",
  "850820":
    "Electro-mechanical tools; saws, for working in the hand, with self-contained electric motor",
  "850860": "Vacuum cleaners, other than with a self-contained electric motor",
  "850870": "Parts of vacuum cleaners",
  "850880":
    "Electro-mechanical tools; (other than drills and saws), for working in the hand, with self-contained electric motor",
  "850890": "Electro-mechanical tools; parts of the tools of heading no. 8508",
  "850910":
    "Electro-mechanical domestic appliances; with self-contained electric motor, vacuum cleaners (including dry and wet)",
  "850920":
    "Electro-mechanical domestic appliances; floor polishers with self-contained electric motor",
  "850930":
    "Electro-mechanical domestic appliances; kitchen waste disposers with self-contained electric motor",
  "850940":
    "Electro-mechanical domestic appliances; food grinders and mixers, fruit or vegetable juice extractors, with self-contained electric motor",
  "850980":
    "Electro-mechanical domestic appliances; with self-contained electric motor, other than vacuum cleaners of heading 85.08, n.e.c. in heading no. 8509",
  "850990":
    "Electro-mechanical domestic appliances; parts for the appliances of heading no. 8509",
  "851010": "Shavers; with self-contained electric motor",
  "851020": "Hair clippers; with a self-contained electric motor",
  "851030": "Hair-removing appliances; with self-contained electric motor",
  "851090":
    "Shavers and hair clippers; parts of those with self-contained electric motor",
  "851110":
    "Ignition or starting equipment; spark plugs, of a kind used for spark or compression-ignition internal combustion engines",
  "851120":
    "Ignition or starting equipment; ignition magnetos, magneto-dynamos and magnetic flywheels, of a kind used for spark or compression-ignition internal combustion engines",
  "851130":
    "Ignition or starting equipment; distributors and ignition coils of a kind used for spark-ignition or compression-ignition internal combustion engines",
  "851140":
    "Ignition or starting equipment; starter motors and dual purpose starter-generators, of a kind used for spark or compression-ignition internal combustion engines",
  "851150":
    "Ignition or starting equipment; generators n.e.c. in heading no. 8511, of a kind used for spark or compression-ignition internal combustion engines",
  "851180":
    "Ignition or starting equipment; n.e.c. in heading no. 8511, of a kind used for spark or compression-ignition internal combustion engines",
  "851190":
    "Ignition or starting equipment; parts of the equipment of heading no. 8511, for use in spark-ignition or compression-ignition internal combustion engines",
  "851210":
    "Lighting or visual signalling equipment; electrical, of a kind used on bicycles, excluding articles of heading no. 8539",
  "851220":
    "Lighting or visual signalling equipment for motor vehicles; excl. main electric filament or discharge lamp categories",
  "851230":
    "Sound signalling equipment; electrical, used on cycles or motor vehicles (excluding articles of heading no. 8539)",
  "851240":
    "Windscreen wipers, defrosters and demisters; electrical, of kinds used for cycles or motor vehicles",
  "851290":
    "Lighting or signalling equipment; electrical, (excluding articles of heading no. 8539), windscreen wipers, defrosters and demisters; parts, of those kinds used for cycles or motor vehicles",
  "851310":
    "Lamps; portable, electric, designed to function by their own source of energy (excluding lighting equipment of heading no. 8512)",
  "851390":
    "Lamps; parts of portable, electric lamps of heading no. 8513, designed to function by their own source of energy",
  "851410":
    "Furnaces and ovens; electric, for industrial or laboratory use, resistance heated",
  "851411":
    "Furnaces and ovens; electric, for industrial or laboratory use, resistance heated; hot isostatic presses",
  "851419":
    "Furnaces and ovens; electric, for industrial or laboratory use, resistance heated; other than hot isostatic presses, for the manufacture of semiconductor devices on semiconductor wafers",
  "851420":
    "Furnaces and ovens; electric, for industrial or laboratory use, functioning by induction or dielectric loss",
  "851430":
    "Furnaces and ovens; electric, for industrial or laboratory use, other than those functioning by induction, dielectric loss or resistance heated",
  "851431":
    "Furnaces and ovens; electric, for industrial or laboratory use, other than those functioning by induction, dielectric loss or resistance heated, electron beam furnaces",
  "851432":
    "Furnaces and ovens; electric, for industrial or laboratory use, other than those functioning by induction, dielectric loss or resistance heated, plasma and vacuum arc furnaces",
  "851439":
    "Furnaces and ovens; electric, for industrial or laboratory use, other than those functioning by induction, dielectric loss or resistance heated, other than electron beam, plasma or vacuum arc furnaces",
  "851440":
    "Heating equipment; for the heat treatment of materials by induction or dielectric loss, industrial or laboratory, other than furnaces and ovens",
  "851490":
    "Furnaces, ovens and heating equipment; parts of the industrial or laboratory equipment of heading no. 8514",
  "851511":
    "Brazing or soldering machines and apparatus; soldering irons and guns, whether or not capable of cutting",
  "851519":
    "Brazing or soldering machines and apparatus; other than soldering irons and guns, whether or not capable of cutting",
  "851521":
    "Welding machines and apparatus; for resistance welding of metal, fully or partly automatic, whether or not capable of cutting",
  "851529":
    "Welding machines and apparatus; for resistance welding of metal, other than fully or partly automatic, whether or not capable of cutting",
  "851531":
    "Welding machines and apparatus; for arc (including plasma arc) welding of metals, fully or partly automatic, whether or not capable of cutting",
  "851539":
    "Welding machines and apparatus; for arc (including plasma arc) welding of metals, other than fully or partly automatic, whether or not capable of cutting",
  "851580":
    "Welding machines and apparatus; n.e.c. in heading no. 8515, whether or not capable of cutting",
  "851590":
    "Welding, brazing or soldering machines; parts of the machines of heading no. 8515",
  "851610":
    "Heaters; electric, instantaneous or storage water and immersion heaters",
  "851621": "Heating apparatus; electric storage heating radiators",
  "851629":
    "Heating apparatus; electric soil heating apparatus and space heating apparatus (excluding storage heating radiators)",
  "851631": "Hair-dressing apparatus; electro-thermic hair dryers",
  "851632": "Hair-dressing apparatus; electro-thermic, other than hair dryers",
  "851633": "Hand-drying apparatus; electro-thermic",
  "851640": "Smoothing irons; electric",
  "851650": "Ovens; microwave, of a kind used for domestic purposes",
  "851660":
    "Ovens, cookers, cooking plates, boiling rings, grillers and roasters; of a kind used for domestic purposes (excluding microwaves)",
  "851671":
    "Electro-thermic appliances; coffee or tea makers, of a kind used for domestic purposes",
  "851672":
    "Electro-thermic appliances; toasters, of a kind used for domestic purposes",
  "851679":
    "Electro-thermic appliances; n.e.c. in heading no. 8516, used for domestic purposes",
  "851680": "Resistors; electric heating, other than those of heading no. 8545",
  "851690":
    "Electro-thermic appliances; parts, of heating resistors, of water, space and soil heaters, hair-dressing apparatus, hand dryers, smoothing irons and other domestic appliances of heading no. 8516",
  "851710": "Line telephony or telegraphy apparatus; telephone sets",
  "851711": "Line telephone sets with cordless handsets",
  "851712": "Cellphones",
  "851713":
    "Telephone sets; smartphones for cellular or other wireless networks",
  "851714":
    "Telephone sets; other than smartphones, for cellular or other wireless networks",
  "851718": "Telephone sets n.e.c. in item no. 8517.1",
  "851719":
    "Line telephony or telegraphy apparatus; telephone sets, n.e.s. in item no. 8517.11, videophones",
  "851720": "Line telephony or telegraphy apparatus; teleprinters",
  "851721": "Line telephony or telegraphy apparatus; facsimile machines",
  "851722": "Line telephony or telegraphy apparatus; teleprinters",
  "851730":
    "Line telephony or telegraphy apparatus; telephonic or telegraphic switching apparatus",
  "851740":
    "Line telephony or telegraphy apparatus; for carrier-current line systems, n.e.s. in heading no. 8517",
  "851750":
    "Line telephony or telegraphy apparatus; n.e.s. in heading no. 8517, for carrier-current line systems or for digital line systems",
  "851761": "Base stations",
  "851762":
    "Communication apparatus (excluding telephone sets or base stations)",
  "851769":
    "Communication apparatus (excluding telephone sets or base stations); machines for the transmission or reception of voice, images or other data (including wired/wireless networks), n.e.c. in item no. 8517.6",
  "851770": "Parts for phones or cellphones",
  "851771":
    "Communication apparatus; parts, aerials and aerial reflectors of all kinds, part suitable for use therewith",
  "851779":
    "Communication apparatus; parts, other than aerials and aerial reflectors of all kinds",
  "851780":
    "Line telephony or telegraphy apparatus; n.e.s. in heading no. 8517",
  "851781": "Telephonic apparatus; n.e.s. in heading no. 8517",
  "851782": "Telegraphic apparatus; n.e.s. in heading no. 8517",
  "851790":
    "Line telephony or telegraphy apparatus; electrical, parts of the apparatus of heading no. 8517",
  "851810": "Microphones and stands therefor",
  "851821": "Loudspeakers; single, mounted in their enclosures",
  "851822": "Loudspeakers; multiple, mounted in the same enclosure",
  "851829": "Loudspeakers; not mounted in their enclosures",
  "851830": "Headphones and earphones",
  "851840": "Amplifiers; audio-frequency electric",
  "851850": "Amplifier sets; electric sound",
  "851890":
    "Microphones, headphones, earphones, amplifier equipment; parts of the equipment of heading no. 8518",
  "851910":
    "Sound reproducing apparatus; coin or disc-operated record players, not incorporating a sound recording device",
  "851920":
    "Sound recording or reproducing apparatus; operated by coins, banknotes, bank cards, tokens or by other means of payment",
  "851921":
    "Sound reproducing apparatus; record players without loudspeaker, other than coin or disc-operated, not incorporating a sound recording device",
  "851929":
    "Sound reproducing apparatus; record players with loudspeaker, other than coin or disc-operated, not incorporating a sound recording device",
  "851930":
    "Sound recording or reproducing apparatus; turntables (record-decks)",
  "851931":
    "Sound reproducing apparatus; turntables (record-decks), with automatic record changing mechanism, not incorporating a sound recording device",
  "851939":
    "Sound reproducing apparatus; turntables (record-decks), without automatic record changing mechanism, not incorporating a sound recording device",
  "851940":
    "Sound reproducing apparatus; transcribing machines, not incorporating a sound recording device",
  "851950":
    "Sound recording or reproducing apparatus; telephone answering machines",
  "851981":
    "Sound recording or reproducing apparatus; using magnetic, optical or semiconductor media, n.e.c. in item no 8519.20, 8519.30 or 8519.50",
  "851989":
    "Sound recording or reproducing apparatus; n.e.c. in heading no 8519",
  "851991":
    "Sound reproducing apparatus; cassette-type, n.e.s. in heading no. 8519, not incorporating a sound recording device",
  "851992":
    "Sound reproducing apparatus; n.e.s. in heading no. 8519, pocket-size cassette players, not incorporating a sound recording device",
  "851993":
    "Sound reproducing apparatus; n.e.s. in heading no. 8519, cassette-type, (not pocket-size), not incorporating a sound recording device",
  "851999":
    "Sound reproducing apparatus; other than cassette-type, n.e.s. in heading no. 8519, not incorporating a sound recording device",
  "852010":
    "Sound recording apparatus; dictating machines, not capable of operating without an external source of power, whether or not incorporating a sound reproducing device",
  "852020":
    "Sound recording apparatus; telephone answering machines, whether or not incorporating a sound reproducing device",
  "852031":
    "Sound recording apparatus; magnetic tape recorders, cassette-type, incorporating a sound reproducing apparatus",
  "852032":
    "Sound recording apparatus; magnetic tape recorders (n.e.s. in item no. 8520.10 or 8520.20), incorporating sound reproducing apparatus, digital audio type",
  "852033":
    "Sound recording apparatus; magnetic tape recorders (n.e.s. in item no. 8520.10 or 8520.20), incorporating sound reproducing apparatus, cassette type, not digital audio type",
  "852039":
    "Sound recording apparatus; magnetic tape recorders (n.e.s. in item no. 8520.10 or 8520.20), incorporating sound reproducing apparatus, other than cassette-type or digital audio type",
  "852090":
    "Sound recording apparatus; n.e.s. in heading no. 8520, whether or not incorporating sound reproducing apparatus",
  "852110": "Video recording or reproducing apparatus; magnetic tape-type",
  "852190":
    "Video recording or reproducing apparatus; other than magnetic tape-type",
  "852210":
    "Sound recording or reproducing apparatus; parts and accessories thereof, pick-up cartridges",
  "852290":
    "Sound or video recording or reproducing apparatus; parts and accessories thereof, other than pick-up cartridges",
  "852311":
    "Media, unrecorded; magnetic tapes, prepared, of a width not exceeding 4mm, for sound or similar recording of other phenomena (excluding products of chapter 37)",
  "852312":
    "Media, unrecorded; magnetic tapes, prepared, of a width exceeding 4mm but not exceeding 6.5mm, for sound or similar recording of other phenomena (excluding products of chapter 37)",
  "852313":
    "Media, unrecorded; magnetic tapes, prepared, of a width exceeding 6.5mm, for sound or similar recording of other phenomena (excluding products of chapter 37)",
  "852320":
    "Media, unrecorded; magnetic discs, prepared, for sound or similar recording of other phenomena (excluding products of chapter 37)",
  "852321":
    "Magnetic media; cards incorporating a magnetic stripe, whether or not recorded, excluding products of Chapter 37",
  "852329":
    "Magnetic media; other than cards incorporating a magnetic stripe, whether or not recorded, excluding products of Chapter 37",
  "852330":
    "Media, unrecorded; cards incorporating a magnetic stripe, prepared, for sound or similar recording of other phenomena, (excluding products of chapter 37)",
  "852340":
    "Optical media, whether or not recorded, excluding products of Chapter 37",
  "852341": "Optical media; unrecorded, excluding products of Chapter 37",
  "852349": "Optical media; recorded, excluding products of Chapter 37",
  "852351": "Semiconductor media storage devices; solid-state, non-volatile",
  "852352":
    "Semiconductor media; smart cards,  whether or not recorded, excluding products of Chapter 37",
  "852359":
    "Semiconductor media; other than smart cards, whether or not recorded, excluding products of Chapter 37",
  "852380":
    "Media n.e.c. in heading 8523, whether or not recorded, excluding products of Chapter 37",
  "852390":
    "Media, unrecorded; prepared products n.e.s. in heading no. 8523, for sound or similar recording of other phenomena (excluding products of chapter 37)",
  "852410":
    "Media, recorded; gramophone records, for sound or other similarly recorded phenomena (excluding products of chapter 37)",
  "852411":
    "Flat panel display modules, whether or not incorporating touch-sensitive screens; of liquid crystals, without drivers or control circuits",
  "852412":
    "Flat panel display modules, whether or not incorporating touch-sensitive screens; of organic light-emitting diodes (OLED), without drivers or control circuits",
  "852419":
    "Flat panel display modules, whether or not incorporating touch-sensitive screens; of other than liquid crystals or organic light-emitting diodes (OLED), without drivers or control circuits",
  "852421":
    "Media, recorded; magnetic tapes, (of a width not exceeding 4mm), for sound or other similarly recorded phenomena (excluding products of chapter 37)",
  "852422":
    "Media, recorded; magnetic tapes, of a width exceeding 4mm but not exceeding 6.5mm, for sound recording or similar recording of other phenomena (excluding products of chapter 37)",
  "852423":
    "Media, recorded; magnetic tapes, of a width exceeding 6.5mm, for sound or other similarly recorded phenomena (excluding products of chapter 37)",
  "852431":
    "Media, recorded; discs for laser reading systems, for reproducing phenomena other than sound or image, (excluding products of chapter 37)",
  "852432":
    "Media, recorded; discs for laser reading systems, for reproducing sound only, (excluding products of chapter 37)",
  "852439":
    "Media, recorded; discs for laser reading systems, for reproducing sound or image, not for reproducing sound only, (excluding products of chapter 37)",
  "852440":
    "Media, recorded; magnetic tapes for reproducing phenomena (other than sound or image), (excluding products of chapter 37)",
  "852451":
    "Media, recorded; magnetic tapes for reproducing sound or image, of a width not exceeding 4mm, (excluding products of chapter 37)",
  "852452":
    "Media, recorded; magnetic tapes for reproducing sound or image, of a width exceeding 4mm but not exceeding 6.5mm, (excluding products of chapter 37)",
  "852453":
    "Media, recorded; magnetic tapes for reproducing sound or image, of a width exceeding 6.5mm, (excluding products of chapter 37)",
  "852460":
    "Media, recorded; cards incorporating a magnetic stripe, for sound or other similarly recorded phenomena, (excluding products of chapter 37)",
  "852490":
    "Media, recorded; n.e.s. in heading no. 8524 for sound or similarly recorded phenomena, including matrices and masters for the production of records (excluding products of chapter 37)",
  "852491":
    "Media, recorded; n.e.s. in heading no. 8524, for reproducing phenomena other than sound or image, (excluding products of chapter 37)",
  "852492":
    "Flat panel display modules, whether or not incorporating touch-sensitive screens; of organic light-emitting diodes (OLED), with drivers or control circuits",
  "852499":
    "Media, recorded; n.e.s. in heading no. 8524, for reproducing sound or image, (excluding products of chapter 37)",
  "852510":
    "Transmission apparatus; for radio-telephony, radio-telegraphy, radio-broadcasting or television, whether or not incorporating reception or sound recording and reproducing apparatus",
  "852520":
    "Transmission apparatus; for radio-telephony, radio-telegraphy, radio-broadcasting or television, with reception apparatus, with or without sound recording or reproducing apparatus",
  "852530": "Television cameras",
  "852540":
    "Cameras; still image video cameras and other video camera recorders; digital cameras",
  "852550":
    "Transmission apparatus for radio-broadcasting or television, whether or not incorporating sound recording or reproducing apparatus, not incorporating reception apparatus",
  "852560":
    "Transmission apparatus for radio-broadcasting or television, whether or not incorporating sound recording or reproducing apparatus, incorporating reception apparatus",
  "852580": "Television cameras, digital cameras and video camera recorders",
  "852581":
    "Television cameras, digital cameras and video camera recorders; high-speed goods as specified in subheading note 1 to this chapter",
  "852582":
    "Television cameras, digital cameras and video camera recorders; radiation-hardened or radiation-tolerant goods as specified in subheading note 2 to this chapter",
  "852583":
    "Television cameras, digital cameras and video camera recorders; night vision goods as specified in subheading note 3 to this chapter",
  "852589": "Television cameras; n.e.c. in item no 8525.8",
  "852610": "Radar apparatus",
  "852691": "Radio navigational aid apparatus",
  "852692": "Radio remote control apparatus",
  "852711":
    "Radio-broadcast receivers; operational without external power source, combined with sound recording or reproducing apparatus, including apparatus capable of receiving radio-telephony or radio-telegraphy",
  "852712":
    "Radio broadcast receivers capable of operating without an external power source; pocket-size radio cassette-players",
  "852713":
    "Radio broadcast receivers capable of operating without an external power source; apparatus (other than pocket-size radio cassette-players), combined with sound recording or reproducing apparatus",
  "852719":
    "Radio broadcast receivers capable of operating without an external power source; n.e.c. in item no. 8527.1",
  "852721":
    "Radio-broadcast receivers not capable of operating without an external source of power, of a kind used in motor vehicles; combined with sound recording or reproducing apparatus",
  "852729":
    "Radio-broadcast receivers not capable of operating without an external source of power, of a kind used in motor vehicles; not combined with sound recording or reproducing apparatus",
  "852731":
    "Radio-broadcast receivers; n.e.s. in heading no. 8527, combined with sound recording or reproducing apparatus, including apparatus capable of receiving radio-telephony or radio-telegraphy",
  "852732":
    "Radio broadcast receivers; n.e.s. in heading no. 8527, combined with a clock, including apparatus capable of receiving radio-telephony or radio-telegraphy",
  "852739":
    "Radio-broadcast receivers; n.e.s. in heading no. 8527, other than with sound recording, reproducing apparatus or clock, including apparatus capable of receiving radio-telephony or radio-telegraphy",
  "852790":
    "Reception apparatus; for radio-telephony, radio-telegraphy or radio-broadcasting, whether or not combined in the same housing, n.e.s. in heading no. 8527",
  "852791":
    "Radio-broadcast receivers n.e.c. in heading no. 8527; combined with sound recording or reproducing apparatus",
  "852792":
    "Radio-broadcast receivers n.e.c. in heading no. 8527; not combined with sound recording or reproducing apparatus but combined with a clock",
  "852799":
    "Radio-broadcast receivers n.e.c. in heading no. 8527; not combined with sound recording or reproducing apparatus and not combined with a clock",
  "852810":
    "Television receivers; colour, whether or not combined, in the same housing, with radio broadcast receivers or sound or video recording or reproducing apparatus",
  "852812":
    "Television receivers; colour, whether or not combined, in the same housing, with radio-broadcast receivers or sound or video recording or reproducing apparatus",
  "852813":
    "Television receivers; black and white or other monochrome, whether or not incorporating radio broadcast receivers or sound or video recording or reproducing apparatus",
  "852820":
    "Television receivers; black and white or other monochrome, whether or not combined, in the same housing, with radio broadcast receivers or sound or video recording or reproducing apparatus",
  "852821": "Video monitors; colour",
  "852822": "Video monitors; black and white and other monochrome",
  "852830": "Video projectors",
  "852841":
    "Cathode-ray tube monitors; of a kind solely or principally used in an automatic data processing system of heading 84.71",
  "852842":
    "Monitors; cathode-ray tube, capable of directly connecting to and designed for use with an automatic data processing machine of heading 84.71",
  "852849":
    "Monitors; cathode-ray tube, n.e.c. in subheading 8528.42, whether or not colour",
  "852851":
    "Monitors other than cathode-ray tube; of a kind solely or principally used in an automatic data processing system of heading 84.71",
  "852852": "Computer monitors; excl. CRTs",
  "852859":
    "Monitors other than cathode-ray tube; n.e.c. in subheading 8528.52, whether or not colour",
  "852861":
    "Projectors; of a kind solely or principally used in an automatic data processing system of heading 84.71",
  "852862":
    "Projectors; capable of directly connecting to and designed for use with an automatic data processing machine of heading 84.71",
  "852869": "Projectors; n.e.c. in subheading 8528.62, whether or not colour",
  "852871":
    "Reception apparatus for television, whether or not incorporating radio-broadcast receivers or sound or video recording or reproducing apparatus; not designed to incorporate a video display or screen",
  "852872": "Televisions",
  "852873":
    "Reception apparatus for television, whether or not incorporating radio-broadcast receivers or sound or video recording or reproducing apparatus; incorporating a monochrome video display or screen",
  "852910":
    "Reception and transmission apparatus; aerials and aerial reflectors of all kinds and parts suitable for use therewith",
  "852990": "Parts for radio or TV reception and transmission apparatus",
  "853010":
    "Signalling, safety or traffic control equipment; for railways or tramways (excluding those of heading no. 8608)",
  "853080":
    "Signalling, safety or traffic control equipment; for roads, inland waterways, parking facilities, port installations or airfields (excluding those of heading no. 8608)",
  "853090":
    "Signalling apparatus; parts of safety, traffic control equipment for railways, tramways, roads, inland waterways, airfields, parking facilities, port instalments (excluding those of heading no. 8608)",
  "853110":
    "Signalling apparatus; electric, sound or visual, burglar or fire alarms and similar, other than those of heading no. 8512 or 8530",
  "853120":
    "Signalling apparatus; electric, sound or visual, indicator panels incorporating liquid crystal devices (LCD) or light-emitting diodes (LED), excluding those of heading no. 8512 or 8530",
  "853180":
    "Signalling apparatus; electric, sound or visual, apparatus n.e.c. in heading no. 8531, excluding those of heading no. 8512 or 8530",
  "853190":
    "Signalling apparatus; parts of the electric, sound or visual apparatus of heading no. 8531",
  "853210":
    "Electrical capacitors; fixed, designed for use in 50/60 Hz circuits and having a reactive power handling capacity of not less than 0.5 kvar (power capacitors)",
  "853221": "Electrical capacitors; fixed, tantalum",
  "853222": "Electrical capacitors; fixed, aluminium electrolytic",
  "853223": "Electrical capacitors; fixed, ceramic dielectric, single layer",
  "853224": "Electric capacitors; fixed, ceramic, multilayer",
  "853225": "Electrical capacitors; fixed, dielectric of paper or plastics",
  "853229": "Electrical capacitors; fixed, n.e.c. in heading no. 8532",
  "853230":
    "Electrical capacitors; variable or adjustable (pre-set) capacitors",
  "853290":
    "Electrical capacitors; parts of the capacitors of heading no. 8532",
  "853310":
    "Electrical resistors; fixed carbon resistors, composition or film types (including rheostats and potentiometers but excluding heating resistors)",
  "853321":
    "Electrical resistors; fixed, for a power handling capacity not exceeding 20W (including rheostats and potentiometers but excluding heating resistors and carbon resistors)",
  "853329":
    "Electrical resistors; fixed, for a power handling capacity exceeding 20W (including rheostats and potentiometers but excluding heating resistors and carbon resistors)",
  "853331":
    "Electrical resistors; wirewound variable, including rheostats and potentiometers, for a power handling capacity not exceeding 20W (excluding heating)",
  "853339":
    "Electrical resistors; wirewound variable, including rheostats and potentiometers, for a power handling capacity exceeding 20W (excluding heating)",
  "853340":
    "Electrical resistors; variable, including rheostats and potentiometers (excluding heating)",
  "853390": "Resistors; parts of the resistors of heading no. 8533",
  "853400": "Printed circuits",
  "853510": "Electrical apparatus; fuses, for a voltage exceeding 1000 volts",
  "853521":
    "Electrical apparatus; automatic circuit breakers, for a voltage exceeding 1000 volts but less than 72.5kV",
  "853529":
    "Electrical apparatus; automatic circuit breakers, for a voltage of 72.5kV or more",
  "853530":
    "Electrical apparatus; isolating and make-and-break switches, for a voltage exceeding 1000 volts",
  "853540":
    "Electrical apparatus; lightning arresters, voltage limiters and surge suppressors (for a voltage exceeding 1000 volts)",
  "853590":
    "Electrical apparatus; n.e.c. in heading no. 8535, for switching or protecting electrical circuits, for a voltage exceeding 1000 volts",
  "853610":
    "Electrical apparatus; fuses, for a voltage not exceeding 1000 volts",
  "853620":
    "Electrical apparatus; automatic circuit breakers, for a voltage not exceeding 1000 volts",
  "853630":
    "Electrical apparatus; for protecting electrical circuits, n.e.c. in heading no. 8536, for a voltage not exceeding 1000 volts",
  "853641":
    "Electrical apparatus; relays, (for a voltage not exceeding 60 volts)",
  "853649": "Electrical apparatus; relays, for a voltage exceeding 60 volts",
  "853650": "Other electrical switches <1kV (exclusionary category)",
  "853661":
    "Electrical apparatus; lamp-holders, for a voltage not exceeding 1000 volts",
  "853669": "Electrical plugs and sockets; <1kV",
  "853670": "Connectors for optical fibres, optical fibre bundles or cables",
  "853690":
    "Other electrical circuit switches and protectors; <1kV (exclusionary category)",
  "853710": "Electrical control and distribution boards; < 1kV",
  "853720":
    "Boards, panels, consoles, desks and other bases; for electric control or the distribution of electricity, (other than switching apparatus of heading no. 8517), for a voltage exceeding 1000 volts",
  "853810":
    "Electrical apparatus; parts (e.g. boards, panels, consoles, desks, cabinets, other bases), for goods of heading no. 8537, not equipped with their apparatus",
  "853890": "Parts for electric switches, protectors, connectors, and boards",
  "853910": "Lamps; sealed beam units",
  "853921":
    "Lamps; filament, (excluding ultra-violet or infra-red), tungsten halogen",
  "853922":
    "Lamps; filament, (excluding ultra-violet or infra-red), of a power not exceeding 200W and for a voltage exceeding 100 volts, other than tungsten halogen",
  "853929":
    "Lamps; filament, (excluding ultra-violet or infra-red), n.e.c. in item no. 8539.2",
  "853931":
    "Lamps; discharge, (excluding ultra-violet), fluorescent, hot cathode",
  "853932":
    "Lamps; discharge, (excluding ultra-violet), mercury or sodium vapour lamps, metal halide lamps",
  "853939":
    "Lamps; discharge, (excluding ultra-violet, excluding fluorescent, hot cathode)",
  "853940":
    "Lamps; ultra-violet or infra-red, arc-lamps lamps, ultra-violet or infra-red, arc-lamps",
  "853941": "Lamps; arc-lamps",
  "853949": "Lamps; ultra-violet or infra-red lamps, (excluding arc-lamps)",
  "853950": "Lamps; light-emitting diode (LED) lamps",
  "853951":
    "Lamps; light-emitting diode (LED) light sources, light-emitting diode (LED) modules",
  "853952":
    "Lamps; light-emitting diode (LED) light sources, light-emitting diode (LED) lamps",
  "853990": "Lamps; parts of the lamps of heading no. 8539",
  "854011":
    "Tubes; cathode-ray television picture tubes, including video monitor cathode-ray tubes, colour",
  "854012":
    "Tubes; cathode-ray television picture tubes, including video monitor cathode-ray tubes, monochrome",
  "854020":
    "Tubes; television camera tubes, image converters and intensifiers, other photo-cathode tubes",
  "854030": "Tubes; cathode ray tubes, n.e.s. in heading no. 8540",
  "854040":
    "Tubes; data/graphic display tubes, monochrome; data/graphic display tubes, colour, with a phosphor dot screen pitch smaller than 0.4mm",
  "854041": "Tubes; microwave tubes, magnetrons, excluding grid-controlled",
  "854042": "Tubes; microwave tubes, klystrons, excluding grid-controlled",
  "854049":
    "Tubes; microwave tubes, other than magnetrons and klystrons, excluding grid-controlled",
  "854050": "Tubes; data/graphic display, black and white or other monochrome",
  "854060": "Tubes; cathode ray, n.e.c. in heading no. 8540",
  "854071": "Tubes; microwave, magnetrons, excluding grid-controlled tubes",
  "854072": "Tubes; microwave, klystrons, excluding grid-controlled tubes",
  "854079":
    "Tubes; microwave (for example klystrons, travelling wave tubes, carlinotrons), excluding magnetrons and grid-controlled tubes",
  "854081": "Valves and tubes; receiver or amplifier",
  "854089": "Valves and tubes; n.e.c. in heading no. 8540",
  "854091": "Tubes; parts of cathode-ray tubes",
  "854099":
    "Valves and tubes; parts of the valves and tubes of heading no. 8540, excluding parts of cathode-ray tubes",
  "854110":
    "Electrical apparatus; diodes, other than photosensitive or light-emitting diodes (LED)",
  "854121":
    "Electrical apparatus; transistors, (other than photosensitive), with a dissipation rate of less than 1W",
  "854129": "Transistors; dissipation rate >1W; excl. photosensitive",
  "854130":
    "Electrical apparatus; thyristors, diacs and triacs, other than photosensitive devices",
  "854140": "Photosensitive/photovoltaic/LED semiconductor devices",
  "854141":
    "Electrical apparatus; photosensitive semiconductor devices, light emitting diodes (LED)",
  "854142":
    "Electrical apparatus; photosensitive semiconductor devices, photovoltaic cells not assembled in modules or made up into panels",
  "854143":
    "Electrical apparatus; photosensitive semiconductor devices, photovoltaic cells assembled in modules or made up into panels",
  "854149":
    "Electrical apparatus; photosensitive semiconductor devices, diodes other than light emitting diodes and photovoltaic cells whether or not assembled in modules or made up into panels",
  "854150":
    "Electrical apparatus; photosensitive semiconductor devices n.e.c. in heading no. 8541, including photovoltaic cells, whether or not assembled in modules or made up into panels",
  "854151":
    "Electrical apparatus; photosensitive semiconductor devices, semiconductor-based transducers",
  "854159":
    "Electrical apparatus; photosensitive semiconductor devices n.e.c. in heading no. 8541",
  "854160": "Crystals; mounted piezo-electric",
  "854190":
    "Electrical apparatus; parts for diodes, transistors and similar semiconductor devices and photosensitive semiconductor devices",
  "854210":
    "Electronic integrated circuits; cards incorporating an electronic integrated circuit (smart cards)",
  "854211": "Electronic circuits; monolithic integrated, digital",
  "854212":
    'Electronic circuits; monolithic, integrated, digital, cards incorporating an electronic integrated circuit ("smart" cards)',
  "854213":
    "Electronic circuits; monolithic, integrated, digital, metal oxide semiconductors (MOS technology)",
  "854214":
    "Electronic circuits; monolithic, integrated, digital, circuits obtained by bipolar technology",
  "854219":
    "Electronic circuits; monolithic, integrated, digital, other, n.e.s. in item no. 8542.1, including circuits obtained by a combination of bipolar and MOS technologies (BIMOS technology)",
  "854220": "Electronic circuits; hybrid integrated",
  "854221":
    "Electronic integrated circuits and microassemblies; monolithic integrated circuits, digital",
  "854229":
    "Electronic integrated circuits; monolithic integrated circuits, other than digital",
  "854230": "Electronic circuits; monolithic, integrated, other than digital",
  "854231": "Chips; processors and controllers",
  "854232": "Chips; memories",
  "854233": "Integrated circuit amplifier",
  "854239": "Other chips (exclusionary category)",
  "854240": "Electronic circuits; hybrid, integrated",
  "854250": "Electronic microassemblies",
  "854260": "Electronic integrated circuits; hybrid integrated circuits",
  "854270": "Electronic microassemblies",
  "854280":
    "Electronic circuits and microassemblies; integrated, other than monolithic and hybrid integrated circuits",
  "854290": "Parts of electronic integrated circuits",
  "854310": "Electrical machines and apparatus; particle accelerators",
  "854311":
    "Electrical machines and apparatus; particle accelerators, ion implanters for doping semiconductor materials, having individual functions n.e.s. in chapter 85",
  "854319":
    "Electrical machines and apparatus; particle accelerators, (other than ion implanters for doping semiconductor materials), having individual functions n.e.s. in chapter 85",
  "854320": "Electrical machines and apparatus; signal generators",
  "854330":
    "Electrical machines and apparatus; for electroplating, electrolysis or electrophoresis",
  "854340":
    "Electrical machines and apparatus; electric fence energisers, having individual functions n.e.s. in chapter 85",
  "854370":
    "Other electrical machines and apparatus; having individual functions (exclusionary category)",
  "854380":
    "Electrical machines and apparatus; having individual functions, n.e.s. in heading no. 8543",
  "854381":
    "Electrical machines and apparatus; n.e.s. in heading no. 8543, proximity cards and tags, having individual functions n.e.s. in chapter 85",
  "854389":
    "Electrical machines and apparatus; n.e.s. in heading no. 8543, (other than proximity cards or tags), having individual functions n.e.s. in chapter 85",
  "854390":
    "Electrical machines and apparatus; parts of the electrical goods of heading no. 8543",
  "854411": "Insulated electric conductors; winding wire, of copper",
  "854419":
    "Insulated electric conductors; winding wire, (of other than copper)",
  "854420":
    "Insulated electric conductors; co-axial cable and other co-axial electric conductors",
  "854430": "Ignition/other wiring sets for vehicles, aircraft, or ship",
  "854441":
    "Insulated electric conductors; for a voltage not exceeding 80 volts, fitted with connectors",
  "854442": "Insulated electric conductors; >1kV, fitted with connectors",
  "854449": "Insulated electric conductors; <1kV, not fitted with connectors",
  "854451":
    "Insulated electric conductors; for a voltage exceeding 80 volts but not exceeding 1000 volts, fitted with connectors",
  "854459":
    "Insulated electric conductors; for a voltage exceeding 80 volts but not exceeding 1000 volts, not fitted with connectors",
  "854460": "Insulated electric conductors; for a voltage exceeding 1000 volts",
  "854470": "Insulated electric conductors; optical fibre cables",
  "854511":
    "Carbon electrodes; with or without metal, of a kind used for furnaces",
  "854519":
    "Carbon electrodes; with or without metal, of a kind used for other than furnaces",
  "854520":
    "Carbon brushes; with or without metal, used for electrical purposes",
  "854590":
    "Carbon; lamp carbons, battery carbons and other articles of graphite or other carbon, with or without metal, of a kind used for electrical purposes",
  "854610": "Electrical insulators; of glass",
  "854620": "Electrical insulators; of ceramics",
  "854690": "Electrical insulators; other than of glass and ceramics",
  "854710":
    "Insulating fittings; of ceramics, for electrical machines, of insulating material only (except minor assembly parts), excluding those of heading no. 8546",
  "854720":
    "Insulating fittings; of plastics, for electrical machines, of insulating material only (except minor assembly parts), excluding those of heading no. 8546",
  "854790":
    "Insulating fittings; (other than of ceramics or plastics), for electrical machines, appliances and equipment, excluding insulators of heading no. 8546",
  "854800":
    "Electrical apparatus; parts of machinery and apparatus, n.e.s. in chapter 85",
  "854810":
    "Waste and scrap of primary cells, primary batteries and electric accumulators; spent primary cells, spent primary batteries and spent electric accumulators",
  "854890": "Electrical parts of machinery or apparatus; n.e.c. in chapter 85",
  "854911":
    "Waste and scrap of lead-acid accumulators; spent lead-acid accumulators",
  "854912":
    "Waste and scrap; of primary cells, primary batteries and electric accumulators, spent or not, containing lead, cadmium or mercury, other than lead-acid accumulators",
  "854913":
    "Waste and scrap; of primary cells, primary batteries and electric accumulators, spent or not, sorted by chemical type and not containing lead, cadmium or mercury",
  "854914":
    "Waste and scrap; of primary cells, primary batteries and electric accumulators, spent or not, unsorted and not containing lead, cadmium or mercury",
  "854919":
    "Waste and scrap; of primary cells, primary batteries and electric accumulators, n.e.c. in item no 8549.1",
  "854921":
    "Electrical and electronic waste and scrap; of a kind used principally for the recovery of precious metal, containing primary cells and batteries, electric accumulators, mercury-switches, glass from cathode ray tubes or other activated glass, or electrical",
  "854929":
    "Waste and scrap; of a kind used principally for the recovery of precious metal n.e.c. in item no 8549.21",
  "854931":
    "Electrical and electronic waste and scrap; electrical and electronic assemblies and printed circuit boards, other than those used principally for the recovery of precious metal, containing primary cells and batteries, electric accumulators, mercury-switch",
  "854939":
    "Waste and scrap; electrical and electronic assemblies and printed circuit boards, other than those used principally for the recovery of precious metal n.e.c. in item no 8549.31",
  "854991": "Waste and scrap; n.e.c. in heading no 8549",
  "854999": "Waste and scrap; n.e.c. in item no 8549.91",
  "860110": "Rail locomotives; powered from an external source of electricity",
  "860120": "Rail locomotives; powered by electric accumulators",
  "860210": "Rail locomotives; diesel-electric powered",
  "860290":
    "Rail locomotives and locomotive tenders; other than diesel-electric powered",
  "860310":
    "Railway or tramway coaches, vans and trucks; self-propelled, powered from an external source of electricity (excluding those of heading no. 8604)",
  "860390":
    "Railway or tramway coaches, vans and trucks; self-propelled, powered other than from an external source of electricity (excluding those of heading no. 8604)",
  "860400":
    "Railway or tramway maintenance or service vehicles; whether or not self-propelled (e.g. workshops, cranes, ballast tampers, trackliners, testing coaches and track inspection vehicles)",
  "860500":
    "Railway or tramway coaches; passenger coaches, luggage vans, post office coaches and other special purpose railway or tramway coaches, not self-propelled (excluding those of heading no. 8604)",
  "860610":
    "Railway or tramway goods vans and wagons; tank wagons and the like, not self-propelled",
  "860620":
    "Railway or tramway goods vans and wagons; insulated or refrigerated, not self-propelled, excluding those of item no. 8606.10",
  "860630":
    "Railway or tramway goods vans and wagons; self-discharging, not self-propelled, excluding those of item no. 8606.10",
  "860691":
    "Railway or tramway goods vans and wagons; covered and closed, not self-propelled",
  "860692":
    "Railway or tramway goods vans and wagons; open, with non-removable sides of a height exceeding 60cm, not self-propelled",
  "860699":
    "Railway or tramway goods vans and wagons; n.e.c. in heading no. 8606, not self-propelled",
  "860711":
    "Railway or tramway locomotives or rolling stock; parts, driving bogies and bissel-bogies",
  "860712":
    "Railway or tramway locomotives or rolling stock; parts, bogies and bissel-bogies (excluding driving bogies and bissel-bogies)",
  "860719":
    "Railway or tramway locomotives or rolling stock; parts, axles and wheels, and parts thereof",
  "860721":
    "Railway or tramway locomotives or rolling stock; parts, air brakes and parts thereof",
  "860729":
    "Railway or tramway locomotives or rolling stock; parts, brakes (other than air brakes) and parts thereof",
  "860730":
    "Railway or tramway locomotives or rolling stock; parts, hooks and other coupling devices, buffers and parts thereof",
  "860791": "Railway or tramway locomotives; parts n.e.c. in heading no. 8607",
  "860799":
    "Railway or tramway rolling stock; parts n.e.c. in heading no. 8607",
  "860800":
    "Railway or tramway track fixtures and fittings; mechanical (including electro-mechanical) signalling, safety or traffic control equipment for railways, tramways, roads, inland waterways, parking facilities, port installations or airfields; parts thereof",
  "860900":
    "Containers; (including containers for transport of fluids) specially designed and equipped for carriage by one or more modes of transport",
  "870110": "Tractors; single axle",
  "870120": "Tractors for semi-trailers",
  "870121":
    "Tractors; road tractors for semi-trailers, with only compression-ignition internal combustion piston engine (diesel or semi-diesel)",
  "870122":
    "Tractors; road tractors for semi-trailers, with both compression-ignition internal combustion piston engine (diesel or semi-diesel) and electric motors for propulsion",
  "870123":
    "Tractors; road tractors for semi-trailers, with both spark-ignition internal combustion piston engine and electric motors for propulsion",
  "870124":
    "Tractors; road tractors for semi-trailers, with only electric motors for propulsion",
  "870129":
    "Tractors; road tractors for semi-trailers, with other propulsion methods n.e.c. in item no 8701.2",
  "870130": "Tractors; track-laying",
  "870190":
    "Tractors; n.e.c. in heading no 8701 (other than tractors of heading no 8709)",
  "870191":
    "Tractors; n.e.c. in heading no 8701 (other than tractors of heading no 8709); of an engine power not exceeding 18kW",
  "870192":
    "Tractors; n.e.c. in heading no 8701 (other than tractors of heading no 8709); of an engine power exceeding 18kW but not exceeding 37kW",
  "870193":
    "Tractors; n.e.c. in heading no 8701 (other than tractors of heading no 8709); of an engine power exceeding 37kW but not exceeding 75kW",
  "870194":
    "Tractors; n.e.c. in heading no 8701 (other than tractors of heading no 8709); of an engine power exceeding 75kW but not exceeding 130kW",
  "870195":
    "Tractors; n.e.c. in heading no 8701 (other than tractors of heading no 8709); of an engine power exceeding 130kW",
  "870210": "Diesel powered buses",
  "870220":
    "Vehicles; public transport type (carries 10 or more persons, including driver), with both compression-ignition internal combustion piston engine (diesel or semi-diesel) and electric motor for propulsion, new or used",
  "870230":
    "Vehicles; public transport type (carries 10 or more persons, including driver), with both compression-ignition internal combustion piston engine (diesel or semi-diesel) and electric motor for propulsion, new or used",
  "870240":
    "Vehicles; public transport type (carries 10 or more persons, including driver), with only electric motor for propulsion, new or used",
  "870290":
    "Vehicles; public transport type (carries 10 or more persons, including driver), n.e.c. in heading 8702, new or used",
  "870310":
    "Vehicles; specially designed for travelling on snow, golf cars and similar vehicles",
  "870321": "ICE vehicle; micro SI engine, <=1000cc",
  "870322": "ICE vehicle; small SI engine, 1000-1500cc",
  "870323": "ICE vehicle; medium SI engine, 1500-3000cc",
  "870324": "ICE vehicle; large SI engine, >3000cc",
  "870331": "Small diesel cars",
  "870332": "Diesel/Semi-diesel vehicle; engine displacement, 1500-2500cc",
  "870333": "Large diesel non chargeable cars",
  "870340": "NOVC-HEV with spark iginition engines",
  "870350":
    "Vehicles; with both compression-ignition internal combustion piston engine (diesel or semi-diesel) and electric motor for propulsion, incapable of being charged by plugging to external source of electric power",
  "870360": "OVC-HEV with spark iginition engines",
  "870370":
    "Vehicles; with both compression-ignition internal combustion piston engine (diesel or semi-diesel) and electric motor for propulsion, capable of being charged by plugging to external source of electric power",
  "870380": "Electric motor vehicles",
  "870390":
    "Vehicles; for transport of persons (other than those of heading no. 8702) n.e.c. in heading no. 8703",
  "870410":
    "Vehicles; dumpers, designed for off-highway use, for transport of goods",
  "870421": "Diesel Trucks <5t",
  "870422": "Diesel Trucks 5-20t",
  "870423": "Diesel Trucks >20t",
  "870431": "Spark ignition trucks <5t",
  "870432":
    "Vehicles; spark-ignition internal combustion piston engine, for transport of goods, (of a g.v.w. exceeding 5 tonnes), n.e.c. in item no 8704.1",
  "870441":
    "Vehicles; with both compression-ignition internal combustion piston engine (diesel/semi-diesel) and electric motor as motor for propulsion, unassembled as in section 14, (gvw not exceeding 5000kg), for the transport of goods, vans",
  "870442":
    "Vehicles; with both compression-ignition internal combustion piston engine (diesel/semi-diesel) and electric motors for propulsion, of a g.v.w. exceeding 5,000kg but not exceeding 20,000kg",
  "870443":
    "Vehicles; with both compression-ignition internal combustion piston engine (diesel/semi-diesel) and electric motors for propulsion, of a g.v.w. exceeding 20,000kg",
  "870451":
    "Vehicles; with both spark-ignition internal combustion piston engine and electric motors for propulsion, of a g.v.w. not exceeding 5,000kg",
  "870452":
    "Vehicles; with both spark-ignition internal combustion piston engine and electric motors for propulsion, of a g.v.w. exceeding 5,000kg",
  "870460": "Vehicles; with only electric motor for propulsion",
  "870490": "Vehicles; for transport of goods, n.e.c. in heading no. 8704",
  "870510": "Vehicles; crane lorries",
  "870520": "Vehicles; mobile drilling derricks",
  "870530": "Vehicles; fire fighting vehicles",
  "870540": "Vehicles; concrete-mixer lorries",
  "870590":
    "Vehicles; break-down lorries, road-sweepers, spraying lorries, mobile workshops, mobile radiological units, and other special purpose vehicles n.e.c. in heading no. 8705",
  "870600":
    "Chassis; fitted with engines, for the motor vehicles of heading no. 8701 to 8705",
  "870710":
    "Vehicles; bodies (including cabs) for the motor vehicles of heading no. 8703",
  "870790":
    "Vehicles; bodies (including cabs) for the motor vehicles of heading no. 8701, 8702, 8704 or 8705",
  "870810":
    "Vehicles; bumpers and parts thereof, for the vehicles of heading no. 8701 to 8705",
  "870821": "Vehicles; parts of bodies, safety seat belts",
  "870822":
    "Vehicles; parts and accessories, front windscreens (windshields), rear windows and other windows specified in subheading note 1 to this chapter",
  "870829": "Parts and accessories for vehicle bodies; excl. seat belts",
  "870830": "Brakes and servo-brakes; incl. parts",
  "870831": "Vehicles; parts, mounted brake linings",
  "870839":
    "Vehicles; brakes, servo brakes and parts, not mounted brake linings",
  "870840": "Gear boxes; incl. parts",
  "870850": "Drive axles with differential for motor vehicles",
  "870860": "Vehicles; non-driving axles and parts thereof",
  "870870": "Wheels for motor vehicles",
  "870880": "Suspension systems for motor vehicles",
  "870891": "Vehicle parts; radiators and parts thereof",
  "870892":
    "Vehicle parts; silencers (mufflers) and exhaust pipes; parts thereof",
  "870893": "Vehicle parts; clutches and parts thereof",
  "870894": "Parts of steering wheels, columns, and boxes",
  "870895": "Vehicle parts; safety airbags with inflater system; parts thereof",
  "870899": "Other vehicle parts and accessories (exclusionary category)",
  "870911":
    "Vehicles; electrical, self-propelled, (not fitted with lifting or handling equipment), of the type used for short distance transport of goods in factories, warehouses, dock areas or airports",
  "870919":
    "Vehicles; (not electrical), self-propelled, without handling equipment, used for short distance transport of goods in factories, airports and such, and tractors of the type used on railway station platforms",
  "870990": "Vehicles; parts of the vehicles of heading no. 8709",
  "871000":
    "Tanks and other armoured fighting vehicles; motorised, whether or not fitted with weapons, and parts of such vehicles",
  "871110":
    "Motorcycles (including mopeds) and cycles; fitted with an auxiliary motor, with reciprocating internal combustion piston engine not exceeding 50cc, with or without side-cars; side-cars",
  "871120":
    "Motorcycles (including mopeds) and cycles; fitted with an auxiliary motor, reciprocating internal combustion piston engine, of cylinder capacity exceeding 50cc but not exceeding 250cc, with or without side-cars; side-cars",
  "871130":
    "Motorcycles (including mopeds) and cycles; fitted with an auxiliary motor, reciprocating internal combustion piston engine, of cylinder capacity exceeding 250cc but not exceeding 500cc, with or without side-cars; side-cars",
  "871140":
    "Motorcycles (including mopeds) and cycles; fitted with auxiliary motor, reciprocating internal combustion piston engine of cylinder capacity exceeding 500cc but not exceeding 800cc, with or without sidecars; side-cars",
  "871150":
    "Motorcycles (including mopeds) and cycles; fitted with auxiliary motor, with reciprocating internal combustion piston engine of a cylinder capacity exceeding 800cc, with or without side-cars; side-cars",
  "871160":
    "Motorcycles (including mopeds) and cycles; fitted with auxiliary motor, with electric motor for propulsion, with or without side-cars; side-cars",
  "871190":
    "Motorcycles (including mopeds) and cycles; n.e.c. in heading no. 8711, fitted with auxiliary motor, with or without side-cars; side-cars",
  "871200":
    "Bicycles and other cycles; including delivery tricycles, not motorised",
  "871310": "Carriages for disabled persons; not mechanically propelled",
  "871390": "Carriages for disabled persons; mechanically propelled",
  "871410": "Motorcycles (including mopeds); parts and accessories",
  "871411": "Motorcycles (including mopeds); parts, saddles",
  "871419": "Motorcycles (including mopeds); parts, other than saddles",
  "871420": "Carriages for disabled persons; parts and accessories thereof",
  "871491": "Cycles; frames and forks, and parts thereof",
  "871492": "Cycles; parts thereof, wheel rims and spokes",
  "871493":
    "Cycles; parts thereof, hubs (other than coaster braking hubs and hub brakes) and free-wheel sprocket-wheels",
  "871494":
    "Cycles; parts thereof, brakes, including coaster braking hubs and hub-brakes, and parts thereof",
  "871495": "Cycles; parts thereof, saddles",
  "871496": "Cycles; parts, pedals and crank-gear, and parts thereof",
  "871499": "Cycles; parts thereof, n.e.c. in item no. 8714.9",
  "871500": "Baby carriages and parts thereof",
  "871610":
    "Trailers and semi-trailers; of the caravan type, for housing or camping",
  "871620":
    "Trailers and semi-trailers; self-loading or self-unloading, for agricultural purposes",
  "871631": "Tanker trailers and tanker semi-trailers",
  "871639": "Trailers and semi-trailers; (other than tanker type)",
  "871640": "Trailers and semi-trailers; n.e.c. in item no. 8716.3",
  "871680": "Vehicles; n.e.c. in heading no. 8716",
  "871690":
    "Trailers, semi-trailers and other vehicles not mechanically propelled; parts thereof for heading no. 8716",
  "880100":
    "Balloons and dirigibles; gliders, hang gliders and other non-powered aircraft.",
  "880110": "Gliders and hang gliders",
  "880190": "Balloons and dirigibles and other non-powered aircraft",
  "880211": "Helicopters; of an unladen weight not exceeding 2000kg",
  "880212": "Helicopters; of an unladen weight exceeding 2000kg",
  "880220":
    "Aeroplanes and other aircraft; of an unladen weight not exceeding 2000kg",
  "880230":
    "Aeroplanes and other aircraft; of an unladen weight exceeding 2000kg but not exceeding 15,000kg",
  "880240": "Aeroplanes and other aircraft; weight >15t",
  "880250": "Spacecraft (including satellites) and spacecraft launch vehicles",
  "880260":
    "Spacecraft; (including satellites) and suborbital and spacecraft launch vehicles",
  "880310": "Aircraft and spacecraft; propellers and rotors and parts thereof",
  "880320": "Aircraft and spacecraft; under-carriages and parts thereof",
  "880330": "Other aircraft parts (exclusionary category)",
  "880390": "Aircraft and spacecraft; parts thereof n.e.c. in chapter 88",
  "880400":
    "Parachutes (including dirigible parachutes and paragliders) and rotochutes; parts thereof and accessories thereto",
  "880510":
    "Aircraft launching gear, deck-arrestor or similar gear and parts thereof",
  "880520": "Ground flying trainers and parts thereof",
  "880521":
    "Ground flying trainers and parts thereof; air combat simulators and parts thereof",
  "880529":
    "Ground flying trainers and parts thereof; other than air combat simulators and parts thereof",
  "880610": "Unmanned aircraft; for carriage of passengers",
  "880621":
    "Unmanned aircraft; for remote-controlled flight only, for other than for carriage of passengers, with the maximum take-off weight of not more than 250g",
  "880622":
    "Unmanned aircraft; for remote-controlled flight only, for other than for carriage of passengers, with the maximum take-off weight of more than 250g but not more than 7kg",
  "880623":
    "Unmanned aircraft; for remote-controlled flight only, for other than for carriage of passengers, with the maximum take-off weight of more than 7kg but not more than 25kg",
  "880624":
    "Unmanned aircraft; for remote-controlled flight only, for other than for carriage of passengers, with the maximum take-off weight of more than 25kg but not more than 150kg",
  "880629":
    "Unmanned aircraft; for remote-controlled flight only, for other than for carriage of passengers, with the maximum take-off weight of more than 150kg",
  "880691":
    "Unmanned aircraft; for other than remote-controlled flight and other than for carriage of passengers with a maximum take-off weight not more than 250g",
  "880692":
    "Unmanned aircraft; for other than remote-controlled flight and other than for carriage of passengers with a maximum take-off weight more than 250g but not more than 7kg",
  "880693":
    "Unmanned aircraft; for other than remote-controlled flight and other than for carriage of passengers with a maximum take-off weight more than 7kg but not more than 25kg",
  "880694":
    "Unmanned aircraft; for other than remote-controlled flight and other than for carriage of passengers with a maximum take-off weight more than 25kg but not more than 150kg",
  "880699":
    "Unmanned aircraft; for other than remote-controlled flight and other than for carriage of passengers with a maximum take-off weight more than 150kg",
  "880710": "Aircraft and spacecraft; propellers and rotors and parts thereof",
  "880720": "Aircraft and spacecraft; under-carriages and parts thereof",
  "880730":
    "Aircraft and spacecraft; parts of aeroplanes, helicopters or unmanned aircraft n.e.c. in heading no. 8807",
  "880790": "Aircraft and spacecraft; parts thereof n.e.c. in chapter 88",
  "890110":
    "Cruise ships, excursion boats and similar vessels, principally designed for the transport of persons, ferry boats of all kinds",
  "890120": "Tankers",
  "890130": "Vessels, refrigerated; other than tankers",
  "890190":
    "Other vessels for transport of persons and goods (exclusionary category)",
  "890200":
    "Fishing vessels, factory ships and other vessels; for processing or preserving fishery products",
  "890310":
    "Yachts and other vessels; for pleasure or sports, rowing boats and canoes, inflatable",
  "890311":
    "Yachts and other vessels; for pleasure or sports, inflatable (including rigid hull inflatable), fitted or designed to be fitted with a motor, unladen (net) weight (excluding the motor) not exceeding 100kg",
  "890312":
    "Yachts and other vessels; for pleasure or sports, inflatable (including rigid hull inflatable), not designed to be used with a motor and unladen (net) weight not exceeding 100kg",
  "890319":
    "Yachts and other vessels; for pleasure or sports, inflatable (including rigid hull inflatable), unladen (net) weight exceeding 100kg",
  "890321":
    "Sailboats; (other than inflatable) with or without auxiliary motor, for pleasure or sports, of a length not exceeding 7.5m",
  "890322":
    "Sailboats; (other than inflatable) with or without auxiliary motor, for pleasure or sports, of a length exceeding 7.5m but not exceeding 24m",
  "890323":
    "Sailboats; (other than inflatable) with or without auxiliary motor, for pleasure or sports, of a length exceeding 24m",
  "890331":
    "Motorboats; (other than outboard motorboats), for pleasure or sports, other than inflatable, of a length not exceeding 7.5m",
  "890332":
    "Motorboats; (other than outboard motorboats), for pleasure or sports, other than inflatable, of a length exceeding 7.5m but not exceeding 24m",
  "890333":
    "Motorboats; (other than outboard motorboats), for pleasure or sports, other than inflatable, of a length exceeding 24m",
  "890391":
    "Sailboats; with or without auxiliary motor, for pleasure or sports, other than inflatable",
  "890392":
    "Motorboats; (other than outboard motorboats), for pleasure or sports, other than inflatable",
  "890393":
    "Vessels; (other than sailboats and motorboats), for pleasure or sports, other than inflatable, of a length not exceeding 7.5m",
  "890399":
    "Yachts and other vessels; for pleasure or sports, rowing boats and canoes, n.e.c. in heading no. 8903, other than inflatable",
  "890400": "Tugs and pusher craft",
  "890510": "Dredgers",
  "890520": "Floating or submersible drilling or production platforms",
  "890590":
    "Vessels; light, fire-floats, floating cranes and other vessels, the navigability of which is subsidiary to their main function, floating docks",
  "890600":
    "Vessels; other, including warships and lifeboats, other than rowing boats",
  "890610": "Vessels; warships",
  "890690":
    "Vessels; other, including lifeboats other than rowing boats, other than warships",
  "890710": "Rafts; inflatable",
  "890790":
    "Floating structures; tanks, coffer-dams, landing stages, buoys and beacons",
  "890800": "Vessels and other floating structures; for breaking up",
  "900110":
    "Optical fibres, optical fibre bundles and cables; excluding those of heading no. 8544",
  "900120": "Optical elements; polarising material, sheets and plates thereof",
  "900130":
    "Lenses, contact; unmounted, of any material, excluding elements of glass not optically worked",
  "900140":
    "Lenses, spectacle; unmounted, of glass, excluding elements of glass not optically worked",
  "900150": "Lenses, spectacle; unmounted, of materials other than glass",
  "900190":
    "Optical elements; lenses n.e.c. in heading no. 9001, prisms, mirrors and other optical elements, unmounted, of any material (excluding elements of glass not optically worked)",
  "900211":
    "Lenses; objective, for cameras, projectors or photographic enlargers or reducers, mounted, being parts or fittings for instruments or apparatus, of any material (excluding glass not optically worked)",
  "900219":
    "Lenses; objective, (other than for cameras, projectors or photographic enlargers or reducers), mounted, of any material (excluding elements of glass not optically worked)",
  "900220":
    "Filters; mounted as parts or fittings for instruments or apparatus, of any material (excluding elements of glass not optically worked)",
  "900290":
    "Optical elements; n.e.c. in heading no. 9002 (e.g. prisms and mirrors), mounted, being parts or fittings for instruments or apparatus, of any material (excluding elements of glass not optically worked)",
  "900311":
    "Frames and mountings; for spectacles, goggles or the like, of plastics",
  "900319":
    "Frames and mountings; for spectacles, goggles or the like, of materials other than plastics",
  "900390": "Frames and mountings; parts for spectacles, goggles or the like",
  "900410": "Sunglasses; corrective, protective or other",
  "900490":
    "Spectacles, goggles and the like; (other than sunglasses) corrective, protective or other",
  "900510": "Binoculars",
  "900580":
    "Monoculars; other optical telescopes and astronomical instruments, excluding instruments for radio-astronomy",
  "900590":
    "Binoculars, monoculars, other optical telescopes, astronomical instruments (excluding those of radio-astronomy); parts and accessories (including mountings)",
  "900610":
    "Cameras, photographic (excluding cinematographic); of a kind used for preparing printing plates or cylinders",
  "900620":
    "Cameras, photographic (excluding cinematographic); of a kind used for recording documents on microfilm, microfiche or other microforms",
  "900630":
    "Cameras, photographic (excluding cinematographic); specially designed for underwater use, aerial survey, medical or surgical examination of internal organs; comparison cameras for forensic or criminological use",
  "900640":
    "Cameras, photographic (excluding cinematographic); instant print cameras",
  "900651":
    "Cameras, photographic (excluding cinematographic); with a through-the-lens viewfinder, single lens reflex (SLR), for a roll film of a width not exceeding 35mm",
  "900652":
    "Cameras, photographic (excluding cinematographic); of a kind (not SLR) for roll film of a width less than 35mm",
  "900653":
    "Cameras, photographic (excluding cinematographic); of a kind (not SLR) for roll film of a width of 35mm",
  "900659":
    "Cameras, photographic (excluding cinematographic); n.e.c. in heading no 9006",
  "900661": "Photographic flashlight apparatus; discharge lamp (electronic)",
  "900662":
    "Photographic flashlight apparatus; flashbulbs, flashcubes and the like",
  "900669": "Photographic flashlight apparatus; n.e.c. in heading no. 9006",
  "900691":
    "Cameras, photographic (excluding cinematographic); parts and accessories",
  "900699":
    "Photographic flashlight apparatus; parts and accessories, for other than cameras",
  "900710":
    "Cameras, cinematographic; whether or not incorporating sound recording apparatus",
  "900711":
    "Cameras, cinematographic; whether or not incorporating sound recording apparatus, for film of less than 16mm width or for double-8mm film",
  "900719":
    "Cameras, cinematographic; whether or not incorporating sound recording apparatus, for film n.e.c. in item no. 9007.11",
  "900720":
    "Projectors, cinematographic; whether or not incorporating sound recording or reproducing apparatus",
  "900721":
    "Projectors, cinematographic; whether or not incorporating sound reproducing apparatus, for film of less than 16mm width",
  "900729":
    "Projectors, cinematographic; whether or not incorporating sound reproducing apparatus, for film 16mm or more wide",
  "900791":
    "Cameras, cinematographic; parts and accessories, whether or not incorporating sound recording apparatus",
  "900792":
    "Projectors, cinematographic; parts and accessories, whether or not incorporating sound reproducing apparatus",
  "900810": "Projectors, image; slide (excluding cinematographic)",
  "900820":
    "Projectors, image; microfilm, microfiche or other microform readers, whether or not capable of producing copies",
  "900830":
    "Projectors, image; (other than slide projectors and microfilm, microfiche or other microform readers), (excluding cinematographic)",
  "900840": "Photographic (excluding cinematographic) enlargers and reducers",
  "900850":
    "Image projectors, photographic enlargers and reducers, excluding cinematographic",
  "900890":
    "Photographic (other than cinematographic) image projectors, enlargers, and reducers; parts and accessories",
  "900911":
    "Photocopying apparatus; electrostatic, operating by reproducing the original image directly onto the copy (direct process)",
  "900912":
    "Photocopying apparatus; electrostatic, operating by reproducing the original image via an intermediate onto the copy (indirect process)",
  "900921":
    "Photocopying apparatus; (excluding electrostatic), incorporating an optical system",
  "900922":
    "Photocopying apparatus; (excluding electrostatic), of the contact type",
  "900930": "Thermo-copying apparatus",
  "900990": "Photo and thermo-copying apparatus; parts and accessories",
  "900991":
    "Photo and thermo-copying apparatus; parts and accessories; automatic document feeders",
  "900992":
    "Photo and thermo-copying apparatus; parts and accessories; paper feeders",
  "900993":
    "Photo and thermo-copying apparatus; parts and accessories; sorters",
  "900999": "Photo and thermo-copying apparatus; other parts and accessories",
  "901010":
    "Photographic laboratory apparatus and equipment; for automatically developing photographic (including cinematographic) film or paper in rolls or for automatically exposing developed film to rolls of paper",
  "901020":
    "Photographic laboratory apparatus and equipment (including cinematographic); negatoscopes and other equipment n.e.s. in heading no. 9010",
  "901030":
    "Photographic laboratory apparatus and equipment (including cinematographic); projection screens",
  "901041":
    "Photographic laboratory apparatus and equipment (including cinematographic); for the projection or drawing of circuit patterns on sensitised semiconductor materials, direct write-on-wafer apparatus",
  "901042":
    "Photographic laboratory apparatus and equipment (including cinematographic); for the projection or drawing of circuit patterns on sensitised semiconductor materials, step and repeat aligners",
  "901049":
    "Photographic laboratory apparatus and equipment (including cinematographic); for the projection or drawing of circuit patterns on sensitised semiconductor materials, n.e.s. in item no. 9010.4",
  "901050":
    "Photographic laboratory apparatus and equipment; n.e.c. in item no. 9010.10, for photographic (including cinematographic) laboratories; negatoscopes",
  "901060":
    "Photographic laboratory apparatus and equipment (including cinematographic); projection screens",
  "901090":
    "Photographic laboratory apparatus and equipment (including cinematographic); parts and accessories",
  "901110": "Microscopes, compound optical; stereoscopic microscopes",
  "901120":
    "Microscopes, compound optical; for photomicrography, cinephotomicrography or microprojection",
  "901180":
    "Microscopes, compound optical; (other than stereoscopic and microscopes for photomicrography, cinephotomicrography or microprojection)",
  "901190":
    "Microscopes, compound optical; parts and accessories (including those for photomicrography, cinephotomicrography or microprojection)",
  "901210":
    "Microscopes (excluding optical microscopes); diffraction apparatus",
  "901290":
    "Microscopes (excluding optical microscopes); diffraction apparatus; parts and accessories",
  "901310":
    "Optical appliances and instruments; telescopic sights for fitting to arms; periscopes; telescopes designed to form parts of machines, appliances, instruments or apparatus of this chapter",
  "901320": "Lasers; excl. laser diodes",
  "901380": "Other optical devices (exclusionary category)",
  "901390":
    "Optical appliances and instruments; parts and accessories for articles of heading no. 9013",
  "901410":
    "Navigational instruments and appliances; direction finding compasses",
  "901420":
    "Navigational instruments and appliances; for aeronautical or space navigation (excluding compasses)",
  "901480":
    "Navigational instruments and appliances; for navigation other than aeronautical or space navigation (excluding direction finding compasses)",
  "901490": "Navigational instruments and appliances; parts and accessories",
  "901510": "Rangefinders",
  "901520": "Surveying equipment; theodolites and tacheometers",
  "901530": "Surveying equipment; levels",
  "901540":
    "Surveying equipment; photogrammetrical surveying instruments and appliances",
  "901580":
    "Surveying equipment; articles n.e.c. in heading no. 9015, including hydrographic, oceanographic, hydrological, meteorological or geophysical instruments and appliances (excluding compasses)",
  "901590":
    "Surveying equipment; parts and accessories for articles of heading no. 9015",
  "901600":
    "Balances; of a sensitivity of 5cg or better, with or without weights",
  "901710": "Drafting tables and machines; whether or not automatic",
  "901720": "Drawing, marking-out or mathematical calculating instruments",
  "901730": "Mathematical equipment; micrometers, callipers and gauges",
  "901780":
    "Mathematical instruments and equipment; n.e.c. in heading no. 9017",
  "901790":
    "Drawing, marking-out equipment and mathematical instruments; parts and accessories",
  "901811":
    "Medical, surgical instruments and appliances; electro-cardiographs",
  "901812":
    "Medical, surgical instruments and appliances; ultrasonic scanning apparatus",
  "901813":
    "Medical, surgical instruments and appliances; magnetic resonance imaging apparatus",
  "901814":
    "Medical, surgical instruments and appliances; scintigraphic apparatus",
  "901819":
    "Electro-diagnostic apparatus; excl. MRI, electro-cardiographs, scintigraphic and ultrasonic apparatus",
  "901820":
    "Medical, surgical instruments and appliances; ultra-violet or infra-red ray apparatus",
  "901831":
    "Medical, surgical instruments and appliances; syringes, with or without needles",
  "901832":
    "Medical, surgical instruments and appliances; tubular metal needles and needles for sutures",
  "901839": "Catheters, cannulae, and similar",
  "901841":
    "Dental instruments and appliances; dental drill engines, whether or not combined on a single base with other dental equipment",
  "901849":
    "Dental instruments and appliances; other than dental drill engines",
  "901850": "Ophthalmic instruments and appliances",
  "901890": "Other medical and surgical instruments (exclusionary category)",
  "901910": "Massage and psychological aptitude-testing apparatus",
  "901920": "Therapeutic respiration apparatus",
  "902000":
    "Breathing appliances and gas masks; excluding protective masks having neither mechanical parts nor replaceable filters and excluding apparatus of item no. 9019.20",
  "902110": "Orthopaedic or fracture appliances",
  "902111": "Orthopaedic or fracture appliances; artificial joints",
  "902119":
    "Orthopaedic or fracture appliances; crutches, surgical belts and trusses, splints and other fracture appliances",
  "902121": "Dental fittings; artificial teeth",
  "902129": "Dental fittings; other than artificial teeth",
  "902130": "Artificial parts of the body",
  "902131": "Artificial body parts",
  "902139": "Artificial body parts; excl. joints",
  "902140": "Hearing aids (excluding parts and accessories)",
  "902150":
    "Pacemakers; for stimulating heart muscles (excluding parts and accessories)",
  "902190": "Other orthopaedic appliances (exclusionary category)",
  "902211":
    "Apparatus based on the use of x-rays, including radiography or radiotherapy apparatus; for medical, surgical, dental or veterinary uses",
  "902212":
    "Apparatus based on the use of x-rays; including radiography or radiotherapy apparatus, whether or not for medical, surgical, dental or veterinary uses, computed tomography apparatus",
  "902213":
    "Apparatus based on the use of x-rays; including radiography or radiotherapy apparatus, for dental uses, excluding computed tomography apparatus",
  "902214":
    "Apparatus based on the use of x-rays; including radiography or radiotherapy apparatus, for medical, surgical or veterinary uses, not dental uses, excluding computed tomography apparatus",
  "902219":
    "Apparatus based on the use of x-rays, including radiography or radiotherapy apparatus; for other than medical, surgical, dental or veterinary uses",
  "902221":
    "Apparatus based on the use of alpha, beta or gamma radiations, including radiography or radiotherapy apparatus; for medical, surgical, dental or veterinary uses",
  "902229":
    "Apparatus based on the use of alpha, beta or gamma radiations, including radiography or radiotherapy apparatus; (for other than medical, surgical, dental or veterinary uses)",
  "902230": "X-ray tubes",
  "902290":
    "Apparatus based on use of x-rays and similar; parts and accessories (x-ray generators, tubes, high tension generators, control panels and desks, screens, examination or treatment tables, chairs and like",
  "902300":
    "Instruments, apparatus and models; designed for demonstrational purposes (in education or exhibitions), unsuitable for other uses",
  "902410":
    "Machines and appliances; for testing the hardness, strength, compressibility, elasticity or other mechanical properties of metals",
  "902480":
    "Machines and appliances; for testing the hardness, strength, compressibility, elasticity or other mechanical properties of materials other than metals",
  "902490":
    "Machines and appliances; parts and accessories for those testing hardness, strength, compressibility, elasticity or other mechanical properties of materials (e.g. metal, wood, textiles, paper, plastics)",
  "902511":
    "Thermometers and pyrometers; liquid filled, for direct reading, not combined with other instruments",
  "902519":
    "Thermometers and pyrometers; (other than liquid filled, for direct reading), not combined with other instruments",
  "902520": "Barometers; not combined with other instruments",
  "902580":
    "Hydrometers and similar floating instruments, barometers, hygrometers, psychrometers, thermometers, pyrometers; recording or not, any combination of these instruments (excluding thermometers and barometers not combined with other instruments)",
  "902590":
    "Hydrometers and similar floating instruments, barometers, hygrometers, psychrometers, thermometers, pyrometers; recording or not, any combination of these instruments, parts and accessories",
  "902610":
    "Instruments and apparatus; for measuring or checking the flow or level of liquids",
  "902620": "Instruments to measure pressure",
  "902680":
    "Instruments and apparatus; for measuring or checking variables of liquids or gases (excluding pressure or the flow and level of liquids and those of heading no. 9014, 9015, 9028 and 9032)",
  "902690":
    "Instruments and apparatus; parts and accessories for those measuring or checking the flow, level, pressure or other variables of liquids or gases (excluding those of heading no. 9014, 9015, 9028 or 9032)",
  "902710":
    "Instruments and apparatus; gas or smoke analysis apparatus, for physical or chemical analysis",
  "902720": "Chromatographs and electrophoresis instruments",
  "902730":
    "Spectrometers, spectrophotometers and spectrographs; using optical radiations (UV, visible, IR)",
  "902740": "Exposure meters",
  "902750":
    "Instruments using optical radiations; excl. spectrometers, spectrophotometers, spectographs",
  "902780":
    "Other equipment for physical or chamical analysis (exclusionary category)",
  "902781":
    "Instruments and apparatus; for physical or chemical analysis, for measuring or checking viscosity, porosity, expansion, surface tension or quantities of heat, sound or light, mass spectrometers",
  "902789":
    "Instruments and apparatus; for physical or chemical analysis, for measuring or checking viscosity, porosity, expansion, surface tension or quantities of heat, sound or light, exposure meters",
  "902790": "Microtomes; incl. parts and accessories",
  "902810":
    "Meters; gas, supply or production meters, including calibrating meters thereof",
  "902820":
    "Meters; liquid supply or production meters, including calibrating meters thereof",
  "902830":
    "Meters; electricity supply or production meters, including calibrating meters thereof",
  "902890":
    "Meters; parts and accessories of gas, liquid, electricity supply or production meters, including calibrating meters thereof",
  "902910":
    "Meters and counters; revolution counters, production counters, taximeters, mileometers, pedometers and the like",
  "902920": "Meters; speed indicators and tachometers; stroboscopes",
  "902990":
    "Meters and counters; parts and accessories for revolution and production counters, taximeters, mileometers, pedometers and the like; speed indicators, tachometers (excluding heading no. 9015), stroboscopes",
  "903010":
    "Instruments and apparatus; for measuring or detecting ionising radiations",
  "903020": "Oscilloscopes and oscillographs",
  "903031":
    "Multimeters; for measuring or checking voltage, current, resistance or power, without a recording device",
  "903032":
    "Multimeters; for measuring or checking voltage, current, resistance or power, with a recording device",
  "903033":
    "Instruments and apparatus; for measuring or checking voltage, current, resistance or power, without a recording device (excluding multimeters)",
  "903039":
    "Instruments and apparatus; for measuring or checking voltage, current, resistance or power, with a recording device (excluding multimeters)",
  "903040":
    "Instruments and apparatus; specially designed for telecommunications (e.g. cross-talk meters, gain measuring instruments, distortion factor meters, psophometers)",
  "903081":
    "Instruments and apparatus; with a recording device, specially designed for telecommunications (eg cross-talk meters, gain measuring instruments, distortion factor meters, psophometers)",
  "903082":
    "Instruments and apparatus; for measuring or checking semiconductor wafers or devices",
  "903083":
    "Instruments and apparatus; for measuring or detecting alpha, beta, gamma, x-ray, cosmic or other ionising radiations, with a recording device",
  "903084":
    "Instruments and apparatus; n.e.c. in heading no. 9030, with a recording device",
  "903089":
    "Instruments and apparatus; n.e.c. in heading no. 9030, without a recording device",
  "903090":
    "Instruments, apparatus for measuring, checking electrical quantities, not meters of heading no. 9028; parts and accessories, for measuring or detecting alpha, beta, gamma, x-ray, cosmic and other radiations",
  "903110": "Machines; for balancing mechanical parts",
  "903120": "Test benches",
  "903130": "Profile projectors",
  "903140":
    "Optical instruments and appliances; for measuring or checking, n.e.s. in chapter 90",
  "903141":
    "Optical instruments and appliances; for inspecting semiconductor wafers or devices or for inspecting photomasks or reticles used in manufacturing semiconductor devices, n.e.c. in chapter 90",
  "903149": "Other optical instruments for measuring (exclusionary category)",
  "903180":
    "Other instruments, appliances, and machines for measuring (exclusionary category)",
  "903190":
    "Instruments, appliances and machines; parts and accessories for those measuring or checking devices of heading no. 9031",
  "903210":
    "Regulating or controlling instruments and apparatus; automatic type, thermostats",
  "903220":
    "Regulating or controlling instruments and apparatus; automatic, manostats",
  "903281":
    "Regulating or controlling instruments and apparatus; automatic, hydraulic or pneumatic",
  "903289":
    "Automatic regulating or controlling instruments; excl. hydraulic and pneumatic",
  "903290":
    "Regulating or controlling instruments and apparatus; automatic, parts and accessories",
  "903300":
    "Machines and appliances, instruments or apparatus of chapter 90; parts and accessories n.e.c. in chapter 90",
  "910111":
    "Wrist-watches; electrically operated, with or without a stop-watch, with case of precious metal or of metal clad with precious metal, with mechanical display only",
  "910112":
    "Wrist-watches; electrically operated, with or without a stop-watch, with case of precious metal or of metal clad with precious metal, with opto-electronic display only",
  "910119":
    "Wrist-watches; electrically operated, with or without a stop-watch, with case of precious metal or metal clad with precious metal, without mechanical display",
  "910121":
    "Wrist-watches; (not electrically operated), automatic winding, whether or not incorporating a stop-watch facility, case of precious metal or of metal clad with precious metal",
  "910129":
    "Wrist-watches; (not electrically operated), (not automatic winding), whether or not incorporating a stop-watch facility, case of precious metal or of metal clad with precious metal",
  "910191":
    "Pocket-watches and other watches, including stop-watches; (excluding wrist-watches), with case of precious metal or of metal clad with precious metal, electrically operated",
  "910199":
    "Pocket-watches and other watches, including stop-watches; (excluding wrist-watches), with case of precious metal or of metal clad with precious metal, not electrically operated",
  "910211":
    "Wrist-watches; electrically operated, with or without a stop-watch, (other than those of heading no. 9101) with mechanical display only",
  "910212":
    "Wrist-watches; electrically operated, with or without a stop-watch, (other than those of heading no. 9101) with opto-electronic display only",
  "910219":
    "Wrist-watches; electrically operated, with or without a stop-watch, (other than those of heading no. 9101) without mechanical or opto-electronic display",
  "910221":
    "Wrist-watches; whether or not incorporating a stop-watch facility, with automatic winding",
  "910229":
    "Wrist-watches; whether or not incorporating a stop-watch facility, with other than automatic winding",
  "910291":
    "Pocket watches and other watches, including stop-watches; (excluding wrist-watches), other than those of heading no. 9101, electrically operated",
  "910299":
    "Pocket watches and other watches, including stop-watches; (excluding wrist-watches), other than those of heading no. 9101, other than electrically operated",
  "910310":
    "Clocks; with watch movements, electrically operated, excluding clocks of heading no. 9104",
  "910390":
    "Clocks; with watch movements, other than electrically operated, excluding clocks of heading no. 9104",
  "910400":
    "Clocks; instrument panel clocks and clocks of a similar type for vehicles, aircraft, spacecraft or vessels",
  "910511":
    "Clocks; (excluding those with watch movements and instrument panel clocks), alarm clocks, electrically operated",
  "910519":
    "Clocks; (excluding those with watch movements and instrument panel clocks), alarm clocks, other than electrically operated",
  "910521":
    "Clocks; (excluding those with watch movements and instrument panel clocks), wall clocks, electrically operated",
  "910529":
    "Clocks; (excluding those with watch movements and instrument panel clocks), wall clocks, other than electrically operated",
  "910591":
    "Clocks; (excluding those with watch movements and instrument panel clocks), (other than alarm or wall clocks), electrically operated",
  "910599":
    "Clocks; (excluding those with watch movements and instrument panel clocks), other than alarm or wall clocks, other than electrically operated",
  "910610":
    "Time recording apparatus; time-registers, time recorders, with clock, watch movement or synchronous motor",
  "910620": "Parking meters",
  "910690":
    "Time recording apparatus; with clock or watch movement or with synchronous motor, n.e.c. in heading no. 9106",
  "910700": "Time switches; with clock, watch movement or synchronous motor",
  "910811":
    "Watch movements; complete and assembled, electrically operated, with mechanical display only or with a device to which a mechanical display can be incorporated",
  "910812":
    "Watch movements; complete and assembled, electrically operated, by means of solar cells, with opto-electronic display",
  "910819":
    "Watch movements; complete and assembled, electrically operated, by means of solar cells, without mechanical display or device including such or opto-electronic display",
  "910820": "Watch movements; complete and assembled, with automatic winding",
  "910890":
    "Watch movements; complete and assembled, not automatic winding or electrically operated",
  "910891":
    "Watch movements; complete and assembled, (not automatic winding or battery or accumulator powered), measuring 33.8mm or less",
  "910899":
    "Watch movements; complete and assembled, (not automatic winding or battery or accumulator powered), measuring more than 33.8mm",
  "910910": "Clock movements; complete and assembled, electrically operated",
  "910911":
    "Clock movements; complete and assembled, of alarm clocks, electrically operated",
  "910919":
    "Clock movements; complete and assembled, (other than of alarm clocks), electrically operated",
  "910990":
    "Clock movements; complete and assembled, other than electrically operated",
  "911011":
    "Watches; complete movements, unassembled or partly assembled (movement sets)",
  "911012": "Watches; incomplete movements, assembled",
  "911019": "Watches; rough movements",
  "911090":
    "Clocks; movements, whether or not complete, incomplete, assembled or unassembled",
  "911110":
    "Watch cases; of precious metal or of metal clad with precious metal",
  "911120":
    "Watch cases; of base metal, whether or not gold-plated or silver-plated",
  "911180": "Watch cases; n.e.c. in heading no. 9111",
  "911190": "Watch cases and parts thereof",
  "911210":
    "Clock cases and similar cases for other goods of chapter 91; of metal, other than watch cases",
  "911220":
    "Clock cases and similar cases for other goods of chapter 91; other than watch cases",
  "911280":
    "Clock cases and similar cases for other goods of chapter 91; excluding those made of metal, other than watch cases",
  "911290":
    "Clock cases and similar cases for other goods of chapter 91; other than watch cases, parts thereof",
  "911310":
    "Watch straps, watch bands, watch bracelets, and parts thereof; of precious metal or of metal clad with precious metal",
  "911320":
    "Watch straps, watch bands, watch bracelets, and parts thereof; of base metal, whether or not gold- or silver-plated",
  "911390":
    "Watch straps, watch bands, watch bracelets, and parts thereof; n.e.c. in heading no. 9113",
  "911410": "Clock or watch parts; springs, including hairsprings",
  "911420": "Clock or watch parts; jewels",
  "911430": "Clock or watch parts; dials",
  "911440": "Clock or watch parts; plates and bridges",
  "911490":
    "Clock or watch parts; other than springs (including hairsprings), dials, plates, and bridges",
  "920110": "Musical instruments; pianos, upright, including automatic pianos",
  "920120": "Musical instruments; pianos, grand",
  "920190":
    "Musical instruments; harpsichords and other keyboard stringed instruments n.e.c. in heading no. 9201",
  "920210": "Musical instruments; string, played with a bow (e.g. violins)",
  "920290":
    "Musical instruments; string, played other than with a bow (e.g. guitars and harps)",
  "920300":
    "Musical instruments; keyboard pipe organs, harmoniums and similar keyboard instruments with free metal reeds",
  "920410": "Musical instruments; accordions and similar instruments",
  "920420": "Musical instruments; mouth organs",
  "920510":
    "Musical instruments; brass-wind (e.g. trumpets), other than fairground organs and mechanical street organs",
  "920590":
    "Musical instruments; wind, other than brass, (eg. clarinet, bagpipes, pipe organs), other than fairground organs and mechanical street organs",
  "920600":
    "Musical instruments; percussion (e.g. drums, xylophones, cymbals, castanets, maracas)",
  "920710":
    "Musical instruments; keyboard, (other than accordions), the sound of which is produced or must be amplified electrically",
  "920790":
    "Musical instruments; (other than keyboard), the sound of which is produced or must be amplified electrically",
  "920810": "Musical boxes",
  "920890":
    "Fairground and mechanical street organs, mechanical singing birds, musical saws and musical instruments n.e.c. in chapter 92; decoy calls of all kinds; whistles; call horns and other mouth-blown sound signalling instruments",
  "920910":
    "Musical instruments; parts and accessories, metronomes, tuning forks and pitch pipes",
  "920920": "Musical boxes; parts, mechanisms",
  "920930": "Musical instrument strings",
  "920991": "Musical instruments; parts and accessories for pianos",
  "920992":
    "Musical instruments; parts and accessories for string musical instruments other than keyboard instruments",
  "920993":
    "Musical instruments; parts and accessories for non-stringed keyboard instruments",
  "920994":
    "Musical instruments; parts and accessories for the musical instruments the sound of which is produced or must be amplified electrically (e.g. organs, guitars and accordions)",
  "920999":
    "Musical instruments; parts and accessories for musical instruments n.e.c. in heading no. 9209; metronomes, tuning forks and pitch pipes",
  "930100":
    "Military weapons; other than revolvers, pistols and arms of heading no. 9307",
  "930110":
    "Military weapons; artillery weapons (e.g. guns, howitzers, and mortars)",
  "930111":
    "Military weapons; other than revolvers, pistols and arms of heading 9307; artillery weapons (for example, guns, howitzers and mortars), self propelled",
  "930119":
    "Military weapons; other than revolvers, pistols and arms of heading 9307; artillery weapons (for example, guns, howitzers and mortars), not self propelled",
  "930120":
    "Military weapons; rocket launchers, flame-throwers, grenade launchers, torpedo tubes and similar projectors",
  "930190":
    "Military weapons; other than revolvers, pistols, and arms of heading 9307, n.e.c. in heading 9301",
  "930200":
    "Revolvers and pistols; other than those of heading no. 9303 or 9304",
  "930310": "Firearms; muzzle-loading",
  "930320":
    "Firearms; sporting, hunting or target-shooting shotguns, including combination shotgun-rifles",
  "930330":
    "Firearms; sporting, hunting or target-shooting rifles n.e.c. in heading no. 9303",
  "930390": "Firearms; n.e.c. in heading no. 9303",
  "930400":
    "Firearms; (e.g. spring, air or gas guns and pistols, truncheons), excluding those of heading no. 9307",
  "930510": "Firearms; parts and accessories, of revolvers or pistols",
  "930520":
    "Firearms; parts and accessories, of shotguns or rifles of heading 9303",
  "930521": "Firearms; parts and accessories, of shotgun barrels",
  "930529":
    "Firearms; parts and accessories, of shotguns or rifles of heading no. 9303, other than shotgun barrels",
  "930590":
    "Firearms; parts and accessories, of articles of heading no. 9301 to 9304, other than of revolvers or pistols or of shotguns or rifles of heading no. 9303",
  "930591":
    "Firearms; parts and accessories, of military weapons of heading 9301",
  "930599":
    "Firearms; parts and accessories, of firearms other than the military weapons of heading 9301",
  "930610":
    "Ammunition; cartridges for riveting or similar tools or for captive-bolt humane killers and parts thereof",
  "930621": "Ammunition; shotgun cartridges",
  "930629": "Ammunition; parts of shotgun cartridges",
  "930630":
    "Ammunition; cartridges and parts thereof n.e.c. in heading no. 9306",
  "930690": "Ammunition; n.e.c. in chapter 93",
  "930700":
    "Arms; swords, cutlasses, bayonets, lances and the like, parts thereof and scabbards and sheaths therefor",
  "940110": "Seats; of a kind used for aircraft",
  "940120": "Seats; of a kind used for motor vehicles",
  "940130":
    "Seats; swivel with variable height adjustment, excluding medical, surgical, dental, veterinary or barber furniture",
  "940131":
    "Seats; swivel with variable height adjustment of wood, excluding medical, surgical, dental, veterinary or barber furniture",
  "940139":
    "Seats; swivel with variable height adjustment of other than wood, excluding medical, surgical, dental, veterinary or barber furniture",
  "940140":
    "Seats; convertible into beds, other than garden seats or camping equipment",
  "940141":
    "Seats; convertible into beds of wood, other than garden seats or camping equipment",
  "940149":
    "Seats; convertible into beds of other than wood, other than garden seats or camping equipment",
  "940150": "Seats; of cane, osier, bamboo or similar materials",
  "940151": "Seats; of bamboo or rattan",
  "940152": "Seats; of bamboo",
  "940153": "Seats; of rattan",
  "940159":
    "Seats; of cane, osier or similar materials, other than bamboo or rattan",
  "940161":
    "Seats; with wooden frames, upholstered, (excluding medical, surgical, dental, veterinary or barber furniture)",
  "940169":
    "Seats; with wooden frames, not upholstered, (excluding medical, surgical, dental, veterinary or barber furniture)",
  "940171":
    "Seats; with metal frames, upholstered, (excluding medical, surgical, dental, veterinary or barber furniture)",
  "940179":
    "Seats; with metal frames, not upholstered, (excluding medical, surgical, dental, veterinary or barber furniture)",
  "940180":
    "Seats; n.e.c. in heading no. 9401, (excluding medical, surgical, dental, veterinary or barber furniture)",
  "940190": "Seat; parts",
  "940191":
    "Seats; parts, of wood, (other than for use in the assembly of motor vehicles as determined by the minister, other than automotive)",
  "940199":
    "Seats; parts, (of other than wood) for use in the assembly of motor vehicles as determined by the minister",
  "940210":
    "Chairs; dentists', barbers' or similar chairs having rotating as well as both reclining and elevating movements, and parts thereof",
  "940290":
    "Furniture; for medical, surgical, veterinary use (e.g. operating tables, examination tables, hospital beds with mechanical fittings) and parts thereof",
  "940310": "Furniture; metal, for office use",
  "940320": "Furniture; metal, other than for office use",
  "940330": "Furniture; wooden, for office use",
  "940340": "Furniture; wooden, for kitchen use",
  "940350": "Furniture; wooden, for bedroom use",
  "940360": "Furniture; wooden, other than for office, kitchen or bedroom use",
  "940370": "Furniture; plastic",
  "940380":
    "Furniture; materials n.e.s. in heading no. 9403, including cane, osier, bamboo or similar materials",
  "940381": "Furniture; of bamboo or rattan",
  "940382": "Furniture; of bamboo",
  "940383": "Furniture; of rattan",
  "940389":
    "Furniture; of cane, osier, or similar materials (other than bamboo or rattan)",
  "940390": "Furniture; parts",
  "940391": "Furniture; parts, of wood",
  "940399": "Furniture; parts, of other than wood",
  "940410": "Mattress supports",
  "940421":
    "Mattresses; of cellular rubber or plastics, whether or not covered",
  "940429": "Mattresses; of other materials, not cellular rubber or plastics",
  "940430": "Sleeping bags",
  "940440": "Quilts, bedspreads, eiderdowns and duvets (comforters)",
  "940490": "Other bedding articles (exclusionary category)",
  "940510": "Chandeliers and other electric light fittings for ceilings/walls",
  "940511":
    "Luminaires and light fittings; chandeliers and electric ceiling or wall light fittings; (excluding those used for lighting public open spaces or thoroughfares), for use solely with light-emitting diode (LED) light sources",
  "940519":
    "Chandeliers and electric ceiling or wall light fittings; (excluding those used for lighting public open spaces or thoroughfares), for use other than with light-emitting diode (LED) light sources",
  "940520": "Lamps, electric; floor-standing or for table, desk or bedside",
  "940521":
    "Luminaires and light fittings; electric, table, desk, bedside or floor-standing, for use solely with light-emitting diode (LED) light sources",
  "940529":
    "Luminaires and light fittings; electric, table, desk, bedside or floor-standing, for other than use solely with light-emitting diode (LED) light sources",
  "940530": "Lighting sets; of a kind used for Christmas trees",
  "940531":
    "Luminaires and light fittings; electric, lighting strings of a kind used for Christmas trees, for use solely with light-emitting diode (LED) light sources",
  "940539":
    "Luminaires and light fittings; electric, lighting strings of a kind used for Christmas trees, for other than use solely with light-emitting diode (LED) light sources",
  "940540": "Other electric lamps (exclusionary category)",
  "940541":
    "Luminaires and light fittings; electric, photovoltaic, designed for use solely with light-emitting diode (LED) light sources",
  "940542":
    "Luminaires and light fittings; electric, designed for use solely with light-emitting diode (LED) light sources",
  "940549":
    "Luminaires and light fittings; electric, designed for other than use solely with light-emitting diode (LED) light sources",
  "940550": "Lamps and light fittings; non-electric",
  "940560": "Illuminated signs, name plates and the like",
  "940561":
    "Luminaires; illuminated signs, illuminated name-plates and the like, designed for use solely with light-emitting diode (LED) light sources",
  "940569":
    "Luminaires; illuminated signs, illuminated name-plates and the like, designed for other than use solely with light-emitting diode (LED) light sources",
  "940591": "Lamps and light fittings; parts thereof, of glass",
  "940592": "Lamps and light fittings; parts thereof, of plastics",
  "940599":
    "Lamps and light fittings; parts thereof, of materials other than glass or plastics",
  "940600": "Buildings; prefabricated",
  "940610": "Buildings; prefabricated, of wood",
  "940620": "Buildings; modular building units, of steel",
  "940690": "Buildings; prefabricated, not of wood",
  "950100":
    "Toys; wheeled, designed to be ridden by children (eg tricycles, scooters, pedal cars), dolls' carriages",
  "950210": "Dolls; representing only human beings, whether or not dressed",
  "950291":
    "Dolls; representing only human beings, garments and accessories therefor, footwear and headgear",
  "950299":
    "Dolls; representing only human beings, parts and accessories, (other than garments and accessories therefor or footwear and headgear)",
  "950300":
    "Tricycles, scooters, pedal cars and similar wheeled toys; dolls' carriages; dolls; other toys; reduced-size (scale) models and similar recreational models, working or not; puzzles of all kinds",
  "950310":
    "Toys; electric trains, including tracks, signals and other accessories therefor",
  "950320":
    "Toys; reduced-size (scale) model assembly kits, whether or not working models, excluding those of item no. 9503.10",
  "950330":
    "Toys; construction sets and constructional toys, excluding (scale) model assembly kits",
  "950341": "Toys; representing animals or non-human creatures, stuffed",
  "950349": "Toys; representing animals or non-human creatures, not stuffed",
  "950350": "Toy musical instruments and apparatus",
  "950360": "Toys; puzzles",
  "950370": "Toys; n.e.s. in heading no. 9503, put up in sets or outfits",
  "950380":
    "Toys and models; n.e.s. in heading no. 9503, incorporating a motor",
  "950390": "Toys; n.e.s. in heading no. 9503",
  "950410": "Video games; of a kind used with a television receiver",
  "950420": "Billiard articles and accessories of all kinds",
  "950430":
    "Games; operated by coins, banknotes, bank cards, tokens or by other means of payment, other than billiard articles and accesssories, and automatic bowling alley equipment",
  "950440": "Games; playing cards",
  "950450": "Video game consoles and machines",
  "950490":
    "Games; articles for funfair, table or parlour games, including pintables, special tables for casino games, automatic bowling alley equipment, n.e.c. in heading 9504",
  "950510": "Christmas festivity articles",
  "950590":
    "Festive, carnival or other entertainment articles including novelty jokes and conjuring tricks; other than Christmas festivity articles",
  "950611": "Skis; for snow",
  "950612": "Ski-fastenings (ski-bindings); for snow-skis",
  "950619": "Snow-ski equipment",
  "950621": "Sailboards; for water sport",
  "950629":
    "Water sport equipment; water-skis, surf-boards and other water-sport equipment, excluding sailboards",
  "950631": "Golf clubs; complete",
  "950632": "Golf balls",
  "950639": "Golf equipment; other than clubs and balls",
  "950640": "Table-tennis articles and equipment",
  "950651": "Lawn-tennis racquets; whether or not strung",
  "950659": "Tennis, badminton and similar racquets; whether or not strung",
  "950661": "Lawn-tennis balls",
  "950662": "Balls; inflatable",
  "950669":
    "Balls; (other than inflatable or for lawn-tennis, golf or table-tennis)",
  "950670":
    "Skates; ice and roller, including skating boots with skates attached",
  "950691": "Athletics and gymnastics equipment",
  "950699":
    "Equipment for outdoor games and recreation n.e.c. in heading no. 9506",
  "950710": "Fishing rods",
  "950720": "Fish-hooks; whether or not snelled",
  "950730": "Fishing reels",
  "950790":
    "Fishing tackle n.e.c., butterfly nets, decoy birds (other than those of heading no. 9208 or 9705) and similar hunting or shooting requisites",
  "950800":
    "Roundabouts, swings, shooting galleries, other fairground amusements, travelling circuses, menageries and travelling theatres",
  "950810": "Travelling circuses and travelling menageries",
  "950821": "Amusement park rides and water park amusements; Roller coasters",
  "950822":
    "Amusement park rides and water park amusements; carousels, swings and roundabouts",
  "950823": "Amusement park rides and water park amusements; dodge'em cars",
  "950824":
    "Amusement park rides and water park amusements; motion simulators and moving theatres",
  "950825": "Amusement park rides and water park amusements; water rides",
  "950826":
    "Amusement park rides and water park amusements; water park amusements",
  "950829":
    "Amusement park rides and water park amusements; other than roller coasters, carousels, swings, roundabouts, dodge'em cars, motion simulators and moving theatres, water rides and water park amusements",
  "950830": "Fairground amusements; including shooting galleries",
  "950840": "Travelling theatres",
  "950890":
    "Roundabouts, swings, shooting galleries, other fairground amusements; travelling theatres",
  "960110": "Ivory and articles thereof; worked",
  "960190":
    "Bone, tortoise shell, horn, antlers, coral, mother-of-pearl and other animal carving material and articles thereof (including articles obtained by moulding)",
  "960200":
    "Vegetable, mineral carving material and articles of these materials, moulded or carved articles of wax, stearin, natural gums, resins or modelling pastes, worked unhardened gelatin (not heading no. 3503)",
  "960310":
    "Brooms and brushes; consisting of twigs or other vegetable materials bound together, with or without handles",
  "960321": "Brushes; toothbrushes",
  "960329":
    "Brushes; shaving, hair, nail, eyelash and other toilet brushes for use on the person, including brushes as parts of appliances",
  "960330":
    "Brushes; artists' brushes, writing brushes and similar brushes for the application of cosmetics",
  "960340":
    "Brushes; paint, distemper, varnish or similar brushes (not those of item no. 9603.30), paint pads and rollers",
  "960350": "Brushes; constituting parts of machines, appliances or vehicles",
  "960390":
    "Brooms, brushes, mops, feather dusters, squeegees, hand operated mechanical floor sweepers; (not motorised), prepared knots and tufts for brooms or brush making n.e.c.",
  "960400": "Hand sieves and hand riddles",
  "960500":
    "Travel sets; for personal toilet, sewing, shoe or clothes cleaning",
  "960610": "Press-fasteners, snap-fasteners, press-studs and parts therefor",
  "960621": "Buttons; of plastics, not covered with textile material",
  "960622": "Buttons; of base metal, not covered with textile material",
  "960629":
    "Buttons; of other than base metal or plastics, not covered with textile material",
  "960630": "Button moulds and other parts of buttons; button blanks",
  "960711": "Slide fasteners; fitted with chain scoops of base metal",
  "960719":
    "Slide fasteners; other than those fitted with chain scoops of base metal",
  "960720": "Slide fasteners; parts",
  "960810": "Pens; ball point",
  "960820": "Pens; felt tipped and other porous-tipped pens and markers",
  "960830": "Pens; fountain, stylograph and other pens",
  "960831": "Pens; Indian ink drawing pens",
  "960839":
    "Pens; fountain, stylograph and other pens, excluding Indian ink drawing pens",
  "960840": "Pencils; propelling or sliding",
  "960850":
    "Pen and pencil sets; of articles from two or more of the foregoing sub-headings",
  "960860":
    "Pens; ball-point, refills comprising the ball point and ink-reservoir",
  "960891": "Pens; nibs and nib points",
  "960899":
    "Pens and pencils; duplicating stylos, pen-holders, pencil-holders, and similar holders, parts of the articles of heading 9608, including caps and clips",
  "960910": "Pencils and crayons; with leads encased in rigid sheath",
  "960920": "Pencil leads; black or coloured",
  "960990":
    "Pastels, drawing charcoals, writing or drawing chalks, tailors' chalk",
  "961000":
    "Slates and boards; with writing or drawing surfaces, whether or not framed",
  "961100":
    "Stamps; date, numbering, sealing stamps and the like (including devices for printing or embossing labels), designed for operating by hand; hand operated composing sticks and printing sets",
  "961210":
    "Ribbons; for typewriters and the like, inked or otherwise prepared, for giving impressions, whether or not on spools or in cartridges",
  "961220": "Ink pads; whether or not inked, with or without boxes",
  "961310": "Lighters; pocket, cigarette, gas fuelled, non-refillable",
  "961320": "Lighters; pocket, cigarette, gas fuelled, refillable",
  "961330": "Lighters; table lighters, whether or not mechanical or electrical",
  "961380":
    "Lighters; whether or not mechanical or electrical, n.e.c. in heading no. 9613",
  "961390":
    "Lighters; parts for cigarette lighters and other lighters, whether or not mechanical or electrical, other than flints and wicks",
  "961400":
    "Smoking pipes (including pipe bowls) and cigar or cigarette holders, and parts thereof",
  "961410":
    "Pipes; smoking, roughly shaped blocks of wood or root, for the manufacture of pipes",
  "961420": "Pipes and pipe bowls and parts",
  "961490": "Cigar, cigarette holders and parts thereof",
  "961511": "Combs, hair slides and the like; of hard rubber or plastics",
  "961519":
    "Combs, hair slides and the like; of other than hard rubber or plastics",
  "961590":
    "Hairpins, curling pins, curling grips, hair curlers and the like (not those of heading no. 8516) and parts thereof",
  "961610":
    "Scent sprays and similar toilet sprays, and mounts and heads therefor",
  "961620":
    "Powder puffs and pads; for the application of cosmetics or toilet preparations",
  "961700":
    "Vacuum flasks and other vacuum vessels, complete with cases; parts thereof other than glass inners",
  "961800":
    "Tailors' dummies and other lay figures; automata and other animated displays used for shop window dressing",
  "961900":
    "Sanitary towels (pads) and tampons, napkins and napkin liners for babies and similar articles, of any material",
  "962000": "Monopods, bipods, tripods and similar articles",
  "970110":
    "Paintings, drawings and pastels; executed entirely by hand, other than drawings of heading no. 4906",
  "970121":
    "Paintings, drawings and pastels; executed entirely by hand, other than drawings of heading no. 4906, of an age exceeding 100 years",
  "970122":
    "Mosaics; executed entirely by hand, other than drawings of heading no. 4906, of an age exceeding 100 years",
  "970129":
    "Artwork; other than paintings, drawings, pastels mosaics, executed entirely by hand, other than drawings of heading no. 4906, of an age exceeding 100 years",
  "970190": "Artwork; collages and similar decorative plaques",
  "970191":
    "Paintings, drawings and pastels; executed entirely by hand, other than drawings of heading no. 4906, of an age not exceeding 100 years",
  "970192":
    "Mosaics; executed entirely by hand, other than drawings of heading no. 4906, of an age not exceeding 100 years",
  "970199":
    "Artwork; other than paintings, drawings, pastels mosaics, executed entirely by hand, other than drawings of heading no. 4906, of an age not exceeding 100 years",
  "970200": "Engravings, prints and lithographs; original",
  "970210":
    "Engravings, prints and lithographs; original of an age exceeding 100 years",
  "970290":
    "Engravings, prints and lithographs; original of an age not exceeding 100 years",
  "970300": "Sculptures and statuary; original, in any material",
  "970310":
    "Sculptures and statuary; original, in any material, of an age exceeding 100 years",
  "970390":
    "Sculptures and statuary; original, in any material, of an age not exceeding 100 years",
  "970400":
    "Stamps, postage or revenue; stamp-postmarks, first-day covers, postal stationery (stamped paper) and like, used or unused, other than those of heading 4907",
  "970500":
    "Collections and collectors' pieces; of zoological, botanical, mineralogical, anatomical, historical, archaeological, palaeontological, ethnographic or numismatic interest",
  "970510":
    "Collections and collectors' pieces; of archaeological, ethnographic or historical interest",
  "970521":
    "Collections and collectors' pieces; of zoological, botanical, mineralogical, anatomical or palaeontological interest, human specimens and parts thereof",
  "970522":
    "Collections and collectors' pieces; of zoological, botanical, mineralogical, anatomical or palaeontological interest, extinct or endangered species and parts thereof",
  "970529":
    "Collections and collectors' pieces; of zoological, botanical, mineralogical, anatomical or palaeontological interest, other than human species, extinct or endangered species and parts thereof",
  "970531":
    "Collections and collectors' pieces; of numismatic interest, of an age exceeding 100 years",
  "970539":
    "Collections and collectors' pieces; of numismatic interest, of an age not exceeding 100 years",
  "970600": "Antiques; of an age exceeding one hundred years",
  "970610": "Antiques; of an age exceeding 250 years",
  "970690":
    "Antiques; of an age exceeding 100 years but not exceeding 250 years",
  "999999": "Commodities not specified according to kind",
  "010110":
    "Horses, asses, mules and hinnies; live, pure-bred breeding animals",
  "010111": "Horses; live, pure-bred breeding animals",
  "010119": "Horses; live, other than pure-bred breeding animals",
  "010120": "Asses, mules and hinnies; live",
  "010121": "Horses; live, pure-bred breeding animals",
  "010129": "Horses; live, other than pure-bred breeding animals",
  "010130": "Asses; live",
  "010190": "Mules and hinnies; live",
  "010210": "Bovine animals; live, pure-bred breeding animals",
  "010221": "Cattle; live, pure-bred breeding animals",
  "010229": "Live cattle; excl. pure-bred breeding animals",
  "010231": "Buffalo; live, pure-bred breeding animals",
  "010239": "Buffalo; live, other than pure-bred breeding animals",
  "010290": "Live bovine animals; excl. cattle and buffalo",
  "010310": "Swine; live, pure-bred breeding animals",
  "010391":
    "Swine; live, other than pure-bred breeding animals, weighing less than 50kg",
  "010392":
    "Swine; live, other than pure-bred breeding animals, weighing 50kg or more",
  "010410": "Sheep; live",
  "010420": "Goats; live",
  "010511":
    "Poultry; live, fowls of the species Gallus domesticus, weighing not more than 185g",
  "010512": "Poultry; live, turkeys, weighing not more than 185g",
  "010513": "Poultry; live, ducks, weighing not more than 185g",
  "010514": "Poultry; live, geese, weighing not more than 185g",
  "010515": "Poultry; live, guinea fowls, weighing not more than 185g",
  "010519":
    "Poultry; live, weighing not more than 185g, ducks, geese and guinea fowls",
  "010591":
    "Poultry; live, fowls of the species gallus domesticus, weighing more than 185g",
  "010592":
    "Poultry; live, weighing over 185g but not more than 2000g, fowls of the species gallus domesticus",
  "010593":
    "Poultry; live, weighing over 2000g, fowls of the species gallus domesticus",
  "010594":
    "Poultry; live, fowls of the species Gallus domesticus, weighing more than 185g",
  "010599":
    "Poultry; live, ducks, geese, turkeys and guinea fowls, weighing more than 185g",
  "010600": "Animals; live, n.e.s. in chapter 1",
  "010611": "Mammals; live, primates",
  "010612":
    "Mammals; live, whales, dolphins and porpoises (mammals of the order Cetacea); manatees and dugongs (mammals of the order Sirenia); seals, sea lions and walruses (mammals of the suborder Pinnipedia)",
  "010613": "Mammals; live, camels and other camelids (Camelidae)",
  "010614": "Mammals; live, rabbits and hares",
  "010619":
    "Mammals; live, other than primates, whales, dolphins, porpoises (mammals of the order Cetacea); manatees, dugongs (mammals of the order Sirenia); seals, sea lions, walruses (mammals of the suborder Pinnipedia), camels, other camelids, rabbits and hares",
  "010620": "Reptiles; live (including snakes and turtles)",
  "010631": "Birds; live, birds of prey",
  "010632": "Birds; live, Psittaciformes",
  "010633": "Birds; live, ostriches; emus (Dromaius novaehollandiae)",
  "010639":
    "Birds; live, other than birds of prey, Psittaciformes, ostriches and emus (Dromaius novaehollandiae)",
  "010641": "Insects; live, bees",
  "010649": "Insects; live, other than bees",
  "010690":
    "Animals; live, n.e.c. in chapter 01, other than mammals, reptiles, birds and insects",
  "020110":
    "Meat; of bovine animals, carcasses and half-carcasses, fresh or chilled",
  "020120": "Bovine cuts; bone in, fresh or chilled; excl. carcasses",
  "020130": "Bovine cuts; boneless, fresh or chilled",
  "020210": "Meat; of bovine animals, carcasses and half-carcasses, frozen",
  "020220":
    "Meat; of bovine animals, cuts with bone in (excluding carcasses and half-carcasses), frozen",
  "020230": "Bovine cuts; boneless, frozen",
  "020311": "Meat; of swine, carcasses and half-carcasses, fresh or chilled",
  "020312":
    "Meat; of swine, hams, shoulders and cuts thereof, with bone in, fresh or chilled",
  "020319": "Swine cuts; fresh or chilled; excl. carcasses and cuts with bone",
  "020321": "Meat; of swine, carcasses and half-carcasses, frozen",
  "020322":
    "Meat; of swine, hams, shoulders and cuts thereof, with bone in, frozen",
  "020329": "Other swine cuts; frozen (exclusionary category)",
  "020410":
    "Meat; of sheep, lamb carcasses and half-carcasses, fresh or chilled",
  "020421":
    "Meat; of sheep, carcasses and half-carcasses (excluding carcasses and half-carcasses of lamb), fresh or chilled",
  "020422":
    "Meat; of sheep (including lamb), cuts with bone in (excluding carcasses and half-carcasses), fresh or chilled",
  "020423": "Meat; of sheep (including lamb), boneless cuts, fresh or chilled",
  "020430": "Meat; of sheep, lamb carcasses and half-carcasses, frozen",
  "020441":
    "Meat; of sheep, carcasses and half-carcasses (excluding carcasses and half-carcasses of lamb), frozen",
  "020442":
    "Meat; of sheep (including lamb), cuts with bone in (excluding carcasses and half-carcasses), frozen",
  "020443": "Meat; of sheep (including lamb), boneless cuts, frozen",
  "020450": "Meat; of goats, fresh, chilled or frozen",
  "020500":
    "Meat; of horses, asses, mules or hinnies, fresh, chilled or frozen",
  "020610": "Offal, edible; of bovine animals, fresh or chilled",
  "020621": "Offal, edible; of bovine animals, tongues, frozen",
  "020622": "Offal, edible; of bovine animals, livers, frozen",
  "020629":
    "Offal, edible; of bovine animals, (other than tongues and livers), frozen",
  "020630": "Offal, edible; of swine, fresh or chilled",
  "020641": "Offal, edible; of swine, livers, frozen",
  "020649": "Offal, edible; of swine, (other than livers), frozen",
  "020680":
    "Offal, edible; of sheep, goats, horses, asses, mules or hinnies, fresh or chilled",
  "020690":
    "Offal, edible; of sheep, goats, horses, asses, mules or hinnies, frozen",
  "020710":
    "Meat and edible offal; poultry, not cut in pieces, fresh or chilled",
  "020711":
    "Meat and edible offal; of fowls of the species Gallus domesticus, not cut in pieces, fresh or chilled",
  "020712":
    "Meat and edible offal; of fowls of the species Gallus domesticus, not cut in pieces, frozen",
  "020713":
    "Meat and edible offal; of fowls of the species Gallus domesticus, cuts and offal, fresh or chilled",
  "020714": "Fowl meat and offal; frozen",
  "020721":
    "Meat and edible offal; fowls of the species gallus domesticus, not cut in pieces, frozen",
  "020722": "Meat and edible offal; turkeys, not cut in pieces, frozen",
  "020723":
    "Meat and edible offal; ducks, geese and guinea fowls, not cut in pieces, frozen",
  "020724":
    "Meat and edible offal; of turkeys, not cut in pieces, fresh or chilled",
  "020725": "Meat and edible offal; of turkeys, not cut in pieces, frozen",
  "020726":
    "Meat and edible offal; of turkeys, cuts and offal, fresh or chilled",
  "020727": "Meat and edible offal; of turkeys, cuts and offal, frozen",
  "020731": "Offal, edible; of geese or ducks, fatty livers, fresh or chilled",
  "020732":
    "Meat and edible offal; of the poultry of heading no. 0105, of ducks, geese or guinea fowls, (not cut in pieces), fresh or chilled",
  "020733":
    "Meat and edible offal; of the poultry of heading no. 0105, of ducks, geese or guinea fowls, (not cut in pieces), frozen",
  "020734":
    "Meat and edible offal; of the poultry of heading no. 0105, of ducks, geese or guinea fowls, fatty livers, fresh or chilled (foie gras from ducks or geese only)",
  "020735":
    "Meat and edible offal; of the poultry of heading no. 0105, of ducks, geese or guinea fowls, fresh or chilled, poultry cuts or offal (excluding fatty livers)",
  "020736":
    "Meat and edible offal; of the poultry of heading no. 0105, of ducks, geese or guinea fowls, frozen",
  "020739":
    "Meat and edible offal; poultry cuts and offal (including livers but excluding the fatty livers of geese or ducks), fresh or chilled",
  "020741": "Duck meat; fresh or chilled, whole",
  "020742": "Meat and edible offal; of ducks, not cut in pieces, frozen",
  "020743":
    "Meat and edible offal; of ducks, fatty livers (foie gras), fresh or chilled",
  "020744":
    "Meat and edible offal; of ducks, cuts and offal, excluding fatty livers, fresh or chilled",
  "020745":
    "Meat and edible offal; of ducks, cuts and offal, excluding fatty livers, frozen",
  "020750": "Offal, edible; of poultry, livers, frozen",
  "020751":
    "Meat and edible offal; of geese, not cut in pieces, fresh or chilled",
  "020752": "Meat and edible offal; of geese, not cut in pieces, frozen",
  "020753":
    "Meat and edible offal; of geese, fatty livers (foie gras), fresh or chilled",
  "020754":
    "Meat and edible offal; of geese, cuts and offal, excluding fatty livers, fresh or chilled",
  "020755":
    "Meat and edible offal; of geese, cuts and offal, excluding fatty livers, frozen",
  "020760": "Meat and edible offal; of guinea fowls, fresh, chilled or frozen",
  "020810":
    "Meat and edible meat offal; of rabbits or hares, fresh, chilled or frozen",
  "020820": "Meat and edible meat offal; frogs' legs, fresh, chilled or frozen",
  "020830": "Meat and edible meat offal; of primates, fresh, chilled or frozen",
  "020840":
    "Meat and edible meat offal; of whales, dolphins and porpoises (mammals of the order Cetacea); of manatees and dugongs (mammals of the order Sirenia); of seals, sea lions and walruses (mammals of the suborder Pinnipedia), fresh, chilled or frozen",
  "020850":
    "Meat and edible meat offal; of reptiles (including snakes and turtles), fresh, chilled or frozen",
  "020860":
    "Meat and edible meat offal; of camels and other camelids (Camelidae), fresh, chilled or frozen",
  "020890":
    "Meat and edible meat offal; n.e.c. in chapter 2, fresh, chilled or frozen",
  "020900":
    "Fat; pig fat, free of lean meat, and poultry fat, (not rendered or otherwise extracted), fresh, chilled, frozen, salted, in brine, dried or smoked",
  "020910":
    "Fat; pig fat, free of lean meat, not rendered or otherwise extracted, fresh, chilled, frozen, salted, in brine, dried or smoked",
  "020990":
    "Fat; poultry fat, not rendered or otherwise extracted, fresh, chilled, frozen, salted, in brine, dried or smoked",
  "021011":
    "Meat; salted, in brine, dried or smoked, of swine, hams, shoulders and cuts thereof, with bone in",
  "021012":
    "Meat; salted, in brine, dried or smoked, of swine, bellies (streaky) and cuts thereof",
  "021019":
    "Meat; salted in brine, dried or smoked, of swine, n.e.c. in item no. 0210.1",
  "021020": "Meat; salted, in brine, dried or smoked, of bovine animals",
  "021090":
    "Meat and edible meat offal, preserved; salted, in brine, dried or smoked, and edible flours and meals of meat or meat offal, n.e.s. in heading no. 0210",
  "021091":
    "Meat and edible meat offal; salted, in brine, dried or smoked, and edible flours and meals of meat or meat offal, of primates",
  "021092":
    "Meat and edible meat offal; salted, in brine, dried or smoked; edible flours, meals of meat or meat offal, of whales, dolphins, porpoises (of order Cetacea); manatees, dugongs (of order Sirenia); seals, sea lions, and walruses (of suborder Pinnipedia)",
  "021093":
    "Meat and edible meat offal; salted, in brine, dried or smoked, and edible flours and meals of meat or meat offal, of reptiles (including snakes and turtles)",
  "021099":
    "Meat and edible meat offal; salted, in brine, dried or smoked, and edible flours and meals of meat or meat offal, other than of primates, whales, dolphins, porpoises, manatees, dugongs, seals, sea lions, walruses, reptiles (including snakes and turtles)",
  "030110": "Fish; live, ornamental",
  "030111": "Fish; live, ornamental, freshwater",
  "030119": "Fish; live, ornamental, other than freshwater",
  "030191":
    "Fish; live, trout (Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache and Oncorhynchus chrysogaster)",
  "030192": "Fish; live, eels (Anguilla spp.)",
  "030193":
    "Fish; live, carp (Cyprinus spp., Carassius spp., Ctenopharyngodon idellus, Hypophthalmichthys spp., Cirrhinus spp., Mylopharyngodon piceus, Catla catla, Labeo spp., Osteochilus hasselti, Leptobarbus hoeveni, Megalobrama spp.)",
  "030194":
    "Fish; live, Atlantic and Pacific bluefin tunas (Thunnus thynnus, Thunnus orientalis)",
  "030195": "Fish; live, southern bluefin tunas (Thunnus maccoyii)",
  "030199": "Fish; live, n.e.c. in heading 0301",
  "030211":
    "Fish; fresh or chilled, trout (Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache and Oncorhynchus chrysogaster), excluding fillets, fish meat of 0304, and edible fish offal of 0302.9",
  "030212": "Salmon, Pacific-, Atlantic-, Danube-; fresh or chilled, uncut",
  "030213":
    "Fish; fresh or chilled, Pacific salmon (Oncorhynchus nerka, Oncorhynchus gorbuscha, Oncorhynchus keta, Oncorhynchus tschawytscha, Oncorhynchus kisutch, Oncorhynchus masou, Oncorhynchus rhodurus), not fillets, meat of 0304, and edible fish offal of 0302.9",
  "030214": "Salmon, Atlantic-, Danube-; fresh or chilled, uncut",
  "030219":
    "Fish; fresh or chilled, salmonidae, n.e.c. in item no. 0302.1, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030221":
    "Fish; fresh or chilled, halibut (Reinhardtius hippoglossoides, Hippoglossus hippoglossus, Hippoglossus stenolepis), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030222":
    "Fish; fresh or chilled, plaice (Pleuronectes platessa), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030223":
    "Fish; fresh or chilled, sole (Solea spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030224":
    "Fish; fresh or chilled, turbots (Psetta maxima, Scophthalmidae), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030229":
    "Fish; fresh or chilled, flat fish, n.e.c. in item no. 0302.2, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030231":
    "Fish; fresh or chilled, albacore or longfinned tunas (Thunnus alalunga), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030232":
    "Fish; fresh or chilled, yellowfin tunas (Thunnus albacares), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030233":
    "Fish; fresh or chilled, skipjack or stripe-bellied bonito, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030234":
    "Fish; fresh or chilled, bigeye tunas (Thunnus obesus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030235":
    "Fish; fresh or chilled, Atlantic and Pacific bluefin tunas (Thunnus thynnus, Thunnus orientalis), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030236":
    "Fish; fresh or chilled, southern bluefin tunas (Thunnus maccoyii), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030239":
    "Fish; fresh or chilled, tuna, n.e.c. in item no. 0302.3, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030240":
    "Fish; herrings (clupea harengus, clupea pallasii), fresh or chilled (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030241":
    "Fish; fresh or chilled, herrings (Clupea harengus, Clupea pallasii), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030242":
    "Fish; fresh or chilled, anchovies (Engraulis spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030243":
    "Fish; fresh or chilled, sardines (Sardina pilchardus, Sardinops spp.), sardinella (Sardinella spp.), brisling or sprats (Sprattus sprattus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030244":
    "Fish; fresh or chilled, mackerel (Scomber scombrus, Scomber australasicus, Scomber japonicus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030245":
    "Fish; fresh or chilled, jack and horse mackerel (Trachurus spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030246":
    "Fish; fresh or chilled, cobia (Rachycentron canadum), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030247":
    "Fish; fresh or chilled, swordfish (Xiphias gladius), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030249":
    "Fish; fresh or chilled, n.e.c. in item no. 0302.4, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030250":
    "Fish; cod (gadus morhua, gadus ogac, gadus macrocephalus), fresh or chilled (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030251":
    "Fish; fresh or chilled, cod (Gadus morhua, Gadus ogac, Gadus macrocephalus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030252":
    "Fish; fresh or chilled, haddock (Melanogrammus aeglefinus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030253":
    "Fish; fresh or chilled, coalfish (Pollachius virens), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030254":
    "Fish; fresh or chilled, hake (Merluccius spp., Urophycis spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030255":
    "Fish; fresh or chilled, Alaska pollack (Theragra chalcogramma), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030256":
    "Fish; fresh or chilled, blue whitings (Micromesistius poutassou, Micromesistius australis),excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030259":
    "Fish; fresh or chilled, n.e.c. in item no. 0302.5, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030261":
    "Fish; sardines (sardina pilchardus, sardinops spp.), sardinella (sardinella spp.), brisling or sprats (sprattus sprattus), fresh or chilled (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030262":
    "Fish; haddock (melanogrammus aeglefinus), fresh or chilled (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030263":
    "Fish; coalfish (pollachius virens), fresh or chilled (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030264":
    "Fish; mackerel (scomber scombrus, scomber australasicus, scomber japonicus), fresh of chilled (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030265":
    "Fish; dogfish and other sharks, fresh or chilled (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030266":
    "Fish; eels (anguilla spp.), fresh or chilled (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030267":
    "Fish; swordfish (Xiphias gladius), fresh or chilled (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030268":
    "Fish; toothfish (Dissostichus spp.), fresh or chilled (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030269": "Other fish; fresh or chilled (exclusionary category)",
  "030270": "Fish; livers and roes, fresh or chilled",
  "030271":
    "Fish; fresh or chilled, tilapias (Oreochromis spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030272":
    "Fish; fresh or chilled, catfish (Pangasius spp., Silurus spp., Clarias spp., Ictalurus spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030273":
    "Fish; fresh or chilled, Carp (as specified by the WCO.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030274":
    "Fish; fresh or chilled, eels (Anguilla spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030279":
    "Fish; fresh or chilled, Nile perch (Lates niloticus) and snakeheads (Channa spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030281":
    "Fish; fresh or chilled, dogfish and other sharks, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030282":
    "Fish; fresh or chilled, rays and skates (Rajidae), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030283":
    "Fish; fresh or chilled, toothfish (Dissostichus spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030284":
    "Fish; fresh or chilled, seabass (Dicentrarchus spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030285":
    "Fish; fresh or chilled, seabream (Sparidae), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030289":
    "Fish; fresh or chilled, n.e.c. in heading 0302, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0302.91 to 0302.99",
  "030290": "Fish; fresh or chilled, livers and roes",
  "030291": "Fish; fresh or chilled, livers, roes and milt",
  "030292": "Fish; fresh or chilled, shark fins",
  "030299":
    "Fish; fresh or chilled, fish fins (other than shark fins), heads, tails, maws and other edible fish offal",
  "030310":
    "Fish; Pacific salmon, (oncorhynchus nerka/gorbuscha/keta/tschawytscha/kisutch/masou/rhodurus), frozen, (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030311":
    "Fish; frozen, Pacific salmon, sockeye salmon (red salmon) (Oncorhynchus nerka), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030312":
    "Fish; frozen, Pacific salmon (Oncorhynchus gorbuscha/keta/tschawytscha/ kisutch/masou/rhodurus) other than sockeye salmon (Oncorhynchus nerka), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030313":
    "Fish; frozen, Atlantic salmon (Salmo salar) and Danube salmon (Hucho hucho), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030314":
    "Fish; frozen, trout (Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache and Oncorhynchus chrysogaster), excluding fillets, meat of 0304, and edible fish offal of 0303.91 to 0303.99",
  "030319":
    "Fish; frozen, salmonidae, n.e.c. in item no. 0303.1, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030321":
    "Fish; trout (salmo trutta, oncorhynchus mykiss, oncorhynchus clarki, oncorhynchus aguabonita, oncorhynchus gilae, oncorhynchus apache and oncorhynchus chrysogaster), frozen (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030322":
    "Fish; Atlantic salmon (salmo salar) and Danube salmon (hucho hucho), frozen (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030323":
    "Fish; frozen, tilapias (Oreochromis spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030324":
    "Fish; frozen, catfish (Pangasius spp., Silurus spp., Clarias spp., Ictalurus spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030325":
    "Fish; frozen, carp  (as specified by the WCO), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030326":
    "Fish; frozen, eels (Anguilla spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030329":
    "Fish; frozen, Nile perch (Lates niloticus) and snakeheads (Channa spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030331":
    "Fish; frozen, halibut (Reinhardtius hippoglossoides, Hippoglossus hippoglossus, Hippoglossus stenolepis), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030332":
    "Fish; frozen, plaice (Pleuronectes platessa), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030333":
    "Fish; frozen, sole (Solea spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030334":
    "Fish; frozen, turbots (Psetta maxima, Scophthalmidae), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030339":
    "Fish; frozen, flat fish, n.e.c. in item no. 0303.3, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030341":
    "Fish; frozen, albacore or longfinned tunas (Thunnus alalunga), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030342":
    "Fish; frozen, yellowfin tunas (Thunnus albacares), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030343":
    "Fish; frozen, skipjack or stripe-bellied bonito, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030344":
    "Fish; frozen, bigeye tunas (Thunnus obesus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030345":
    "Fish; frozen, Atlantic and Pacific bluefin tunas (Thunnus thynnus, Thunnus orientalis), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030346":
    "Fish; frozen, southern bluefin tunas (Thunnus maccoyii), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030349":
    "Fish; frozen, tuna, n.e.c. in item no. 0303.4, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030350":
    "Fish; herrings (clupea harengus, clupea pallasii), frozen (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030351":
    "Fish; frozen, herrings (Clupea harengus, Clupea pallasii), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030352":
    "Fish; cod (Gadus morhua, Gadus ogac, Gadus macrocephalus), frozen (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030353":
    "Fish; frozen, sardines (Sardina pilchardus, Sardinops spp.), sardinella (Sardinella spp.), brisling or sprats (Sprattus sprattus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030354":
    "Fish; frozen, mackerel (Scomber scombrus, Scomber australasicus, Scomber japonicus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030355":
    "Fish; frozen, jack and horse mackerel (Trachurus spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030356":
    "Fish; frozen, cobia (Rachycentron canadum), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030357":
    "Fish; frozen, swordfish (Xiphias gladius), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030359":
    "Fish; frozen, n.e.c. in item no. 0303.5, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030360":
    "Fish; cod (gadus morhua, gadus ogac, gadus macrocephalus), frozen (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030361":
    "Fish; swordfish (Xiphias gladius), frozen (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030362":
    "Fish; toothfish (Dissostichus spp.), frozen (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030363":
    "Fish; frozen, cod (Gadus morhua, Gadus ogac, Gadus macrocephalus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030364":
    "Fish; frozen, haddock (Melanogrammus aeglefinus), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030365":
    "Fish; frozen, coalfish (Pollachius virens), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030366":
    "Fish; frozen, hake (Merluccius spp., Urophycis spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030367":
    "Fish; frozen, Alaska pollack (Theraga chalcogramma), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030368":
    "Fish; frozen, blue whitings (Micromesistius poutassou, Micromesistius australis), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030369":
    "Fish; frozen, of Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae, Muraenolepididae, other than cod, haddock, coalfish, hake, Alaska pollack, blue whitings, not fillets, meat of 0304, and edible offal of 0303.9",
  "030371":
    "Fish; sardines (sardina pilchardus, sardinops spp.), sardinella (sardinella spp.), brisling or sprats (sprattus sprattus), frozen (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030372":
    "Fish; haddock (melanogrammus aeglefinus), frozen (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030373":
    "Fish; coalfish (pollachius virens), frozen (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030374":
    "Fish; mackerel (scomber scombrus, scomber australasicus, scomber japonicus), frozen (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030375":
    "Fish; dogfish and other sharks, frozen (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030376":
    "Fish; eels (anguilla spp.), frozen (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030377":
    "Fish; sea bass (dicentrarchus labrax, dicentrarchus punctatus), frozen, (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030378":
    "Fish; hake (merluccius spp., urophycis spp.), frozen (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030379":
    "Fish; frozen, n.e.c. in heading no. 0303 (excluding fillets, livers, roes and other fish meat of heading no. 0304)",
  "030380": "Fish; livers and roes, frozen",
  "030381":
    "Fish; frozen, dogfish and other sharks, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030382":
    "Fish; frozen, rays and skates (Rajidae), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030383":
    "Fish; frozen, toothfish (Dissostichus spp.), excluding fillets, livers, roes, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030384":
    "Fish; frozen, seabass (Dicentrarchus spp.), excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030389":
    "Fish; frozen, n.e.c. in heading 0303, excluding fillets, fish meat of 0304, and edible fish offal of subheadings 0303.91 to 0303.99",
  "030390": "Fish; frozen, livers and roes",
  "030391": "Fish; frozen, livers, roes and milt",
  "030392": "Fish; frozen, shark fins",
  "030399":
    "Fish; frozen, fish fins (other than shark fins), heads, tails, maws and other edible fish offal",
  "030410":
    "Fish; fillets and other fish meat, fresh or chilled (whether or not minced)",
  "030411":
    "Fish; swordfish (Xiphias gladius), fillets and other fish meat (whether or not minced), fresh or chilled",
  "030412":
    "Fish; toothfish (Dissostichus spp.), fillets and other fish meat (whether or not minced), fresh or chilled",
  "030419":
    "Fish; fillets and other fish meat (whether or not minced), fresh or chilled, other than swordfish (Xiphias gladius) and toothfish (Dissostichus spp.)",
  "030420": "Fish fillets; frozen",
  "030421": "Fish; swordfish (Xiphias gladius), fillets, frozen",
  "030422": "Fish; toothfish (Dissostichus spp.), fillets, frozen",
  "030429": "Fish fillets; frozen; excl. swordfish and toothfish",
  "030431": "Fish fillets; fresh or chilled, tilapias (Oreochromis spp.)",
  "030432":
    "Fish fillets; fresh or chilled, catfish (Pangasius spp., Silurus spp., Clarias spp., Ictalurus spp.)",
  "030433": "Fish fillets; fresh or chilled, Nile perch (Lates niloticus)",
  "030439":
    "Fish fillets; fresh or chilled, carp (as specified by the WCO), eels (Anguilla spp.), and snakeheads (Channa spp.)",
  "030441":
    "Fish fillets; fresh or chilled, salmon, Pacific (Oncorhynchus nerka, Oncorhynchus gorbuscha, Oncorhynchus keta, Oncorhynchus tschawytscha, Oncorhynchus kisutch, Oncorhynchus masou and Oncorhynchus rhodurus), Atlantic (Salmo salar), Danube (Hucho hucho)",
  "030442":
    "Fish fillets; fresh or chilled, trout (Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache and Oncorhynchus chrysogaster)",
  "030443":
    "Fish fillets; fresh or chilled, flat fish (Pleuronectidae, Bothidae, Cynoglossidae, Soleidae, Scophthalmidae and Citharidae)",
  "030444":
    "Fish fillets; fresh or chilled, of the families Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae, and Muraenolepididae",
  "030445": "Fish fillets; fresh or chilled, swordfish (Xiphias gladius)",
  "030446": "Fish fillets; fresh or chilled, toothfish (Dissostichus spp.)",
  "030447": "Fish fillets; fresh or chilled, dogfish and other sharks",
  "030448": "Fish fillets; fresh or chilled, rays and skates (Rajidae)",
  "030449": "Fish fillets; fresh or chilled, other than fish of heading 0304.4",
  "030451":
    "Fish meat, excluding fillets, whether or not minced; fresh or chilled, tilapias, catfish, carp, eels, Nile perch, and snakeheads",
  "030452":
    "Fish meat, excluding fillets, whether or not minced; fresh or chilled, salmonidae",
  "030453":
    "Fish meat, excluding fillets, whether or not minced; fresh or chilled, of the families Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae, and Muraenolepididae",
  "030454":
    "Fish meat, excluding fillets, whether or not minced; fresh or chilled, swordfish (Xiphias gladius)",
  "030455":
    "Fish meat, excluding fillets, whether or not minced; fresh or chilled, toothfish (Dissostichus spp.)",
  "030456":
    "Fish meat; excluding fillets, whether or not minced; fresh or chilled, dogfish and other sharks",
  "030457":
    "Fish meat; excluding fillets, whether or not minced; fresh or chilled, rays and skates (Rajidae)",
  "030459":
    "Fish meat; excluding fillets, whether or not minced; fresh or chilled, of fish n.e.c. in item no. 0304.5",
  "030461": "Fish fillets; frozen, tilapias (Oreochromis spp.)",
  "030462":
    "Fish fillets; frozen, catfish (Pangasius spp., Silurus spp., Clarias spp., Ictalurus spp.)",
  "030463": "Fish fillets; frozen, Nile Perch (Lates niloticus)",
  "030469":
    "Fish fillets; frozen, carp (Cyprinus/Carassius/Ctenopharyngodon idellus/Hypophthalmichthys/Cirrhinus/Mylopharyngodon piceus/Catla catla/Labeo/Osteochilus hasselti/Leptobarbus hoeveni/Megalobrama), eels (Anguilla) and snakeheads (Channa)",
  "030471":
    "Fish fillets; frozen, cod (Gadus morhua, Gadus ogac, Gadus macrocephalus)",
  "030472": "Fish fillets; frozen, haddock (Melanogrammus aeglefinus)",
  "030473": "Fish fillets; frozen, coalfish (Pollachius virens)",
  "030474": "Fish fillets; frozen, hake (Merluccius spp., Urophycis spp.)",
  "030475": "Fish fillets; frozen, Alaska pollack (Theragra chalcogramma)",
  "030479":
    "Fish fillets; frozen, of the families Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae and Muraenolepididae other than cod, haddock, coalfish, hake, and Alaska pollack",
  "030481":
    "Fish fillets; frozen, salmon, Pacific (Oncorhynchus nerka, Oncorhynchus gorbuscha, Oncorhynchus keta, Oncorhynchus tschawytscha, Oncorhynchus kisutch, Oncorhynchus masou, Oncorhynchus rhodurus), Atlantic (Salmo salar), and Danube (Hucho hucho)",
  "030482":
    "Fish fillets; frozen, trout (Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache and Oncorhynchus chrysogaster)",
  "030483":
    "Fish fillets; frozen, flat fish (Pleuronectidae, Bothidae, Cynoglossidae, Soleidae, Scophthalmidae and Citharidae)",
  "030484": "Fish fillets; frozen, swordfish (Xiphias gladius)",
  "030485": "Fish fillets; frozen, toothfish (Dissostichus spp.)",
  "030486": "Fish fillets; frozen, herrings (Clupea harengus, Clupea pallasii)",
  "030487":
    "Fish fillets; frozen, tunas (of the genus Thunnus), skipjack or stripe-bellied bonito (Euthynnus (Katsuwonus) pelamis)",
  "030488":
    "Fish fillets; frozen, dogfish, other sharks, rays and skates (Rajidae)",
  "030489": "Fish fillets; frozen, of fish n.e.c. in heading 0304.8",
  "030490":
    "Fish; fish meat n.e.s. in heading no. 0304 (whether or not minced), fresh, chilled or frozen",
  "030491":
    "Fish meat, excluding fillets, whether or not minced; frozen, swordfish (Xiphias gladius)",
  "030492":
    "Fish meat, excluding fillets, whether or not minced; frozen, toothfish (Dissostichus spp.)",
  "030493":
    "Fish meat, excluding fillets, whether or not minced; frozen, tilapias, catfish, carp, eels, Nile perch, and snakeheads",
  "030494":
    "Fish meat, excluding fillets, whether or not minced; frozen, Alaska Pollack (Theragra chalcogramma)",
  "030495":
    "Fish meat, excluding fillets, whether or not minced; frozen, of the families Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae and Muraenolepididae, other than Alaska Pollack (Theragra chalcogramma)",
  "030496":
    "Fish meat, excluding fillets, whether or not minced; frozen, dogfish and other sharks",
  "030497":
    "Fish meat, excluding fillets, whether or not minced; frozen, rays and skates (Rajidae)",
  "030499":
    "Fish meat, excluding fillets, whether or not minced; frozen, n.e.c. in item no. 0304.9",
  "030510": "Fish; flours, meals and pellets, fit for human consumption",
  "030520":
    "Fish; livers, roes and milt of fish, dried, smoked, salted or in brine",
  "030530": "Fish; fillets, dried, salted or in brine, but not smoked",
  "030531":
    "Fish fillets; dried, salted or in brine, but not smoked, tilapias, catfish, carp, eels, Nile perch, and snakeheads",
  "030532":
    "Fish fillets; dried, salted or in brine, but not smoked, of the families Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae and Muraenolepididae",
  "030539":
    "Fish fillets; dried, salted or in brine, but not smoked, n.e.c. in item no. 0305.3",
  "030541":
    "Fish; smoked, whether or not cooked before or during smoking, salmon, Pacific (Oncorhynchus nerka, gorbuscha, keta, tschawytscha, kisutch, masou, rhodurus), Atlantic (Salmo salar) and Danube (Hucho hucho), includes fillets, but excludes edible fish offal",
  "030542":
    "Fish; smoked, whether or not cooked before or during smoking, herrings (Clupea harengus, Clupea pallasii), includes fillets, but excludes edible fish offal",
  "030543":
    "Fish; smoked, whether or not cooked before or during smoking, trout (Salmo trutta, Oncorhynchus mykiss/clarki/aguabonita/gilae/apache/chrysogaster), includes fillets, but excludes edible fish offal",
  "030544":
    "Fish; smoked, whether or not cooked before or during smoking, tilapias, catfish, carp, eels, Nile perch, and snakeheads, includes fillets, but excludes edible fish offal",
  "030549":
    "Fish; smoked, whether or not cooked before or during smoking, n.e.c. in item no. 0305.4, includes fillets, but excludes edible fish offal",
  "030551":
    "Fish; dried, whether or not salted but not smoked, other than edible fish offal, cod (Gadus morhua, Gadus ogac, Gadus macrocephalus)",
  "030552":
    "Fish; dried, whether or not salted but not smoked, tilapias, catfish, carp, eels, Nile perch, and snakeheads",
  "030553":
    "Fish; dried, whether or not salted but not smoked, fish of the families Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae and Muraenolepididae, other than cod",
  "030554":
    "Dried herrings, anchovies, sardines, sardinella, brisling or sprats, mackerel (incl Indian, jack, or horse), seerfishes, jacks, crevalles, cobia, silver pomfrets, Pacific saury, scads, capelin, swordfish, Kawakawa, bonitos, marlins, sailfishes, spearfish",
  "030559":
    "Fish; dried, whether or not salted but not smoked, other than edible fish offal, n.e.c. in item no. 0305.5",
  "030561":
    "Fish; salted or in brine, not dried or smoked, other than edible fish offal, herrings (Clupea harengas, Clupea pallasii)",
  "030562":
    "Fish; salted or in brine, not dried or smoked, other than edible fish offal, cod (Gadus morhua, Gadus ogac, Gadus macrocephalus)",
  "030563":
    "Fish; salted or in brine, not dried or smoked, other than edible fish offal, anchovies (Engrails spp.)",
  "030564":
    "Fish; salted or in brine, not dried or smoked, other than edible fish offal, tilapias, catfish, carp, eels, Nile perch, and snakeheads",
  "030569":
    "Fish; salted or in brine, not dried or smoked, other than edible fish offal, n.e.c. in item no. 0305.6",
  "030571": "Fish; edible offal, shark fins",
  "030572": "Fish; edible offal, fish heads, tails and maws",
  "030579":
    "Fish; edible offal, other than shark fins, fish heads, tails and maws",
  "030611":
    "Crustaceans; frozen, rock lobsters and other sea crawfish (Palinurus spp., Panulirus spp., Jasus spp.), in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water",
  "030612":
    "Crustaceans; frozen, lobsters (Homarus spp.), in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water",
  "030613": "Shrimps and prawns; frozen",
  "030614":
    "Crustaceans; frozen, crabs, in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water",
  "030615":
    "Crustaceans; frozen, Norway lobsters (Nephrops norvegicus), in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water",
  "030616":
    "Crustaceans; frozen, cold-water shrimps and prawns (Pandalus spp., Crangon crangon), in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water",
  "030617": "Shrimps and prawns; frozen, smoked; excl. cold-water varieties",
  "030619":
    "Crustaceans; frozen, n.e.c. in item no. 0306.1, in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water; including edible flours, meals, and pellets of crustaceans",
  "030621":
    "Crustaceans; not frozen, rock lobsters and other sea crawfish (Palinurus spp., Panulirus spp., Jasus spp.), in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or boiling in water; edible flours, meals, pellets",
  "030622":
    "Crustaceans; not frozen, lobsters (Homarus spp.), whether in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water; edible flours, meals, and pellets",
  "030623":
    "Crustaceans; shrimps and prawns, not frozen, (whether in shell or not, whether or not cooked by steaming or by boiling in water)",
  "030624":
    "Crustaceans; not frozen, crabs, whether in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water; edible flours, meals, and pellets",
  "030625":
    "Crustaceans; not frozen, Norway lobsters (Nephrops norvegicus), in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water; edible flours, meals, and pellets",
  "030626":
    "Crustaceans; not frozen, cold-water shrimps and prawns (Pandalus spp., Crangon crangon), in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water; edible flour, meals, and pellets",
  "030627":
    "Crustaceans; not frozen, shrimps and prawns excluding cold-water varieties, in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water; edible flour, meals, and pellets",
  "030629":
    "Crustaceans; not frozen, n.e.c. in item no. 0306.2, in shell or not, smoked, cooked or not before or during smoking; in shell, cooked by steaming or by boiling in water; including edible flours, meals, and pellets of crustaceans",
  "030631":
    "Crustaceans; live, fresh or chilled, rock lobsters and other sea crawfish (Palinurus spp., Panulirus spp., Jasus spp.), in shell or not",
  "030632":
    "Crustaceans; live, fresh or chilled, lobsters (Homarus spp.), whether in shell or not",
  "030633":
    "Crustaceans; live, fresh or chilled, crabs, whether in shell or not",
  "030634":
    "Crustaceans; live, fresh or chilled, Norway lobsters (Nephrops norvegicus), in shell or not",
  "030635":
    "Crustaceans; live, fresh or chilled, cold-water shrimps and prawns (Pandalus spp., Crangon crangon), in shell or not",
  "030636":
    "Crustaceans; live, fresh or chilled, shrimps and prawns excluding cold-water varieties, in shell or not",
  "030639":
    "Crustaceans; live, fresh or chilled, n.e.c. in item no. 0306.3, in shell or not, including edible flours, meals, and pellets of crustaceans",
  "030691":
    "Crustaceans; rock lobsters and other sea crawfish (Palinurus spp., Panulirus spp., Jasus spp.), smoked, cooked or not, whether in shell or not, whether or not cooked before or during smoking",
  "030692":
    "Crustaceans; lobsters (Homarus spp.), smoked, cooked or not, whether in shell or not, whether or not cooked before or during smoking",
  "030693":
    "Crustaceans; crabs, smoked, cooked or not, whether in shell or not, whether or not cooked before or during smoking",
  "030694":
    "Crustaceans; Norway lobsters (Nephrops norvegicus), smoked, cooked or not, whether in shell or not, whether or not cooked before or during smoking",
  "030695":
    "Crustaceans; shrimps and prawns, smoked, cooked or not, whether in shell or not, whether or not cooked before or during smoking",
  "030699":
    "Crustaceans; smoked, whole, cooked or not, n.e.c. in item no. 0306.9, in shell or not, including edible flours, meals, and pellets of crustaceans",
  "030710":
    "Molluscs; oysters, live, fresh, chilled, frozen, dried, salted or in brine (whether in shell or not)",
  "030711":
    "Molluscs; oysters, whether in shell or not, live, fresh or chilled",
  "030712": "Molluscs; oysters, whether in shell or not, frozen",
  "030719":
    "Molluscs; oysters, whether in shell or not, dried, salted or in brine, smoked, cooked or not before or during the smoking process",
  "030721":
    "Molluscs; scallops, whether in shell or not, including queen scallops, of the genera Pecten, Chlamys or Placopecten, live, fresh or chilled",
  "030722":
    "Molluscs; scallops, whether in shell or not, including queen scallops of the genera Pecten, Chlamys or Placopecten, frozen",
  "030729":
    "Molluscs; scallops, whether in shell or not, including queen scallops of the genera Pecten, Chlamys or Placopecten, dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
  "030731":
    "Molluscs; mussels (Mytilus spp., Perna spp.), whether in shell or not, live, fresh or chilled",
  "030732":
    "Molluscs; mussels (Mytilus spp., Perna spp.), whether in shell or not, frozen",
  "030739":
    "Molluscs; mussels (Mytilus spp., Perna spp.), whether in shell or not, dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
  "030741":
    "Molluscs; cuttle fish and squid, whether in shell or not, live, fresh or chilled",
  "030742":
    "Molluscs; cuttle fish and squid, whether in shell or not, live, fresh or chilled",
  "030743": "Cuttle fish and squid; frozen, processed or not",
  "030749":
    "Molluscs; cuttle fish and squid, whether in shell or not, includes flours, meals, and pellets of molluscs, fit for human consumption, dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
  "030751": "Molluscs; octopus (Octopus spp.), live, fresh or chilled",
  "030752": "Molluscs; octopus (Octopus spp.), frozen",
  "030759":
    "Molluscs; octopus (Octopus spp.), dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
  "030760":
    "Molluscs; snails, other than sea snails, whether in shell or not, live, fresh, chilled, frozen, dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
  "030771":
    "Molluscs; clams, cockles and ark shells (families Arcidae, Arcticidae, Cardiidae, Donacidae, Hiatellidae, Mactridae, Mesodesmatidae, Myidae, Semelidae, Solecurtidae, Solenidae, Tridacnidae and Veneridae), whether in shell or not, live, fresh or chilled",
  "030772":
    "Molluscs; clams, cockles, ark shells (Arcidae, Arcticidae, Cardiidae, Donacidae, Hiatellidae, Mactridae, Mesodesmatidae, Myidae, Semelidae, Solecurtidae, Solenidae, Tridacnidae and Veneridae), whether in shell or not, frozen",
  "030779":
    "Molluscs; clams, cockle, ark shells (families Arcidae, Arcticidae, Cardiidae, Donacidae, Hiatellidae, Mactridae, Mesodesmatidae, Myidae, Semelidae, Solecurtidae, Solenidae, Tridacnidae, Veneridae), whether in shell or not, dried, salted, in brine, smoked",
  "030781":
    "Molluscs; abalone (Haliotis spp.), whether in shell or not, live, fresh or chilled",
  "030782":
    "Molluscs; stromboid conchs (Strombus spp.), whether in shell or not, live, fresh or chilled",
  "030783":
    "Molluscs; abalone (Haliotis spp.), whether in shell or not, frozen",
  "030784":
    "Molluscs; stromboid conchs (Strombus spp.), whether in shell or not, frozen",
  "030787":
    "Molluscs; abalone (Haliotis spp.), whether in shell or not, dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
  "030788":
    "Molluscs; stromboid conchs (Strombus spp.), whether in shell or not, includes flours, meals, and pellets of molluscs, fit for human consumption, dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
  "030789":
    "Molluscs; abalone (Haliotis spp.), whether in shell or not, frozen, dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
  "030791":
    "Molluscs; n.e.c. in heading 0307, whether in shell or not, includes flours, meals, and pellets of molluscs, fit for human consumption, live or fresh, chilled",
  "030792":
    "Molluscs; n.e.c. in heading 0307, whether in shell or not, includes flours, meals, and pellets of molluscs, fit for human consumption, frozen",
  "030799":
    "Molluscs; n.e.c. in heading 0307, whether in shell or not, includes flours, meals, and pellets of molluscs, fit for human consumption, dried, salted, in brine, or smoked, cooked or not before or during the smoking process",
  "030811":
    "Aquatic invertebrates; sea cucumbers (Stichopus japonicus, Holothuroidea), live, fresh or chilled",
  "030812":
    "Aquatic invertebrates; sea cucumbers (Stichopus japonicus, Holothuroidea), frozen",
  "030819":
    "Aquatic invertebrates; sea cucumbers (Stichopus japonicus, Holothuroidea), dried, salted or in brine, smoked, whether or not cooked before or during the smoking process",
  "030821":
    "Aquatic invertebrates; sea urchins (Strongylocentrotus spp., Paracentrotus lividus, Loxechinus albus, Echinus esculentus), live, fresh or chilled",
  "030822":
    "Aquatic invertebrates; sea urchins (Strongylocentrotus spp., Paracentrotus lividus, Loxechinus albus, Echinus esculentus), frozen",
  "030829":
    "Aquatic invertebrates; sea urchins (Strongylocentrotus spp., Paracentrotus lividus, Loxechinus albus, Echinus esculentus), dried, salted or in brine, smoked, whether or not cooked before or during smoking process",
  "030830":
    "Aquatic invertebrates; jellyfish (Rhopilema spp.), live, fresh, chilled, frozen, dried, salted or in brine, smoked, whether or not cooked before or during smoking",
  "030890":
    "Aquatic invertebrates; other than crustaceans, molluscs, sea urchins, sea cucumbers and jellyfish, live, fresh, chilled, frozen, dried, salted or in brine, smoked, cooked or not before or during smoking, includes edible flours, meals, and pellets",
  "030910": "Flours, meals and pellets of fish, fit for human consumption",
  "030990":
    "Flours, meals and pellets of crustaceans, molluscs and other aquatic invertebrates, fit for human consumption",
  "040110":
    "Dairy produce; milk and cream, not concentrated, not containing added sugar or other sweetening matter, of a fat content, by weight, not exceeding 1%",
  "040120": "Milk; 1%-6% fat",
  "040130":
    "Dairy produce; milk and cream, not concentrated, not containing added sugar or other sweetening matter, of a fat content exceeding 6% (by weight)",
  "040140":
    "Dairy produce; milk and cream, not concentrated, not containing added sugar or other sweetening matter, of a fat content, by weight, exceeding 6% but not exceeding 10%",
  "040150":
    "Dairy produce; milk and cream, not concentrated, not containing added sugar or other sweetening matter, of a fat content, by weight, exceeding 10%",
  "040210":
    "Dairy produce; milk and cream, concentrated or containing added sugar or other sweetening matter, in powder, granules or other solid forms, of a fat content not exceeding 1.5% (by weight)",
  "040221": "Unsweetened Milk Powder; >1.5% fat",
  "040229":
    "Dairy produce; milk and cream, containing added sugar or other sweetening matter, in powder, granules or other solid forms, of a fat content exceeding 1.5% (by weight)",
  "040291":
    "Dairy produce; milk and cream, concentrated, not containing added sugar or other sweetening matter, other than in powder, granules or other solid forms",
  "040299":
    "Dairy produce; milk and cream, containing added sugar or other sweetening matter, other than in powder, granules or other solid forms",
  "040310":
    "Dairy produce; yoghurt, whether or not concentrated or containing added sugar or other sweetening matter or flavoured or containing added fruit or cocoa",
  "040320":
    "Dairy produce; yoghurt, whether or not concentrated or containing added sugar or other sweetening matter or flavoured or containing added fruit, nuts or cocoa",
  "040390":
    "Dairy produce; buttermilk, curdled milk or cream, kephir, fermented or acidified milk or cream, whether or not concentrated or containing added sweetening, flavouring, fruit or cocoa (excluding yoghurt)",
  "040410":
    "Dairy produce; whey, whether or not concentrated or containing added sugar or other sweetening matter",
  "040490":
    "Dairy produce; natural milk constituents (excluding whey), whether or not containing added sugar or other sweetening matter, n.e.c. in chapter 04",
  "040500": "Butter and other milk fats",
  "040510": "Dairy produce; derived from milk, butter",
  "040520": "Dairy produce; dairy spreads",
  "040590":
    "Dairy produce; fats and oils derived from milk (other than butter or dairy spreads)",
  "040610":
    "Dairy produce; fresh cheese (including whey cheese), not fermented, and curd",
  "040620": "Dairy produce; cheese of all kinds, grated or powdered",
  "040630": "Dairy produce; cheese, processed (not grated or powdered)",
  "040640":
    "Dairy produce; cheese, blue-veined and other cheese containing veins produced by Penicillium roqueforti (not grated, powdered or processed)",
  "040690": "Other cheeses (exclusionary category)",
  "040700": "Eggs; birds' eggs, in the shell, fresh, preserved or cooked",
  "040711":
    "Birds' eggs, in shell; fresh, fertilised eggs for incubation, of fowls of the species Gallus domesticus (domestic hens)",
  "040719":
    "Birds' eggs, in shell; fresh, fertilised eggs for incubation, other than fowls of the species Gallus domesticus (domestic hens)",
  "040721":
    "Birds' eggs, in shell; fresh, not for incubation, of fowls of the species Gallus domesticus (domestic hens)",
  "040729":
    "Birds' eggs, in shell; fresh, not for incubation, other than fowls of the species Gallus domesticus (domestic hens)",
  "040790": "Birds' eggs, in shell; preserved or cooked",
  "040811":
    "Eggs; birds' eggs, yolks, dried, whether or not containing added sugar or other sweetening matter",
  "040819":
    "Eggs; birds' eggs, yolks, fresh, cooked by steaming or by boiling in water, moulded, frozen or otherwise preserved, whether or not containing added sugar or other sweetening matter",
  "040891":
    "Eggs; birds' eggs (not in shell, excluding yolks only), dried, whether or not containing added sugar or other sweetening matter",
  "040899":
    "Eggs; birds' eggs (not in shell, excluding yolks only), fresh, cooked by steaming or boiling in water, moulded, frozen, otherwise preserved, whether or not containing added sugar or other sweetening matter",
  "040900": "Honey; natural",
  "041000": "Animal products; edible, n.e.c. in this or other chapters",
  "041010": "Animal products; insects",
  "041090":
    "Animal products; edible products of animal origin, not elsewhere specified or included, other than insects",
  "050100":
    "Animal products; hair, human, unworked, whether or not washed or scoured, and waste of human hair",
  "050210":
    "Animal products; hair and bristles, of pigs, hogs or boars, and waste thereof",
  "050290":
    "Animal products; badger hair and other brush making hair and waste of such bristles or hair, n.e.c. in heading no. 0502 (excluding horsehair)",
  "050300":
    "Animal products; horsehair and horsehair waste, whether or not put up as a layer with or without supporting material",
  "050400":
    "Animal products; guts, bladders and stomachs of animals (other than fish), whole and pieces thereof, fresh, chilled, frozen, salted, in brine, dried or smoked",
  "050510":
    "Animal products; feathers and down used for stuffing, not further worked than cleaned, disinfected or treated for preservation",
  "050590":
    "Animal products; skins and other parts of birds, feathers and down (not for stuffing), powder and waste of such, not further worked than cleaned, disinfected or treated for preservation",
  "050610": "Animal products; ossein and bones treated with acid",
  "050690":
    "Animal products; bones and horn-cores and powder or waste of such, unworked, defatted, simply prepared (not cut to shape), or treated with acid or degelatinised, n.e.c. in heading no. 0506",
  "050710":
    "Animal products; ivory, unworked or simply prepared but not cut to shape, ivory powder and waste",
  "050790":
    "Animal products; tortoise-shell, whalebone and whalebone hair, horns, antlers, hooves, nails, claws and beaks, unworked or simply prepared but not cut to shape, waste and powder of these products",
  "050800":
    "Animal products; coral and similar materials, shells of molluscs, crustaceans, echinoderms, cuttle-bone, unworked or simply prepared but not cut to shape, powder and waste thereof",
  "050900": "Animal products; natural sponges of animal origin",
  "051000":
    "Animal products; ambergris, castoreum, civet, musk, cantharides, bile (dried or not) glands and other animal products, for pharmaceutical purposes, fresh, chilled, frozen or otherwise provisionally preserved",
  "051110": "Animal products; bovine semen",
  "051191":
    "Animal products; of fish or crustaceans, molluscs or other aquatic invertebrates; dead animals of chapter 03, unfit for human consumption",
  "051199": "Animal products; n.e.c. in chapter 5",
  "060110":
    "Plants, live; bulbs, tubers, tuberous roots, corms, crowns and rhizomes, dormant",
  "060120":
    "Plants, live; bulbs, tubers, tuberous roots, corms, crowns and rhizomes, in growth or in flower, chicory plants and roots other than of heading no. 1212",
  "060210": "Plants, live; unrooted cuttings and slips",
  "060220":
    "Plants, live; edible fruit or nut trees, shrubs and bushes, grafted or not",
  "060230": "Plants, live; rhododendrons and azaleas, grafted or not",
  "060240": "Plants, live; roses, grafted or not",
  "060290": "Other live plants (exclusionary category)",
  "060291": "Plants, live; mushroom spawn",
  "060299": "Other live plants (exclusionary category)",
  "060310": "Flowers; fresh, for bouquets or ornaments",
  "060311":
    "Flowers, cut; roses, flowers and buds of a kind suitable for bouquets or ornamental purposes, fresh",
  "060312":
    "Flowers, cut; carnations, flowers and buds of a kind suitable for bouquets or ornamental purposes, fresh",
  "060313":
    "Flowers, cut; orchids, flowers and buds of a kind suitable for bouquets or ornamental purposes, fresh",
  "060314":
    "Flowers, cut; chrysanthemums, flowers and buds of a kind suitable for bouquets or ornamental purposes, fresh",
  "060315":
    "Flowers, cut; lilies (Lilium spp.), flowers and flower buds of a kind suitable for bouquets or ornamental purposes, fresh",
  "060319":
    "Flowers, cut; flowers and buds of a kind suitable for bouquets or ornamental purposes, fresh, other than roses, carnations, orchids, chrysanthemums or lillies",
  "060390":
    "Flowers, cut; flowers and flower buds of a kind suitable for bouquets or ornamental purposes, dried, dyed, bleached, impregnated or otherwise prepared",
  "060410":
    "Mosses and lichens; of a kind suitable for bouquets or ornamental purposes, fresh, dried, dyed, bleached, impregnated or otherwise prepared",
  "060420":
    "Foliage, branches and other parts of plants, without flowers or flower buds, and grasses, mosses and lichens; suitable for bouquets or for ornamental purposes, fresh",
  "060490":
    "Foliage, branches and other parts of plants, without flowers or flower buds, and grasses, mosses and lichens; suitable for bouquets or for ornamental purposes, dried, dyed, bleached, impregnated or otherwise prepared",
  "060491":
    "Foliage, branches and other parts of plants, without flowers or flower buds, and grasses; being goods of a kind suitable for bouquets or for ornamental purposes, fresh",
  "060499":
    "Foliage, branches and other parts of plants, without flowers or flower buds, and grasses; kind suitable for bouquets or for ornamental purposes dried, dyed, bleached, impregnated, otherwise prepared, excluding fresh",
  "070110": "Vegetables; seed potatoes, fresh or chilled",
  "070190": "Vegetables; potatoes (other than seed), fresh or chilled",
  "070200": "Tomatoes; fresh or chilled",
  "070310": "Vegetables, alliaceous; onions and shallots, fresh or chilled",
  "070320": "Vegetables, alliaceous; garlic, fresh or chilled",
  "070390":
    "Vegetables, alliaceous; leeks and other kinds n.e.c. in heading no. 0703, fresh or chilled",
  "070410":
    "Vegetables, brassica; cauliflowers and headed broccoli, fresh or chilled",
  "070420": "Vegetables, brassica; brussel sprouts, fresh or chilled",
  "070490":
    "Vegetables, brassica; edible, n.e.c. in heading no. 0704, fresh or chilled",
  "070511":
    "Vegetables; cabbage (head) lettuce (lactuca sativa), fresh or chilled",
  "070519":
    "Vegetables; lettuce (lactuca sativa), (other than cabbage lettuce), fresh or chilled",
  "070521":
    "Vegetables; witloff chicory (cichorium intybus var. foliosum), fresh or chilled",
  "070529":
    "Vegetables; chicory (cichorium spp.), (other than witloof chicory), fresh or chilled",
  "070610": "Vegetables, root; carrots and turnips, fresh or chilled",
  "070690":
    "Vegetables, root; salad beetroot, salsify, celeric, radishes and similar edible roots, fresh or chilled",
  "070700": "Vegetables; cucumbers and gherkins, fresh or chilled",
  "070810":
    "Vegetables, leguminous; peas (pisum sativum), shelled or unshelled, fresh or chilled",
  "070820":
    "Vegetables, leguminous; beans (vigna spp., phaseolus spp.), shelled or unshelled, fresh or chilled",
  "070890":
    "Vegetables, leguminous; (other than peas and beans), shelled or unshelled, fresh or chilled",
  "070910": "Vegetables; globe artichokes, fresh or chilled",
  "070920": "Vegetables; asparagus, fresh or chilled",
  "070930": "Vegetables; aubergines, (e.g. plants), fresh or chilled",
  "070940": "Vegetables; celery (other than celeriac), fresh or chilled",
  "070951": "Vegetables; mushrooms of the genus Agaricus, fresh or chilled",
  "070952": "Vegetables; truffles, fresh or chilled",
  "070953": "Vegetables; mushrooms of the genus Cantharellus, fresh or chilled",
  "070954":
    "Vegetables; shiitake mushrooms (Lentinus edodes), fresh or chilled",
  "070955":
    "Vegetables; matsutake mushrooms (Tricholoma matsutake, Tricholoma magnivelare, Tricholoma anatolicum, Tricholoma dulciolens, Tricholoma caligatum), fresh or chilled",
  "070956": "Vegetables; truffles (Tuber spp.), fresh or chilled",
  "070959":
    "Vegetables; truffles and mushrooms (other than of the genus Agaricus), fresh or chilled",
  "070960": "Peppers (Capsicum, Pimenta); fresh or chilled",
  "070970":
    "Vegetables; spinach, New Zealand spinach and orache spinach (garden spinach), fresh or chilled",
  "070990": "Vegetables; edible, n.e.c. in chapter 7, fresh or chilled",
  "070991": "Vegetables; globe artichokes, fresh or chilled",
  "070992": "Vegetables; olives, fresh or chilled",
  "070993":
    "Vegetables; pumpkins, squash and gourds (Cucurbita spp.), fresh or chilled",
  "070999": "Vegetables; edible, n.e.c. in chapter 07, fresh or chilled",
  "071010":
    "Vegetables; potatoes, uncooked or cooked by steaming or boiling in water, frozen",
  "071021":
    "Vegetables, leguminous; peas (pisum sativum), shelled or unshelled, uncooked or cooked by steaming or boiling in water, frozen",
  "071022":
    "Vegetables, leguminous; beans (vigna spp., phaseolus spp.), shelled or unshelled, uncooked or cooked by steaming or boiling in water, frozen",
  "071029":
    "Vegetables, leguminous; (other than peas or beans), shelled or unshelled, uncooked or cooked by steaming or boiling in water, frozen",
  "071030":
    "Vegetables; spinach, New Zealand spinach and orache spinach (garden spinach), uncooked or cooked by steaming or boiling in water, frozen",
  "071040":
    "Vegetables; sweetcorn, uncooked or cooked by steaming or boiling in water, frozen",
  "071080":
    "Vegetables; uncooked or cooked by steaming or boiling in water, n.e.c. in heading no. 0710, frozen",
  "071090":
    "Vegetable mixtures; uncooked or cooked by steaming or boiling in water, frozen",
  "071110":
    "Vegetables; onions, provisionally preserved by sulphur dioxide gas, but unsuitable in that state for immediate consumption",
  "071120":
    "Vegetables; olives, provisionally preserved but unsuitable in that state for immediate consumption",
  "071130":
    "Vegetables; capers, provisionally preserved but unsuitable in that state for immediate consumption",
  "071140":
    "Vegetables; cucumbers and gherkins, provisionally preserved but unsuitable in that state for immediate consumption",
  "071151":
    "Vegetables; mushrooms of the genus Agaricus, provisionally preserved but unsuitable in that state for immediate consumption",
  "071159":
    "Vegetables; mushrooms other than of the genus Agaricus, provisionally preserved but unsuitable in that state for immediate consumption",
  "071190":
    "Vegetables and mixed vegetables; n.e.c. in heading no. 0711, provisionally preserved but unsuitable in that state for immediate consumption",
  "071210":
    "Vegetables; potatoes, whether or not cut or sliced but not further prepared, dried",
  "071220":
    "Vegetables; onions, whole, cut, sliced, broken or in powder but not further prepared, dried",
  "071230":
    "Vegetables; mushrooms and truffles, whole, cut, sliced, broken or in powder but not further prepared, dried",
  "071231":
    "Vegetables; mushrooms of the genus Agaricus, whole, cut, sliced, broken or in powder but not further prepared, dried",
  "071232":
    "Vegetables; wood ears (Auricularia spp), whole, cut, sliced, broken or in powder but not further prepared, dried",
  "071233":
    "Vegetables; jelly fungi (Tremella spp)), whole, cut, sliced, broken or in powder but not further prepared, dried",
  "071234":
    "Vegetables; shiitake mushrooms (Lentinus edodes), whole, cut, sliced, broken or in powder but not further prepared, dried",
  "071239":
    "Vegetables; mushrooms, other than the genus Agaricus and truffles, whole, cut, sliced, broken or in powder but not further prepared, dried",
  "071290":
    "Vegetables; mixtures of vegetables n.e.c. in heading no. 0712, whole, cut, sliced, broken or in powder but not further prepared, dried",
  "071310":
    "Vegetables, leguminous; peas (pisum sativum), shelled, whether or not skinned or split, dried",
  "071320":
    "Vegetables, leguminous; chickpeas (garbanzos), shelled, whether or not skinned or split, dried",
  "071331":
    "Vegetables, leguminous; beans of the species vigna mungo (l.) hepper or vigna radiata (l.) wilczek, shelled, whether or not skinned or split, dried",
  "071332":
    "Vegetables, leguminous; small red (adzuki) beans (phaseolus or vigna angularis), shelled, whether or not skinned or split, dried",
  "071333":
    "Vegetables, leguminous; kidney beans, including white pea beans (phaseolus vulgaris), shelled, whether or not skinned or split, dried",
  "071334":
    "Vegetables, leguminous; bambara beans (Vigna subterranea or Voandzeia subterranea), shelled, whether or not skinned or split, dried",
  "071335":
    "Vegetables, leguminous; cow peas (Vigna unguiculata), shelled, whether or not skinned or split, dried",
  "071339":
    "Vegetables, leguminous; n.e.c. in item no. 0713.3, shelled, whether or not skinned or split, dried",
  "071340":
    "Vegetables, leguminous; lentils, shelled, whether or not skinned or split, dried",
  "071350":
    "Vegetables, leguminous; broad beans (vicia faba var. major) and horse beans (vicia faba var. equina and vicia faba var. minor), shelled, whether or not skinned or split, dried",
  "071360":
    "Vegetables, leguminous; pigeon peas (Cajanus cajan), shelled, whether or not skinned or split, dried",
  "071390":
    "Vegetables, leguminous; n.e.c. in heading no. 0713, shelled, whether or not skinned or split, dried",
  "071410":
    "Vegetable roots and tubers; manioc (cassava), with high starch or inulin content, fresh, chilled, frozen or dried, whether or not sliced or in the form of pellets",
  "071420":
    "Vegetable roots and tubers; sweet potatoes, with high starch or inulin content, fresh, chilled, frozen or dried, whether or not sliced or in the form of pellets",
  "071430":
    "Vegetable roots and tubers; yams (Dioscorea spp.) with high starch or inulin content, fresh, chilled, frozen or dried, whether or not sliced or in the form of pellets",
  "071440":
    "Vegetable roots and tubers; taro (Colocasia spp.) with high starch or inulin content, fresh, chilled, frozen or dried, whether or not sliced or in the form of pellets",
  "071450":
    "Vegetable roots and tubers; yautia (Xanthosoma spp.) with high starch or inulin content, fresh, chilled, frozen or dried, whether or not sliced or in the form of pellets",
  "071490":
    "Vegetable roots and tubers; arrowroot, salep, Jerusalem artichokes and similar roots and tubers (not manioc, sweet potatoes, yams, taro or yautia), high starch or inulin content, fresh, chilled, frozen, dried, sliced or not, or in pellet form; sago pith",
  "080110":
    "Nuts, edible; coconuts, fresh or dried, whether or not shelled or peeled",
  "080111": "Nuts, edible; coconuts, desiccated",
  "080112": "Nuts, edible; coconuts, in the inner shell (endocarp)",
  "080119":
    "Nuts, edible; coconuts, fresh or dried, other than desiccated or in the inner shell (endocarp)",
  "080120":
    "Nuts, edible; Brazil nuts, fresh or dried, whether or not shelled or peeled",
  "080121": "Nuts, edible; brazil nuts, fresh or dried, in shell",
  "080122": "Nuts, edible; brazil nuts, fresh or dried, shelled",
  "080130":
    "Nuts, edible; cashew nuts, fresh or dried, whether or not shelled or peeled",
  "080131": "Cashew nuts; fresh or dried, in shell",
  "080132": "Nuts, edible; cashew nuts, fresh or dried, shelled",
  "080211": "Nuts, edible; almonds, fresh or dried, in shell",
  "080212": "Nuts, edible; almonds, fresh or dried, shelled",
  "080221":
    "Nuts, edible; hazelnuts or filberts (corylus spp.), fresh or dried, in shell",
  "080222":
    "Nuts, edible; hazelnuts or filberts (corylus spp.), fresh or dried, shelled",
  "080231": "Nuts, edible; walnuts, fresh or dried, in shell",
  "080232": "Nuts, edible; walnuts, fresh or dried, shelled",
  "080240":
    "Nuts, edible; chestnuts (castanea spp.), fresh or dried, whether or not shelled or peeled",
  "080241": "Nuts, edible; chestnuts (Castanea spp.), fresh or dried, in shell",
  "080242": "Nuts, edible; chestnuts (Castanea spp.), fresh or dried, shelled",
  "080250":
    "Nuts, edible; pistachios, fresh or dried, whether or not shelled or peeled",
  "080251": "Nuts, edible; pistachios, fresh or dried, in shell",
  "080252": "Nuts, edible; pistachios, fresh or dried, shelled",
  "080260":
    "Nuts, edible; macadamia, fresh or dried, whether or not shelled or peeled",
  "080261": "Nuts, edible; macadamia, fresh or dried, in shell",
  "080262": "Nuts, edible; macadamia, fresh or dried, shelled",
  "080270":
    "Nuts, edible; kola nuts (Cola spp.), fresh or dried, whether or not shelled or peeled",
  "080280":
    "Nuts, edible; areca nuts, fresh or dried, whether or not shelled or peeled",
  "080290":
    "Nuts, edible; n.e.c. in heading no. 0801 and 0802, fresh or dried, whether or not shelled or peeled",
  "080291": "Nuts, edible; pine nuts, fresh or dried, in shell",
  "080292": "Nuts, edible; pine nuts, fresh or dried, shelled",
  "080299":
    "Nuts, edible; n.e.c. in heading 0801 and 0802, fresh or dried, whether or not shelled or peeled",
  "080300": "Bananas; fresh or dried, incl. plantains",
  "080310": "Fruit, edible; plantains, fresh or dried",
  "080390": "Bananas; fresh or dried; excl. plantains",
  "080410": "Fruit, edible; dates, fresh or dried",
  "080420": "Fruit, edible; figs, fresh or dried",
  "080430": "Fruit, edible; pineapples, fresh or dried",
  "080440": "Avocados; fresh or dried",
  "080450": "Fruit, edible; guavas, mangoes and mangosteens, fresh or dried",
  "080510": "Oranges; fresh or dried",
  "080520":
    "Fruit, edible; mandarins (including tangerines and satsumas), clementines, wilkings and similar citrus hybrids, fresh or dried",
  "080521":
    "Fruit, edible; mandarins (including tangerines and satsumas), fresh or dried",
  "080522": "Fruit, edible; clementines, fresh or dried",
  "080529":
    "Fruit, edible; tangelos, wilkings and similar citrus hybrid, fresh or dried",
  "080530":
    "Fruit, edible; lemons (citrus limon, citrus limonum), limes (citrus aurantifolia)",
  "080540": "Fruit, edible; grapefruit, including pomelos, fresh or dried",
  "080550":
    "Fruit, edible; lemons (Citrus limon, Citrus limonum), limes (Citrus aurantifolia , Citrus latifolia), fresh or dried",
  "080590":
    "Fruit, edible; citrus fruit n.e.c. in heading no. 0805, fresh or dried",
  "080610": "Grapes; fresh",
  "080620": "Fruit, edible; grapes, dried",
  "080710": "Fruit, edible; melons (including watermelons), fresh",
  "080711": "Fruit, edible; watermelons, fresh",
  "080719": "Fruit, edible; melons, other than watermelons, fresh",
  "080720": "Fruit, edible; papaws (papayas), fresh",
  "080810": "Apples; fresh",
  "080820": "Fruit, edible; pears and quinces, fresh",
  "080830": "Fruit, edible; pears, fresh",
  "080840": "Fruit, edible; quinces, fresh",
  "080910": "Fruit, edible; apricots, fresh",
  "080920": "Fruit, edible; cherries, fresh",
  "080921": "Fruit, edible; sour cherries (Prunus cerasus), fresh",
  "080929":
    "Fruit, edible; cherries, other than sour cherries (Prunus cerasus), fresh",
  "080930": "Fruit, edible; peaches, including nectarines, fresh",
  "080940": "Fruit, edible; plums and sloes, fresh",
  "081010": "Fruit, edible; strawberries, fresh",
  "081020":
    "Fruit, edible; raspberries, blackberries, mulberries, and loganberries, fresh",
  "081030":
    "Fruit, edible; black, white or red currants and gooseberries, fresh",
  "081040":
    "Fruit, edible; cranberries, bilberries and other fruits of the genus vaccinium, fresh",
  "081050": "Fruit, edible; kiwifruit, fresh",
  "081060": "Durian; fresh",
  "081070": "Fruit, edible; persimmons, fresh",
  "081090": "Fruit, edible; fruits n.e.c. in heading no. 0801 to 0810, fresh",
  "081110":
    "Fruit, edible; strawberries, uncooked or cooked by steaming or boiling in water, frozen, whether or not containing added sugar or other sweetening matter",
  "081120":
    "Fruit, edible; raspberries, blackberries, mulberries, loganberries, black, white or red currants and gooseberries, uncooked or cooked, whether or not containing added sugar or other sweetening matter",
  "081190":
    "Fruit, edible; fruit and nuts n.e.c. in heading no. 0811, uncooked or cooked, frozen whether or not containing added sugar or other sweetening matter",
  "081210":
    "Fruit, edible; cherries, provisionally preserved, but unsuitable in that state for immediate consumption",
  "081220":
    "Fruit, edible; strawberries, provisionally preserved, but unsuitable in that state for immediate consumption",
  "081290":
    "Fruit, edible; fruit and nuts n.e.c. in heading no. 0812, provisionally preserved, but unsuitable in that state for immediate consumption",
  "081310": "Fruit, edible; apricots, dried",
  "081320": "Fruit, edible; prunes, dried",
  "081330": "Fruit, edible; apples, dried",
  "081340": "Fruit, edible; fruit n.e.c. in heading no. 0812, dried",
  "081350": "Nuts, edible; mixtures of nuts or dried fruits of chapter 08",
  "081400":
    "Peel; of citrus fruit or melons (including watermelons), fresh, frozen, dried or provisionally preserved in brine, in sulphur water and other preservative solutions",
  "090111": "Coffee; not roasted or decaffeinated",
  "090112": "Coffee; decaffeinated, not roasted",
  "090121": "Coffee; roasted; not decaffeinated",
  "090122": "Coffee; roasted, decaffeinated",
  "090130": "Coffee; husks and skins",
  "090140": "Coffee; substitutes containing coffee, in any proportion",
  "090190":
    "Coffee; husks and skins, coffee substitutes containing coffee in any proportion",
  "090210":
    "Tea, green; (not fermented), in immediate packings of a content not exceeding 3kg",
  "090220":
    "Tea, green; (not fermented), in immediate packings of a content exceeding 3kg",
  "090230":
    "Tea, black; (fermented) and partly fermented tea, in immediate packings of a content not exceeding 3kg",
  "090240":
    "Tea, black; (fermented) and partly fermented tea, in immediate packings of a content exceeding 3kg",
  "090300": "Mate",
  "090411": "Spices; pepper (of the genus piper), neither crushed nor ground",
  "090412": "Spices; pepper (of the genus piper), crushed or ground",
  "090420":
    "Spices; fruits of the genus capsicum or pimenta, dried or crushed or ground",
  "090421":
    "Spices; fruits of the genus Capsicum or Pimenta, dried, neither crushed nor ground",
  "090422":
    "Spices; fruits of the genus Capsicum or Pimenta, crushed or ground",
  "090500": "Spices; vanilla",
  "090510": "Spices; vanilla, neither crushed nor ground",
  "090520": "Spices; vanilla, crushed or ground",
  "090610":
    "Spices; cinnamon and cinnamon-tree flowers, neither crushed nor ground",
  "090611":
    "Spices; cinnamon (Cinnamomum zeylanicum Blume), neither crushed nor ground",
  "090619":
    "Spices; cinnamon and cinnamon-tree flowers, other than cinnamon (Cinnamomum zeylanicum Blume), neither crushed nor ground",
  "090620": "Spices; cinnamon and cinnamon-tree flowers, crushed or ground",
  "090700": "Spices; cloves (whole fruit, cloves and stems)",
  "090710":
    "Spices; cloves (whole fruit, cloves and stems), neither crushed nor ground",
  "090720": "Spices; cloves (whole fruit, cloves and stems), crushed or ground",
  "090810": "Spices; nutmeg",
  "090811": "Spices; nutmeg, neither crushed nor ground",
  "090812": "Spices; nutmeg, crushed or ground",
  "090820": "Spices; mace",
  "090821": "Spices; mace, neither crushed nor ground",
  "090822": "Spices; mace, crushed or ground",
  "090830": "Spices; cardamoms",
  "090831": "Spices; cardamoms, neither crushed nor ground",
  "090832": "Spices; cardamoms, crushed or ground",
  "090910": "Spices; anise or badian seeds",
  "090920": "Spices; coriander seeds",
  "090921": "Spices; coriander seeds, neither crushed nor ground",
  "090922": "Spices; coriander seeds, crushed or ground",
  "090930": "Spices; cumin seeds",
  "090931": "Spices; cumin seeds, neither crushed nor ground",
  "090932": "Spices; cumin seeds, crushed or ground",
  "090940": "Spices; caraway seeds",
  "090950": "Spices; fennel or juniper seeds",
  "090961":
    "Spices; seeds of anise, badian, caraway or fennel; juniper berries, neither crushed nor ground",
  "090962":
    "Spices; seeds of anise, badian, caraway or fennel; juniper berries, crushed or ground",
  "091010": "Spices; ginger",
  "091011": "Spices; ginger, neither crushed nor ground",
  "091012": "Spices; ginger, crushed or ground",
  "091020": "Spices; saffron",
  "091030": "Spices; turmeric (curcuma)",
  "091040": "Herbs; thyme, bay leaves",
  "091050": "Curry",
  "091091": "Spices; mixtures of 2 or more products of different headings",
  "091099": "Spices; n.e.c. in heading no. 0910",
  "9999AA":
    "Commodities not specified according to kind **LEGACY NON-WCO CODE**",
} as const;
